import React, { Component } from "react";
import styled, { keyframes } from "styled-components";
import { fadeInUp, fadeIn } from "react-animations";
import { above, below } from "../style/functions";
import * as vars from "../style/vars"

const fadeInUpAnimation = keyframes`${fadeInUp}`;
const fadeInAnimation = keyframes`${fadeIn}`;

const locationGroups = [
	{
    key: "Villages",
    desc: "Surrounding Suburbs",
    color: "#222221",
    subgroups: [
      { locNum: "01", desc: "Fairfield" },
      { locNum: "02", desc: "Kew" },
      { locNum: "03", desc: "Kew East" },
      { locNum: "04", desc: "Clifton Hill" },
      { locNum: "05", desc: "Ivanhoe" },
      { locNum: "06", desc: "Northcote/Thornbury" },
      { locNum: "07", desc: "Hawthorn" }
    ]
  },
  {
    key: "Education",
    desc: "Education",
    color: "#CF6449",
    subgroups: [
      { locNum: "08", desc: "Alphington Grammar & Alphington Primary School" },
      { locNum: "09", desc: "St. Anthony’s Primary" },
      { locNum: "10", desc: "Alphington Primary" },
      { locNum: "11", desc: "Ivanhoe Grammar" },
      { locNum: "12", desc: "Ivanhoe Girls Grammar" },
      { locNum: "13", desc: "St Bernadette’s Catholic School" },
      { locNum: "14", desc: "Mary Immaculate Primary" },
      { locNum: "15", desc: "Kew East Primary" },
      { locNum: "16", desc: "St Anne’s Catholic Primary" },
      { locNum: "17", desc: "Andale School" },
      { locNum: "18", desc: "Sacred Heart Primary" },
      { locNum: "19", desc: "Trinity Grammar" },
      { locNum: "20", desc: "Ruyton Girls" },
      { locNum: "21", desc: "MLC Melbourne" },
      { locNum: "22", desc: "Xavier College" },
      { locNum: "23", desc: "St Paul’s College" },
      { locNum: "24", desc: " Kew High School" },
      { locNum: "25", desc: "Carey Baptist Grammar" },
      { locNum: "26", desc: "Camberwell Grammar" }
    ]
  },
  // {
  //   key: "Transport",
  //   desc: "Transport",
  //   color: "red",
  //   subgroups: [
  //     { locNum: "", desc: "Alphington Train Station 450m" },
  //     { locNum: "", desc: "Fairfield Train Station 1000m" },
  //     { locNum: "", desc: "Bus route 546 2m" }
  //   ]
	// },
	/*
  {
    key: "Parks",
    desc: "Surrounds",
    color: "#589D74",
    subgroups: [
      { locNum: "27", desc: "Coate Park" },
      { locNum: "28", desc: "Studley Park" },
      { locNum: "29", desc: "Studley Park Boathouse" },
      { locNum: "30", desc: "Yarra Bend Park" },
      { locNum: "31", desc: "Yarra Bend Golf Course" },
      { locNum: "32", desc: "Latrobe Golf Club" },
      { locNum: "33", desc: "Green Acres Golf Club" },
      { locNum: "34", desc: "Kew Golf Club" },
      { locNum: "35", desc: "Ivanhoe Public Golf Course" },
      { locNum: "36", desc: "Freeway Golf Course" },
      { locNum: "37", desc: "Alphington Park" },
      { locNum: "38", desc: "Eaglemont Tennis Club" },
      { locNum: "39", desc: "Eaglemont dirt Jumps" }
    ]
	},
	*/
  {
    key: "Hospitals",
    desc: "Hospitals",
    color: "#CA4F69",
    subgroups: [
      { locNum: "40", desc: "Austin Hospital" },
      { locNum: "41", desc: "Warringal Private Hospital" },
      { locNum: "42", desc: "Mercy Hospital for Women" },
      { locNum: "43", desc: "St Vincent’s Hospital" }
    ]
  },
  {
    key: "Food",
    desc: "Food & Drink",
    color: "#22A0B5",
    subgroups: [
      { locNum: "44", desc: "Benjamin’s Kitchen" },
      { locNum: "45", desc: "Paladarr" },
      { locNum: "46", desc: "Fossette" },
      { locNum: "47", desc: "Fifteen Pounds" },
      { locNum: "48", desc: "Hoppa & Joe" },
      { locNum: "49", desc: " Mr Wednesday" },
      { locNum: "50", desc: "Thai Station" },
      { locNum: "51", desc: "Flour and Salt" },
      { locNum: "52", desc: "C.H. James" },
      { locNum: "53", desc: "Two Fat Monks" },
      // { locNum: "54", desc: "Estelle Bistro and ESP" }
    ]
  },
  {
    key: "Shopping",
    desc: "Shopping",
    color: "#725A9D",
    subgroups: [
      { locNum: "55", desc: "Interior Base" },
      { locNum: "56", desc: "Fairfield Books" },
      { locNum: "57", desc: "Brenta Meats" },
      { locNum: "58", desc: "Fairfield Library" }
    ]
  }
];

class LocationMap extends Component {
  state = {
    selectedItem: "Villages",
    popover: {
      show: false,
      position: {
        top: "10px",
        left: "10px"
      },
      text: "Kew East"
    }
  };

  renderLocGroup = item => {
    const { selectedItem } = this.state;
    const { key, desc } = item;
    return (
      <div>
        <li
          className={`loc-group-item ${selectedItem === key ? "active" : ""}`}
          onClick={e => this.onGroupSelected(key)}
        >
          <p style={{ fontSize: "12px" }}>
            <span
              className="loc-group-bullet"
              style={{ backgroundColor: item.color }}
            />
            {desc}
          </p>
        </li>
        <div
          className="loc-subgroups"
          style={{ display: selectedItem === item.key ? "inherit" : "none" }}
        >
          <div className="drop-arrow" />
          <div className="grid">
            <div className="col col-06">
              {item.subgroups.map((s, idx, arr) => {
                if (idx >= arr.length / 2) return;
                return (
                  <div
                    className="grid loc-subgroup-item"
                    onMouseOver={e => this.onMouseOver(s.locNum)}
                    onMouseOut={e =>
                      this.setState({
                        ...this.state,
                        popover: {
                          ...this.state.popover,
                          show: false
                        }
                      })
                    }
                  >
                    <div className="col col-02">{s.locNum}</div>
                    <div
                      className="col col-10"
                      style={{ wordWrap: "break-word", lineHeight: 1.2 }}
                    >
                      {s.desc}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="col col-06">
              {item.subgroups.map((s, idx, arr) => {
                if (idx < arr.length / 2) return;
                return (
                  <div
                    className="grid loc-subgroup-item"
                    onMouseOver={e => this.onMouseOver(s.locNum)}
                    onMouseOut={e =>
                      this.setState({
                        ...this.state,
                        popover: {
                          ...this.state.popover,
                          show: false
                        }
                      })
                    }
                  >
                    <div className="col col-02">{s.locNum}</div>
                    <div className="col col-10">{s.desc}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderLocGroupMobile = () => {
    const { selectedItem } = this.state;
    const item = locationGroups.find(i => {
      return i.key === selectedItem;
    });
    if (!item) return;
    const { key, desc } = item;
    return (
      <div>
        <div style={{ display: "flex", paddingTop: "15px" }}>
          <li className={`col col-xs-10 loc-group-item active`}>
            <p style={{ fontSize: "12px" }}>
              <span
                onClick={this.handleClickNextLocationGroup}
                className="loc-group-bullet"
                style={{ backgroundColor: item.color }}
              />
              {desc}
            </p>
          </li>
          <div
            className="col col-xs-02"
            onClick={this.handleClickNextLocationGroup}
            style={{
              position: "relative",
              top: "5px",
              fontSize: "1.8rem",
              textAlign: "right",
              paddingRight: "20px"
            }}
          >
            >
          </div>
        </div>
        <div className="loc-subgroups">
          <div className="grid">
            <div className="col col-xs-06">
              {item.subgroups.map((s, idx, arr) => {
                if (idx >= arr.length / 2) return;
                return (
                  <div
                    className="grid loc-subgroup-item"
                    onMouseOver={e => this.onMouseOver(s.locNum)}
                    onMouseOut={e =>
                      this.setState({
                        ...this.state,
                        popover: {
                          ...this.state.popover,
                          show: false
                        }
                      })
                    }
                  >
                    <div className="col col-xs-02">{s.locNum}</div>
                    <div
                      className="col col-xs-10"
                      style={{ wordWrap: "break-word", lineHeight: 1.2 }}
                    >
                      {s.desc}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="col col-xs-06">
              {item.subgroups.map((s, idx, arr) => {
                if (idx < arr.length / 2) return;
                return (
                  <div
                    className="grid loc-subgroup-item"
                    onMouseOver={e => this.onMouseOver(s.locNum)}
                    onMouseOut={e =>
                      this.setState({
                        ...this.state,
                        popover: {
                          ...this.state.popover,
                          show: false
                        }
                      })
                    }
                  >
                    <div className="col col-xs-02">{s.locNum}</div>
                    <div className="col col-xs-10">{s.desc}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  };

  handleClickNextLocationGroup = e => {
    const { selectedItem } = this.state;
    let index = locationGroups.findIndex(i => {
      return i.key === selectedItem;
    });
    if (index == -1) return;
    index = index + 1;
    if (index > locationGroups.length - 1) {
      index = 0;
    } 

    this.setState({
      ...this.state,
      selectedItem: locationGroups[index].key
    });
  };

  onGroupSelected = selectedItem => {
    this.setState({
      selectedItem: selectedItem
    });
  };

  onLocationMapMouseOut = e => {
    if (e.target.tagName === "text" || e.target.tagName === "circle") return;
    this.setState({
      ...this.state,
      popover: {
        ...this.state.popover,
        show: false
      }
    });
  };
  onLocationMapMouseOver = e => {
    const { selectedItem } = this.state;
    const target = e.target;
    let locPointEle, pt, locPoint;
    if (target.tagName !== "text" && target.tagName !== "circle") return;
    const locMapSvg = document.getElementById("locationMapSvg");
    pt = locMapSvg.createSVGPoint();

    if (target.tagName === "text") {
      locPointEle = target.previousSibling;
      locPoint = target.innerHTML;
    } else if (target.tagName === "circle") {
      locPointEle = target;
      locPoint = locPointEle.nextSibling.innerHTML;
    }

    pt.x = locPointEle.getAttribute("cx");
    pt.y = locPointEle.getAttribute("cy");
    pt = pt.matrixTransform(locPointEle.getCTM());
    const item = locationGroups.find(i => {
      return i.key === selectedItem;
    });

    if (!item) return;
    const subgroupItem = item.subgroups.find(i => {
      return i.locNum === locPoint;
    });

    if (!subgroupItem) return;
    this.setState({
      ...this.state,
      popover: {
        ...this.state.popover,
        show: true,
        text: subgroupItem.desc,
        position: {
          top: pt.y - 65,
          left: pt.x - 60
        }
      }
    });
  };

  onMouseOver = locPoint => {
    const { selectedItem } = this.state;
    const locMapSvg = document.getElementById("locationMapSvg");
    const locPointEle = locMapSvg.getElementById(`loc-${locPoint}`);
    let pt = locMapSvg.createSVGPoint();
    pt.x = locPointEle.previousSibling.getAttribute("cx");
    pt.y = locPointEle.previousSibling.getAttribute("cy");
    pt = pt.matrixTransform(locPointEle.previousSibling.getCTM());
    const item = locationGroups.find(i => {
      return i.key === selectedItem;
    });

    if (!item) return;
    const subgroupItem = item.subgroups.find(i => {
      return i.locNum === locPoint;
    });

    if (!subgroupItem) return;

    // console.log(`x: ${locPointEle.clientX}  y:${locPointEle.clientY}`);
    this.setState({
      ...this.state,
      popover: {
        ...this.state.popover,
        show: true,
        text: subgroupItem.desc,
        position: {
          top: pt.y - 65,
          left: pt.x - 60
        }
      }
    });
  };

  render() {
    const { selectedItem, popover } = this.state;
    return (
      <LocationMapWrapper>
        <div className="grid">
          <div className="col col-xs-12 col-09">
            <div
              id="popover"
              style={{
                display: popover.show ? "inherit" : "none",
                position: "absolute",
                top: `${popover.position.top}px`,
                left: `${popover.position.left}px`,
                backgroundColor: "black",
                zIndex: "1000",
                textAlign: "center"
              }}
            >
              <p style={{ color: "white", padding: "5px 5px" }}>
                {popover.text}
              </p>
            </div>
            <svg
              id="locationMapSvg"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              viewBox="350 0 1524.9 1026"
              style={{ enableBackground: "new 350 100 1524.9 1026" }}
              xmlSpace="preserve"
              onMouseOver={this.onLocationMapMouseOver}
              onMouseOut={this.onLocationMapMouseOut}
            >
              <style
                type="text/css"
                dangerouslySetInnerHTML={{
                  __html:
                    "\n\t.st0{fill:#F1F2F2;}\n\t.st1{fill:#ACD9BA;}\n\t.st2{fill:#636667;}\n\t.st3{fill:none;}\n\t.st4{fill:#C6E8ED;}\n\t.st5{fill:#81C88E;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:#E6E7E8;}\n\t.st8{fill:none;stroke:#6D6E71;stroke-width:3;stroke-miterlimit:10;}\n\t.st9{fill:none;stroke:#6D6E71;stroke-width:3;stroke-miterlimit:10;stroke-dasharray:0.5,1;}\n\t.st10{fill:none;stroke:#9D9FA2;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:10,10;}\n\t.st11{fill:none;stroke:#9D9FA2;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:10.05,10.05;}\n\t.st12{fill:none;stroke:#9D9FA2;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:9.97,9.97;}\n\t.st13{fill:none;stroke:#9D9FA2;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:9.99,9.99;}\n\t.st14{fill:none;stroke:#9D9FA2;stroke-width:0.75;stroke-miterlimit:10;stroke-dasharray:10.01,10.01;}\n\t.st15{fill:#231F20;}\n\t.st16{fill:#9D9FA2;}\n\t.st17{fill:#6D6E71;}\n\t.st18{fill:#189670;}\n\t.st19{fill:#589D74;}\n\t.st20{font-family:'CircularPro-Medium';}\n\t.st21{font-size:12.5876px;}\n\t.st22{fill:#22A0B5;}\n\t.st23{fill:#725A9D;}\n\t.st24{fill:#CA4F69;}\n\t.st25{fill:#CF6449;}\n\t.st26{fill:#222221;}\n"
                }}
              />
              <g id="Map">
							
                <rect
                  x="0"
                  y="0"
                  className="st0"
                  width="2375.9"
                  height="1654.4"
                />
                <path
                  className="st1"
                  d="M562.7,914.1l-11-21.2c-1.3-2.5-2.6-5.5-1.6-8.2s2.4-3,4.1-4.1c16.2-10.3,36.5-11.8,55.9-11.5
		c26.9,0.4,53.6,3.7,80.3,7l52.8,6.4c3.1,0.4,6.6,1,8.3,3.6s1.1,4.1,1,6.2c-1.1,28.1-3.8,56.2-8,84c-3.7,25.4-8.8,50.6-13.8,75.8
		c-6.3-11.5-19.8-17.3-32.7-20.6s-26.6-4.8-38.3-11.2s-19.5-16.3-26.4-27s-12.5-22-20.1-32.1c-3.3-4.5-7-8.6-10.6-12.8l-18.2-20.8
		c-2.5-2.9-5.1-5.9-8.4-7.8s-16.4-14.4-20.3-16.8s0.9,4.5,0,0"
                />
                <path
                  className="st1"
                  d="M978.3,393.4c25.1,3.9,50.8,2.3,75.3-4.7c12.6-3.6,25.9-8.6,38.2-4.5c1,0.2,1.8,0.8,2.2,1.7
		c0.3,1.3-0.9,2.3-2,3c-2.9,1.6-6.3,2.4-9.4,3.7s-6.2,3.2-7.7,6.2s-0.8,7.3,2.3,8.8s4,0.7,5.4,2.1s0.8,5.2-0.9,7.3s-4.1,3.9-4.5,6.6
		c-1.2,7.3,11.8,10.5,11.1,17.9c-0.3,3.5-4,6.8-2.6,10s7.4,3.2,8.6,6.8c0.2,0.9,0.3,1.8,0.3,2.7c0.4,2.5,2.2,4.5,3.8,6.4
		c5.2,6,9.5,12.7,12.7,19.9c1,2.5,2,5.2,1.3,7.8c-1.3,5-7.7,6.4-12.9,6.8c-22.2,1.7-44.6,2.1-66.3-2.3c-1.9-0.4-3.9-0.9-5.1-2.4
		s-1.1-5.3-0.5-8c2.4-9.6,3.5-19.8,1.1-29.4s-8.7-18.6-17.9-22.2c-6.1-2.5-13.2-2.4-19-5.6S981,420.8,978,413.4s-4.8-15-0.8-21.1"
                />
                <path
                  className="st1"
                  d="M466,939.1c-0.6,15.7,38.4,24.1,40.6,39.6c0.7,4.7,1.6,9.4,0.9,14s-2.1,7.4-1,11c0.5,1.9,1.8,3.5,2.5,5.3
		c3.8,8.9-4.8,18.6-3.5,28.1c0.8,6.7,6.4,12.2,7,18.9c1,10-9.4,19.7-5.5,29.1c2,4.7,7.1,7.5,12,9.6c19.4,8.1,41.7,9.9,59.8,20.4
		c6,3.5,11.5,7.9,17.7,11.1c8.7,4.3,18.5,6,28.2,6.7c15,1.1,30.1-0.1,44.8-3.5c2.4-0.6,5.1-1.5,5.8-3.8c0.2-1.3,0.1-2.6-0.3-3.8
		c-1.9-6.7-2.7-13.7-2.3-20.6c0.9-18.7,9.7-36.2,13.3-54.7c0.5-2.3,0.8-4.9-0.5-6.9c-1.2-1.5-2.8-2.5-4.6-3
		c-7.4-2.5-15.7-1-23.3-2.9s-13.2-6.5-18.6-11.3c-13.8-12.2-25.7-26.4-35.4-42.1c-6.9-11-12.5-22.6-20.2-33.1s-17.9-19.9-30.6-23.9
		c-6.3-2-13-2.6-19.7-2.9c-14.7-0.7-29.5-0.6-44.2,0.5c-5.8,0.4-11.9,1-16.9,4S463.7,934,466,939.1"
                />
                <path
                  className="st1"
                  d="M1070.6,421.4l30,7.5c10.7,2.6,21.5,5.3,32.6,5.1c3.2,0,6.3-0.5,9.3-1.5c2-0.7,3.8-1.8,5.9-2.4s6.8-1,10.2-0.9
		l11.2,0.3c2.1,0,4.2,0.1,5.9,1.3c1.8,1.5,2.8,3.8,2.8,6.2c0.1,2.3-0.4,4.6-0.4,7c0.1,4.5,1.9,8.8,3.8,13
		c6.4,14.4,13.1,29.3,24.8,39.8c-29,5-58.5,5.6-87.7,1.9c-3.3-0.4-6.6-0.9-9.5-2.6s-4.6-3.7-6.5-5.9c-12-13.6-24.4-28-27.9-45.7
		c-0.9-4.9-1.2-9.9-3-14.5c-1-2.6-2.5-5.4-1.5-8.1"
                />
                <path
                  className="st1"
                  d="M1102.8,503.1l22.6,1.3c1.7,0.1,3.7,0.3,4.8,1.7c0.7,1,1,2.3,0.9,3.5c0,8.9-5.5,17.2-12.7,22.6
		c-4,3.1-9.1,5.9-10.2,10.9s2.4,10.1,6.7,13.1s9.4,4.6,13.7,7.6c6.8,4.9,10.7,13.1,12.3,21.4s1.2,16.8,0.8,25.2
		c0,2.6-0.1,5.4,1.5,7.5s2.6,2.3,3.3,3.8c1.9,4.1-3.6,7.6-4.8,11.9s0.9,6.8,2.2,10.1c5.3,12.9,2.6,27.6-0.6,41.2
		c-1.9,8.1-4.3,16.7-10.8,21.8c-4.2,3.3-9.5,4.7-14.7,5.4c-15.9,2.1-32.1-1.2-46-9.3c-1.2-0.6-2.3-1.5-3-2.6c-1.6-3.1,1.4-6.6,4-8.9
		c6.5-5.8,12-12.5,16.3-20c2.7-4.6,5-9.6,5.5-14.8c0.9-8.1-2.3-15.9-4.8-23.6c-2.6-7.9-4.7-15.9-6.2-24.1c-1.8-9.7-3-20-8.6-28.2
		s-16.8-13.9-26.1-19.8s-18.3-14.9-18-25.9c0.2-4,1.3-7.9,3.3-11.4c1.6-3,3.8-5.6,6.6-7.6c2.8-1.6,6-2.5,9.2-2.9
		c18-2.6,37.7-0.1,53.5-9.1"
                />
                <path
                  className="st1"
                  d="M1006.1,791.9c-11.6-3.1-20.3-12.7-22.1-24.6c-1.2-8.4,0.8-18.2-4.9-24.4c-2.5-2.7-6.1-4.1-9.6-5.1
		c-25.2-7.4-52.4,1.2-78.4-2.2c-2.6-0.2-5.2-0.9-7.5-2.1c-4.7-2.7-6.7-8.4-8.2-13.6s-2.9-11.4-1.8-17.1s5.6-11,11.4-11.4
		s9.2,2.9,13.3,5.6c7.4,4.9,15.5,8.9,23.9,11.8c15.8,1.1,31.3-5.1,42-16.8c2-2.3,3.9-4.8,4.4-7.8c1.3-6.5-4.1-12.3-9-16.8
		c-27.2-25-54.8-50.4-87.8-66.9c-2.7-1.3-5.4-2.7-7.1-5.2s-1.4-6.3,1.1-7.7c1.1-0.5,2.4-0.8,3.6-0.7c6.9-0.2,13.7,0.6,20.4,2.2
		c2,0.6,4.2,1.1,6.2,0.4c4.2-1.5,4.5-7.1,6.1-11.2c1.6-4,5.1-6.9,9.4-7.7c4.3-0.7,8.5,1.4,10.5,5.3c2.5,5.4-0.7,12.1,1.5,17.7
		s11.8,7.9,18.3,5.2s11.5-8.1,17.2-12.2c9.6-6.7,21.3-9.6,32.9-8.3c2.1,0.2,4.7,1,5.3,3.1l-30,18.4c-4.2,2.5-8.4,5.2-11.3,9.1
		c-4.8,6.5-4.9,15.2-4.9,23.3c0.1,2.4,0.1,4.9,1.2,7s4.2,4.5,7.2,5.2c11,2.5,20.5-7.3,29.6-14c11.6-8.7,21.8-15.9,35.9-12.9
		s31.5,17.2,33.7,31.4c0.7,4.8,0.3,9.8,1.8,14.4c2.8,8.8,11.9,14.4,21.1,16.1c4.8,1,9.9,1.1,14.4,3.1s8.4,6.7,7.2,11.5
		s-6.6,7.3-11.5,8c-22.7,3.1-43-16.3-65.9-17.2c-2.3-0.2-4.6,0.1-6.7,1.1c-3.9,2.1-5.1,7-5.9,11.4c-5.4,31.2-7.1,62.9-5.1,94.5"
                />
                <path
                  className="st1"
                  d="M1150.4,1050.9l-8.2-26c0,0-11.9-15.1-12.8-15.3c-3.6,0.4-7.1,1-10.6,1.8l-15.8,7.5l-10.1,5l-20.9-17.3
		l-7.3-22L1063,957l-10.6-51l-25.5,177.5c0,0,5.2-6.2,18-2.5s73.7,17.8,73.7,17.8l6.5,2.2c0,0-0.8,11,0,11.4s12.4,7.3,12.4,7.3
		s2.8,8.2,2.9,9.1s6.2,12.2,6.2,12.2l12.8,6.2l19.4-6.7l28.8-32.7l6-9.3l-14.1-10.8L1150.4,1050.9z"
                />
                <polygon
                  className="st1"
                  points="516.9,645.7 503.4,740.6 554.9,747.7 568.3,652.8 	"
                />
                <polygon
                  className="st1"
                  points="760.2,512 813.3,518.7 818,484.9 765.1,477.6 	"
                />
                <polygon
                  className="st1"
                  points="1453,705.4 1464.2,629.2 1420.5,650.5 1444.3,704.2 	"
                />
                <polygon
                  className="st1"
                  points="818,484.9 825.2,434.1 784.9,452.9 	"
                />
                <path
                  className="st1"
                  d="M441.9,405.1l4.6-36.7c-2-1-8.4-7.3-11.7-12s-3.9-12.2-3.2-20.5s0.1-13.1-1.3-15.9s-12-12.6-12-12.6l-16.3-2.3
		l0,0l-9.8,93.2l0,0c-2.6,24.9-5.5,53.3-8.3,81.8c3.5,0.9,5.9,2.8,10.2,10.1c13.3,15.9,15.4,18.2,30.4,19.2s28.7,20.9,46.6,21
		s28-17.6,28-17.6l13.3-98L441.9,405.1z"
                />
                <path
                  className="st1"
                  d="M676.9,413c-9,0-17.4,4.3-22.7,11.6h-0.5l-9.5,13.2l-3.5,8.4l-1.6,9.2l-2.6,22.3l26.6,4.1c0,0,1.4-4.8,5.1-5.8
		s8.6-0.7,11.1-2.1s11.9-7.6,16.7-13.6l0,0c5.5-5.1,8.7-12.3,8.7-19.8C704.6,425.2,692.2,412.9,676.9,413z"
                />
                <polygon
                  className="st1"
                  points="351.4,756.7 310.9,772.3 326.9,816.9 360.4,804.4 348.9,772.3 	"
                />
                <polygon
                  className="st1"
                  points="612,818.9 568.3,834.4 578.4,861.3 667.7,872.4 680,785.4 617.9,777 	"
                />
                <path
                  className="st1"
                  d="M365.6,398.3c-0.2-7.8-6-46.4,36.6-97l-123.9-18.7c0,0-9.8,57.5-7.1,69.1c-5.7,1.7-10.8,5.1-14.6,9.8
		c0,0-15.7-5.2-38-5.5s-28.2-0.6-31.2,2.1l-2.4,7.1l-4.4,7.6l2.8,28.2l1.8,16.8l30.9,34l-17.2,10.3c-5,2.9-3.5,9.4-3.5,9.4
		l102.8,107.2l54.6-54.9l27.2-5.1l3.9-38.6l-14.9-3.4C369,476.7,365.9,406,365.6,398.3z"
                />
                <path
                  className="st1"
                  d="M1192.8,98.8l13.8,2.5l0.9-5.9c3.3,0.6,26.6,10.6,31.5,12.7s4.9,24.5,4.9,24.5l21.8,3l3.1-30.2
		c0,0-33-3.1-38.3-4.9s-21.6-8.7-23.5-11.5s0.5-14.2,0.5-14.2h2.9l6.5-21.9l9.9,0.2l8.3-10.8c-1.9-1.4-3.9-2.7-6-3.8
		c-1.5-0.6,1.7-5.9,4.8-10.2s3.1-15.7,3.1-15.7h-24.2c0,0-0.7,16.2-1,18.8s-12.7,22.6-14.3,25.9s-1,8.6-1,8.6l-66.9-7.7l-8.2,57.6
		l68.8,9.4L1192.8,98.8z"
                />
                <path
                  className="st1"
                  d="M1252.6,273.5l32,3.5l-3,15.9l6.8-2.9l14.3-6.2l-3.3-8.8h7l10.2-40.2l-3.6-4.5c0,0,0.6-12.3,1.9-14.8
		s2.2-10.7,1.5-14.2s-2.8-4.8-3.4-10s-4.4-3-6.1-2.3s-5.8-2.7-10-4.7s-13.8,1-18,2l-16.3,4.1L1252.6,273.5z"
                />
                <path
                  className="st1"
                  d="M925.3,182.6l1.8-15.3l44.5,5.2l2-24.7l-38.5-5l2-17.5l-30-4.5c-8.5,26.7,8,60.4,8,60.4L925.3,182.6z"
                />
                <path
                  className="st1"
                  d="M1434.5,1027.8l-4.7,33l49.1,9.8c0,0,7-0.3,3,21.2l8.9,4.2l13.6-38.9l-19.7-21.9L1434.5,1027.8z"
                />
                <path
                  className="st3"
                  d="M1166.3,430.1c-2.7-0.6-5.4-1.1-8.1-1.4c-12.5-1.3-20.2,3.8-28.9,5.4s-27.4-6.9-31.7-8.2s-44.5-9.3-57-10.1
		s-10,7.4-3.9,11.6s25.3,22.7,31.2,28.7s6.9,15,21,31.1c3.2,3.7,6.2,7.2,8.8,10.4c4.1,0.2,8.5,0.5,12.9,1c44.6,4.2,58.9,5,83.3,2.3
		l-24.7-19.3L1166.3,430.1z"
                />
                <path
                  className="st1"
                  d="M402,305.1c-0.7,5.8-1.2,10-1.5,12.2c-0.7,5.9-4,38.4-8.3,81l0,0L402,305.1z"
                />
                <path
                  className="st4"
                  d="M804.1,1131.6c-34-12.5-46.2-25.6-72.2-61.9c-2.2-3.2-4.5-6.3-7-9.3c-4.4-7.1-16.4-14.2-25-17.1
		s-32.5-9-42.5-13s-20.3-14.8-24.5-24.8s-29.8-39.5-34.5-43.2s-15.3-25.8-34-41.3s-41.8-6.7-61.9-7.1s-70.1,9.9-98.5,21.9
		s-33.1,30.2-66.6,40.7s-54.5,2.5-63.3,0s-22.2-4.2-36.5-5.5s-27.2-8.2-27.2-8.2l-123-40.3c-2.9-0.7-5.9-0.8-8.8-0.2
		c0,0-1-3,3.8-3.8c9.7-1.5,10.5-6.2,10.5-6.2l72.7,19.7l64-30.2c-2.7-4-8.6-23-8.6-23l-37.6,17.5l-3.5-6.3l17.7-8.5l-2.7-5.9
		l22-11.1l-6.8-18.5l-125,55.8l-18-0.3l-71.2,3.8l0.2-14.5l18.8-2.3V881c0,0,14.5-0.2,15.5-6.5c1.7-10.2-13.3-14-14.8-14.7
		s2.3-3,0-4.2s-5.5,0-5.5,0l-41.5,20.7v54.2c0,0,6.3,0.8,29,1s21.8,5.5,36,6.8s48.5,5.7,51.8,6s106,31.5,107.7,32.2s13,16.8,13,16.8
		l44.8,5.7l2.6-11.7c0,0,21.9,3.6,56.1,4.7c40.5-0.5,50-11,54.5-13.2s46-31.3,63.3-38.3s92.5-18.7,111.2-18.2s27.3,13.7,42,29
		s49.3,75.5,71.5,84.7c31.2,13,39,12.3,54,19c6.5,2.9,24.3,28.5,24.3,28.5l26.3,30.4l19.9,12.5l38,14.3l24.4,3.7l10.5-1.1l3.2-3.3
		C852.7,1140,838.1,1144.1,804.1,1131.6z"
                />
                <polyline
                  className="st1"
                  points="1352.5,936.6 1383.1,941.2 1380.4,962.4 1349.1,957.7 1352.5,936.6 	"
                />
                <path className="st3" d="M1212,435.4l0.3,0.2L1212,435.4z" />
                <path
                  className="st3"
                  d="M1363.2,380l16-19.6c-3.1,2.7-5.8,5.9-8,9.4c-4,5.8-13.9,16.2-17.9,24.8l0,0L1363.2,380z"
                />
                <polygon
                  className="st3"
                  points="1256.5,480.1 1256.5,480.1 1256.5,480.1 	"
                />
                <path
                  className="st3"
                  d="M1256.5,480.1L1256.5,480.1l4.6,0.6L1256.5,480.1z"
                />
                <path
                  className="st3"
                  d="M1379.2,360.4l8.6-4.6C1384.7,356.8,1381.7,358.3,1379.2,360.4z"
                />
                <path
                  className="st3"
                  d="M1395.6,337.3c-1.6,2.1-3.1,4.4-4.4,6.7c-1.5,2.1-0.7,5-0.5,7.4l0.5-7.4L1395.6,337.3z"
                />
                <path
                  className="st3"
                  d="M1353.2,407.9c0.4,1.1,1.1,2.1,1.9,3l-2.1-3.5c0,0.1,0,0.2,0.1,0.3C1353.1,407.8,1353.1,407.8,1353.2,407.9z"
                />
                <path className="st3" d="M1352.7,406.6L1352.7,406.6z" />
                <path
                  className="st3"
                  d="M1201.4,435c1.8-0.2,3.7-0.3,5.5-0.3C1205.1,434.7,1203.2,434.8,1201.4,435z"
                />
                <path
                  className="st3"
                  d="M1225.7,455.8c0.2,0.2,0.3,0.4,0.4,0.6C1226,456.2,1225.9,456,1225.7,455.8z"
                />
                <path
                  className="st3"
                  d="M1353.2,407.9c-0.1-0.1-0.1-0.1-0.1-0.2S1353.1,407.8,1353.2,407.9z"
                />
                <path className="st3" d="M1212.5,435.7l0.4,0.3L1212.5,435.7z" />
                <path className="st3" d="M1211.4,435.1L1211.4,435.1z" />
                <path className="st3" d="M1352.2,405.1" />
                <path
                  className="st3"
                  d="M1214.2,437.2c0.2,0.2,0.3,0.4,0.5,0.5S1214.4,437.4,1214.2,437.2z"
                />
                <path className="st3" d="M1231.7,462.8l0.6,0.5L1231.7,462.8z" />
                <path className="st3" d="M1227.3,458l0.4,0.6L1227.3,458z" />
                <path className="st3" d="M1230.7,461.9l0.6,0.5L1230.7,461.9z" />
                <path className="st3" d="M1229,460.1l0.5,0.5L1229,460.1z" />
                <path className="st3" d="M1226.5,456.9l0.4,0.6L1226.5,456.9z" />
                <path className="st3" d="M1235.3,465.5l1.3,1L1235.3,465.5z" />
                <path className="st3" d="M1214.8,437.8l0.5,0.7L1214.8,437.8z" />
                <path className="st3" d="M1213.1,436.2l0.4,0.3L1213.1,436.2z" />
                <path className="st3" d="M1213.7,436.6l0.4,0.5L1213.7,436.6z" />
                <path className="st3" d="M1238.1,467.8l1,0.9L1238.1,467.8z" />
                <path
                  className="st3"
                  d="M1239.6,469.2c0.2,0.1,0.3,0.2,0.4,0.4C1239.9,469.4,1239.8,469.3,1239.6,469.2z"
                />
                <path className="st3" d="M1228.1,459l0.5,0.6L1228.1,459z" />
                <path className="st3" d="M1221.5,448.9l0.3,0.4L1221.5,448.9z" />
                <path
                  className="st3"
                  d="M1236.8,466.7c0.4,0.2,0.7,0.5,1,0.8C1237.5,467.2,1237.2,466.9,1236.8,466.7z"
                />
                <path
                  className="st3"
                  d="M1230.4,461.5l-0.6-0.5L1230.4,461.5z"
                />
                <path className="st3" d="M1221.1,448.1L1221.1,448.1z" />
                <path
                  className="st3"
                  d="M1224.2,453.5c0.2,0.2,0.3,0.4,0.4,0.6C1224.5,453.9,1224.4,453.7,1224.2,453.5z"
                />
                <path
                  className="st3"
                  d="M1235,465.3c-0.4-0.4-0.9-0.7-1.4-1l-1-0.8l1,0.8C1234.1,464.6,1234.6,464.9,1235,465.3z"
                />
                <path className="st3" d="M1181.5,434.3l1.1,0.2L1181.5,434.3z" />
                <path className="st3" d="M1222.8,451.2l0.4,0.5L1222.8,451.2z" />
                <path className="st3" d="M1223.5,452.3l0.4,0.6L1223.5,452.3z" />
                <path
                  className="st3"
                  d="M1793.2,108.6c6.9-7.6,12.3-16.5,15.8-26.2L1793.2,108.6z"
                />
                <path className="st3" d="M1183.4,434.8l0.9,0.2L1183.4,434.8z" />
                <path className="st3" d="M1179.4,433.6l1.2,0.4L1179.4,433.6z" />
                <path className="st3" d="M1190.4,436.1L1190.4,436.1z" />
                <path
                  className="st3"
                  d="M1352.7,396c0.1,0,0.1,0,0.1-0.1C1352.8,396,1352.8,396,1352.7,396z"
                />
                <path
                  className="st3"
                  d="M1225,454.7c0.1,0.2,0.2,0.4,0.4,0.5C1225.2,455.1,1225.1,454.9,1225,454.7z"
                />
                <path
                  className="st3"
                  d="M1351.9,398.8c0.1-0.1,0.1-0.2,0.1-0.3C1352,398.6,1352,398.7,1351.9,398.8z"
                />
                <path className="st3" d="M1186.7,435.6l0.8,0.2L1186.7,435.6z" />
                <path className="st3" d="M1188.1,435.9L1188.1,435.9z" />
                <path className="st3" d="M1351.8,402.1L1351.8,402.1z" />
                <path className="st3" d="M1222.2,450l0.3,0.5L1222.2,450z" />
                <path className="st3" d="M1352.3,397.4L1352.3,397.4z" />
                <path
                  className="st3"
                  d="M1352.7,396c-0.1,0.5-0.3,0.9-0.4,1.3l0,0l-0.3,1.1c0,0.1,0,0.2-0.1,0.3c0,0.4-0.1,0.8-0.1,1.2v2.1
		c0.1,0.4,0.1,0.8,0.1,1.2c0.1,0.1,0.1,0.3,0.1,0.4c0.1,0.5,0.1,0.9,0.2,1.4l0,0c0.2,0.5,0.3,0.9,0.4,1.4h0.1c0,0.2,0.1,0.5,0.2,0.7
		l0.4-12.7c-0.2,0.4-0.3,0.9-0.5,1.3c0.1,0,0.1,0.1,0.1,0.2C1352.9,396,1352.8,396,1352.7,396z"
                />
                <path
                  className="st3"
                  d="M1352,403.7c0-0.1,0-0.3-0.1-0.4C1352,403.4,1352,403.6,1352,403.7z"
                />
                <path className="st3" d="M1185.1,435.2l0.9,0.3L1185.1,435.2z" />
                <path
                  className="st1"
                  d="M1811.2,73.9c2-11.6,2-9-12-27s-11-15.3-9.8-29.6c0.3-3.7,0-7.4-1-11h-60.9l-3.6,24.5c0,0,0.5,5,6,14
		s5,17.5,0,24s-13,7.5-12.5,17.5s-1.5,18-4.5,23s-11,3-18,6s-22,23-4.5,46.3s15.5,27.2,15.5,32.7s-10.5,6-11,9.5s-6.5,9.5-15,9.5
		s-16.5,21-15,28s8.5,20,3.5,30.5s-4.5,24.5-4.5,24.5s-8.7,20.2-8.4,28c0.7,15.9-26,15.9-26,15.9l-3.5,13.4l6.9,0.7
		c5.6,0.3,12.2,1.1,4.6,11.5s5.9,10.3,10,12.2s12.1,10.1,17.5,8.1s21-6,10.6-21.6c-7.7-11.4-11.8-4.1-6.7-18.6s7.4-8.5,5.6-21.6
		s0.3-23.9,14.8-51s9.2-22.4,5.6-29.4s-5.3-16.9,0-24.1s19.6-27.5,24.6-22.5s7,14.3,22.4,15.3s19.3,18.7,27,22.7s10.3,6,15.6-2.7
		s-13.3-13-14.3-18s6-23.3-4-26.7s-39.7-14.3-41.7-30.6s-2.6-29.7,9.7-28c12.3,1.7,25,13.3,37.3,12.3s10-1.9,11-12.5
		s1.4-10.2,10.7-20.5l15.8-26.2C1810,79.6,1810.7,76.8,1811.2,73.9z"
                />
                <path
                  className="st1"
                  d="M1789.4,17.3c-1.2,14.3-4.2,11.6,9.8,29.6s14,15.4,12,27c-0.5,2.9-1.2,5.7-2.2,8.5h17.2l28.7-76.1h-66.5
		C1789.4,9.9,1789.7,13.6,1789.4,17.3z"
                />
                <path
                  className="st1"
                  d="M1221.1,448.1c0.2,0.3,0.3,0.5,0.4,0.8C1221.4,448.6,1221.3,448.4,1221.1,448.1z"
                />
                <path
                  className="st1"
                  d="M1221.8,449.3c0.1,0.3,0.2,0.5,0.4,0.7C1222,449.8,1221.9,449.6,1221.8,449.3z"
                />
                <path className="st1" d="M1222.5,450.5l0.3,0.7L1222.5,450.5z" />
                <path className="st1" d="M1223.2,451.7l0.3,0.6L1223.2,451.7z" />
                <path className="st1" d="M1184.3,435l0.8,0.2L1184.3,435z" />
                <path
                  className="st1"
                  d="M1226.7,456.9l5.2,4.7l13.4-95l-19.5-2.7l-10.5,74.6l0,0c2.1,3,4,6.2,5.7,9.5L1226.7,456.9z"
                />
                <path className="st1" d="M1186,435.5L1186,435.5z" />
                <path className="st1" d="M1182.6,434.5l0.8,0.3L1182.6,434.5z" />
                <path className="st1" d="M1180.6,434l0.9,0.3L1180.6,434z" />
                <path
                  className="st1"
                  d="M1178.3,433.3L1178.3,433.3l1.1,0.3L1178.3,433.3z"
                />
                <path className="st1" d="M1187.5,435.8L1187.5,435.8z" />
                <path className="st1" d="M1188.9,436L1188.9,436z" />
                <path className="st1" d="M1213.5,436.5L1213.5,436.5z" />
                <path className="st1" d="M1214.7,437.7L1214.7,437.7z" />
                <path className="st1" d="M1214.1,437.1L1214.1,437.1z" />
                <path className="st1" d="M1211.6,435.2l0.4,0.2L1211.6,435.2z" />
                <path
                  className="st1"
                  d="M1212.9,436c0.1,0,0.1,0.1,0.2,0.2S1213,436,1212.9,436z"
                />
                <path className="st1" d="M1212.3,435.6L1212.3,435.6z" />
                <path className="st1" d="M1351.8,401.7L1351.8,401.7z" />
                <path className="st1" d="M1265.6,480.7L1265.6,480.7z" />
                <path
                  className="st1"
                  d="M1351.9,403.3c0-0.4,0-0.8-0.1-1.2C1351.9,402.5,1351.9,402.9,1351.9,403.3z"
                />
                <path
                  className="st1"
                  d="M1351.8,400c0-0.4,0.1-0.8,0.1-1.2S1351.8,399.6,1351.8,400z"
                />
                <path className="st1" d="M1352,398.5l0.3-1.1L1352,398.5z" />
                <path className="st1" d="M1353,407.4L1353,407.4z" />
                <path
                  className="st1"
                  d="M1353.1,407.7c-0.1-0.1-0.1-0.2-0.1-0.3h-0.1c-0.1-0.2-0.2-0.5-0.2-0.7
		C1352.8,407.1,1352.9,407.4,1353.1,407.7z"
                />
                <path
                  className="st1"
                  d="M1352.6,406.5c-0.1-0.5-0.2-0.9-0.4-1.4C1352.4,405.6,1352.5,406,1352.6,406.5z"
                />
                <path
                  className="st1"
                  d="M1352.2,405.1c-0.1-0.5-0.1-0.9-0.2-1.4S1352.1,404.6,1352.2,405.1z"
                />
                <path
                  className="st1"
                  d="M1197.4,435.5c-2.3,0.3-4.7,0.5-7,0.6l0,0C1192.7,436,1195.1,435.8,1197.4,435.5z"
                />
                <path
                  className="st1"
                  d="M1352.3,397.3c0.1-0.4,0.3-0.8,0.4-1.3S1352.4,396.9,1352.3,397.3z"
                />
                <path
                  className="st1"
                  d="M1211.4,435.1h-0.6c-1.3-0.2-2.6-0.3-3.9-0.3c1.3,0,2.6,0.1,3.9,0.3H1211.4z"
                />
                <path
                  className="st1"
                  d="M1480.9,259.3l-20.1-16.3l-31,39l-9.3,0.8l-10,9.9l-12.4,12.3l-2.5,32.3l0,0c1.3-1.5,2.4-2.1,3.2-0.6
		c1.8,3,6.4,11.6,10,9s-5.4-9,3.8-12.8s9.2,11.6,17.2,10.1s10.2-14.4,14.8-10.7c0.8,0.6,1.3,1.7,1.1,2.7l44.9-63
		C1481.4,264.7,1480.9,259.3,1480.9,259.3z"
                />
                <path
                  className="st1"
                  d="M1626.4,313.3l-0.9-8.3l-0.6-8.7l-3.3-8.9l-9.3-1.4l-10.4-4.7l-3-0.7l-3.4,6l-4.1,9.2l-9.1,0.5l-13.4,4
		l-11.8,4.7c0,0-5.2,8.8-10.2,8.3s-46.5-33.5-56-41l-0.3-0.3l-44.9,63c-0.2,4.4-6.3,11.2,0.9,14.3c9,3.7,12.1-3.3,15.6-0.8
		s6.7,9.8,17.9,10.6s9.8,4,10.8,12.9s4.3,22.2,16.9,28.5s16.3,8.5,24.5,6.5s8.2-14.6,4.9-17.9s-19.2,8.1-24.8,4.5
		s6.1-50.6,18.9-45.1c6.1,2.5-0.8,20.2,2.3,21.3c7.4,3.4,20.2-21.8,29.4-19.5s11.5,2.7,15.3-0.5s4.6-13.5,4.6-13.5
		c2.7-5.5,10-15.2,16.5-4.7s8.3,19.1,26.3,22l4-16.8L1626.4,313.3z"
                />
                <path
                  className="st1"
                  d="M1353.3,394.6L1353.3,394.6c-0.2,0.4-0.3,0.9-0.5,1.3S1353.1,395,1353.3,394.6z"
                />
                <path
                  className="st5"
                  d="M1261.1,480.7l-4.6-0.6c2.2,0.4,4.5,0.6,6.7,0.6h4.2c21.2-1.2,34.5-4.5,90-3c9.5,0.3,12-10.8,13.8-20.4
		s-0.5-9.1-6.4-19.4s3.8-16.9,7-16.7c7.6,0.5,4.3,11.4,9.9,13.9s8.4,3.8,13.5-6.3s9.8-16.1,15.6-24.2s4.6-11.1,2.3-13.4
		s-12.2,7.1-17.1,8.6s-20.2,4.8-25.8,10.6s-13.6,5.4-17-2.4c-0.1-0.1-0.1-0.1-0.1-0.2c-0.2-0.3-0.3-0.7-0.4-1.1h-0.1
		c-0.1-0.5-0.2-0.9-0.4-1.4l0,0c-0.1-0.5-0.1-0.9-0.2-1.4c0-0.1,0-0.3-0.1-0.4c0-0.4,0-0.8-0.1-1.2V400c0-0.4,0.1-0.8,0.1-1.2
		c0.1-0.1,0.1-0.2,0.1-0.3l0.3-1.1l0,0c0.1-0.4,0.3-0.8,0.4-1.3c0.1,0,0.1,0,0.1-0.1c0.2-0.4,0.3-0.9,0.5-1.3
		c-9.2-7.7-12.9-7.8-21.7-9.5s-5.1-26.9-5.1-26.9l-19.8-6.8c0,0-1.7,2.4-4.1,10.5s3.7,11.4,3.7,11.4l10.3,6.7l-16.1,23.2l5.5,3.7
		l-5.5,10.8l-38.5,19.7l-5.5,42.6l0,0L1261.1,480.7z M1262.4,480.7L1262.4,480.7z"
                />
                <path
                  className="st1"
                  d="M1230.7,461.9l-0.3-0.4L1230.7,461.9z"
                />
                <path className="st1" d="M1226.9,457.5l0.4,0.5L1226.9,457.5z" />
                <path
                  className="st1"
                  d="M1390.7,351.4L1390.7,351.4l-2.9,4.4l0,0C1390.9,355.7,1391,353.8,1390.7,351.4z"
                />
                <path className="st1" d="M1231.3,462.4l0.4,0.4L1231.3,462.4z" />
                <path className="st1" d="M1229.5,460.6l0.3,0.4L1229.5,460.6z" />
                <path
                  className="st1"
                  d="M1227.7,458.6c0.2,0.1,0.3,0.3,0.4,0.4S1227.9,458.7,1227.7,458.6z"
                />
                <path
                  className="st1"
                  d="M1224.6,454.1c0.1,0.2,0.2,0.4,0.4,0.6C1224.8,454.5,1224.7,454.3,1224.6,454.1z"
                />
                <path className="st1" d="M1225.4,455.2l0.3,0.6L1225.4,455.2z" />
                <path className="st1" d="M1226.1,456.4l0.4,0.5L1226.1,456.4z" />
                <path className="st1" d="M1228.6,459.6l0.4,0.5L1228.6,459.6z" />
                <path className="st1" d="M1232.3,463.3l0.3,0.2L1232.3,463.3z" />
                <path
                  className="st1"
                  d="M1239.1,468.7c0.2,0.2,0.4,0.3,0.5,0.5S1239.3,468.9,1239.1,468.7z"
                />
                <path className="st1" d="M1223.9,452.9l0.3,0.6L1223.9,452.9z" />
                <path
                  className="st1"
                  d="M1240,469.6c4.7,4.5,8.4,8.8,16.5,10.5C1248.4,478.4,1244.7,474.1,1240,469.6z"
                />
                <path className="st1" d="M1235,465.3l0.3,0.2L1235,465.3z" />
                <path
                  className="st1"
                  d="M1236.6,466.5c0.1,0,0.2,0.1,0.2,0.2C1236.8,466.6,1236.7,466.5,1236.6,466.5z"
                />
                <path className="st1" d="M1237.8,467.5l0.3,0.3L1237.8,467.5z" />
                <path
                  className="st1"
                  d="M1763.4,312.9c-5.7,10.3-2,13.3-14.4,11s-5-14.4-8-18.9s-16.6-2.1-21.9-10.8s-13.7-13-17.4-15.3
		c-1.7-1.1-6.1-5.3-10.4-9.5c-0.7,1.2-1.3,2.5-2,3.9c-14.5,27.1-16.5,37.8-14.8,51s-0.5,7.1-5.6,21.6s-1,7.2,6.7,18.6
		c10.4,15.6-5.2,19.6-10.6,21.6s-13.4-6.2-17.5-8.1s-17.6-1.9-10-12.2s1-11.2-4.6-11.5l-6.9-0.7l-4.7,18.1l-2.1,22.1l3.2,11.6
		l49.8-6.6l32.7-8.2l36.5-21.8l56.4-28.2l9-3.2l2.2-60.2C1779.5,283.1,1768.5,303.4,1763.4,312.9z"
                />
                <path
                  className="st1"
                  d="M1817.8,153l-25.6-10.7l21.7-27.4l-20.7-6.3c-9.3,10.3-9.7,10-10.7,20.5c-1,10.5,1.4,11.5-11,12.5
		s-25-10.7-37.3-12.3c-12.3-1.6-11.7,11.6-9.7,28s31.7,27.3,41.7,30.6s3,21.7,4,26.7s19.7,9.3,14.3,18s-8,6.7-15.6,2.7
		s-11.7-21.7-27-22.7s-17.4-10.3-22.4-15.3s-19.4,15.2-24.6,22.5s-3.6,17.1,0,24.1s8.3,2.7-3.6,25.5c4.3,4.2,8.7,8.4,10.4,9.5
		c3.7,2.3,12.2,6.6,17.4,15.3s18.9,6.2,21.9,10.8s-4.3,16.6,8,18.9s8.7-0.7,14.4-11s16.1-29.8,45.6-35.7l2.8-72.9L1817.8,153z"
                />
                <path className="st1" d="M1354.6,410.3l-0.7-1L1354.6,410.3z" />
                <path
                  className="st1"
                  d="M1355.1,410.9L1355.1,410.9l-0.3-0.3L1355.1,410.9z"
                />
                <path
                  className="st1"
                  d="M1354.8,410.5l-0.2-0.2L1354.8,410.5z"
                />
                <path className="st1" d="M1353.9,409.3L1353.9,409.3z" />
                <path
                  className="st1"
                  d="M1353.8,409.1c-0.2-0.4-0.4-0.8-0.6-1.2C1353.4,408.3,1353.6,408.7,1353.8,409.1z"
                />
                <path
                  className="st1"
                  d="M1599.4,331.6c-6.5-10.5-13.8-0.8-16.5,4.7c0,0-0.7,10.2-4.6,13.5s-6.1,2.7-15.3,0.5
		c-4.6-1.2-10,4.5-15.3,10.1c13.4,3.2,36.1,9.2,38,13.3c2.7,5.8-0.1,5.6,3.6,12.2c0,0,6.6-1,13.1-1.6s4.5-15.7,7.8-20.2
		s12.5,2.3,12.5,2.3l3-12.8C1607.7,350.7,1605.2,341,1599.4,331.6z"
                />
                <path
                  className="st1"
                  d="M1013.4,555.2c2.1-8.7-0.7-11,0-17.7s3-2,10.3-7.2c3.7-2.6,5.7-14.1,6.8-24.6l-8.7,2.2l-31.9,12.6
		c0,0-6.5-19-3-24c8.2-11.7,3.7-11.6,4.2-23.2c0.3-17.3-7-51.5-9.5-60.6c-1.6-6.5-2.5-13.1-2.7-19.8l-23-3.4l-21.5,4.3l-31.6,10.6
		c0,0,27.5,19.6,36.6,23.7s10.2,6.5,9.7,10.5s-2.8,24.5-2.8,24.5h-6.4l-1.2,9.7l-45.3-5l-4.5,28l17.5,1.9l-5,37.3
		c-7,1.2-16.7,11.8-16.7,11.8l3.6,14l-0.9,9.3l-7.5,2.2c0,0-5.6-0.2-13.5,4.2s0,9.8,0,9.8c4.1-1.5,15.4-3,21.5,0s6.9,3.8,11-6
		s10-14.9,17.1-12.9s10,9.6,9.2,20.9s3.9,16.2,11.5,12.1s29.2-22.9,34.6-24.4s18.7-3.8,19.3,4.5s-14,16.7-20.4,20.2
		s-15.6,8.8-16.6,18.6s-1.8,19,3.1,22.5s10.5,2,21.5-3.5s16.6-9.4,20.4-13.9s5.7-8.3,14.4-8.3C1004,587.4,1011.7,562.5,1013.4,555.2
		z"
                />
                <path
                  className="st5"
                  d="M1107.8,646.5c-6.4-7.5-17.9-11.8-12.3-18.1s19.5-6.3,27.9-14.4s-6.1-14.3-15.8-15.1s-24.6-7.3-24.6-15.4
		s6.9-9.2,6.7-16.5s-17.2-6.7-26.6-12.7s-21-9.3-21.5-20.4s-2.8-20.5,2.5-20.5s8-0.5,27.9,5.3s34.3,8.3,37.1,2.5s-1.4-10-15.5-26.2
		l-2.7,0.3l-7.1,2.1l-23.9,0.7l-29.4,7.6c-1.1,10.5-3.1,22-6.8,24.6c-7.3,5.2-9.6,0.4-10.3,7.2s2.1,9,0,17.7s-9.4,32.2-0.4,60.9
		l3.3,0.2c11.5,1.3,30.4,4.1,39.1,20.9c6.4,11.4-1,21.2,6.4,28.5s23,15.4,30.7,15.7s17.1,7.2,30.2-4
		C1135.4,670.3,1114.2,653.9,1107.8,646.5z"
                />
                <path
                  className="st1"
                  d="M1589.3,385.9c-3.7-6.6-0.9-6.4-3.6-12.2c-1.9-4.1-24.6-10.1-38-13.3c-5.3,5.6-10.4,11.1-14.1,9.4
		s3.8-18.8-2.3-21.3c-12.8-5.5-24.6,41.6-18.9,45.1s21.4-7.8,24.8-4.5s3.3,15.9-4.9,17.9s-12-0.2-24.5-6.5s-15.9-19.7-16.9-28.5
		s0.5-12.1-10.8-12.9s-14.3-8.1-17.9-10.6s-6.6,4.5-15.6,0.8s2.6-13.4-2-17s-6.9,9.1-14.8,10.7s-8-13.9-17.2-10.1
		s-0.2,10.3-3.8,12.8s-8.2-6-10-9c-0.8-1.5-1.9-0.9-3.2,0.6l-4.4,6.7l-0.5,7.4c0.3,2.4,0.2,4.3-2.9,4.4l0,0l-8.6,4.6l0,0l-16,19.6
		l-9.9,14.6l-0.4,12.7h0.1l2,3.4c4.2,4.5,11.4,3.4,15.2-0.5c5.6-5.8,21-9.1,25.8-10.6s14.8-10.8,17.1-8.6s3.6,5.3-2.3,13.4
		s-10.4,14.1-15.6,24.2c-0.3,0.6-0.6,1.2-0.9,1.8c6,8.8,13.9,22.6,13.1,33c-0.4,3.6,5.3,1.3,11,4s2.3,8.4-1.4,23l-1,3.6l4.4,0.5
		c0-0.5,0-0.9,0.1-1.4l43.1,1.6l48.3-18.2l48.2-43.7c0,0,23.9-29.5,29.2-34.1S1589.3,385.9,1589.3,385.9z"
                />
                <path
                  className="st1"
                  d="M1418.4,467.5c-5.7-2.7-11.4-0.4-11-4c0.8-10.4-7.1-24.2-13.1-33c-4.5,8.1-7.3,6.9-12.6,4.5
		s-2.3-13.4-9.9-13.9c-3.2-0.2-12.9,6.3-7,16.7s8.2,9.8,6.4,19.4s-4.3,20.7-13.8,20.4c-55.5-1.5-68.8,1.8-90,3h-4.2
		c-2.2,0-4.5-0.2-6.7-0.6l0,0c-8.1-1.7-11.8-6-16.5-10.5c-0.1-0.2-0.2-0.3-0.4-0.4c-0.1-0.2-0.3-0.3-0.5-0.5l-1-0.9l-0.3-0.3
		c-0.3-0.3-0.6-0.6-1-0.8c0-0.1-0.1-0.2-0.2-0.2l-1.3-1l-0.3-0.2c-0.4-0.4-0.9-0.7-1.4-1l-1-0.8l-0.3-0.2l-0.6-0.5l-0.4-0.4
		l-0.6-0.5l-0.3-0.4l-0.6-0.5l-0.3-0.4l-0.5-0.5l-0.4-0.5l-0.5-0.6c-0.1-0.1-0.2-0.3-0.4-0.4l-0.4-0.6l-0.4-0.5l-0.4-0.6l-0.4-0.5
		c-0.1-0.2-0.2-0.4-0.4-0.6l-0.3-0.6c-0.2-0.1-0.3-0.3-0.4-0.5c-0.2-0.2-0.3-0.4-0.4-0.6s-0.2-0.4-0.4-0.6l-0.3-0.6l-0.4-0.6
		l-0.3-0.6l-0.4-0.5l-0.3-0.7l-0.3-0.5c-0.2-0.2-0.3-0.4-0.4-0.7l-0.3-0.4c-0.1-0.3-0.2-0.5-0.4-0.8h-0.1c-1.7-3.3-3.6-6.5-5.7-9.5
		l-0.5-0.7h-0.1c-0.2-0.1-0.3-0.3-0.5-0.5h-0.1l-0.4-0.5h-0.2l-0.4-0.3c-0.1-0.1-0.1-0.2-0.2-0.2l-0.4-0.3h-0.2l-0.3-0.2l-0.4-0.2
		h-0.8c-1.3-0.2-2.6-0.3-3.9-0.3c-1.8,0-3.7,0.1-5.5,0.3l-4,0.5c-2.3,0.3-4.7,0.5-7,0.6h-2.9l-0.8-0.2h-0.7l-0.9-0.3l-0.8-0.2
		l-0.9-0.2l-0.8-0.3l-1.1-0.2l-0.9-0.3l-1.2-0.4l-1.1-0.3c0,0.6,0.1,1.1,0.1,1.7c0.5,10.8-1.8,21.2,6.9,36.6
		c6.9,10.4,15.6,19.6,25.5,27.2l21-2.8c55.8-7.7,117.2-7,143.2-6.5c9.2,0.1,19.3,1.7,30.5,3.2l0,0l10.5,1.4l1-3.6
		C1420.7,475.9,1424,470.2,1418.4,467.5z"
                />
                <path
                  className="st1"
                  d="M1696.3,610.3l88,12.5l-7.8,45.1l-44-7.2l3-19.9l-14.2-1.7c0,0-3.5-6.2-7.8-7s-20-2.9-20-2.9L1696.3,610.3z"
                />
                <path
                  className="st4"
                  d="M304.3,982.8l2.2,0.2h10.2l4.1-0.5c5.5-0.7,10.8-2.1,16-4c10.4-3.9,20.2-9.9,29.7-16.4
		c4.8-3.2,9.5-6.6,14.3-10l7.3-5.1l3.6-2.5l0.5-0.2l0.2-0.2l0.5-0.3l0.9-0.5l1.9-1.2l1.9-1.1l2.1-1l4.3-2.1l4.2-1.7l4.2-1.7
		c2.9-0.9,5.7-2,8.6-2.8l4.3-1.3l4.3-1.1c11.5-2.9,23.2-5.1,34.8-6.9s23.3-3.3,35-4.6l17.4-2c5.8-0.7,11.7-1.4,17.8-1.7
		c3.1-0.2,6.2-0.2,9.3,0.1c3.3,0.3,6.5,0.9,9.6,2c3.1,1,6.1,2.4,8.8,4.2c2.6,1.7,5.2,3.7,7.5,5.8c4.5,4.1,8.6,8.6,12.4,13.3
		c3.8,4.6,7.4,9.3,10.9,14.1l10.2,14.4l4.9,7.3l2.5,3.6l1.2,1.8l1.2,1.8l5.1,7.1l2.5,3.6l2.7,3.4c1.7,2.2,3.4,4.5,5.3,6.7l5.6,6.4
		c7.8,8.4,16.2,16.1,25.8,21.7l1.8,1.1l1.9,0.9l3.7,1.8c2.5,1.1,5.1,2.1,7.8,2.9c2.6,0.9,5.4,1.6,8.1,2.3l8.5,1.7l4.4,1l4.4,1
		l2.2,0.6l1.1,0.3l1.1,0.3l2.2,0.8l1.1,0.3l0.6,0.2h0.3l0.4,0.2l2,0.9l2.3,1.2l2.2,1.3l1.9,1.4c2.5,2,4.9,4.1,7,6.5
		c4,4.5,7.7,9.3,11,14.4l9.6,14.8c3.1,4.9,6.3,9.7,9.8,14.2c3.3,4.5,7,8.7,11.1,12.6c4,3.7,8.5,6.8,13.4,9.2l0.9,0.4h0.4l0.5,0.2
		l2.1,0.9l4,1.7l4.1,1.6l4,1.6c10.7,4.1,21.7,7.7,32.8,9.4c5.4,0.9,10.9,1,16.3,0.3c5.4-0.6,10.7-2.3,16.5-4l4.4-1.2l2.2-0.5
		l1.1-0.3l0.9-0.2l2.1-0.6l1.1-0.2l0.9-0.4l1.7-0.7l1.8-0.7c5.1-2.4,9.9-5.3,14.5-8.5c4.7-3.3,9.3-6.8,13.8-10.4s9.2-7.4,14-10.9
		l3.8-2.6c0.6-0.5,1.3-0.9,2-1.3l2.2-1.2l2.3-1l0.4-0.2h0.3l0.5-0.2h1.4c1.8-0.4,3.6-0.6,5.4-0.6c3.4,0.2,6.7,0.9,9.8,2.1
		c2.9,1.1,5.7,2.4,8.4,4c2.7,1.4,5.2,3,7.7,4.4c1.2,0.8,2.4,1.5,3.7,2.1l1.7,0.8l0.8,0.3l0.5,0.3h0.3l0.5,0.2l0.5,0.2h0.2l0.4,0.3
		l1.5,0.9l0.6,0.5l0.5,0.5l1,1c0.6,0.6,1.2,1.3,1.7,2l1.4,2.1c1.7,2.7,2.9,5.4,4.3,7.7c1.2,2.1,2.7,4,4.6,5.6l0.7,0.5l0.3,0.2h0.1
		c0.3,0.1-0.1,0,0.1,0l0.5,0.3h0.9l0.3-0.2c0.7-0.7,1.2-1.5,1.5-2.4c0.5-1.2,0.9-2.4,1.3-3.6c0.7-2.7,1.2-5.4,1.6-8.2l0.6-4.3v-0.8
		c0,0,0.1-0.7,0.1-0.5l0.2-1.1c0.2-0.9,0.5-1.8,0.9-2.7c1.4-3.3,3.5-6.1,6.3-8.3c5-4.3,10.6-7,15.8-9.6l1.9-1l0.9-0.5h0.3
		c-0.2,0,0.4-0.3,0.5-0.3l0.5-0.2h0.6l1-0.3h1.6c1-0.1,2-0.1,3,0c3.3,0.4,6.6,1.4,9.6,2.9c2.7,1.4,5.4,2.9,8,4.5l7.5,4.9l7.2,5
		l3.6,2.5l1.7,1.1l0.9,0.6l0.5,0.2h0.1l0.2,0.2l2,1l1.6,0.8c1,0.4,2,0.7,3,0.9c0.9,0,1.8-0.1,2.6-0.4c1.1-0.5,2.2-1.2,3.2-1.9
		c2.6-1.7,5.4-3.1,8.2-4.4l0.6-0.3h0.2l0.5-0.2l1.1-0.3l1-0.4l1.4-0.3l2.7-0.4h2.5c3.2,0,6.5,0.4,9.6,1.2c3,0.6,6,1.5,8.8,2.7
		c5.6,2.2,11.1,4.8,16.3,7.8l1,0.5l0.3,0.2c-0.1-0.1,0.3,0.1,0.3,0.2l0.5,0.3l0.5,0.3l0.6,0.4l0.7,0.5l0.5,0.5
		c1.5,1.4,2.7,3.1,3.4,5c0.6,1.6,1,3.4,1.2,5.1c0.2,1.5,0.4,2.9,0.6,4.1c0.4,2.3,1.4,4.4,3,6.1c0.8,0.9,1.6,1.8,2.6,2.5l3.3,2.1
		l1.8,0.9l0.4,0.2h0.2c0,0,0.4,0.2,0.1,0l1,0.4l1,0.4l0.7,0.2l0.7,0.2h0.9c2.4,0.2,4.7,0,7-0.8c5-2,9.6-4.9,13.5-8.6
		c4.2-3.8,8.1-7.9,11.7-12.3c3.6-4.5,7-9.1,10.5-13.8l1.3-1.8l1.4-1.7l1.3-1.8l1-1.5c0.5-0.8,0.9-1.7,1.1-2.6c0-0.2,0-0.2,0.1,0.2
		l0.3,0.3h0.5l-1.6-0.6l-45.4-33.5l0.5,0.3l-3.3-1.7l-1.7-1l-1.6-1l-1.6-1.1l-1.5-1.2l-3-2.7l-1.3-1.5l-1.3-1.6
		c-0.4-0.5-0.8-1.1-1.1-1.7c-0.4-0.5-0.7-1.1-1.1-1.7c-0.6-1.2-1.2-2.4-1.6-3.7c-0.5-1.2-0.9-2.4-1.2-3.7c-1.4-4.9-1.9-9.6-3.1-13.8
		c-0.3-1-0.7-2-1.1-3l-0.6-1.4l-0.7-1.4l-0.8-1.3l-0.9-1.2l-1-1.2l-1.1-1.1l-0.3-0.4v-0.2c-0.9-1.4-1.9-2.7-3.1-3.8l-0.3-0.3
		l-0.4-0.3l-0.7-0.3c-0.2-0.2-0.4-0.1-0.6-0.2h-0.9c-1.5,0.1-3.1,0.4-4.5,0.9c-1.8,0.5-3.5,1.2-5.2,1.9l-2.7,1l-2.6,1.1l-2.4,1.1
		l-2.3,1.2c-1.6,0.9-3,1.9-4.6,3c-1.7,1.4-3.6,2.6-5.6,3.5c-1.3,0.5-2.8,0.8-4.2,0.8c-1.4-0.1-2.7-0.4-4-0.9c-2.1-0.8-4-2-5.7-3.4
		c-0.9-0.6-1.7-1.2-2.4-1.9l-0.6-0.4l-0.4-0.3l-0.2-0.3l-1.1-0.9l-2.2-1.9l-2.2-2.3c-5.8-6.1-9.9-13.5-11.9-21.6
		c-1-4-1.4-8-1.4-12.1c-0.1-2,0-4,0.1-6v-3.8h0.1v-1.8c0-0.9-0.1-1.8-0.3-2.7c-0.1-0.8-0.1-1.6-0.3-2.6s-0.5-3.7-0.9-5.6
		c-0.6-3.7-1.4-7.5-2.1-11.2c-3-15-6.3-30.1-9.5-45.1c-1.6-7.6-3.2-15.1-4.6-22.7c-0.3-2-0.7-3.9-1-5.8l-0.4-3l0,0v-6.2
		c0.1-1,0.1-2.1,0.3-3.1s0.5-3.9,0.8-5.9c1.3-7.7,3.1-15.3,5-22.8s4-14.9,6.1-22.3c1-3.7,2-7.4,2.9-11.1c0.3-0.9,0.5-1.8,0.7-2.7
		l0.2-1.2l0,0c0,0,0.1-0.1,0.1,0l0,0v-0.9c0.1-0.6-0.1-1.1,0-0.9h0.1l-0.5-0.2l-2.1-0.2h-2.7l-5.7,0.2h-5.9c-1.8,0-3.7,0-5.5,0.2
		c-7.2,0.5-14.9,2.6-23.1,2.7c-4.1,0-8.3-0.5-12.3-1.5c-3.9-1-7.8-2.4-11.4-4.2h-0.3l-0.2-0.2c-0.4-0.3-0.8-0.6-1.1-1
		c-0.3-0.2-0.6-0.5-0.8-0.8c-0.6-0.5-1.1-1.2-1.5-1.8c-0.9-1.3-1.7-2.6-2.4-3.9c-0.3-0.6-0.6-1.3-0.9-2c-0.3-0.7-0.6-1.4-0.9-2.1
		c-0.2-0.7-0.4-1.4-0.6-2.1c-0.2-0.7-0.4-1.4-0.6-2.1l-0.5-2.1l-0.3-2.1c-0.3-1.5-0.3-2.9-0.5-4.3s-0.1-2.9-0.1-4.2v-9.9
		c0-0.6-0.1-1.2-0.2-1.8c0-0.6-0.2-1.1-0.2-1.7l-0.5-1.4c-0.2-0.4-0.4-0.8-0.6-1.1l-0.4-0.5l-0.5-0.5c-0.8-0.7-1.7-1.2-2.6-1.7
		l-1.6-0.7l-1.8-0.6c-1.2-0.5-2.4-0.8-3.7-1.2l-3.8-1h0.4c-8.3-1.2-16.9-0.4-25.7,0.5c-4.3,0.4-8.8,0.9-13.3,1.2
		c-2.2,0.2-4.5,0.3-6.7,0.3h-6.8c-4.3,0-8.8,0.2-13.4-0.1c-4.8-0.2-9.6-1.2-14-3.1l-0.8-0.4l-0.9-0.5l-1.6-0.9l-3-2.3l-2.6-2.7
		l-2.2-2.9l-1.8-3.2c-0.6-1-1.1-2.1-1.5-3.2l-0.4-0.8v-0.5l-0.2-0.4l-0.5-1.6l-0.5-1.6c-0.2-0.6-0.4-1.2-0.5-1.8
		c-0.3-1.2-0.6-2.4-0.7-3.6c-0.2-1.3-0.3-2.5-0.3-3.8v-1.9l0.3-1.9V704l0.3-1l0.6-1.9c1.1-2.5,2.7-4.7,4.7-6.5c2-1.7,4.3-3,6.8-3.8
		l1.9-0.6l2-0.3h3.8c2.4,0.2,4.7,0.6,7,1.1c4.5,1,8.9,2.4,13.1,4.3c4.2,1.8,8.3,3.9,12.2,6l5.8,3.1c1.7,1,3.4,1.8,5.3,2.4
		c0.7,0.2,1.4,0.3,2.1,0.1c0.9-0.1,1.8-0.4,2.6-0.7l6-2.5c3.9-1.7,7.9-3.6,11.7-5.6c1.8-1.1,3.7-2.1,5.4-3.3l2.6-1.8h0.1
		c0,0,0.2-0.1,0.1,0l0.3-0.3l0.6-0.5l0.9-0.9c2.5-2.8,4-6.5,3.4-9.5l-0.3-1.2c-0.2-0.3-0.4-0.7-0.5-1.1c-0.5-0.7-1-1.4-1.6-2
		c-0.6-0.7-1.3-1.3-2-1.8c-0.4-0.3-0.8-0.6-1.2-0.8l-1.3-0.8l-2.9-1.8l-2.9-1.9l-5.5-4c-3.6-2.8-7-5.7-10.3-8.7s-6.6-6-9.8-9.1
		s-6.3-6.3-9.4-9.5l-2.3-2.5l-1.2-1.2l-0.5-0.6l-0.5-0.6c-0.7-0.8-1.5-1.5-2.3-2.1l-2.4-2.2c-6.7-5.5-13.7-10.6-21.1-15.1l-2.8-1.6
		l-2.8-1.5l-2.9-1.4l-3-1.2c-4.7-2-8.6-5.3-11.3-9.6c-1.5-2.2-2.4-4.8-2.7-7.4c-0.2-1.5,0-3,0.4-4.5c0.4-1,0.9-1.8,1.6-2.6
		c0.4-0.4,0.9-0.7,1.5-1l0.5-0.2h0.2l0.4-0.2l1.8-0.5l1.8-0.3c1.1-0.3,2.3-0.4,3.5-0.5c2.3-0.3,4.7-0.4,7-0.3c2.5,0.1,5,0.6,7.4,1.4
		l0.9,0.4l0.9,0.4l1.4,0.7c0.7,0.4,1.4,0.6,2.2,0.8l0,0c-0.1,0-0.1,0-0.1,0.1l0,0c0-0.1,0-0.1,0.1-0.1l0.2-0.3
		c0.5-0.8,1-1.6,1.4-2.4c0.4-0.9,0.8-1.9,1.3-2.9c0.4-1.1,0.9-2.1,1.4-3.1c1-2.2,2.3-4.3,3.8-6.2c1.6-2.1,3.6-3.8,6-5
		c2.5-1.3,5.4-1.7,8.2-1.2l1,0.2h1l0.8,0.3l1,0.5c0.7,0.3,1.3,0.7,1.9,1.1l1.6,1.3c1.9,1.9,3.3,4.2,4.1,6.8c0.8,2.3,1.2,4.8,1.3,7.2
		c0.1,1.2,0.1,2.4,0.1,3.5c0,0.6,0,1.2-0.1,1.8v4.7c0.1,0.5,0.1,0.9,0.1,1.4l0.3,1.4c0.3,1.8,1.1,3.3,2,3.8c0.5,0.3,1,0.5,1.6,0.4h1
		l1.2-0.4l1.2-0.6l1.4-0.7l2.5-1.7c1.8-1.2,3.5-2.6,5.3-3.9l10.5-8c3.5-2.7,7-5.4,10.9-8l3.2-1.8l1.1-0.4h0.9l1.7-0.4
		c2.3-0.5,4.7-0.8,7.1-1c2.6-0.2,5.2,0.2,7.6,1.1c1.5,0.5,2.9,1.4,3.9,2.6c1.1,1.3,1.7,2.8,1.8,4.5v0.7c0,0.4,0,0.7-0.1,1.1
		c-0.1,0.7-0.2,1.5-0.4,2.2c-0.4,1.3-1,2.5-1.8,3.6c-1.4,2-3.1,3.9-5,5.5c-3.5,3-7.3,5.6-11.3,7.8c-3.9,2.3-7.7,4.2-11,6.7
		c-3.2,2.3-5.6,5.4-6.9,9.1l-0.4,1.3l-0.2,1.4L956,623c-0.2,2.1-0.4,4.3-0.4,6.4c-0.1,2,0.1,4,0.4,6c0.2,0.8,0.5,1.6,0.8,2.4
		c0.3,0.7,0.8,1.3,1.4,1.7h0.1l0.3,0.2l0.6,0.4l0.5,0.2l0.5,0.2c0.8,0.3,1.6,0.4,2.4,0.4c1.9-0.1,3.8-0.5,5.6-1.2
		c4-1.6,7.9-3.4,11.7-5.4c3.8-2,7.5-4.2,11-6.6c1.7-1.2,3.3-2.5,4.7-4l1-1.1l1-1.3l2.2-2.6c1.8-2,4.1-3.5,6.6-4.4
		c2.4-0.7,5-1,7.5-0.9h1.7l1.8,0.2l3.3,0.4l6.7,1.1c4.6,1,9,2.4,13.2,4.4c4.3,2.1,8.2,5,11.4,8.5c1.7,1.7,3.1,3.7,4.4,5.7
		c0.5,1,1.2,2,1.7,3.1l0.7,1.5l0.7,1.8c0.8,2.3,1.2,4.8,1.3,7.2c0.1,2.4,0,4.7,0,6.9c-0.1,1.9,0.1,3.9,0.5,5.8
		c0.5,1.7,1.5,3.2,2.8,4.3c3.1,2.9,6.5,5.4,10.2,7.5c3.7,2.1,7.5,3.9,11.5,5.4c1.9,0.7,3.8,1.2,5.8,1.5l1.6,0.2h0.8l1,0.2h1l0.8,0.2
		l1.7,0.4c4.3,1,8.2,1.8,12,1.1c3.9-0.8,7.5-2.7,10.5-5.4l0.2-0.2h0.2c0.9-0.4,1.6-1.1,2.2-1.9c0.5-0.7,0.7-1.6,0.5-2.5
		c-0.6-2.3-1.6-4.5-3.1-6.4c-3.4-4.4-7.2-8.5-11.3-12.3l-3-3.1c-1.1-1.3-1.8-2-2.8-3s-4.2-3.5-6.4-5.4c-1.2-0.9-2.3-2-3.4-3.1
		c-0.6-0.7-1.1-1.4-1.6-2.2c-0.5-0.9-0.8-2-0.9-3c-0.1-1.1,0.1-2.3,0.6-3.3c0.2-0.5,0.5-1,0.8-1.4l0.4-0.5l0.2-0.3l0.4-0.3
		c0.5-0.6,1.1-1.1,1.7-1.5l1.1-0.8l1-0.7c2.7-1.4,5.4-2.5,8.3-3.4c2.7-1,5.3-1.8,7.8-2.9c2.4-1,4.7-2.4,6.7-4l0.7-0.6l0.4-0.3
		l0.3-0.3l0.4-0.4l0.2-0.3c0.1-0.2,0.3-0.4,0.4-0.6c0.2-0.3,0.3-0.7,0.4-1.1c0.1-0.3,0.1-0.7,0-1c-0.4-0.9-0.9-1.6-1.7-2.2
		c-1-0.8-2-1.4-3.1-2c-2.4-1.1-4.8-1.9-7.4-2.5c-1.3-0.3-2.6-0.4-4-0.6l-2.2-0.2l-2.3-0.4c-2.9-0.7-5.8-1.6-8.5-2.8
		c-2.8-1.2-5.5-2.7-7.9-4.6c-1.3-1-2.4-2.2-3.4-3.5c-1.1-1.4-1.9-3.1-2.2-4.9c0-0.2-0.1-0.5-0.1-0.7v-1.9c0-0.3,0.1-0.9,0.1-1.3
		v-0.7c0.1-0.2,0.2-0.4,0.2-0.6c0.5-1.6,1.2-3.2,2.2-4.6c0.9-1.2,1.8-2.3,2.5-3.4c0.7-0.9,1.1-1.9,1.3-3c0.1-0.2,0.1-0.5,0.1-0.7
		v-0.9c0,0.2-0.1-0.8-0.1-0.6l-0.2-0.3c-0.5-0.8-1.3-1.4-2.1-1.8c-2.5-1-5-1.9-7.6-2.5c-2.7-0.7-5.6-1.4-8.4-2.3l-4.2-1.7
		c-1.4-0.6-2.7-1.4-3.9-2.2c-2.4-1.5-4.8-2.8-7.3-4.2c-2.7-1.4-5.2-3-7.5-4.9c-2.6-2-4.6-4.7-5.8-7.7c-0.3-0.8-0.4-1.6-0.7-2.4
		l-0.3-2.5c0-1.4-0.1-2.7-0.2-4.2s-0.5-5.6-0.7-8.6c0-1.6,0-3.1,0.2-4.7c0.2-1,0.5-1.9,1-2.8c0.3-0.6,0.7-1,1.2-1.4
		c0.5-0.5,1.1-0.8,1.7-1c0.6-0.2,1.2-0.2,1.8-0.2h3.2c1.5,0,3,0.1,4.5,0.3c3,0.4,5.8,1.1,8.6,1.7c5.6,1.4,11.1,3.1,16.5,4.6
		c5.4,1.6,10.8,2.8,16.3,3.8c2.7,0.5,5.4,0.8,8.1,0.7c1.2,0,2.4-0.2,3.6-0.5c0.5-0.1,0.9-0.3,1.3-0.6c0.3-0.2,0.5-0.5,0.7-0.8l0,0
		v-0.5l0,0c0.1-0.2,0.1-0.3,0.1-0.5c0.1-0.5,0-1-0.1-1.5c-0.2-1.2-0.6-2.4-1.1-3.5c-1.2-2.4-2.6-4.8-4.1-7c-3.2-4.6-6.6-9-10.3-13.3
		c-3.6-4.3-7.5-8.5-10.9-13.3c-1.7-2.3-3.4-4.7-4.9-7.2s-2.8-5.1-4.2-7.6c-1.2-2.4-2.6-4.7-4.2-6.8l-1.3-1.5l-1.5-1.5l-3-2.9
		l-12.3-11.8l-6.3-5.7c-2.1-1.8-4.2-3.7-6.3-5.4l-1.7-1.2l-1-0.8l-0.9-0.8c-1.2-1.2-2.2-2.6-2.9-4.1c-0.4-0.8-0.7-1.8-0.8-2.7
		c-0.1-1.1,0.1-2.3,0.7-3.3c0.5-1,1.3-1.8,2.3-2.3c0.8-0.4,1.7-0.8,2.6-1c3-0.5,6.2-0.5,9.2,0c2.9,0.3,5.7,0.7,8.5,1.2
		c11.3,1.7,22.5,3.8,33.7,6.1l8.3,1.8l2.2,0.5l1.1,0.2h0.5l0.5,0.2l4.1,1.5c5.2,2.1,10.5,3.9,15.9,5.4c2.6,0.6,5.2,1,7.9,1.1h1.8
		l2-0.4c1.2-0.4,2.6-0.7,3.9-1.2c5.3-1.7,11-3.7,17-4h6.8l2.1,0.3c2.9,0.4,5.8,1,8.6,1.7c5.6,1.4,11.1,3.2,16.4,4.6
		c1.3,0.4,2.6,0.7,3.9,0.8h3.8l8.5-1c3-0.3,6-0.3,9,0h0.7c0.2,0,0.4,0.1,0.6,0.2l0.9,0.3l0.6,0.4c0.7,0.5,1.4,1.1,2,1.7
		c1.1,1.1,2,2.4,2.8,3.7c3.1,5,5.5,10,8.6,14.7c1.5,2.2,3.2,4.3,5,6.3c1.8,1.8,4.2,3,6.6,5.1s4.3,4.1,6.3,6c1.9,1.9,4,3.4,6.3,4.7
		c4.7,2.3,10.2,2.7,15.7,2.5s11.2-0.9,16.9-1.3s11.3-1,17-1.3c11.4-0.7,22.8-0.8,34.2-0.8h8.6l8.5,0.2h7.2l0.7-0.2
		c1.1-0.4,2.1-0.9,2.9-1.7c0.9-0.8,1.7-1.8,2.2-2.9c1.3-2.4,2.3-4.9,2.9-7.5c0.6-2.6,1.2-5.4,1.6-8.1c0.2-1.3,0.3-2.5,0.3-3.8
		c-0.1-1.2-0.4-2.3-1-3.4c-0.6-1.1-1.3-2.2-2.1-3.4l-2.3-3.7c-0.4-0.6-0.8-1.2-1.1-1.9l-0.2-0.2c0-0.1-0.2-0.4-0.1-0.3l-0.3-0.5
		l-0.4-1c-0.2-0.4-0.4-0.7-0.5-1.1l-0.4-1.2c-0.1-0.4-0.1-0.8-0.2-1.2c-0.1-0.4-0.2-0.9-0.2-1.3c-0.1-1.7,0.2-3.3,0.7-4.9
		c0.7-1.5,1.6-3,2.7-4.2c1.1-1.2,2.4-2.3,3.9-3c0.9-0.4,1.8-0.7,2.7-0.8h1.4l1.4,0.4c1,0.3,1.8,0.8,2.6,1.5c0.7,0.6,1.2,1.4,1.6,2.2
		c0.6,1.4,1.1,2.9,1.4,4.4c0.3,1.3,0.7,2.5,1.2,3.7c0.3,0.4,0.6,0.8,0.9,1.2c0.1,0.2,0.3,0.3,0.5,0.4l0.7,0.4c1.1,0.6,2.4,1,3.6,1.3
		c0.9,0.3,1.9,0.1,2.7-0.5c0.9-0.7,1.7-1.6,2.3-2.6c0.8-1.1,1.5-2.3,2.1-3.5c1.2-2.5,2.6-5.1,4.1-7.6c2.9-4.9,6.1-9.6,9.6-14.2
		c1.7-2.2,3.3-4.5,4.7-6.9c0.6-1.1,1-2.2,1.3-3.4c0.1-0.5,0.1-1,0-1.5c-0.1-0.5-0.3-0.9-0.5-1.3l-0.5-0.6h-0.2c0.1,0-0.2-0.3,0.1,0
		l-0.3-0.2h0.3c0.2,0.1,0,0-0.2,0.1l-0.7,0.2c-1.2,0.5-2.3,1.2-3.4,1.9c-2.3,1.4-4.6,3.1-7.1,4.6c-1.3,0.9-2.8,1.6-4.3,2.1l-2,0.6
		l-2.1,0.6c-2.7,0.7-5.4,1.5-8.1,2.4c-2.6,0.8-5.2,1.9-7.6,3.1c-1.2,0.5-2.3,1.2-3.4,2l-0.8,0.6l-0.7,0.6c-0.5,0.6-1.1,1.1-1.7,1.5
		c-0.7,0.5-1.4,1-2.2,1.3c-0.7,0.3-1.4,0.6-2.2,0.9c-1.6,0.4-3.3,0.6-4.9,0.4c-3.4-0.3-6.5-2.3-8.3-5.2c-1.5-2.8-2.3-5.9-2.3-9v-2.4
		c0.1-0.4,0.1-0.7,0.2-1.1l0.4-1.2c0.2-0.8,0.5-1.5,0.8-2.2c0.3-0.7,0.6-1.4,1-2c2.8-5.3,6.4-9.8,9.9-14.2l5.4-6.7l1.2-1.6l1.2-1.7
		c0.8-1.2,1.7-2.4,2.6-3.5c1.8-2.4,3.9-4.5,6.3-6.4c2.5-1.7,5.2-3.1,8.1-4h1.4l0.3-0.2c0.2-0.5,0.2-1.1,0.1-1.6
		c-0.3-2-0.4-3.9-0.4-5.9c0-0.6,0.1-1.2,0.3-1.7c0.2-0.6,0.5-1.2,0.8-1.7l1.5-2.3c1-1.7,2.2-3.3,3.4-4.9c0.5-0.5,1-0.9,1.6-1.2
		c0.4-0.2,0.9-0.3,1.4-0.3c0.6,0,1.2,0.2,1.7,0.6c0.3,0.2,0.6,0.6,0.8,0.9l0.4,0.7l0.7,1.2c0.9,1.6,1.9,3,3,4.4
		c0.5,0.7,1.1,1.3,1.7,1.8c0.6,0.5,1.2,0.8,1.4,0.7h0.5v-0.2l0,0c0.1-0.6,0-1.2-0.3-1.8c-0.3-0.9-0.6-1.8-0.9-2.9
		c-0.3-1.2-0.2-2.4,0.2-3.6c0.4-1.2,1.2-2.2,2.2-3l0.7-0.5l0.7-0.4l0.7-0.4h0.8l0.7-0.2l0.8-0.3l1.8-0.2c1.2,0,2.5,0.4,3.5,1.1
		c1.8,1.2,3.2,2.7,4.2,4.6c0.9,1.5,2,2.9,3.2,4.1c0.5,0.4,1.1,0.8,1.7,1h1.5l0.6-0.2l2-0.9l1.9-1.6c1.1-1.3,2.2-2.7,3.3-4.2l1.9-2.4
		c0.3-0.4,0.7-0.8,1.2-1.1c0.6-0.5,1.3-0.8,2-0.9c0.8-0.2,1.6-0.1,2.3,0.3c0.6,0.3,1.2,0.8,1.6,1.3c0.9,1.1,1.2,2.5,1,3.9
		c-0.4,2-1,3.9-1.8,5.7c-0.6,1.7-1,3.3-0.6,4.4s1.6,1.9,3.3,2.4l0.6,0.2l0.6,0.2l1.1,0.2h2.4c1.7-0.3,3.4-0.9,4.9-1.7l1.6-0.5
		c0.7-0.1,1.4-0.1,2.1,0l1,0.3l0.5,0.3h0.4l0.5,0.4l0.7,0.6c1.4,1.4,2.5,2.8,3.8,4c1.2,1.2,2.7,2.3,4.2,3.1c1.6,0.8,3.2,1.3,4.9,1.7
		c0.9,0.2,1.7,0.3,2.6,0.3l2.8,0.3c1,0.1,2,0.3,3,0.6l1.6,0.5l0.7,0.4l0.8,0.5c1,0.7,1.8,1.7,2.2,2.9c0.4,1,0.6,2,0.7,3.1
		c0.2,2,0.3,3.8,0.5,5.6s0.5,3.7,0.8,5.4c0.7,3.6,1.9,7,3.5,10.3c1.6,3.2,3.7,6,6.4,8.4c0.7,0.5,1.3,1.1,2.1,1.6l1.1,0.8l1.1,0.6
		l1.2,0.7l1.3,0.6l2.5,1.3c3.2,1.7,6.6,3.2,10,4.4c1.7,0.5,3.4,0.7,5.1,0.7c0.8,0,1.7-0.1,2.5-0.3l1.3-0.2h0.6c0.1-0.1-0.1,0-0.1,0
		l0.7-0.3l0.7-0.2l0.4-0.2l0.5-0.3l0.4-0.3l0.8-0.8c0.3-0.3,0.5-0.6,0.7-1c0.9-1.4,1.4-3,1.6-4.6c0.2-1.7,0.2-3.4-0.2-5l-0.2-0.6
		l-0.2-0.6c-0.1-0.4-0.3-0.7-0.5-1l-0.3-0.4l0,0l-0.3-0.3c-0.1,0.1,0.1,0.1-0.1,0.1h-0.4c-0.8,0-1.6,0.1-2.3,0.4l-2.5,0.8l-5.2,2
		c-1.8,0.6-3.6,1.3-5.5,1.8l-2.9,0.7c-1.1,0.1-2.2,0.1-3.3,0c-0.6-0.1-1.2-0.3-1.7-0.6h-0.7l-0.2-0.2l-0.5-0.5
		c-0.1-0.2-0.2-0.3-0.2-0.5c-0.5-1-0.8-2.1-0.9-3.2c-0.1-2,0-3.9,0.2-5.9c0.4-3.8,1.1-7.6,2.1-11.3c0.9-3.7,2.1-7.3,3.6-10.8
		c1.4-3.6,3.2-7,5.4-10.2c1.2-1.7,2.7-3.2,4.5-4.3c1-0.6,2.1-1,3.2-1.1h1.8l0.8,0.2l0.4,0.2h1l0.2,0.2l0.8,0.7c0.5,0.4,0.8,1,1,1.6
		c0.5,1,0.7,2,0.8,3.1c0.1,2,0.1,3.9-0.2,5.9c-0.2,1.9-0.5,3.8-0.7,5.6c-0.1,0.9-0.2,1.8-0.2,2.7v1.1c0.1,0.1,0.1,0.1,0.1,0.2
		l-0.2-0.2h0.1c0.9,0.3,2,0.1,2.8-0.4c1.2-0.6,2.2-1.3,3.2-2.2c2-1.7,3.9-3.8,5.9-5.8s3.8-4.1,5.9-6.1l3.4-2.8
		c1.3-0.9,2.7-1.6,4.2-2.1c0.8-0.3,1.7-0.4,2.5-0.3h1.3l1,0.3l4.1,0.9c1.3,0.3,2.6,0.5,3.9,0.6c1.2,0.1,2.4-0.2,3.4-0.8
		c1-0.6,1.9-1.4,2.6-2.3c0.7-1.1,1.3-2.3,1.6-3.5c0.4-1.2,0.7-2.6,1-3.9s0.4-2.7,0.5-4v-0.3l0.2-0.2c0.9-2,2.1-3.8,3.5-5.4
		c1.3-1.8,3.1-3.3,5.2-4.2c1.2-0.5,2.5-0.7,3.8-0.4c1.2,0.3,2.3,0.8,3.3,1.6c0.9,0.8,1.6,1.6,2.3,2.6l0.9,1.3l0.8,1.3
		c2.1,3.6,3.9,7.3,6.3,10.3c1.2,1.5,2.6,2.9,4.1,4.1c1.6,1.1,3.3,2.1,5.1,2.9c3.7,1.4,7.6,2.4,11.5,2.8l6.1,0.5
		c1.1,0.1,2.1,0.2,3.2,0.5c1.3,0.3,2.4,0.9,3.3,1.8c0.5,0.5,0.9,1.2,1,1.9c0.2,0.7,0.2,1.3,0.1,2c-0.2,1.2-0.6,2.3-1.2,3.3
		c-0.5,1-1,1.9-1.6,2.8l-0.9,1.2l-0.8,1.2c-0.5,0.8-0.9,1.6-1.1,2.5c-0.2,0.7-0.1,1.4,0.2,2c0.4,0.7,1,1.2,1.7,1.6l2.6,1
		c1.9,0.6,3.9,0.9,6,1.6c1,0.4,2.1,0.9,3,1.5l2.5,1.8c1.7,1.2,3.3,2.4,5,3.4c1.6,1,3.4,1.7,5.2,2h1.7l0.7-0.3l2.9-1
		c1.9-0.6,3.6-1.5,5.3-2.6c1.5-1,2.8-2.3,3.7-3.9c0.7-1.6,1-3.4,0.6-5.2c-0.5-1.9-1.2-3.7-2.2-5.3l-0.7-1.2l-0.2-0.3l-0.2-0.3
		l-0.5-0.6c-0.6-0.8-1.2-1.6-1.8-2.3l-2.1-2l-2.4-1.8l-0.6-0.6l-0.7-0.7l-0.3-0.4l-0.3-0.5c0-0.2-0.1-0.4-0.2-0.5V354
		c0-0.3,0-0.6,0.1-0.9l0.3-1.7c0.6-2,1.3-4,1.9-5.9l1.1-2.9c0.4-1,0.8-2,1.3-2.9c0.4-1,0.9-1.9,1.4-2.8c0.5-0.9,1.1-1.8,1.5-2.6
		c0.5-0.8,0.7-1.6,0.8-2.5v-1.4c0-0.5-0.1-1-0.1-1.4c-0.1-2-0.4-4-0.7-6.1s-0.2-2.1-0.2-3.1s-0.1-2.1-0.1-3.1
		c0-4.2,0.6-8.4,1.7-12.5c1.1-4,2.5-7.9,4.1-11.7c1.6-3.8,3.4-7.5,5.2-11.2c3.6-7.3,7.7-14.4,11.1-21.8c0.5-0.9,0.9-1.8,1.2-2.8
		l0.6-1.3l0.4-1.4c0.3-0.9,0.5-1.9,0.6-2.8c0-0.8-0.1-1.5-0.5-2.2l-1.9-2.3l-1.7-2.8l-1.3-2.9c-0.4-1-0.7-2.1-0.9-3.1
		c-1.2-4.1-1.3-8.5-0.3-12.7c0.5-2.1,1.5-4.1,2.7-5.9l3.7-5c2.4-3.2,4.9-6.5,7.7-9.6c1.3-1.6,2.7-3.1,4.2-4.5
		c1.5-1.5,3.2-2.8,5.1-3.9c1.1-0.6,2.3-0.9,3.6-0.9l1.1,0.3l0.4,0.3l0.5,0.3l0.2,0.2h0.1l0.3,0.3l0.5,0.6c1.5,1.7,2.5,3.4,3.8,5
		c1.1,1.6,2.4,3.1,3.9,4.4c1.5,1.2,3.1,2.2,4.9,2.9c1.8,0.7,3.7,1.2,5.7,1.5h3l1.6,0.2h0.7l0.8,0.3c4.2,1.1,8,3.5,10.8,6.8
		c2.9,3.1,5.1,6.6,7.5,9.8c1.1,1.6,2.4,3.1,3.8,4.4c0.4,0.3,0.8,0.6,1.2,0.8c0.2,0.2,0.4,0.3,0.6,0.4l0.6,0.4l2.7,1.4l2.7,1.1
		c0.8,0.3,1.7,0.4,2.5,0.3c0.8-0.2,1.6-0.6,2.2-1.1c0.7-0.6,1.3-1.3,1.9-2.1c1.1-1.7,2.4-3.3,2.4-4.9s-1.2-3.1-2.6-4.4
		c-1.5-1.3-3.2-2.4-4.9-3.4c-1.7-1.1-3.5-2.2-5.2-3.5c-0.9-0.7-1.7-1.6-2.3-2.6c-0.1-0.3-0.2-0.7-0.3-1c0-0.3-0.1-0.6-0.1-0.9
		c0-0.5,0-1.1,0.1-1.6c0.2-2.1,0.4-4.1,0.8-6.2c0.3-2,0.5-4,0.6-6c0.2-1.9,0-3.9-0.4-5.8c-0.3-1.8-1.3-3.4-2.7-4.5
		c-0.8-0.4-1.7-0.8-2.6-1.1l-2.9-1c-7.8-2.7-15.3-6.3-22.3-10.6c-3.6-2.2-6.9-4.7-9.8-7.7c-3.1-3-5.3-6.8-6.2-11v-1.6l-0.2-1.5
		l-0.3-3.1c-0.2-2-0.4-4.1-0.5-6.2s0-4.1,0.1-6.2c0.2-2.2,0.7-4.3,1.5-6.3c0.4-1.1,1.1-2,1.9-2.8c0.8-0.8,1.8-1.4,2.9-1.8
		c2.1-0.6,4.4-0.6,6.5-0.1c0.5,0.1,1,0.2,1.5,0.3l1.6,0.4c1,0.2,2,0.6,3,1c1.9,0.7,3.8,1.5,5.7,2.4c3.7,1.7,7.3,3.6,11,5.2l2.8,1.1
		l1.5,0.5l1.4,0.4l2.9,0.6l1.5,0.2h1.4c1.9,0,4.1-0.3,6-0.5c1-0.1,2-0.3,2.9-0.6c0.8-0.2,1.5-0.6,2-1.3c0.4-0.8,0.6-1.6,0.6-2.5
		c0.1-1,0.2-2.1,0.2-3.1c0.1-2,0.3-4.1,0.5-6.1c0.2-2.1,0.6-4.2,1.2-6.2c0.8-2,1.9-3.9,3.3-5.5c2.6-3.2,5.5-6.1,8.1-9.2
		c5.3-6.2,9.5-13.1,12.6-20.6c1.5-3.7,2.6-7.6,3.3-11.6c0.4-2,0.7-4,0.9-6c0.2-1.9-0.3-3.8-1.3-5.4c-1.1-1.7-2.3-3.4-3.6-4.9
		l-3.8-4.8l-7.5-9.6l-3.7-5c-1.2-1.7-2.2-3.6-3.1-5.5c-0.7-2-1-4.2-0.7-6.4c0.2-2.1,0.5-4.1,0.8-6.1s0.2-2,0.2-3c0.1-1,0.2-2,0.1-3
		c0.1-1.8,0-3.5-0.2-5.3c-0.4-1.9-1.1-3.8-2-5.6c-0.5-0.8-1-1.6-1.6-2.4c-0.6-0.8-1.2-1.5-2-2.1l0.9-1.2c0.8,0.7,1.6,1.5,2.3,2.3
		c0.6,0.9,1.2,1.8,1.7,2.7c1,1.9,1.8,3.8,2.2,5.9c0.1,0.5,0.2,1.1,0.3,1.6c0.1,0.5,0.2,1,0.2,1.5l0.2,1.6v1.6c0.1,1.1,0,2,0,3.1
		l-0.3,3.1c-0.2,2-0.5,4.1-0.7,6c-0.3,1.9-0.1,3.9,0.6,5.7c0.8,1.8,1.8,3.6,2.9,5.2l3.6,4.9c2.5,3.2,5,6.5,7.6,9.7l3.8,4.7
		c1.3,1.6,2.5,3.3,3.6,5.1c0.6,0.9,1.1,1.9,1.4,3c0.1,0.6,0.2,1.1,0.2,1.7c0,0.5,0,1.1,0,1.6c-0.1,2.1-0.5,4.1-0.8,6.2
		c-0.8,4.1-1.9,8.1-3.5,11.9c-3.1,7.7-7.4,14.8-12.8,21.1c-2.6,3.2-5.5,6.1-8.1,9.2c-1.3,1.4-2.3,3.1-3,4.9
		c-0.5,1.9-0.9,3.9-1.1,5.9c-0.2,2-0.4,4-0.5,6s0,2.1-0.1,3.1c-0.1,1.2-0.4,2.3-0.9,3.4l-0.6,0.7l-0.8,0.6c-0.5,0.3-1,0.6-1.6,0.7
		l-3.1,0.6c-2.1,0.3-4.2,0.5-6.3,0.5c-0.5,0.1-1.1,0-1.6-0.1h-1.6l-3.1-0.7l-1.5-0.4l-1.4-0.5l-3-1.2c-3.8-1.6-7.4-3.5-11.1-5.2
		c-3.6-1.8-7.4-3.1-11.3-3.9c-1.8-0.5-3.8-0.4-5.6,0.1c-1.7,0.6-3.1,1.9-3.8,3.6c-0.7,1.8-1.1,3.7-1.2,5.7c-0.2,2-0.2,4-0.1,6
		c0.2,4,0.6,8,1.2,12c0.9,3.8,2.8,7.3,5.6,10.1c2.8,2.9,6,5.3,9.5,7.4c6.9,4.2,14.3,7.7,21.9,10.4l2.9,1c1.1,0.3,2.1,0.7,3,1.3
		c1,0.6,1.8,1.5,2.4,2.5c0.6,1,1,2,1.3,3.1c0.4,2.1,0.6,4.3,0.4,6.4c-0.1,2.1-0.3,4.1-0.6,6.2c-0.3,2-0.7,4.1-0.8,6
		c-0.1,0.5-0.1,0.9-0.1,1.4c0,0.2,0,0.5,0.1,0.7c0,0.2,0.1,0.3,0.1,0.4c0.4,0.8,1,1.4,1.7,1.9c3.1,2.4,7,4.2,10.2,7
		c0.9,0.7,1.6,1.6,2.2,2.5c0.7,1,1.1,2.2,1.1,3.4v0.9l-0.2,0.9l-0.4,0.9c-0.1,0.3-0.2,0.5-0.4,0.7c-0.5,0.9-1.1,1.8-1.7,2.7
		c-0.7,0.8-1.4,1.6-2.2,2.4c-0.9,0.8-2,1.4-3.2,1.6c-1.2,0.2-2.4,0.1-3.5-0.3l-3-1.3l-2.7-1.4l-1.4-0.8c-0.5-0.3-1-0.6-1.4-1
		c-1.6-1.4-3-3-4.2-4.7c-2.3-3.4-4.8-6.6-7.4-9.7c-2.5-2.9-5.9-5-9.6-6.1l-0.7-0.3h-0.7l-1.5-0.2h-1.5l-1.6-0.2
		c-2.1-0.3-4.2-0.8-6.2-1.6c-2-0.8-3.9-1.9-5.5-3.3c-1.6-1.4-3.1-2.9-4.3-4.7c-1.2-1.7-2.4-3.4-3.6-4.8l-0.5-0.6l-0.3-0.3
		c0,0-0.1-0.1,0-0.1h-0.1l-0.2-0.2h-0.6c-0.8,0-1.6,0.2-2.3,0.6c-1.7,1-3.3,2.2-4.6,3.6c-1.5,1.3-2.9,2.8-4.2,4.3
		c-2.6,3.1-5.1,6.3-7.6,9.6l-3.5,4.9c-1.1,1.6-1.9,3.3-2.4,5.2c-1,3.8-0.8,7.8,0.3,11.5c0.2,1,0.5,2,0.9,2.9
		c0.3,0.9,0.7,1.7,1.1,2.7c0.4,0.8,0.9,1.6,1.5,2.4c0.7,0.8,1.4,1.6,2,2.5l0.4,0.8c0.1,0.3,0.2,0.6,0.3,0.9c0.1,0.3,0.1,0.6,0.2,0.9
		v1c-0.1,1.1-0.4,2.2-0.7,3.2l-0.5,1.5l-0.6,1.5c-0.3,1-0.8,1.9-1.2,2.9c-3.4,7.5-7.5,14.6-11.1,21.9c-1.8,3.6-3.6,7.3-5.1,11
		c-1.6,3.7-2.9,7.5-4,11.4c-1,3.9-1.6,7.9-1.6,11.9c0,2,0.1,3.9,0.3,5.9c0.2,2,0.6,4.1,0.7,6.2c0,0.5,0.1,1,0.1,1.6v1.7
		c-0.1,1.2-0.5,2.3-1,3.3c-0.5,1-1.1,1.8-1.6,2.7s-0.9,1.7-1.3,2.6l-1.2,2.8c-0.4,0.9-0.7,1.9-1.1,2.8s-1.3,3.9-1.8,5.7l-0.3,1.4
		v0.6c0,0.1-0.1,0.2-0.1,0.3v0.7c0,0.1,0,0.1,0.1,0.2v0.2l0.4,0.4l0.5,0.4l2.5,1.9l2.3,2.2c2.8,3.3,5.3,6.8,6.2,11.3
		c0.5,2.3,0.3,4.6-0.8,6.7c-1.1,2-2.7,3.7-4.6,4.9c-1.8,1.2-3.7,2.1-5.7,2.8l-2.9,1.1l-0.7,0.3l-1,0.2h-1.8
		c-2.2-0.4-4.4-1.1-6.3-2.3c-1.8-1.1-3.5-2.3-5.1-3.5l-2.5-1.7c-0.8-0.5-1.6-0.9-2.4-1.3l-5.9-1.5c-1.1-0.3-2.1-0.8-3.1-1.3
		c-1.2-0.5-2.1-1.4-2.8-2.5c-0.6-1.2-0.7-2.6-0.4-3.9c0.3-1.1,0.8-2.2,1.4-3.2l0.9-1.4l0.8-1.2c0.6-0.8,1.1-1.6,1.5-2.5
		c0.4-0.8,0.7-1.6,0.9-2.5c0.2-0.6,0-1.3-0.4-1.8c-0.6-0.5-1.3-0.8-2.1-1l-2.8-0.4l-6.1-0.5c-4.2-0.4-8.4-1.4-12.3-3
		c-2-0.9-3.9-1.9-5.6-3.2c-1.7-1.3-3.2-2.8-4.5-4.5c-2.5-3.4-4.7-6.9-6.6-10.6l-0.8-1.3c-0.2-0.4-0.5-0.8-0.8-1.2
		c-0.5-0.7-1.1-1.4-1.8-2c-0.6-0.5-1.3-0.9-2.1-1.1c-0.8-0.1-1.6,0-2.3,0.3c-1.6,0.8-3.1,2-4.2,3.4c-1.2,1.5-2.2,3.2-3.1,4.9v-0.5
		c-0.1,1.5-0.3,2.9-0.5,4.3c-0.3,1.5-0.7,2.9-1.1,4.3c-0.4,1.4-1.1,2.8-1.9,4.1c-0.9,1.3-2.2,2.4-3.6,3.2c-1.5,0.8-3.1,1.3-4.8,1.2
		c-1.5-0.1-3-0.4-4.4-0.6l-4.1-1l-1-0.3h-0.8c-0.5,0-1.1,0.1-1.6,0.3c-1.2,0.3-2.4,0.9-3.4,1.7c-1.1,0.8-2.1,1.6-3.1,2.6
		c-2,1.8-3.9,3.9-5.8,5.9s-3.9,4.1-6.1,6c-1.1,1-2.4,1.9-3.7,2.7l-1.2,0.4c-0.4,0.2-0.8,0.3-1.3,0.3c-0.9,0.1-1.9,0-2.8-0.3h0.1
		c-0.5-0.2-1-0.6-1.2-1.1c-0.2-0.3-0.3-0.7-0.4-1.1c-0.1-0.6-0.2-1.1-0.1-1.7c0-1,0.1-1.9,0.2-2.9c0.2-1.9,0.5-3.8,0.7-5.6
		c0.2-1.8,0.3-3.5,0.1-5.3c0-0.8-0.2-1.6-0.5-2.3c-0.1-0.3-0.3-0.6-0.5-0.8l-0.2-0.2h-0.2l-0.3-0.2h-0.4l-0.5-0.2h-1
		c-0.8,0.1-1.5,0.4-2.1,0.8c-1.4,0.9-2.6,2.1-3.5,3.5c-2.1,3-3.8,6.2-5.1,9.6c-1.4,3.4-2.6,6.9-3.5,10.4c-0.9,3.6-1.6,7.2-2,10.9
		c-0.2,1.8-0.3,3.5-0.1,5.3c0,0.7,0.1,1.5,0.5,2.1c-0.1,0.2,0.6,0.6,1.2,0.7c1.7,0.1,3.3-0.1,4.9-0.6c1.8-0.5,3.5-1.1,5.2-1.8l5.3-2
		c0.9-0.4,1.8-0.7,2.8-0.9c1-0.3,2.1-0.5,3.2-0.5l1,0.2l1.2,0.5l0.2,0.2l0.3,0.2l0,0l0.2,0.2c0.2,0.2,0.4,0.4,0.5,0.7
		c0.3,0.5,0.6,1,0.8,1.5l0.3,0.8l0.2,0.7c0.5,2,0.6,4.1,0.3,6.2c-0.3,2-1,4-2,5.8c-0.3,0.5-0.6,0.9-1,1.3c-0.3,0.4-0.8,0.9-1.2,1.2
		c-0.2,0.2-0.4,0.4-0.7,0.5l-0.8,0.5l-0.7,0.4l-0.7,0.2l-0.7,0.2h-0.8l-1.5,0.3c-1,0.2-2,0.3-3,0.3c-2,0.1-4.1-0.2-6-0.8
		c-3.6-1.3-7.1-2.8-10.5-4.6l-2.5-1.3l-1.3-0.6l-1.3-0.7l-1.3-0.7l-1.2-0.9c-0.8-0.5-1.6-1.1-2.3-1.8c-2.9-2.6-5.4-5.8-7.2-9.3
		c-1.7-3.5-3-7.2-3.7-11c-0.4-1.9-0.7-3.8-0.9-5.7c-0.2-1.9-0.3-3.8-0.5-5.6c-0.1-0.8-0.3-1.6-0.5-2.4c-0.3-0.6-0.7-1.1-1.2-1.5
		c-1.4-0.8-2.9-1.3-4.5-1.4l-2.8-0.3c-1,0-1.9-0.2-2.9-0.4c-2-0.3-3.9-0.9-5.7-1.9c-1.8-0.9-3.5-2.2-4.9-3.6c-1.5-1.3-2.7-2.8-3.9-4
		l-0.4-0.4l-0.6-0.4c-0.2-0.2-0.4-0.3-0.6-0.3c-0.6-0.1-1.3,0.1-1.8,0.4c-1.8,0.9-3.7,1.5-5.7,1.9h-3.2l-1.6-0.3l-0.8-0.2l-0.6-0.3
		l-0.7-0.2l-0.4-0.2h-0.4l-1.4-0.9c-1.1-0.7-1.9-1.7-2.3-2.9c-0.4-1.2-0.5-2.4-0.3-3.6c0.2-1,0.5-2,0.9-3c0.7-1.6,1.2-3.3,1.6-5
		c0.1-0.5,0-1-0.2-1.4l-0.6-0.5c-0.2-0.1-0.3-0.1-0.4,0c-0.5,0.2-1,0.5-1.3,1c-0.6,0.7-1.2,1.4-1.7,2.1c-1.1,1.6-2.3,3.1-3.6,4.5
		c-1.5,1.6-3.4,2.8-5.5,3.5l-0.7,0.2h-1.9l-0.9-0.2c-1.2-0.3-2.3-0.8-3.2-1.6c-1.4-1.5-2.6-3.1-3.7-4.8c-0.8-1.4-1.9-2.6-3.2-3.6
		c-0.5-0.4-1.2-0.6-1.8-0.6h-1l-0.5,0.2l-0.7,0.2l-0.5,0.2l-0.5,0.3l-0.5,0.3l-0.5,0.3c-0.5,0.4-0.8,0.9-1.1,1.4
		c-0.4,1.1,0.1,2.6,0.7,4.5s0.3,1,0.5,1.5c0.1,0.7,0.1,1.5-0.1,2.2c-0.1,0.4-0.3,0.8-0.6,1.2c-0.1,0.2-0.4,0.4-0.5,0.5h-0.4
		c-0.6,0.5-1.4,0.7-2.2,0.7c-0.7,0.1-1.5-0.1-2.1-0.4c-0.6-0.3-1.1-0.6-1.5-1c-0.8-0.7-1.6-1.4-2.2-2.3c-1.2-1.5-2.3-3.1-3.3-4.8
		l-0.7-1.2l-0.3-0.6h0.4l-0.6,0.6c-1.2,1.3-2.2,2.8-3.1,4.3l-1.5,2.4c-0.3,0.6-0.5,1.2-0.6,1.8c0,1.8,0.2,3.6,0.5,5.4
		c0.1,0.6,0.1,1.1,0,1.7c-0.1,0.8-0.4,1.5-0.8,2.1c-0.5,0.6-1.1,1.1-1.9,1.4l-1.9,0.3h0.4c-2.5,0.8-4.9,2-7,3.6
		c-2.2,1.6-4.1,3.5-5.7,5.7l-2.5,3.3l-1.2,1.8l-1.3,1.7l-5.4,6.7c-3.6,4.3-6.8,8.9-9.6,13.7c-0.3,0.6-0.6,1.2-0.8,1.8
		c-0.3,0.6-0.6,1.2-0.7,1.8l-0.3,0.8c-0.1,0.3-0.1,0.7-0.2,1v0.8l0,0v1c-0.1,2.6,0.5,5.1,1.8,7.3c0.4,0.4,0.6,1,1.1,1.4l0.6,0.6
		l0.7,0.4l0.4,0.3h0.4l0.7,0.4c0.6,0.1,1.1,0.2,1.7,0.3c1.2,0.2,2.4,0,3.6-0.3c1.1-0.3,2.2-0.8,3.1-1.5c0.5-0.5,1-0.9,1.6-1.3
		l0.8-0.9l1-0.7c1.2-0.9,2.5-1.6,3.9-2.3c2.6-1.3,5.3-2.4,8.1-3.3c2.7-0.9,5.5-1.7,8.3-2.4l2-0.6l2-0.6c1.2-0.4,2.3-1,3.4-1.7
		c2.3-1.4,4.6-3.1,7.1-4.7c1.3-0.8,2.7-1.6,4.1-2.2l1.3-0.3c0.7-0.2,1.4-0.1,2,0.1l0.7,0.3l0.2,0.2c0.4,0.4,0.3,0.2,0.4,0.4l0.2,0.2
		l0.9,1c0.5,0.8,0.9,1.7,1.1,2.7c0.1,0.9,0.1,1.8-0.1,2.7c-0.3,1.6-0.8,3.1-1.6,4.5c-1.5,2.5-3.1,5-4.9,7.3c-3.4,4.5-6.6,9.2-9.5,14
		c-1.4,2.4-2.7,4.8-4,7.4s-1.4,2.6-2.2,3.8c-0.9,1.4-2,2.6-3.3,3.6c-0.8,0.6-1.7,1-2.7,1.2h-1.4l-1.4-0.2c-1.5-0.3-3-0.9-4.4-1.5
		l-1.2-0.6l-1.1-0.9c-0.7-0.7-1.2-1.5-1.6-2.3c-0.7-1.4-1.2-2.9-1.5-4.4c-0.2-1.3-0.6-2.5-1.2-3.6c-0.3-0.9-1-1.6-1.9-1.9h-2
		l-0.8,0.3c-1.1,0.5-2,1.2-2.8,2.1c-0.8,0.9-1.4,1.9-1.9,3c-0.3,1.1-0.5,2.3-0.4,3.4c0,0.6,0.1,1.1,0.2,1.7l0.3,0.8
		c0.1,0.3,0.2,0.6,0.3,0.9l0.5,0.9l0.2,0.5c0.1,0.2,0,0,0.1,0.1v0.3l1.1,1.8l2.2,3.5c0.8,1.2,1.6,2.4,2.4,3.8
		c0.8,1.5,1.2,3.1,1.3,4.8c0.1,1.6,0.1,3.1-0.2,4.7c-0.5,2.8-1.1,5.6-1.8,8.5c-0.7,2.9-1.7,5.8-3.2,8.4c-0.7,1.4-1.7,2.7-2.9,3.8
		c-1.3,1.2-2.8,2.1-4.4,2.6c-0.9,0.2-1.7,0.3-2.6,0.4H1335c-11.3,0-22.7,0.1-33.9,0.8c-5.7,0.3-11.3,0.8-17,1.3s-11.3,1-17,1.3
		c-3,0.2-6,0.1-8.9-0.3c-3.1-0.3-6-1.2-8.8-2.6c-2.7-1.4-5.2-3.2-7.3-5.3c-2.1-2-4-4-6.1-5.8s-4.6-3.1-6.8-5.4
		c-2.1-2.1-4-4.4-5.6-6.9c-3.2-4.9-5.7-10.1-8.6-14.7c-0.7-1.1-1.5-2.1-2.4-3.1c-0.3-0.4-0.8-0.8-1.2-1.1l-0.3-0.2h-0.9
		c-2.7-0.3-5.3-0.3-8,0c-2.8,0.2-5.6,0.7-8.5,1h-4.6c-1.5-0.2-3-0.5-4.5-0.9c-5.6-1.4-11-3.2-16.4-4.5c-2.7-0.7-5.4-1.3-8.1-1.7
		l-2.1-0.2l-2-0.2h-4c-5.4,0.3-10.6,2-16,3.8l-4.3,1.3l-2.2,0.4l-1.2,0.2h-1.2c-3,0-6.1-0.4-9-1.2c-5.6-1.5-11-3.3-16.4-5.5
		l-3.9-1.4l-0.5-0.2h-0.2c-0.2,0-0.1,0-0.2-0.1l-1-0.2l-2-0.5l-8.3-1.7c-11.1-2.2-22.3-4.3-33.4-6.1l-8.3-1.1
		c-2.9-0.3-5.6-0.6-7.8,0c-0.8,0.1-1.6,0.5-2.1,1.1c-0.3,0.3-0.2,1.1,0.2,2.1c0.5,1,1.3,1.9,2.1,2.7l0.7,0.7l0.7,0.5l1.8,1.3
		c2.3,1.8,4.4,3.7,6.6,5.6l6.3,5.8l12.4,11.8l3.1,3l1.5,1.5l1.5,1.7c1.8,2.4,3.4,4.9,4.8,7.6c1.3,2.5,2.6,5,4.1,7.4s3,4.6,4.6,6.9
		c3.2,4.5,7,8.6,10.7,13s7.3,8.8,10.7,13.6c1.7,2.4,3.2,5,4.4,7.7c0.7,1.5,1.2,3,1.5,4.6c0.2,0.9,0.2,1.8,0.2,2.7
		c-0.1,0.5-0.2,1.1-0.3,1.6c-0.1,0.1-0.1,0.3-0.2,0.4v0.5l-0.2,0.4c-0.5,1-1.2,1.8-2.1,2.4c-0.8,0.5-1.7,0.9-2.6,1.2
		c-1.6,0.5-3.2,0.7-4.8,0.7c-3,0-6-0.2-8.9-0.7c-5.8-1-11.3-2.4-16.8-3.9s-10.9-3.2-16.4-4.5c-2.7-0.7-5.4-1.3-8.1-1.7l-4-0.2h-3.5
		l-0.3,0.3c-0.1,0.4-0.2,0.8-0.3,1.2c-0.2,1.3-0.2,2.5-0.2,3.8c0.2,2.7,0.5,5.5,0.7,8.4l0.3,4.3c0,0.6,0.1,1.2,0.2,1.8
		c0.1,0.6,0.3,1.2,0.5,1.7c0.9,2.2,2.4,4.2,4.3,5.7c4,3.2,9.3,5.5,14.3,8.6l3.4,2l3.8,1.4c2.5,0.9,5.2,1.6,8,2.3
		c3,0.6,5.9,1.6,8.6,2.9c1.7,0.8,3.2,2.1,4.2,3.7l0.6,1.6v1.1c0-0.1,0.1,0.3,0.1,0.4v1.3c0,0.5-0.1,0.9-0.1,1.3
		c-0.4,1.7-1.1,3.3-2.1,4.8c-0.9,1.4-1.8,2.5-2.5,3.5c-1.4,1.8-2,4-1.8,6.3c0.2,1.8,1.8,3.8,3.8,5.3c2.1,1.6,4.4,2.9,6.8,3.9
		c2.5,1.1,5.1,1.9,7.7,2.5l1.9,0.3l2,0.3c1.5,0.1,3,0.3,4.5,0.6c3,0.6,5.9,1.6,8.6,2.9c1.5,0.7,2.8,1.6,4.1,2.7
		c1.5,1.1,2.7,2.8,3.2,4.6c0.6,2,0.3,4.2-0.9,6l-0.8,1.2l-0.5,0.5l-0.3,0.4l-0.5,0.5l-0.4,0.3l-0.9,0.8c-2.4,1.9-5.1,3.5-7.9,4.7
		c-2.7,1.2-5.5,2.1-8.2,3.1c-2.6,0.8-5,1.8-7.4,3.1l-0.8,0.4l-0.6,0.5c-0.6,0.4-1.1,0.8-1.5,1.3l0,0v0.2l-0.3,0.2l-0.3,0.6
		c-0.1,0.2-0.2,0.5-0.1,0.8c0.1,0.9,0.6,1.6,1.2,2.2c0.9,1,1.9,1.9,2.9,2.7c2.1,1.7,4.4,3.5,6.6,5.6l1.7,1.6l1.4,1.6l2.9,3
		c4,4,8.2,7.9,11.8,12.8c0.9,1.2,1.7,2.5,2.4,3.9c0.8,1.5,1.4,3.2,1.6,4.9c0.3,2-0.1,4-1.2,5.7c-0.9,1.6-2.3,2.9-4,3.7l0.4-0.2
		c-3.6,3.2-8,5.5-12.8,6.5c-2.4,0.5-4.9,0.5-7.4,0.2c-2.3-0.3-4.6-0.7-6.8-1.3l-1.5-0.4h-1.5l-0.7-0.2h-0.8l-1.7-0.2
		c-2.4-0.3-4.7-0.9-7-1.7c-4.3-1.6-8.5-3.6-12.4-5.9l-5.8-3.7l-2.7-2.1l-1.4-1.2l-1.3-1.1l-0.3-0.3h-0.1c-0.1,0-0.2-0.2-0.2-0.2
		l-0.7-0.8l-0.7-0.8c-0.2-0.3-0.4-0.5-0.5-0.8l-0.6-0.9l-0.4-0.9l-0.4-0.9l-0.3-1c-0.6-2.4-0.8-4.8-0.7-7.3c0-2.3,0.1-4.4,0-6.5
		c-0.1-2-0.4-3.9-1-5.8l-0.5-1.2l-0.7-1.5c-0.4-0.9-0.9-1.8-1.5-2.7c-1.1-1.7-2.3-3.3-3.7-4.8c-2.8-3-6.2-5.4-9.9-7.2
		c-3.8-1.8-7.9-3.1-12-3.9l-6.3-1.1l-3.2-0.4h-3.1c-1.9-0.1-3.8,0.1-5.6,0.6c-1.7,0.6-3.1,1.7-4.3,3l-2.1,2.4l-1.1,1.3l-1.2,1.4
		c-1.6,1.7-3.4,3.2-5.3,4.6c-3.7,2.6-7.6,4.9-11.7,7c-4,2.2-8.2,4.1-12.4,5.8c-2.4,0.8-4.8,1.3-7.3,1.5c-1.4,0-2.8-0.2-4.2-0.6
		l-1-0.4l-1-0.6l-0.8-0.4l-0.4-0.3l-0.3-0.2l-0.2-0.2c-1.1-0.9-2.1-2.1-2.8-3.4c-0.6-1.2-1-2.5-1.3-3.8c-0.5-2.4-0.6-4.8-0.5-7.2
		c0-2.3,0.2-4.6,0.4-6.8l0.3-3.4l0.3-1.9c0.1-0.6,0.3-1.2,0.5-1.8c0.7-2.5,1.9-4.7,3.6-6.7c1.5-1.9,3.3-3.6,5.2-5.1
		c3.7-2.9,7.9-5,11.6-7.1c3.7-2.1,7.2-4.5,10.4-7.3c1.5-1.3,2.8-2.7,3.9-4.3c0.6-0.7,1-1.5,1.2-2.3c0.1-0.3,0.2-0.7,0.2-1
		c0-0.2,0.1-0.2,0.1-0.5v-0.5c0-0.1,0,0.2-0.1,0l0,0c-0.1-0.7-0.2-1.2-0.6-1.5c-0.4-0.5-1-0.9-1.6-1.1c-1.7-0.5-3.6-0.7-5.4-0.6
		c-2,0.1-4.1,0.4-6.1,0.8l-1.5,0.4h-0.7l-0.4,0.2l-2.5,1.4c-3.5,2.3-7,5-10.5,7.7l-10.8,7.4l-5.5,4l-2.9,2l-1.6,0.8l-1.8,0.9
		l-1.9,0.6l-1.1,0.2H932c-1.7,0.1-3.3-0.4-4.7-1.3c-1.3-0.9-2.4-2.1-3.1-3.5c-0.4-0.6-0.6-1.2-0.8-1.9l-0.6-1.9l-0.3-1.9
		c0-0.6-0.1-1.2-0.1-1.9v-6.7c0-1.1,0-2.1-0.1-3.1c-0.2-4.1-1.3-8-3.7-10.3l-0.9-0.8l-1-0.5l-0.5-0.3l-0.8-0.3h-0.3
		c-0.1,0,0.1,0.1-0.1,0h0l-0.6-0.2c-1.6-0.2-3.2,0-4.7,0.7c-3,1.5-5.4,5-7.1,8.6c-0.5,0.9-1,1.9-1.4,2.9c-0.4,1.1-0.9,2.1-1.4,3.1
		c-0.5,1.2-1.1,2.3-1.9,3.4l-0.9,1l-0.5,0.4l-0.7,0.5c-0.5,0.3-1,0.5-1.6,0.6h-2.4l-0.6-0.2l-1-0.4l-0.9-0.3l-0.9-0.4l-1.5-0.8
		l-0.6-0.2l-0.6-0.3c-1.8-0.6-3.8-0.9-5.7-1c-2-0.1-4.1,0-6.1,0.2l-3.1,0.5l-1.5,0.3l-1.3,0.3l-0.4,0.2h-0.2c-0.1,0.1,0.1,0,0.1,0
		c0.1,0,0.1,0,0.1-0.1c0.1,0,0,0.1-0.1,0.3c-0.1,0.7-0.2,1.3-0.1,2c0.3,1.8,0.9,3.5,1.8,5c2.2,3.2,5.2,5.7,8.7,7.2l3.1,1.3l3.1,1.5
		l3,1.6l3,1.7c3.9,2.3,7.6,4.8,11.3,7.4s7.2,5.3,10.7,8.3l2.5,2.2l2.6,2.5l1.1,1.2l1.1,1.2l2.3,2.4c3,3.2,6.1,6.3,9.2,9.3
		s6.4,6,9.7,8.9s6.6,5.8,10,8.4c1.7,1.4,3.4,2.6,5.2,3.8l2.6,1.8l2.7,1.6l1.6,1l1.6,1c1,0.8,1.9,1.7,2.8,2.6c0.9,1,1.8,2,2.5,3.2
		c0.3,0.7,0.5,1.3,0.8,1.9c0.2,0.7,0.4,1.4,0.6,2.1c0.5,2.8,0.3,5.6-0.8,8.2c-0.9,2.4-2.3,4.6-4,6.5l-1.5,1.5l-0.6,0.5l-0.3,0.3
		l-0.5,0.3c-0.9,0.8-1.9,1.4-2.8,2.1s-3.9,2.4-5.9,3.5c-4,2.2-8.1,4.1-12.2,5.9c-2.1,0.9-4.1,1.8-6.3,2.6c-1.2,0.5-2.5,0.8-3.8,1.1
		c-1.5,0.2-3,0.1-4.4-0.2c-2.4-0.7-4.6-1.7-6.8-2.9l-5.9-3.2c-3.8-2.1-7.6-4-11.6-5.7c-3.9-1.7-7.9-3-12-4c-2-0.4-4-0.7-6.1-0.9
		h-2.8l-1.3,0.2l-1.3,0.4c-1.7,0.5-3.3,1.4-4.6,2.6c-1.3,1.2-2.3,2.6-3,4.2l-0.4,1.2c-0.1,0.2-0.2,0.5-0.2,0.7v0.6l-0.2,1.4v1.4
		c0,0.9,0.1,1.9,0.2,2.8c0.1,1,0.4,1.9,0.6,2.9c0.1,0.5,0.2,0.9,0.4,1.4l0.5,1.6l0.5,1.5l0.2,0.4c0,0.1-0.1-0.1,0,0.1h0.1l0.3,0.7
		c0.4,1,0.8,1.9,1.3,2.8l1.5,2.6l1.8,2.4l2,2l2.3,1.7l1.2,0.8l0.6,0.3l0.7,0.3c3.7,1.6,7.7,2.4,11.7,2.5c4.2,0.3,8.6,0.1,13.1,0.1
		h3.3c1.1,0,2.2,0.1,3.2,0s4.3-0.1,6.5-0.3c4.3-0.3,8.7-0.8,13.1-1.3c8.8-0.9,17.9-1.7,27.2-0.4h0.3l4,1.1c1.3,0.4,2.7,0.7,4,1.2
		l2.1,0.8l2,0.9c1.5,0.7,2.9,1.6,4.1,2.7l1,0.9l0.8,1.1c0.3,0.3,0.6,0.7,0.8,1.1l0.6,1.2c0.3,0.8,0.5,1.7,0.7,2.5
		c0.2,0.7,0.4,1.5,0.4,2.3c0.1,0.7,0.2,1.5,0.2,2.2v2.1c0.1,1.4,0.1,2.8,0.1,4.1v4.2c0,1.3,0.1,2.5,0.1,3.8s0.2,2.5,0.4,3.7l0.3,1.9
		l0.4,1.8c0.1,0.6,0.3,1.2,0.5,1.8c0.1,0.6,0.3,1.1,0.5,1.7c0.2,0.6,0.4,1.2,0.7,1.7c0.2,0.6,0.5,1.1,0.8,1.6c0.5,1.1,1.1,2.1,1.8,3
		l1.1,1.3l0.5,0.6l0.5,0.4l-0.6-0.3c3.3,1.6,6.7,2.8,10.2,3.7c3.5,0.9,7,1.3,10.6,1.2c7.2,0,14.6-2,22.7-2.7l3-0.2h8.7l5.8-0.2h3.1
		c1.2,0,2.4,0.1,3.5,0.4l2.2,0.9c0.9,0.6,1.6,1.3,2.2,2.2c0.4,0.8,0.7,1.6,0.9,2.5c0,0.4,0,0.7,0.1,1.1v1c-0.1,0.3-0.1,0.6-0.1,0.9
		v0.4l0,0v0.4l-0.3,1.6c-0.3,1-0.5,2-0.7,2.9l-3,11.2c-2.1,7.5-4.1,14.9-6,22.3s-3.6,14.8-4.8,22.2c-0.4,1.9-0.6,3.7-0.8,5.6
		c-0.1,0.9-0.2,1.7-0.3,2.6v5.3l0.4,2.7c0.2,1.8,0.6,3.7,0.9,5.6c1.4,7.4,3,15,4.6,22.5c3.2,15,6.6,30,9.6,45.1
		c0.8,3.8,1.5,7.6,2.2,11.5l0.9,5.7c0.2,1.1,0.3,2.1,0.4,3.2c0.1,1,0.3,2.1,0.3,3v2.1l0,0v3.8c-0.1,1.8-0.2,3.7-0.1,5.5
		c0,3.6,0.4,7.2,1.3,10.7c1.7,6.9,5.2,13.3,10.1,18.4l1.9,1.8c0.7,0.7,1.4,1.3,2.1,1.9l1.1,1l0.3,0.2l0.2,0.2l0.5,0.4l2.1,1.7
		c1.3,1,2.7,1.8,4.2,2.5c0.5,0.3,1,0.4,1.6,0.4c0.5,0,1-0.1,1.4-0.3c1.5-0.7,2.8-1.6,4.1-2.6c1.6-1.2,3.3-2.4,5.1-3.4l2.7-1.5
		c0.9-0.5,1.9-0.9,2.9-1.3l2.7-1.1l2.7-1.1c1.8-0.7,3.7-1.4,5.7-2c2.1-0.8,4.4-1.3,6.7-1.3l2.1,0.2c0.7,0.2,1.3,0.4,2,0.6l1.9,1
		l0.8,0.6l0.7,0.6c1.6,1.6,3.1,3.3,4.3,5.2l-0.5-0.6l1.4,1.5l1.3,1.5c0.4,0.5,0.8,1.1,1.1,1.7c0.4,0.5,0.8,1.1,1.1,1.7
		c0.4,0.6,0.7,1.2,1,1.8c0.2,0.6,0.5,1.2,0.8,1.8c0.5,1.2,0.9,2.5,1.3,3.7c0.4,1.2,0.7,2.4,0.9,3.7c0.3,1.2,0.5,2.4,0.8,3.6
		s0.9,4.5,1.4,6.6s0.7,2.1,1,3.1c0.4,1,0.8,1.9,1.3,2.8l0.8,1.3l0.8,1.3l1,1.2l1,1.1c0.7,0.8,1.5,1.5,2.4,2.1l1.2,1l1.4,0.9l1.3,0.9
		l1.5,0.8c0.9,0.6,1.9,1.1,2.9,1.5l0.4,0.2l0.2,0.2l45.5,33.5l-1.5-0.7l0.8,0.2l0.5,0.2l1.1,0.6c0.7,0.5,1.3,1.2,1.8,1.9
		c0.2,0.4,0.4,0.8,0.6,1.2l0.3,1.2c0.1,0.4,0,0.7,0.1,1c0,0.3,0,0.7-0.1,1l-0.3,1.7c-0.2,0.5-0.3,1-0.5,1.4l-0.6,1.3l-0.7,1.1
		c-0.4,0.8-0.9,1.5-1.4,2.2l-1.3,1.7l-1.4,1.8l-1.2,1.7c-3.5,4.7-7,9.5-10.8,14.1c-3.8,4.7-7.9,9.1-12.4,13.2
		c-2.3,2.1-4.8,4-7.4,5.7c-2.7,1.8-5.6,3.3-8.6,4.3c-3.3,1.2-6.8,1.6-10.3,1.2l-1.3-0.2l-1.4-0.3l-1.4-0.4l-1-0.4l-1-0.4l-0.5-0.2
		h-0.3l-0.5-0.3l-2.1-1.1c-1.4-0.8-2.8-1.6-4.1-2.6c-1.4-1-2.7-2.2-3.8-3.5c-1.2-1.4-2.2-2.9-3-4.5c-0.7-1.6-1.3-3.3-1.6-5
		c-0.7-3.3-0.8-6.2-1.5-8c-0.3-0.8-0.8-1.6-1.5-2.2l-0.3-0.3h-0.2l-0.3-0.2l-0.4-0.3l-0.5-0.3h-0.3l-1-0.5c-4.9-2.8-10-5.2-15.3-7.3
		c-5-2.1-10.3-3.2-15.7-3.4h-1.9l-1.6,0.2l-0.8,0.2l-1,0.3l-1.1,0.3h-0.2l-0.5,0.3c-2.5,1.1-4.9,2.4-7.2,3.9
		c-1.4,0.9-2.9,1.7-4.4,2.4c-1.9,0.8-3.9,1.2-6,1c-1.9-0.2-3.7-0.7-5.4-1.5l-2.3-1.1l-1.9-1.1h-0.3l-0.3-0.2l-0.5-0.3l-1-0.6
		l-1.9-1.2l-3.7-2.5l-7.2-5c-4.6-3.3-9.4-6.3-14.5-8.8c-2.2-1.1-4.6-1.8-7-2.2h-1.9c-0.1,0-0.1,0-0.1,0.1h-0.1c-0.1,0,0-0.1-0.1,0
		h-0.3l-0.5,0.2h-0.2l-1,0.6l-2,1c-5.2,2.6-10.3,5.2-14.2,8.5c-0.5,0.4-0.9,0.8-1.3,1.3l-1.2,1.4c-0.4,0.4-0.7,0.9-1,1.4l-0.4,0.7
		c-0.1,0.2-0.2,0.5-0.3,0.7l-0.3,0.6v0.9l-0.2,1c-0.1,0.4,0-0.1,0,0v0.8l-0.7,4.4c-0.4,3-1,6-1.8,9c-0.4,1.6-0.9,3.2-1.6,4.7
		c-0.8,1.8-1.9,3.5-3.3,4.9c-1,0.9-2.1,1.6-3.4,2c-1.3,0.4-2.7,0.4-4,0.2l-0.9-0.2l-0.9-0.4l-0.5-0.2h-0.2l-0.5-0.2l-0.5-0.3
		l-0.3-0.2l-0.6-0.3l-1.1-0.8c-2.6-2.2-4.8-4.8-6.5-7.8c-1.6-2.7-2.9-5.4-4.3-7.6l-1.1-1.6c-0.3-0.5-0.7-0.9-1.1-1.3
		c-0.1-0.3-0.3-0.4-0.5-0.6l-0.3-0.2l-0.3-0.2l-0.3-0.3h-0.3l-0.5-0.2l-0.5-0.3h-0.3l-1.2-0.5l-2.2-1l-4-2.2l-7.5-4.4
		c-2.4-1.3-4.9-2.4-7.5-3.4c-2.3-1-4.8-1.5-7.3-1.6c-1.1-0.1-2.2,0-3.3,0.3h-1.6l-1.6,0.7c-0.6,0.3-1.2,0.6-1.7,1l-1.7,1l-3.5,2.4
		c-4.5,3.4-9.1,7.1-13.7,10.7s-9.2,7.3-14.2,10.8c-4.9,3.5-10.2,6.6-15.7,9.2c-0.7,0.3-1.4,0.6-2.2,0.9l-2.4,0.9l-1.1,0.4l-1.1,0.3
		l-2.1,0.6h-1.3l-1,0.3l-2,0.4l-4.1,1.1c-5.5,1.6-11.4,3.6-17.6,4.4c-6.2,0.7-12.4,0.6-18.6-0.3l-4.5-0.8c-1.5-0.2-3-0.6-4.4-1
		l-4.4-1l-4.3-1.3c-3-0.8-5.7-1.8-8.6-2.7s-5.6-2-8.4-3.1l-4.1-1.6l-4.1-1.7l-4-1.7l-2.1-0.8l-1.1-0.5l-1-0.5
		c-5.7-2.7-10.9-6.2-15.5-10.5c-4.4-4.2-8.5-8.7-12.1-13.6c-3.7-4.8-7-9.8-10.2-14.7s-6.3-9.9-9.5-14.7c-3-4.7-6.5-9.2-10.2-13.4
		c-1.8-2-3.8-3.8-5.9-5.5l-1.6-1.1c-0.6-0.3-1.1-0.8-1.6-1l-1.6-0.9l-2-0.8l-3.7-1.3l-1-0.3l-1-0.3l-2-0.5l-4.2-1l-4.2-0.8
		c-11.4-2.1-23.8-5.3-34.3-11.7s-19.7-14.4-27.9-23.2l-5.9-6.7c-1.9-2.3-3.7-4.7-5.6-7.1l-2.7-3.5c-1-1.2-1.7-2.4-2.6-3.6l-5.1-7.1
		l-1.2-1.8l-1.3-1.9l-2.5-3.6l-4.9-7.3l-10.1-14.2c-3.4-4.7-6.9-9.3-10.6-13.7c-3.5-4.4-7.4-8.5-11.5-12.3c-2-1.8-4.2-3.5-6.4-5
		c-2.2-1.4-4.5-2.5-6.9-3.3c-4.9-1.7-10.2-1.9-15.8-1.6s-11.4,1-17.2,1.7l-17.4,2c-11.6,1.3-23.2,2.8-34.6,4.6
		c-11.4,1.7-22.8,4-34,6.8l-4.2,1.1l-4.1,1.2l-8.1,2.7c-1.3,0.4-2.6,1-3.9,1.5l-3.9,1.6l-3.7,1.8l-1.8,0.9l-1.9,1.1l-3.5,2.2
		l-3.6,2.4l-7.1,5l-14.4,10.2c-9.8,6.7-20.2,13-31.7,17.4c-5.8,2.2-11.8,3.7-17.9,4.5c-1.6,0.3-3.1,0.4-4.7,0.5l-4.6,0.2h-2.4
		l-2.4-0.2h-2.3l-2.2-0.2L304.3,982.8z"
                />
                <path
                  className="st6"
                  d="M180.6,457.5l10.6-10.9l-0.2-1c0-0.3-4.8-32-6.6-56.1c-1.3-16.6,0.1-19.1,1.7-22.2c1.2-2,2.2-4.2,2.7-6.5
		c2.5-9.2,12.4-75,14.3-87.6l260.4,39.4l1.8-17.3l-3.9-0.4l-1.5,13.1l-260.2-39.3l-0.3,1.9c-0.1,0.8-11.8,79.4-14.5,89.2
		c-0.5,2-1.3,3.9-2.3,5.6c-2.3,4.2-3.5,7.4-2.2,24.4c1.6,21.8,5.7,49.9,6.5,55.5l-9.2,9.4L180.6,457.5z"
                />
                <path
                  className="st6"
                  d="M384.3,526.7c-4,6.7-7.1,14-9.3,21.5l3.9,1c0.1-0.4,11.2-40.7,36.8-38.9l0.3-4
		C403.9,505.5,393,512.5,384.3,526.7z"
                />
                <polygon
                  className="st6"
                  points="1175.9,319.3 1175.9,315.3 1108,315.3 1100.6,380.5 1119.8,376 1112.2,431.6 1116.2,432.2 
		1124.5,370.8 1105.3,375.3 1111.6,319.3 	"
                />
                <path
                  className="st6"
                  d="M1627.5,305c0-1.4,0.2-14.2-4.4-18.9c-1.1-1.1-2.6-1.8-4.2-1.8c-6.9,0-10.3,0-15.7-4.6
		c-1.2-1.1-2.9-1.6-4.5-1.2c-3,0.9-4.3,4.9-5.6,9.1c-0.9,2.6-1.9,5.8-2.9,6.6s-3.2,0.8-5.8,0.7c-4.3-0.1-10.2-0.2-16.6,3.7l-3.8,2.4
		c-2.5,1.5-3.8,2.3-4.7,2.4s-2.7-0.7-5.7-2l-0.9-0.5c-9.2-4.1-38.7-27.4-39.9-31.5s-4.1-12.8-13.2-19.7c-9.1-6.9-23.5-22-24.2-22.8
		s-7.7-8.6-11.7-12.1c-1.1-1-1.1-1.7-1.1-1.9c0.1-0.9,0.5-1.7,1.2-2.3l-1.4-1.4l-1.3-1.5c-1.5,1.3-2.4,3.2-2.5,5.2
		c0.1,1.9,1,3.7,2.5,4.9c2.8,2.5,7.6,7.7,9.9,10.3c-8.3,8-33.1,41.6-36.1,46c-4.6,6.6-5.2,6.5-9.7,5.7s-11.8,6.1-18.5,14.3l-2.4,2.9
		c-5.9,7.2-8.2,6.8-11.9,6.1h-0.6c-4-0.7-5.7,4.9-8,11.9c-1.5,4.8-3.5,10.7-5.6,12.4c-4.2,3-18.8-1-24.3-4.2s-15.1-21.8-16.1-27.4
		c-0.3-1.3-1.1-2.5-2.3-3.2c-4.7-2.7-15.2,0.9-17.3,1.7l1.4,3.7c4.4-1.6,11.6-3.2,13.9-1.9c0.2,0.1,0.3,0.2,0.3,0.4
		c1.1,5.7,12.2,26.6,18,30.1c3.3,1.9,13.5,5.8,21.4,5.8c2.6,0.1,5.2-0.5,7.4-1.8c3.2-2.4,5.1-8.5,7-14.4c1.1-3.3,2.6-8.2,3.7-9.1
		h0.4c5.1,0.9,8.8,0.9,15.7-7.6l2.4-2.9c5.1-6.3,11-13.5,14.7-12.9c6.5,1.2,8.4,0.2,13.6-7.3s29.4-39.4,35.6-45.4
		c4,4,16.2,16.3,23.5,21.9s10.8,12.8,11.7,17.3s10.3,11.7,18.2,18s18.9,14.1,24,16.4l0.9,0.4c3.5,1.6,5.4,2.4,7.2,2.4s3.7-1,6.9-3.1
		l3.8-2.3c5.4-3.2,10.4-3.1,14.4-3.1s6.1,0.1,8.3-1.5s3.1-5,4.3-8.5s2-6.2,2.9-6.6l0.8,0.5c6.6,5.5,11.2,5.5,18.3,5.5
		c0.5,0,1,0.2,1.3,0.6c2.6,2.6,3.4,11.2,3.3,16L1627.5,305z"
                />
                <path
                  className="st6"
                  d="M1623.3,265.4c-5.3-5.3-32.1-42.1-32.3-42.5l-3.3,2.4c1.1,1.5,27.2,37.4,32.8,42.9c0.9,1,2.2,2.5,3.6,4.4
		c6.9,8.5,19.6,24.4,39.7,25.7h2.2v-2.2c0-0.1-0.4-13.6,4.3-23.6s0.8-18.7-1.6-26c-0.8-2.3-1.4-4.2-1.8-5.7
		c-0.9-4.4,2.6-15.8,7.6-21.9c1.9-2.5,3.8-3.7,5.5-3.7c9.4,0,16.3-6.7,16.9-11.2c0.3-0.6,2.3-1.5,3.6-2c3.1-1.5,7.5-3.4,7.5-7.8
		v-1.5c0.2-5.3,0.4-10.7-15.9-32.4c-8.8-11.7-8.6-21.9-6.8-28.3c2.1-8.2,7.4-13.7,10.5-15c2.6-1,5.3-1.6,8-1.8
		c4.2-0.6,8.6-1.2,10.9-5c3.5-5.9,5.2-14.6,4.8-24.1c-0.3-5.6,2.4-7.7,6.1-10.6c2.2-1.6,4.2-3.5,6-5.6c5.7-7.5,5.7-17,0.1-26.3
		s-5.7-13.1-5.7-13.1l-4,0.4c0,0.2,0.6,5.5,6.3,14.8s4.8,15.6,0.1,21.8c-1.5,1.8-3.3,3.4-5.2,4.8c-4,3.1-8.1,6.3-7.7,14
		s-1.1,16.7-4.2,21.8c-1.3,2.1-3.9,2.6-8.1,3.1c-3.1,0.3-6.1,1-9,2.1c-4.4,1.9-10.4,8.7-12.8,17.6s-2.2,18.8,7.5,31.8
		c15.4,20.5,15.3,25.5,15.1,29.9v1.6c0,1.7-2.2,2.8-5.2,4.1s-5.4,2.5-5.8,5.1s-5.3,7.8-13,7.8c-2.9,0-5.8,1.7-8.6,5.1
		c-5.4,6.7-9.6,19.5-8.4,25.3c0.5,2.1,1.2,4.1,1.9,6.1c2.3,7.1,5.2,15.8,1.8,23.1s-4.7,18.7-4.7,23.2c-17.1-2.1-28-15.8-34.7-24
		C1625.6,268.1,1624.4,266.5,1623.3,265.4z"
                />
                <rect
                  x="1340.5"
                  y="1174.1"
                  transform="matrix(0.1547 -0.988 0.988 0.1547 45.6458 2405.4946)"
                  className="st6"
                  width="176.2"
                  height={4}
                />
                <polygon
                  className="st6"
                  points="755.3,276.8 755.1,278.8 789.4,281.3 805,272 847.6,276.6 847.8,274.6 804.6,269.9 788.9,279.3 	"
                />
                <path
                  className="st6"
                  d="M1737.7,664l171.9,27.4l0.6-4l-131-20.9l16-97.5l81.5,10.7l0.3-2l-81.5-10.6l3.9-24.1
		c27.1,5.7,55.5,10.3,77.5,10.3v-4c-58,0-162.4-32.2-163.4-32.5l-0.5-0.2l-77.1,11.9c-13.4-1.8-241.8-31.8-259.6-32.8
		s-25,8.6-31.7,16.2l-2.9,3.3c-7.3,7.8-26.4,30.5-34.1,42.9l-2-1c-6.8-3.4-11.6-5.8-13.2-6.4s-26.1-18-40.1-28.4l-2.4,3.2
		c3.8,2.8,36.8,27.2,41,28.9c1.4,0.5,6.7,3.2,12.9,6.3l1.8,0.9c-5.5,10.3-7.3,13.1-28.9,26.2c-14.2,8.7-27.9,18.4-40.8,29l1.2,1.6v1
		l1.1,0.2l0.3,0.3l0.3-0.2l40.3,7l-13.9,92.7c-9.2,4.1-17.4,7.7-24.3,10.6h-0.3c-11.3,4.9-18.8,7.9-20.5,8.3
		c-4.3-0.8-29.2-3.9-54.5-7.1l-13.7-1.7c-7.7-1-12-1.3-37.1-1.5c-19.9-0.3-26.2-4-30.9-6.8c-1-0.6-2-1.1-3-1.6
		c-2.7-1.3-19-10.1-37.8-20.3s-39.5-21.5-54.4-29.4l-1.1-0.6c0.8-0.6,1.6-1.1,2.5-1.6c6.9-3.4,9.6-3.6,11.4-3.7
		c2-0.1,3.8-0.9,5.1-2.4c1.5-1.7,2.9-3.4,4.2-5.3c2.7-3.8,7.7-10.9,10.2-10c5.5,2,11.2,7.2,11.5,8.7s0.1,0.6,0.2,0.9
		c0.6,4.2,2,12.9,8.2,13.8h1.4c4.2,0.6,6.1,0.9,10.2,4l2.2,1.7c8.1,6.5,29.8,23.9,47.9,20.6s32.5-14.3,34.1-20.4
		c0.7-2.8-0.2-6-1.1-9.3s-1.8-6.6-1.2-9.2c2.3-9.4-2.1-16.7-12.3-20.1c-2.4-0.8-3.7-1.9-4-3.3c-0.5-3.1,3.9-8.7,10.8-13.9
		s7.1-14.7,5.8-18.8s-2.6-11.7-2-14.8c0.3-1.6-0.5-3.5-2.3-5.9c-4.3-5.5-15-13.8-23.3-14.5c-3-0.2-7.5-5.2-12.2-10.5
		c-7.9-8.9-17.7-19.8-30-20c-5.6,0-9.4-1.1-10.6-3s-0.3-3.9,0.5-5.6s1.3-1.6,1.7-1.7c2.9-0.7,8.4,3.3,11.3,5.4
		c5.3,3.9,13,3.8,18,3.7h1.9c2.3,0.1,4.6,0.5,6.8,1.2c2,0.7,4.1,1.2,6.2,1.5c6.4,0.9,9.5-0.6,13.8-6.8l2.7-3.5
		c4.3-5.4,10.2-12.8,5.8-21.8c-1.1-2.3-2.2-4.8-3.3-7.5c-3.8-9-8.1-19.2-15.5-24.3c-5.6-3.8-14.1-9.7-14.5-13.2c0-0.5,0.2-1,0.5-1.3
		c2-2.1,7.7-2.9,12.6-3.7c3.7-0.3,7.3-1.1,10.8-2.3c7.3-2.9,23.5-8,32.2-6.1c2.6,0.5,5,0.8,7.7,1.1c7.2,0.9,14.7,1.9,24.6,7.9
		l2.1-3.4c-10.6-6.5-18.9-7.5-26.3-8.4c-2.5-0.3-4.9-0.6-7.3-1.1c-12.1-2.6-33.6,6-34.5,6.3c-3.2,1.1-6.5,1.8-9.8,2.1
		c-6.2,0.9-12,1.7-15,4.9c-1.2,1.1-1.8,2.8-1.6,4.4c0.5,5,7.4,10,16.2,16.1c6.5,4.5,10.5,14.1,14.1,22.5c1.2,2.8,2.3,5.4,3.4,7.7
		c3.3,6.8-1.1,12.3-5.3,17.6c-1,1.2-2,2.4-2.9,3.7c-3.8,5.5-5.6,5.8-9.9,5.1c-1.9-0.3-3.8-0.7-5.7-1.3c-2.6-0.8-5.2-1.3-7.9-1.4h-2
		c-4.8,0.1-11.3,0.2-15.5-2.9s-10.4-7.2-14.7-6.1c-2,0.6-3.5,2-4.3,3.9c-2.3,4.6-1.4,7.7-0.3,9.4c2,3.3,6.6,4.9,14,4.9
		c10.5,0.2,19.6,10.4,27,18.6c5.7,6.5,10.3,11.5,14.9,11.9c9,0.7,22.1,12.9,22,15.7c-0.8,4.5,1.7,15.3,2,16.5v0.2
		c0.2,0.4,2.9,9-4.3,14.4c-4,3-13.4,10.9-12.3,17.7c0.3,2.1,1.7,4.9,6.6,6.5c8.3,2.8,11.6,7.9,9.7,15.3c-0.9,3.7,0.2,7.7,1.2,11.2
		s1.5,5.5,1.1,7.3c-0.9,3.4-11.8,14-30.9,17.5c-16.4,3-36.9-13.6-44.7-19.8l-2.3-1.8c-4.9-3.7-7.6-4.1-12-4.7l-1.4-0.2
		c-3.3-0.5-4.5-7.7-4.9-10.4c-0.1-0.4-0.1-0.7-0.2-1c-0.7-3.8-8.3-9.7-14-11.8s-10.4,5.2-14.9,11.5c-1.1,1.7-2.4,3.3-3.7,4.8
		c-0.6,0.8-1.6,1.3-2.6,1.2c-2,0.1-5.2,0.3-12.9,4.1c-1.6,0.9-3.1,1.9-4.5,3.2c-17.9-9.7-22.5-13.4-26.9-17
		c-1.7-1.4-3.5-2.9-6.1-4.7c-9-6.2-16.7-6-21.2-5.9h-26.5c-2.2,0-13.2-1.4-26-3.1c0.6-4,0.6-8.2-0.1-12.2c-0.7-3.6-6.8-9.9-16-19
		c-4.7-4.6-9.6-9.5-10.5-11.3s-1.9-5.2-0.3-20.4c3.3-0.4,13.5,0,20.5,0.2l12.5,0.3h0.1c2.2,0.1,4.2-0.9,5.5-2.7
		c4.3-6.1-0.6-21.1-2.2-25.5l-0.5-1.3h-3.4l3-18.2l-72.2-9.9l-0.5,4l68.1,9.3l-3.1,19h5.3c2.7,7.9,4.5,17.3,2.2,20.5
		c-0.5,0.7-1.3,1.1-2.2,1h-0.1l-12.3-0.3c-5.4-0.2-11-0.4-15.3-0.4c-6.5,0-9,0.2-9.2,2.5v0.4c-1.3,12.1-1.1,20,0.6,23.5
		s5,6.2,11.3,12.4s14.3,14.2,14.9,16.9c0.5,3.6,0.6,7.3,0.1,10.9l-8.7-1.2l-32.9-4.3c-22.8-2.8-32.5-2.6-34-2.5l-71-9.8l20.5-145.3
		l-3.9-0.6l-20.7,145.3l-33.5-4.6l16.8-118.7L702,494l-16.8,118.7l-62.9-8.7l10.4-73.2l-4-0.6l-10.4,73.3l-91.6-12.7l31.6-223.4
		l157.5,21.7c12.5,2,13.8,4.4,18.9,13.3c0.5,0.8,1,1.7,1.5,2.7c6.4,11.1,30.1,57.4,30.3,57.9l3.6-1.8c-0.2-0.5-24-47-30.4-58.1
		l-1.5-2.7c-5.2-9.2-7.4-13-21.8-15.3l-194.3-26.7l6.7-49.3c0.1-0.7,6.8-67,7.9-85.1c0-1.2,0.1-2.5,0.3-3.7l90.8,12.5l0.5-4
		l-90.8-12.5c2.2-16.1,8-49.9,13.6-81.8c33.1,4.3,64.5,8.3,78.9,10.5c24.2,3.5,31.4,2.7,37.3,2.1c3.8-0.5,7.7-0.5,11.5-0.1
		c15.1,1.5,92.3,16.4,93.1,16.5l0.4-1.9l-0.3,1.9l238.2,32.9c-1,16.7-2.3,29.5-3,35.5l-150.3-21.5l-0.3,2l150.4,21.5
		c-0.1,1.2-0.2,1.8-0.2,1.8l-3.2,22.2l-150.5-20.6l-0.3,1.9l150.6,20.6l-15.7,110.6l4,0.6l19-134.7c0-0.1,0.1-0.7,0.3-1.8l89.8,12.8
		l-19,134.9l3.9,0.5l24.4-172.6l79.9,11l0.5-3.9l-79.8-11l8.8-62.2l81.5,10.8l0.3-2l-81.6-10.8l3.4-24l90.9,12.5l-24.7,186.6
		l1.9,0.3l24.7-186.6l171.6,23.6l-16.8,19.2c-7.4,8.1-10.4,24.7-11.1,29.5c-0.2,1.1-0.5,2.2-0.8,3.2c-1.4,5.7-3.7,14.3-0.1,19
		l3.2-2.4c-2.4-3.2-0.4-11,0.8-15.6c0.4-1.4,0.7-2.5,0.9-3.5c1.4-9.5,4.8-21.8,10-27.5s47.7-54.4,50.4-57.5
		c5.6-4.3,5.9-7.9,6.3-11.7c0.1-2.4,0.6-4.7,1.4-6.9c3.3-0.4,10.9-1.6,16.6-4.2l-19.5,113l2,0.3l7.7-44.6c4.6,0.7,23.7,3.8,28.6,2.5
		c2.3-0.5,4.1-2.7,6.2-5.2s7.1-8.3,13.4-7c3.8,0.8,18.3,3,36.5,5.8c31.5,4.7,74.6,11.3,78.5,13.1l25.6,12.3l0.8-1.8l-25.5-12.3
		c-3.9-1.8-38.1-7.1-79.1-13.3c-17.5-2.7-32.6-5-36.4-5.8c-7.4-1.5-11.8,3.6-15.3,7.8c-1.8,2.1-3.5,4.1-5.2,4.5
		c-4,1-20.6-1.4-27.8-2.6l11.7-67.8c4.7-2.7,8.9-6.1,12.6-10.1c3.6-3.5,5.9-5.8,10.8-6.1c4.5-0.2,8.9,0,13.4,0.4
		c7.7,0.6,14.9,1.1,19-0.5c6.3-2.6,58.1-61.6,64-68.3l-1.5-1.4c-23,26.3-58.8,66-63.3,67.8s-10.9,1-18,0.4
		c-4.6-0.4-9.1-0.6-13.7-0.4c-5.7,0.3-8.5,3.2-12.1,6.7c-3.7,4-7.9,7.3-12.6,10c-4.9,2.7-12.5,4.1-16.5,4.6c1.8-3.6,5-8.1,11.1-14.2
		l3.8-3.6c23.2-22.8,58.4-57.2,60.4-79.8l-4-0.3c-1.8,21-36.4,54.8-59.2,77.2l-3.8,3.7c-13.5,13.2-14.1,20.4-14.6,25.7
		c-0.3,3.6-0.5,5.7-4.9,9l-0.3,0.3l-30.4,34.8l-7-0.9l23.5-146.1l-2-0.4l-23.5,146.2l-88.9-12.2l0.6-4.8
		c2.4-17.6,5.7-41.6,15.4-69.7c10.9-31.9,12.1-85.1,12.1-85.6h-4c0,0.6-1.1,53.1-11.9,84.4c-9.8,28.5-13.1,52.7-15.5,70.4
		c-0.3,1.7-0.5,3.3-0.7,4.8l-165.1-22.7L1137.8,14l-3.9-0.6l-14.2,100.1l-93.7-12.9l16.9-123.1l-4-0.5l-16.8,123.1L879.4,80.4
		l-0.6,4l61.4,8.4l-3.9,31.3l-65.8-9.7l-0.3,2l67.8,10l0.8-6.4l78,10.4c-4.8,26.4-5.1,32.5-5.5,44.9c-0.2,3.7-0.3,7.8-0.6,13.2
		c-0.1,1.3-0.1,2.6-0.2,3.9l-237.9-32.8c-3.7-0.7-78.2-15.1-93.4-16.6c-4.1-0.4-8.3-0.4-12.4,0.1c-5.6,0.6-12.5,1.4-36.2-2.1
		c-14.5-2.1-45.8-6.2-78.8-10.4c6.2-35.4,12.1-67.3,12.2-68l-3.9-0.7c-0.5,2.7-6.2,33.8-12.3,68.2l-106.4-13.3l-0.5,4
		c0.9,0.1,54.9,6.7,106.2,13.2c-5.6,31.8-11.4,65.5-13.6,81.8l-546.6-75.3l-0.5,3.9L533,219.7c-0.1,1.7-0.3,3.1-0.3,4.1
		c-1.1,18-7.8,84.2-7.9,84.8l-6.6,49.2l-84.9-11.6l-0.5,3.9l84.8,11.7l-30.3,223.6l-31.9-4.4l7.3-51.8l-4-0.5l-15,106L342,621.6
		l-0.2,2l-1.5-1.3l-22.8,25.2l-50.3-6.8c1.6-11.8,2.8-21.2,3.2-23.4s0.2-1.8,0.3-2.5c0.6-5,0.7-5.8,4.6-10.1l46.7-47.3
		c15.6-15.8,29-29.5,30.8-31.2s17.4-4.7,27.3-5.5l-0.3-4c-4.2,0.4-25.5,2.4-29.8,6.7c-1.8,1.7-15.3,15.4-30.9,31.2
		c-19.7,20.1-42.2,42.8-46.7,47.3s-5,6.8-5.7,12.4l-0.3,2.4l-3.2,23.5l-138.1-18.6l-0.5,4l138.1,18.6c-1.2,8.7-2.5,18.4-3.7,27.4
		l-51.8-7.2l-0.6,4l51.9,7.2c-2.1,15.7-3.8,28.4-3.8,28.8l3.9,0.5c0.1-0.3,1.8-13.1,3.9-28.8l172,23.7l-4.1,29.2
		c-0.8,3.6-0.9,7.3-0.4,11l-81.8,30.5l1.4,3.7l24.5-9.1l10.6,28.2l-164.4,61.1l1.4,3.7L386.1,797l9.9,26.2l-85.8,31.9l1.4,3.8
		l85.8-31.9l10.5,27.8l-85.5,31.8l1.4,3.8l85.5-31.8l9.5,25.1l-169.1,62.9l1.4,3.7l169.1-62.8l9.9,26.2l-119.9,44.2l1.4,3.8
		l267.1-98.4L761,887.9l0.5-4l-91.7-12.3l11.9-84l94.8,13.1v-1L882,815.3l-7.4,50.2l-108.5-14.1l-0.2,2l51,6.6l-5.5,38.9l-50.9-7.6
		l-0.6,4l50.9,7.6l-5.5,38.1l-51-6.2l-0.2,2l51,6.2l-9.3,64.8l2,0.3l15-104.9l55,8.2l-45.7,310.8l-108.4-17.8l-0.6,4l108.4,17.7
		l-5.4,36.9l3.9,0.6l5.4-36.8l108,17.6l-3.5,26.6l4,0.5l3.5-26.4l123.2,20.1l0.6-3.9l-123.3-20.2l41.9-313l312,46.6l-2.8,19.2
		c-9.2-1.3-16.4-2.2-20-2.6l-5.6-0.6c-16.7-1.7-31.2-3.1-40-8.2s-26.8-10.6-36.3-11.6l-0.2,2c9.3,1,25.5,5.6,35.5,11.3
		s23.8,6.8,40.8,8.5l5.6,0.6c3.6,0.3,10.7,1.3,19.9,2.6l-5.6,39.4l-102.8-14.7l-0.2,2l102.7,14.7l-44.6,309.7l4,0.6l46-319.7
		l111.1,14.8c-12.9,85.7-27.1,178.8-37.4,246.3l4,0.6c3.5-23.5,20.8-136.8,37.4-246.3l29.5,3.9l2.6-18.3l47.3,7.1l123.5,137
		c-8.8,0.3-38.3-5.8-65.2-12.7l-1,3.8c0.1,0.1,16.3,4.3,32.9,7.8c18.4,3.9,27.8,5,32.6,5c1.3,0,2.6-0.1,3.9-0.4l93,103.1l3-2.7
		l-92.4-102.4l0.9-0.5c9.5-4.3,20-13.5,24-69.5l5.1-33.5l217.6,33.6l0.6-3.9l-217.6-33.6l15-98.8c6.1,0.1,9-2.3,11.4-4.2
		s4.1-3.2,8.6-2.5s6.3,2.1,10.1,4.4c7.2,4.2,17,10,39.9,13.3c34.6,4.9,151.9,18.8,153,19l0.5-4l-65.9-7.9l12.6-77.4l36.8,5.3l0.6-4
		l-36.8-5.2l13.2-80.8l46,6.9l0.6-3.9l-46-6.9l8.1-49.9l9.3,1.4l0.6-3.9l-9.2-1.4l10.9-66.7l-4-0.6L1848,766l-121.9-18.1L1737.7,664
		z M1101.1,245.3l-89.9-12.8c0.6-6,1.9-18.8,3-35.6l92,12.7L1101.1,245.3z M1119.2,117.5l-3.4,24l-94.7-12.6
		c1.1-5.6,2.3-12.2,3.8-19.8l0.6-4.5L1119.2,117.5z M939,118l3.1-24.9l79.4,10.9l-0.5,4.4c-1.6,7.7-2.8,14.3-3.9,20L939,118z
		 M1014.7,188.7c0.3-5.4,0.4-9.6,0.6-13.2c0.4-12.3,0.6-18.3,5.5-44.6l94.7,12.5l-8.8,62.2l-92.2-12.7
		C1014.5,191.5,1014.6,190.1,1014.7,188.7z M1795.5,542.2l-4,24.3l-158.8-20.7l-0.3,2l158.8,20.7l-16,97.4l-237-37.8
		c0.4-5.4,2.3-27,6.5-41.8l-1.4-0.4c42.6-24.6,89-51.1,93.2-53.5l76.2-11.7C1717.2,522.1,1754.3,533.3,1795.5,542.2z M1522.2,712.9
		l-178.4-24.5c53.2-24.4,118.2-54.8,131.7-63.1l4.2-2.5l54,8.6L1522.2,712.9z M1479.1,618.5l-29.6-12.1c-3.8-1.3-7.7-2.4-11.6-3.1
		l13.4-94.7c66.2,8.4,154.9,20,178.4,23.1C1606.4,545,1510.5,599.9,1479.1,618.5z M1540.2,587.7c-3.9,14.8-5.6,34.1-6,39.8
		l-49.1-7.9C1498,612,1518.4,600.2,1540.2,587.7z M1437.3,607.3c3.7,0.7,7.3,1.6,10.8,2.9l26.7,10.9l-1.4,0.8
		c-5.9,3.6-21,11.2-41.1,20.8L1437.3,607.3z M1344.6,517.9l3-3.3c6.5-7.4,13.8-15.7,28.5-14.9c5.8,0.3,34.7,3.8,71.2,8.4l-13.8,97.7
		c-8.2-3.1-43.1-16.4-54.1-20.8c-7.1-2.9-15.4-4.9-23.3-6.9c-5.5-1.2-11-2.8-16.3-4.6c-5.4-2-17.8-8.1-28.6-13.6
		C1318.8,547.8,1337.5,525.6,1344.6,517.9L1344.6,517.9z M1309.2,563.4c11,5.5,23.6,11.8,29.2,13.9s10.4,3.1,16.7,4.7
		c7.8,1.9,15.9,3.9,22.8,6.7c11.5,4.6,48.8,18.8,55,21.2l-4.9,34.9l-9.3,4.4l-137.5-24.1l5.9-39.1
		C1301.4,576.9,1303.9,573.2,1309.2,563.4L1309.2,563.4z M1240.8,618c12.1-9.7,24.7-18.6,37.9-26.8l6.1-3.7l-5.5,37.2L1240.8,618z
		 M1280.9,627.1l134.7,23.6c-45.3,21.4-106.4,49.2-148.3,67.7L1280.9,627.1z M1258.6,726.7l40.3-18l-3.9,29.4l-46.7-7L1258.6,726.7z
		 M1420.4,929.8c1.6-10.6,3.1-20.7,4.5-30.2l69.4,9.6l-4.5,30.3L1420.4,929.8z M1407.6,988l-111.3-16.6l8.2-56.8l111.4,18.5
		C1413.3,950.3,1410.5,968.7,1407.6,988z M1416.5,929.2l-111.4-18.6l18.4-128l64.7,10.5l-11.9,63.7l1.9,0.4l12-63.8l33.6,5.5
		l-3.5,20.6l12,1.9C1431,831.8,1424.8,873.2,1416.5,929.2z M1424.1,796.9l-100.3-16.3l4.8-33.4l101.4,15.2L1424.1,796.9z
		 M1319.8,780l-27.8-4.6l4.4-33l28.2,4.2L1319.8,780z M1290,775.1l-73.6-12l-0.3,2l103.4,16.8l-17.1,119.2l-104.6-13.4l-5.6,39.4
		l-103.7-15.4L1221,742.2c2-0.5,6.9-2.3,20.4-8.1l53,8L1290,775.1z M1007.5,684.7l-6.2,41.3c-3.3-1.1-9.2-2.8-14.6-2.5l-12.2,1.2
		c-9.6,1-21.6,2.2-25.5,2.1c-3-0.3-6-0.9-8.9-1.6c-5.4-1.3-11-2.6-15.5-1.9l-1.7,0.2c-21,3.1-26.9,2.7-28.1,1.9
		c-2.6-1.6-4.1-4.5-3.9-7.6c0-1,2.2-4.3,5.8-6.7s4.3-2,5.4-1.6s4.3,2.4,7.1,4.2c6.1,4,10.3,6.6,13.2,6.6s23.1-0.5,27.4-1.6
		c2.2-0.6,5.4-3,10.4-6.9c2.6-2,6.4-4.9,7.6-5.3c3.4-0.1,12.7-6.1,13.3-11c0.1-1.2,0.1-2.4,0-3.6c-0.1-5.1-0.4-13.5,3.6-19.4l2,1.1
		L1007.5,684.7z M797.2,632.1l0.3-1.9v2c0.1,0,9.6-0.5,33.5,2.5l15,1.9l-9.6,73.8l-120.6-15.9l10.2-72.2L797.2,632.1z M722,621.8
		l-15,106.5l-33.5-4.6l15.1-106.5L722,621.8z M684.6,616.6l-15.1,106.6l-62.8-8.7l15-106.5L684.6,616.6z M570.7,600.9L520,638.2
		l6.1-43.4L570.7,600.9z M501.6,749.8l-26.2,9.7c-0.9-2.1-1.5-3.6-1.9-4.4l-1.5-3.2c-2.7-5.6-2.8-5.8-1.6-12.2l4.6-34.3l30.8,4.2
		l-4.4,30.8l-0.9,6.3L501.6,749.8z M551.4,769.7l64.3,8.8l-11.9,84.2l-23.9-3.3l-33.2-87.9L551.4,769.7z M430.3,814.7l54.4-20.2
		l21.7,56.6l-54.7,20.4L430.3,814.7z M428.9,811l-9.9-26.2l54.1-20.1c2.5,6.2,6.1,15.5,10.2,26.1L428.9,811z M507.9,854.9l10.1,26.5
		l-54.9,20.2l-10-26.4L507.9,854.9z M511.6,853.5l25.1-9.4l9.9,26.7l-24.9,9.2L511.6,853.5z M510.2,849.7
		c-2.9-7.7-6.2-16.3-9.6-25.1l25.3-9.4l9.4,25.2L510.2,849.7z M529.7,813.8l25.2-9.4l9.4,25.2l-25.2,9.4L529.7,813.8z M553.5,800.7
		l-25.2,9.4l-10.4-27.9l25-9.4L553.5,800.7z M524.6,811.4l-25.4,9.5c-3.7-9.5-7.3-19-10.7-27.8l25.7-9.6L524.6,811.4z M487,789.4
		c-4-10.6-7.6-19.8-10.1-26.1l26.1-9.8l9.8,26.3L487,789.4z M506.4,705.7l-30.8-4.3l7.8-57.5l31.1,4L506.4,705.7z M471.6,700.9
		l-32.6-4.5l8.1-57.2l32.3,4.2L471.6,700.9z M519.3,614.3L488,610l2.7-20.1l31.4,4.4L519.3,614.3z M518.7,618.2l-3.6,25.7l-31.2-4
		l3.5-26L518.7,618.2z M521.6,362.4l32.7,4.5l-31.6,223.4l-31.5-4.3L521.6,362.4z M486.7,589.4l-2.7,20l-32-4.4l2.8-20L486.7,589.4z
		 M451.4,609l32.1,4.4l-3.6,26l-32.2-4.1L451.4,609z M266.7,644.7l50.7,6.8l29.5,29.2v3L263,672.1
		C264.2,663.1,265.5,653.4,266.7,644.7z M350.9,684.2V679l-29.8-29.5l21.5-23.8l100.6,13l-8.1,57.1L350.9,684.2z M434.3,729.8
		L434.3,729.8l4.2-29.4l32.6,4.5l-4.7,34.1c-1.3,7.4-1,8.5,2,14.6l1.5,3.2l1.7,4.1l-54,20.1L407,752.9l46.5-17.3l-1.4-3.8l-18.3,6.8
		C433.6,735.7,433.8,732.7,434.3,729.8L434.3,729.8z M377.8,763.7l25.4-9.4l10.7,28.1l-25.5,9.5L377.8,763.7z M389.8,795.6l25.5-9.4
		l9.9,26.2l-25.5,9.4L389.8,795.6z M401.1,825.6l25.5-9.5l10.5,27.9l-25.4,9.4L401.1,825.6z M413.1,857.2l25.4-9.5l9.5,25.2
		l-25.4,9.4L413.1,857.2z M424,886.1l25.4-9.5l9.9,26.4l-25.4,9.4L424,886.1z M550.4,869.4l-9.9-26.6l25.3-9.5l10,26.8L550.4,869.4z
		 M665.8,871l-58-7.8l11.8-84.1l58.1,8L665.8,871z M813.3,899.2l5.6-38.9l55.4,7.2l-5.9,39.9L813.3,899.2z M981.9,881.5l-5.6,42
		l-54-8l5.8-41L981.9,881.5z M920.3,915.2l-47.9-7.2l5.9-40l47.8,6.2L920.3,915.2z M934,1240.5l-108-17.7L871.8,912l48,7.1
		l-14.6,104.3l2,0.3l14.6-104.3l54,8.1L934,1240.5z M995.9,807.3l-4-0.5l-9.7,72.7L878.6,866l10.8-73.4l-4-0.6l-3.1,21.3
		l-105.4-15.6v1l0.2-2l-94.8-13l2.6-18.1l-4-0.5l-2.6,18l-58-8l2.5-18.1l-3.9-0.5l-2.6,18.1l-64.7-8.9h-1l-5.2,1.9l-8.9-23.5
		l-3.7,1.4l8.8,23.5l-25,9.3l-9.7-26.3l18-6.7l-1.4-3.7l-18,6.7l-0.8-2.1l0.8-5.4l13.8-97.2l57.2-42l41.4,5.7l-15.2,106.6l-42.2-5.8
		l-0.6,4l42.2,5.8l-5.1,36.6l3.9,0.5l5.2-36.5l62.9,8.6l-5,35.3l3.9,0.6l5-35.3l33.5,4.6l-5,35.6l3.9,0.6l5.1-35.7l71.2,9.8l0.5-3.9
		l-71.2-9.8l4.6-32.5l120.7,15.9l-3.8,29.3l-50-5l-0.2,2l50,5l-5.2,40.3l1.9,0.3l9.3-71.6l11.8,1.6c0.5,3.4,2.7,17.3,8.2,22.8l4,3.8
		c4.1,3.6,6.8,6,6.4,10.4l-0.8,7.3l18.5,2.6l-3.2,29.1l2,0.2l2.1-19.3l38.9,4.1l-2.9,20.6l2,0.3l3.1-22.7l-40.8-4.3l1-9.7l-18.5-2.6
		l0.5-5.4c0.6-5.4-2.7-8.4-6.9-12.1l-4-3.7c-5.7-5.7-7.7-22.3-7.7-22.4v-0.8l-13.3-1.8l9.5-73.7L864,639c19.3,2.6,36,4.8,39.2,4.8
		h26.5c4.3-0.1,10.9-0.3,18.8,5.2c2.5,1.7,4.1,3.1,5.9,4.5c4.5,3.7,9.1,7.4,26.8,17.1c-4.4,6.9-4.1,16.2-4,21.4c0.1,1,0.1,2,0,3
		c-0.3,2.6-7.7,7.4-9.5,7.5s-4.1,1.7-9.8,6.1c-3.2,2.5-7.5,5.8-9,6.2c-3.5,0.9-22.1,1.5-26.4,1.5c-1.9,0-7.4-3.6-11.1-5.9
		c-2.4-1.7-5-3.2-7.6-4.5c-2.4-1.1-5.7-0.4-9.2,1.9s-7.6,6.7-7.6,10c-0.2,4.3,2,8.4,5.6,10.8c2.8,2.1,11.2,1.8,31-1.1l1.7-0.2
		c3.8-0.6,9.2,0.7,14,1.8c3.1,0.8,6.4,1.4,9.6,1.7c4.3,0.2,15.8-1.1,26.1-2.1l12.1-1.2c6.7-0.4,15,3.1,15.1,3.1l2.4,1l6.7-44.9
		l29.9,16.2c19.7,10.7,35.2,19.1,38,20.4l2.7,1.5c4.4,2.6,10.9,6.4,28.5,7.1l-8.4,60.4l14.8,1.7l-3.3,29.7l4,0.5l3.7-33.7l-14.7-1.7
		l8-56.8h0.3c24.8,0.2,29.1,0.5,36.6,1.4l13.7,1.8c15.3,1.9,41.8,5.2,51.2,6.6l-152.4,194.8l-83.6-12.5L995.9,807.3z M1068.5,937.3
		l18.6-23.8l106.8,15.8l5.6-39.4l102.6,13.2l-9.7,67.7L1068.5,937.3z M1295.7,975.3l111.3,16.6c-0.9,6.3-1.9,12.6-2.8,19
		c-11.9-1.8-74.6-11.3-111.2-16.5L1295.7,975.3z M1288.5,1025.9l4.2-29.5c36.6,5.2,99.3,14.7,111.2,16.5c-1.4,9.1-2.8,18.5-4.3,27.9
		L1288.5,1025.9z M1433.7,1026.6l-2.6,18.4l-27.5-3.7c2.5-16.5,5-32.8,7.4-48.8l37.6,5.6l32,35.5L1433.7,1026.6z M1633.9,1104
		L1633.9,1104c-4.1,58.4-15.5,63.5-21.6,66.3c-0.7,0.3-1.4,0.6-2.1,1l-110.4-122.5l139.2,21.5L1633.9,1104z M1495.5,1044.2
		l-41.8-46.3l109.1,15.3l0.3-2l-111.5-15.7l-0.5-0.6l-0.5-0.5l-39-5.8c1.3-9.1,2.7-18.1,4-26.8l151.5,22.5l0.3-1.9l-151.5-22.6
		c1.3-8.9,2.7-17.6,3.9-26.1l151.6,21.2c2.8,0.5,66.1,11.3,83.2,13.2l-6.5,42.9c-33-4-81-10-83.1-10.7c0.4,0.2,0.6,0.7,0.5,1.1
		l-1.9-0.3l0.2,0.8c0.3,0.5,0.6,0.8,43.5,6.1l40.5,4.9l-8.2,53.6L1495.5,1044.2z M1825.5,904.5l-241.4-34.1l-0.5,3.9l241.2,34.2
		l-12.6,77.4c-32.1-4-66.8-8.3-83-10.6c-22.1-3.2-31.6-8.7-38.5-12.8c-4-2.3-7.2-4.2-11.5-4.9c-6.3-0.9-9.1,1.4-11.7,3.4
		s-4.6,3.7-10.5,3.3c-12.7-1-84.2-13.2-84.9-13.3l-80.3-11.3l4.4-30.2l80.4,11.1l0.3-2l-80.4-11.1l4.5-30l-2-0.3l-4.4,30l-69.4-9.6
		c5.7-38.2,9.8-66.3,11-75.6l149.8,23.8l0.6-3.9l-161.7-25.7l9.1-53.2l404.6,60.8L1825.5,904.5z M1839.3,819.8l-542.4-81.4l4.1-30.6
		l36-16.3l184.6,25.4l-7.4,52.8l3.9,0.5l19.6-138.1l198.1,31.6l-11.7,83.9l-119-17.6l-0.6,3.9l242.9,36.1L1839.3,819.8z"
                />
                <path
                  className="st7"
                  d="M1804.8,383.3c4.8-17.6,6.8-80.2,8.5-135.4c0.8-26,1.6-50.5,2.6-66.4c2.1-34.9,12.8-45.9,30.4-64.1
		c6.5-6.7,13.8-14.3,21.9-24.2l-4.7-3.8c-7.9,9.7-15.1,17.2-21.5,23.8c-18,18.6-29.8,30.8-32.1,67.9c-1,16-1.8,40.6-2.6,66.6
		c-1.6,52.2-3.7,117.1-8.3,134c-8.8,31.8-88.1,134.4-88.9,135.4l7.2,0.8C1720.5,513.7,1795.7,416.3,1804.8,383.3z"
                />
                <path
                  className="st7"
                  d="M1882.3,1148.3l-329.7-46.6l93.2-623.6c0.6-2.6,8-37.8-0.4-51.4c-2.1-3.5-5.3-6.3-8.7-9.2
		c-10-8.6-21.3-18.4-10.3-52.7l1.5-5.3c5.3-19.6,5.4-20,4.2-28.1c-0.4-2.3-0.8-5.1-1.2-9.4c-0.4-4.5-1.3-9-2.7-13.3
		c-0.2-0.5-0.4-1.1-0.5-1.6c1.1-1.3,2.3-2.6,3.6-3.7l3.2-3c13.9-13.3,22.6-30.4-2.2-115.1c11.4-9.6,21.4-20,35.3-48.7
		s29.6-105.5,30.2-108.7v-61.6h-6V27c-1.1,5.3-16.5,79.5-29.7,107s-23.8,38.5-35.2,48s-33.6,33.3-38.8,39l-120.5-14.7
		c-2.3-0.4-11.9,0.1-30.1,1c-15.4,0.8-34.5,1.8-47.8,1.9s-20.1,1.2-26,6s-8.9,11.9-14.5,24.2l-1.4,2.9
		c-12.5,27.1-18.3,34.8-22.5,40.4l-6.1,8c-6.9,8.8-17.3,22.1-23.3,31.2s-10.8,10.4-16.7,11.7l-3.7,0.8c-3.3,0.9-36.8,8.8-99.9,23.5
		c-1.1-5.6-1.1-11.4-0.1-17l29.9-211.4l-5.9-0.9l-29.9,211.3c-1.2,6.4-1.1,12.9,0.2,19.3l-101.3,23.6l-4.3,1l-11.5,2.6
		c-1.1-2.8-3.2-6.6-6.7-8.5s-46-8.8-54.2-10.1L840.6,347L890.4-4.5l-6-0.8l-49.7,351.5l-36.9-5.1c-1.7-0.2-4.8-4-6.8-6.5l-0.6-0.7
		c-2.4-3-11.3-11.5-19.7-19.5l-0.8-0.8c-3.3-3.1-4-6.3-5-11.1c-0.2-0.6-0.3-1.3-0.5-2c-1.2-5.4-5-15.7-6.1-18.6L798.8-4.5l-5.9-0.8
		L753,276.3l-0.3-0.2c-0.3,0.5-17.2,24.8-37.3,53.5L619,315.7l28.1-198l-5.9-0.8l-28.1,198l-205.5-29.7
		c7.5-59.5,22.6-176.4,22.7-177.9l-5.9-0.7c-0.2,1.5-15.2,118.2-22.8,177.8l-243.3-35.1h-0.1c-4.3-0.5-10.3-3.7-17.2-7.6
		c-12.2-6.6-28.9-15.8-49.9-17.1c-32.2-2-81.3-8.4-81.8-8.4l-0.8,5.9c0.5,0.1,49.8,6.5,82.2,8.5c19.7,1.2,35,9.6,47.4,16.4
		c7.8,4.3,13.9,7.7,19.4,8.2l243.4,35.1c-1.7,13.3-2.9,22.9-3.4,26.6c-1,9.2-8.6,83.6-16.3,159.6h-0.5l-4.4-0.8
		c-6.5-1.4-6.5-1.4-10.1-6c-1.1-1.5-2.5-3.4-4.5-5.8c-9.7-11.7-29.2-13.2-30.1-13.2c-6.1-0.4-12.1-1.6-17.8-3.8
		c-7.3-2.4-13.7-4.6-25.2-0.5c-5,1.8-8.8,4.9-12.9,8.1c-11,8.8-26,20.8-79.1,15.3L160,432.1l-4.3,4.1l9.4,9.7l-3.3,19.9
		c-78.5-9.1-193.5-23.7-194.9-23.9l-0.7,6c1.3,0.1,116.1,14.8,194.6,23.9l-14.6,88.9l62.5,73l-10.8,73.2c-2.8-0.2-5.6-0.1-8.3,0.5
		c-5.6,1.1-11,3.1-16,6c-6.1,3.2-11,5.8-20.8,3.9c-7.6-1.4-23.8-8.6-41-16.3c-22.7-10.2-48.4-21.7-63.8-24.1l-86.7-13.6l-0.9,5.9
		l86.7,13.6c14.5,2.3,39.9,13.6,62.3,23.7c18.2,8.1,34,15.2,42.3,16.7c11.9,2.2,18.1-1,24.7-4.4c4.5-2.6,9.3-4.5,14.4-5.6
		c10-1.9,16.8,2.5,27.1,9.2c6.1,4.1,12.4,7.9,19,11.2c20.2,10.2,38,35.6,43.3,47.4l-86.3,34.5l-14.5-9.9c-21.4-15-45.6-31.9-64.3-33
		c-8.7-0.5-20.6-2.5-37.2-5.4c-26.4-4.5-62.7-10.7-113.4-15.5l-0.6,6c50.5,4.8,86.7,10.9,113,15.5c16.8,2.8,28.8,4.9,37.8,5.4
		c17,1,40.6,17.4,61.3,31.9c5.6,3.9,10.9,7.6,15.9,10.9c21.4,14,23.3,23.7,23.3,23.7v0.6c1.4,4.1,34,100.3,35.4,103.7l5.5-2.2
		c-1-2.6-23.4-68.5-35.2-103.2c-0.4-2.2-3.2-11.5-21.2-24.4l82.3-33c9.4,27.4,84.2,234.5,87.6,243.7l5.6-2
		c-0.8-2.3-78.9-218.3-87.6-243.9l21.1-8.4c8,24,61.7,166.9,75,202.8l5.6-2.1c-11.5-31.1-67.7-180.8-75-203l33.1-13.2l-1.8,12.1
		l54.6,152.1l5.6-2.1L351.9,772l7.3-50l32.4,4.5l8.9,24.5l5.6-2.1l-7.8-21.5l375,52.1l-30.8,217.6l-132.6-19l-0.8,6l132.5,19
		l-36.8,259.7l6,0.9l36.8-259.8c125.3,17.9,290.6,41.5,295.1,41.9c2.7,0.2,7.1,0.5,12.3,0.5c8.5,0,19.1-0.8,28.4-4.3
		c3.3-1.3,6.5-2.7,9.9-4.3c11.4-5.5,23.3-11.1,43-7s33.9,7.4,39,8.6c0.8,11.7,11.9,16.7,18.2,17.7l352.2,49.8l-22.6,151l6,0.9
		l22.6-151.1l329.8,46.6L1882.3,1148.3z M1277.1,340.2l3.5-0.8c6.3-1.3,12.9-2.8,20.4-14.2c5.9-8.9,16.2-22.1,23-30.9
		c2.7-3.4,4.9-6.2,6.2-8c4.4-5.8,10.4-13.9,23.2-41.5l1.3-2.9c11-23.9,12.2-26.4,35.2-26.7c13.4-0.1,32.6-1.1,48-1.9
		c13.3-0.7,27-1.4,28.9-1.1c4.5,0.7,117.4,14.3,122.2,14.9l1.5,0.2l1-1.2c0.3-0.2,22.9-24.7,35.8-36.5c24.7,85.6,12.7,97.2,3,106.5
		l-3.1,3c-5.3,4.9-6.5,6.1-4.7,11.4c1.2,3.9,2.1,8,2.4,12.1c0.4,4.4,0.9,7.5,1.2,9.7c1.1,6.9,1.1,6.9-4,25.7l-1.4,5
		c-12.2,38,1.8,50.2,12.1,59c3.1,2.8,5.8,5.1,7.5,7.8c6.1,9.9,1.8,37.4-0.4,47.1l0,0l-61,408.3L1209.4,834
		c19.7-139.1,42.6-298.9,43-301.7c1.5-10.4-2.6-12.6-10.2-16.6c-2.7-1.5-6-3.2-9.9-5.7c-14.4-9.2-30.7-19.5-44.4-40
		c-6.5-11.5-6.5-20.1-6.4-28.4c0-2.2,0-4.5-0.1-6.7c-0.2-4.8-0.7-9.7-1.1-14.4s-1.1-11.6-0.9-15.1c0.2-3,0.6-6,1.1-8.9
		c1-5.9,2.1-12.7,1.4-17.9c-0.6-2.9-1.4-5.7-2.5-8.5c-0.7-2-1.5-4.1-2.2-6.4C1240.3,349,1273.8,341.1,1277.1,340.2z M1065.6,389.7
		l4.3-1l101.4-23.6c0.8,2.5,1.7,4.9,2.4,7.1c1,2.3,1.8,4.7,2.2,7.2c0.6,4.3-0.4,10.6-1.3,16.2c-0.6,3.1-1,6.3-1.2,9.5
		c0,5.3,0.3,10.6,0.9,15.9c0.4,4.7,0.9,9.6,1.1,14.1c0.1,2.2,0.1,4.3,0.1,6.5c-0.1,8.7-0.1,18.5,7.2,31.4v0.2
		c14.4,21.6,31.3,32.4,46.2,41.8c4.2,2.7,7.6,4.5,10.3,5.9c7.3,3.9,8.1,4.3,7.1,10.6c-1.6,11.3-23.8,166.2-43,301.6l-423.2-58.7
		L828,436.3c25.5-10.6,53-20.3,70.3-26.4l12.6-4.5c10.3-3.9,36-12.7,49.9-11.8c6.7,0.5,13.3,1.5,20.4,2.7s12,1.9,18.3,2.5
		C1013.8,400.2,1029.8,398,1065.6,389.7z M991,373.8c23.4,3.4,49.4,7.9,52.2,9.4s2.8,2.7,3.6,4.5c-23.2,5-35.7,6.2-46.7,5.1
		c-6.1-0.6-12.2-1.5-18-2.5s-14-2.2-20.9-2.7c-14.5-0.9-39.1,7.2-52.4,12.1l-12.5,4.5c-16.6,5.9-42.7,15.1-67.4,25.2l10.9-76.5
		L991,373.8z M734.3,357.8c0.1,0,6.4-0.2,10.8,1.6c10.8,4.2,17.6,7.7,19,9.2c0.2,1.9,0.3,3.7,0.2,5.6c0.1,4.4,0.2,8.9,1.2,11.6
		c0.3,1,1.2,4,2.1,7.5c5,18.1,8.2,28.5,10.9,31.6s9.5,8.2,13,10.8l-15,18l-142.6,71.5c2-16.4,7.6-63.7,8.2-69.6s1.2-12.9,12.4-28.4
		c6.4-8.9,37.4-53.3,63.7-91.1l15,2.1l-2.4,19.7L734.3,357.8z M826.6,403l-4.1,29c-10.5,4.4-20.5,8.9-29.3,13.3L790,447L826.6,403z
		 M753.3,285.8c2,5.2,3.8,10.6,5.3,16c0.1,0.7,0.3,1.3,0.4,2c1.1,5.2,2.1,9.8,6.7,14.2l0.9,0.8c4.5,4.3,16.6,15.7,19.2,18.9l0.5,0.7
		c3.3,4,6.6,8.1,10.7,8.7l36.8,5l-5.6,39.6l-32.8,39.4c-3.3-2.4-9.8-7.3-12.4-10.2s-7.4-21.2-9.6-29.2c-1.1-3.9-1.8-6.7-2.3-7.9
		s-0.7-6.4-0.8-9.7c0.1-2.5,0-5-0.5-7.5c-0.5-1.5-1.4-4.5-22.5-12.8c-3.1-1.2-6.4-1.8-9.7-1.9l2.3-18.8l-17.8-2.5L753.3,285.8z
		 M711.6,335.1c-26,37.3-55.7,79.9-62,88.6c-12.1,16.8-12.8,24.2-13.5,31.4s-6.9,59.3-8.5,72.2l-37.9-5.2l28.5-200.4L711.6,335.1z
		 M403.5,317.6c0.4-3.6,1.6-13.2,3.3-26.4l205.4,29.6l-28.4,200.5l-86.3-11.7l-1,1.8c-0.1,0.1-9.4,16-25.3,16h-0.1
		c-8.6,0-16.5-5.4-24.1-10.6c-7.6-5.2-14.4-9.9-22.3-10.4c-13.9-0.9-15.3-2.5-28.1-17.9c-3.8-6.4-6.4-9.1-9.5-10.4
		C394.8,401.7,402.4,326.8,403.5,317.6z M221.5,477.2c35.5,0,48.2-10.2,57.9-18c3.9-3,7.2-5.7,11.2-7.1c9.6-3.4,14.5-1.8,21.3,0.5
		c6.2,2.3,12.8,3.7,19.4,4.1c0.1,0,17.7,1.3,25.7,11c2,2.3,3.4,4.1,4.5,5.6c4.4,5.7,5.2,6.5,13.6,8.3l4.7,0.8h0.8
		c-7,69.6-14,139.1-16.2,160.1L203,476.4C209.8,476.9,215.9,477.2,221.5,477.2z M170.3,451.2l16.9,17.5l-19.5-2.2L170.3,451.2z
		 M152.6,558.9l14.2-86.4l27,3l169.8,174.9l-9.4,64.8l-56.7-7.9l-1.8-0.2c-15.6-2.7-21.7-3.7-27.5,0.2c-4.9-3.5-9.9-5.8-14.9-6.5
		c-21.4-2.9-41.3-5.8-47.5-6.7l9.2-62.2L152.6,558.9z M221.2,717.4c-6.2-4-11.6-7.5-17.5-9.3l1.2-8.1c6.3,0.9,26.2,3.9,47.6,6.7
		c4,0.8,7.8,2.3,11.1,4.6c-1.2,1.3-2.4,2.7-3.5,4.1c-6.5,7.8-11.1,13.9-13.4,17c-2.3-1.5-4.7-2.9-7.1-4.1
		C233.3,725,227.1,721.4,221.2,717.4L221.2,717.4z M251.5,736c2.3-3.2,6.9-9.2,13.2-16.8c1.4-1.7,2.6-3.2,3.7-4.3
		c6.3,5.1,12.9,12.6,19.7,22.1c9,12.7,16.1,26.3,18.9,33.3l-21.3,8.5C281.1,768.3,268,748.8,251.5,736z M348.5,753.8l-0.7,0.2
		l-35.3,14c-4.8-11.8-20.8-40.8-39.1-56.7c3.8-1.3,9.2-0.4,21.3,1.7l1.9,0.3l56.7,7.9L348.5,753.8z M360.1,716l7.9-54.4l21.3,58.5
		L360.1,716z M369.9,649v-0.7h-0.1c1.1-11.2,8.8-87.2,16.5-163.6c1.5,1.3,2.9,3.4,5.1,7.1l0.3,0.4c13.8,16.4,16.5,19.1,32.5,20.2
		c6.3,0.4,12.6,4.7,19.3,9.3c8.3,5.7,17,11.7,27.5,11.7h0.1c16.1,0,26.2-12.6,29.4-17.3l82.3,11.1l-30.5,215.5L396,721L369.9,649z
		 M558.3,743.6l30.6-215.5l38,5.1l3.5,0.5l118.2,16l0.8-5.9l-109.5-14.9l156-78.2c7.7-3.9,16.5-7.9,25.6-11.7l-47.4,334.5
		L558.3,743.6z M1175.7,1033.2c-5.8-1.3-19.1-4.4-38.2-8.4c-21.6-4.4-35,1.9-46.8,7.4c-3.2,1.6-6.3,3-9.4,4.2
		c-13.8,5.1-31.5,3.9-38.2,3.4c-4.3-0.3-156-22-294.7-41.8l30.8-217.7l423.4,58.8C1189.4,932.1,1177.9,1014.7,1175.7,1033.2z
		 M1194.4,1051.1c-0.6-0.1-13.7-2.5-13.1-14c0.3-5.9,12.8-95.3,27.3-197.2l369.4,51.3l-31.4,209.7L1194.4,1051.1z"
                />
                <path className="st8" d="M1573.2,12.8h-0.2" />
                <path
                  className="st9"
                  d="M1572.3,13.6c-15.1,14.3-27.5,31.2-36.6,49.8c-11.9,18.1-33.9,28.5-48.5,47.9s-38.4,33.5-47.9,40.8
		s-56,20.6-62.4,31.3s-38.1,59.5-40.6,64s-18.8,29.3-32,34.6s-77.1,35.4-99.1,34.4s-151.4,0-151.4,0s-137.5-1-151,0s-31,7.6-38.3,25
		s-27.2,60.3-29.5,78.8S788.8,770,783.2,811.7s-12.7,56-34,68.2s-55.8-3.5-85.6-4.9s-70.9-13.6-88.1-7.3s-92.3,35-92.3,35
		c-18.7,8-121.9,48.2-138.2,48.8s-38.1-42.2-41.1-48.1"
                />
                <path className="st8" d="M303.6,902.9v-0.2" />
                <path className="st8" d="M546.2,878.7h0.2" />
                <path
                  className="st9"
                  d="M547.4,878.5c6-0.8,32.4-3.5,47.1,12.9c16.7,18.6,99.9,84,150.3,97.3s66.4,41.3,60.4,81
		c-5.8,38.1-31.8,184-33.9,195.6"
                />
                <path
                  className="st9"
                  d="M1864.4,982.7c-7.6,4.5-54.4,31.6-67,34.7s-71.6-12-110.2-0.7s-80,8.7-118,10.2s-48-16.9-57.4-31.3
		s-42.6-18.9-42.6-18.9l-240.7-32c-36-4.7-50-4.7-62.7,0s-52.6,44-93.3,76c-40.7,32-58,30-70.7,28.7s-129.3-18.7-161.3-22.5
		s-39.7-7.4-49.9-14.5"
                />
                <path className="st8" d="M790.1,1012.1c0-0.1-0.1-0.1-0.2-0.2" />
                <path
                  className="st7"
                  d="M748.8,543.8l3.5,0.5c1.2,0.1,2.4,0.3,3.6,0.6c2.4,0.4,4.7,1,7,1.9c2.3,0.8,4.5,1.8,6.7,3
		c1.8,1.1,3.8,2.1,5.8,2.8c4.3,1.3,8.6,2.4,13,3.1c4.5,0.9,9,1.7,13.5,2.4c18,2.9,36.2,4.4,54.5,4.7h6.7l6.6-0.8
		c4.5-0.7,8.9-1.6,13.3-2.7c8.8-2.2,17.5-4.9,26.2-7.8c17.2-6,34.3-12.8,51.1-20c8.5-3.6,16.8-7.4,25.2-11.1l12.5-5.8l3.2-1.4
		l3.2-1.4l6.3-2.8c17.2-7.5,35.5-12.1,54.2-13.8c9.3-0.9,18.7-1.2,28-1c9.3,0.2,18.6,1.2,27.7,2s18.3,1.6,27.4,2.2
		c9.1,0.7,18.1,0.8,27.2,0.5c9-0.3,18.1-1.3,27.2-2.5s18.1-2.4,27.3-3.7l13.7-1.7l13.8-1.5c9.2-0.9,18.4-1.6,27.6-2.2
		c18.5-1.1,36.9-1.7,55.4-1.8c9.2-0.1,18.4-0.1,27.6,0.1h10.5l3.6,0.2c4.7,0.3,9.3,0.9,13.9,1.5c9.2,1.2,18.2,2.6,27.2,3.4
		c9,0.9,18,1.3,27,1c8.9-0.3,17.8-1.5,26.5-3.5c8.6-1.8,16.9-5,24.5-9.5c7.5-4.4,14.3-10.2,20.8-16.5s13-12.9,19.9-19.2
		c3.4-3.2,6.9-6.3,10.5-9.3l5.4-4.4l2.8-2.2l1.4-1l1.3-1c0.9-0.8,1.9-1.5,3-2.2l2.9-2l6.1-3.7c4-2.4,8-4.7,12.2-6.9h0.3
		c12.3-5.2,25.1-7.9,37.8-9.9s25.5-3.4,38-5c6.2-0.8,12.5-1.6,18.6-2.8c3-0.5,6-1.2,9-1.9c2.9-0.8,5.7-1.7,8.5-2.8l2-0.8l0.9-0.5
		l0.5-0.2l0.5-0.2l2-1.1l2-1.1l8.1-4.8l16.2-10c10.9-6.7,22-13.2,33.4-19.1c11.4-6,23.3-11.2,35.4-15.7c6.1-2.2,12.3-4.2,18.6-5.8
		c6.3-1.6,12.8-2.9,19.3-3.7c3.3-0.4,6.6-0.7,9.9-0.9c3.3-0.1,6.6-0.1,10,0c3.3,0.1,6.6,0.4,9.9,0.9c3.3,0.4,6.6,1.1,9.9,1.9
		l-2.4,9.7c-2.9-0.7-5.9-1.3-8.9-1.8s-5.9-0.6-9-0.8h-9.1c-3,0.2-6,0.4-9.1,0.8c-6.1,0.7-12.1,1.9-18.1,3.4
		c-6,1.5-11.9,3.3-17.7,5.4c-11.8,4.3-23.2,9.3-34.3,15.1c-11.2,5.7-22.1,12-32.9,18.6l-16.3,9.9l-8.3,5l-2.2,1.1l-2.2,1.2l-0.5,0.3
		l-0.6,0.3l-1.2,0.5l-2.4,1c-3.2,1.3-6.4,2.3-9.7,3.1c-3.2,0.8-6.4,1.5-9.6,2c-6.4,1.2-12.8,2-19.1,2.8c-12.7,1.6-25.3,2.8-37.7,4.8
		s-24.6,4.5-35.8,9.2l0.4-0.2c-4,2.1-8,4.3-11.9,6.6c-3.9,2.2-7.6,4.6-11.1,7.2l-2.8,2.1l-2.6,2.1l-5.3,4.2c-3.5,2.9-6.9,5.9-10.2,9
		c-6.7,6.1-13.1,12.6-19.9,19.1c-3.3,3.2-6.8,6.3-10.5,9.3c-3.8,3-7.7,5.8-11.9,8.2c-8.3,4.8-17.4,8.3-26.8,10.3
		c-9.2,2.1-18.6,3.3-28.1,3.6c-9.4,0.2-18.8-0.1-28.1-1.1c-9.2-0.9-18.4-2.4-27.5-3.6c-4.5-0.6-9-1.2-13.4-1.5l-3.3-0.2h-3.4
		l-6.9-0.2c-9.2-0.1-18.3-0.2-27.5-0.1c-18.3,0-36.6,0.5-54.9,1.6c-9.2,0.5-18.3,1.1-27.4,2l-13.6,1.4l-13.7,1.7
		c-9.1,1.2-18.2,2.5-27.4,3.6s-18.4,2.1-27.7,2.4c-9.3,0.3-18.7,0.1-28-0.6c-9.2-0.6-18.4-1.5-27.5-2.4s-18.2-1.8-27.3-2
		c-9.1-0.3-18.2,0-27.2,0.8c-18,1.6-35.7,6-52.3,13.1l-6.3,2.8l-3.1,1.3l-3.2,1.4l-12.5,5.7c-8.5,3.8-16.9,7.5-25.4,11.1
		c-17,7.2-34.1,14-51.6,19.9c-8.8,3-17.7,5.7-26.7,7.9c-4.6,1.1-9.2,2.1-13.8,2.8c-2.4,0.3-4.7,0.6-7.1,0.7h-7.1
		c-18.5-0.3-37-2-55.3-4.9l-13.7-2.5c-4.6-0.8-9.2-1.9-13.7-3.3c-2.3-0.9-4.6-1.9-6.7-3.2c-1.9-1-3.9-1.9-5.9-2.6
		c-2-0.7-4.1-1.2-6.2-1.5l-3.3-0.5l-3.4-0.3L748.8,543.8z"
                />
                <path
                  className="st7"
                  d="M48.6,1030.9c-0.2-0.7-5.8-17.6-0.2-46c3.5-23.5,12.1-48.3,20.4-72.4c12.8-37,24.9-71.8,19.7-101.2h-0.1
		c-13-86.6-6.8-95.8,6.9-115.8c4.1-5.7,7.9-11.7,11.2-17.9c21.8-41,8.2-91.3,7.6-93.4c-0.2-0.5-14.3-52.8,12.8-104.7l0.2-0.3
		c31.3-50.7,30.1-63.4,27.4-91.2c-0.6-6.5-1.3-13.8-1.7-22.5c-1-23.6-8.5-42.2-15.8-60.2c-6.6-16.3-12.9-31.7-13.6-49.2
		c-1.5-35.4,10-247,10.5-256l10,0.5c-0.1,2.2-12,220.2-10.5,255.1c0.6,15.7,6.6,30.3,12.8,45.8c7.3,17.9,15.5,38.3,16.6,63.6
		c0.4,8.4,1.1,15.6,1.7,21.9c2.8,29.2,4.2,43.9-28.8,97.3c-20.9,40.2-15.8,83.8-12,97.2c1.6,5.7,14.9,57-8.4,100.8
		c-3.5,6.5-7.4,12.8-11.7,18.9c-12.5,18.3-17.7,25.8-5.3,108.5c5.6,31.9-7.4,69.7-20,106.2c-8.2,23.6-16.7,48.1-20,70.7v0.3
		c-5.1,25.6-0.2,40.7-0.2,40.9L48.6,1030.9z"
                />
                <circle className="st10" cx="1200.5" cy="392.9" r="155.9" />
                <circle className="st11" cx="1200.5" cy="392.9" r={275} />
                <circle className="st12" cx="1200.5" cy="392.9" r="412.5" />
                <circle className="st13" cx="1200.5" cy="392.9" r={550} />
                <circle className="st10" cx="1200.5" cy="392.9" r="687.5" />
                <circle className="st14" cx="1200.5" cy="392.9" r={825} />
                <path
                  className="st15"
                  d="M214.1,942.9h-4.5v-12.6h4.5c1.7-0.1,3.3,0.5,4.5,1.7c2.3,2.6,2.3,6.6-0.1,9.2
		C217.3,942.3,215.7,943,214.1,942.9z M212,940.6h2c2.4-0.3,4-2.5,3.6-4.9c-0.1-0.8-0.4-1.5-0.9-2.1c-0.7-0.7-1.7-1.1-2.7-1.1h-2
		V940.6z"
                />
                <path
                  className="st15"
                  d="M222.9,935.2c1.9-1.8,4.7-1.8,6.6,0c0.9,0.9,1.4,2.1,1.3,3.3c-0.1,2.6-2.2,4.6-4.8,4.6
		c-1.1,0-2.2-0.5-3.1-1.3c-0.8-0.9-1.3-2.1-1.3-3.3C221.6,937.3,222.1,936.1,222.9,935.2z M224.6,940.3c0.4,0.5,1,0.7,1.6,0.7
		c0.6,0,1.2-0.2,1.6-0.7c0.8-1.1,0.8-2.5,0-3.6c-0.4-0.5-1-0.7-1.6-0.7c-0.6,0-1.2,0.2-1.6,0.7C223.8,937.8,223.8,939.2,224.6,940.3
		z"
                />
                <path
                  className="st15"
                  d="M236.6,936c-0.6,0-1.2,0.3-1.6,0.7c-0.4,0.5-0.7,1.1-0.6,1.8c0,0.7,0.2,1.3,0.6,1.8c0.4,0.4,1,0.7,1.6,0.7
		c0.5,0,1-0.2,1.3-0.5c0.3-0.2,0.6-0.6,0.7-1l2.1,0.7c-0.2,0.8-0.7,1.6-1.4,2.1c-0.8,0.5-1.7,0.8-2.7,0.8c-1.2,0-2.4-0.4-3.3-1.3
		c-0.8-0.9-1.3-2.1-1.3-3.3c-0.1-1.2,0.4-2.4,1.3-3.3c0.8-0.9,2-1.3,3.2-1.3c1-0.1,2,0.2,2.8,0.8c0.6,0.5,1.1,1.3,1.3,2.1l-2.1,0.7
		C238.3,936.6,237.5,935.9,236.6,936z"
                />
                <path
                  className="st15"
                  d="M250.9,934.1l-3.5,3.7l3.6,5.1h-2.9l-2.3-3.4l-1,1v2.4h-2.4V930h2.4v7.4l3-3.3L250.9,934.1z"
                />
                <path className="st15" d="M254.7,942.9h-2.3V930h2.3V942.9z" />
                <path
                  className="st15"
                  d="M256.7,940.5c-0.1-0.7,0.2-1.3,0.7-1.8c0.5-0.5,1.2-0.8,1.9-0.9l2.1-0.3c0.5,0,0.7-0.3,0.7-0.6
		c0-0.3-0.1-0.6-0.4-0.8c-0.3-0.2-0.7-0.3-1.1-0.3c-0.8-0.1-1.6,0.6-1.7,1.4l-2.1-0.5c0.1-0.8,0.6-1.5,1.2-2
		c0.7-0.6,1.7-0.9,2.6-0.8c1-0.1,2.1,0.2,2.9,0.9c0.6,0.6,0.9,1.5,0.9,2.4v4.3c0,0.5,0,0.9,0.1,1.4h-2.2c0-0.3-0.1-0.7-0.1-1.1
		c-0.5,0.9-1.5,1.4-2.5,1.3c-0.8,0-1.6-0.3-2.2-0.8C257,941.9,256.7,941.2,256.7,940.5z M260.2,941.3c0.5,0,0.9-0.1,1.3-0.4
		c0.4-0.4,0.6-1,0.6-1.6v-0.4l-2,0.3c-0.7,0.1-1.1,0.5-1.1,1.1c0,0.3,0.1,0.6,0.3,0.8C259.5,941.3,259.8,941.3,260.2,941.3z"
                />
                <path
                  className="st15"
                  d="M269.1,937.8v5.1h-2.3v-8.8h2.3v1.1c0.3-0.4,0.6-0.7,1-1c0.5-0.2,1-0.3,1.5-0.3c0.9-0.1,1.8,0.3,2.3,1
		c0.6,0.7,0.9,1.6,0.8,2.5v5.5h-2.3v-5.1c0.1-0.5-0.1-0.9-0.4-1.3c-0.7-0.7-1.7-0.7-2.4,0C269.3,936.9,269.1,937.3,269.1,937.8z"
                />
                <path
                  className="st15"
                  d="M285.5,930v12.9h-2.2c-0.1-0.4-0.1-0.7-0.1-1.1c-0.2,0.4-0.5,0.7-0.9,0.9c-0.5,0.3-1,0.4-1.5,0.4
		c-1.2,0-2.3-0.5-3.1-1.3c-1.6-1.9-1.6-4.7,0-6.6c0.8-0.9,1.9-1.3,3-1.3c0.9-0.1,1.9,0.3,2.4,1.1v-5L285.5,930z M278.9,938.5
		c0,0.7,0.2,1.3,0.6,1.8c0.4,0.4,0.9,0.7,1.5,0.7c0.6,0,1.2-0.3,1.6-0.7c0.4-0.5,0.6-1.1,0.6-1.8c0.1-0.7-0.2-1.3-0.6-1.8
		c-0.4-0.5-1-0.7-1.6-0.7c-0.6,0-1.1,0.2-1.5,0.7C279.1,937.2,278.8,937.8,278.9,938.5z"
                />
                <path
                  className="st15"
                  d="M287.3,940.4l2-0.4c0,0.4,0.2,0.7,0.5,0.9c0.3,0.3,0.7,0.5,1.1,0.4l0.9-0.2c0.2-0.2,0.3-0.4,0.3-0.7
		c0-0.4-0.3-0.7-1-0.8l-1.1-0.3c-0.7-0.1-1.4-0.4-1.9-0.9c-0.4-0.5-0.6-1.1-0.6-1.7c0-0.8,0.3-1.6,1-2c0.6-0.6,1.5-0.9,2.3-0.8
		c0.5,0,1,0,1.5,0.2c0.4,0.1,0.8,0.4,1.1,0.7l0.6,0.8c0.1,0.2,0.2,0.5,0.2,0.8l-2,0.4c0-0.3-0.1-0.6-0.4-0.8c-0.3-0.3-0.6-0.4-1-0.4
		c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.4,0.3,0.7,0.8,0.8l1.2,0.3c0.7,0.1,1.4,0.4,2,0.9c0.4,0.5,0.6,1.1,0.6,1.7
		c0,0.8-0.3,1.6-0.9,2.1c-0.7,0.6-1.6,0.8-2.5,0.8c-0.5,0-1.1-0.1-1.6-0.3c-0.5-0.1-0.9-0.4-1.2-0.7l-0.6-0.8
		C287.4,941,287.3,940.7,287.3,940.4z"
                />
                <path
                  className="st15"
                  d="M759.6,1051.1c-1.7,0-3.4-0.6-4.6-1.8c-1.2-1.3-1.9-3-1.8-4.7c-0.1-1.8,0.6-3.5,1.8-4.8
		c1.2-1.2,2.9-1.8,4.6-1.8c1.4-0.1,2.8,0.4,3.9,1.2c0.9,0.8,1.5,1.8,1.8,3l-2.3,0.7c-0.1-0.7-0.5-1.4-1.1-1.8
		c-1.6-1.1-3.6-0.9-5,0.4c-0.8,0.8-1.3,1.9-1.2,3.1c-0.1,1.1,0.3,2.2,1.1,3c0.7,0.7,1.8,1.1,2.8,1.1c0.9,0.1,1.7-0.2,2.4-0.7
		c0.5-0.5,0.9-1.1,1.1-1.8l2.3,0.7c-0.1,0.5-0.3,1-0.6,1.5l-1.1,1.3c-0.5,0.5-1.1,0.9-1.8,1.1C761.2,1051,760.4,1051.1,759.6,1051.1
		z"
                />
                <path
                  className="st15"
                  d="M772.5,1042.1v2.4h-0.7c-0.6,0-1.2,0.2-1.7,0.6c-0.5,0.5-0.7,1.2-0.6,1.9v4h-2.4v-8.8h2.3v1.3
		c0.5-0.9,1.5-1.4,2.5-1.3L772.5,1042.1z"
                />
                <path
                  className="st15"
                  d="M779.9,1047.8l2,0.6c-0.3,0.8-0.8,1.5-1.4,2c-0.8,0.5-1.7,0.7-2.6,0.7c-2.4,0.1-4.4-1.7-4.5-4.1
		c0-0.2,0-0.3,0-0.5c-0.1-1.2,0.4-2.4,1.3-3.3c0.8-0.9,1.9-1.3,3-1.3c1.2,0,2.3,0.4,3.2,1.2c0.8,0.9,1.1,2.1,1.1,3.3v0.6h-6.3
		c0,0.6,0.3,1.1,0.7,1.5c0.4,0.3,1,0.5,1.5,0.5C778.8,1049.1,779.6,1048.6,779.9,1047.8z M775.8,1045.5h3.9c0-0.5-0.2-0.9-0.5-1.2
		c-0.4-0.3-1-0.5-1.5-0.5c-0.5,0-1,0.2-1.4,0.5C776,1044.6,775.8,1045.1,775.8,1045.5L775.8,1045.5z"
                />
                <path
                  className="st15"
                  d="M786.2,1050.9h-2.3v-8.8h2.2v1.1c0.3-0.4,0.6-0.8,1.1-1c0.5-0.2,1-0.3,1.5-0.3c1.1-0.1,2.1,0.5,2.6,1.4
		c0.6-0.9,1.6-1.4,2.7-1.4c0.8,0,1.6,0.3,2.3,0.8c0.6,0.7,1,1.6,0.9,2.5v5.7h-2.3v-5.2c0-0.4-0.1-0.9-0.4-1.2
		c-0.3-0.3-0.7-0.5-1.1-0.5c-0.5,0-0.9,0.2-1.2,0.5c-0.3,0.4-0.4,0.8-0.4,1.3v5.1h-2.4v-5.2c0-0.4-0.1-0.9-0.4-1.2
		c-0.3-0.3-0.7-0.5-1.1-0.5c-0.5,0-0.9,0.2-1.2,0.5c-0.3,0.4-0.5,0.8-0.5,1.3L786.2,1050.9z"
                />
                <path
                  className="st15"
                  d="M800.3,1043.2c0.8-0.9,2-1.4,3.2-1.3c2.4-0.1,4.5,1.8,4.6,4.2c0,0.1,0,0.3,0,0.4c0.1,1.2-0.4,2.4-1.3,3.3
		c-0.9,0.9-2.1,1.3-3.3,1.3c-1.2,0.1-2.4-0.4-3.2-1.3c-0.9-0.9-1.4-2.1-1.4-3.3C798.9,1045.3,799.4,1044.1,800.3,1043.2z
		 M802,1048.3c0.4,0.5,0.9,0.7,1.5,0.7c0.6,0,1.2-0.2,1.6-0.7c0.9-1,0.9-2.6,0-3.6c-0.4-0.5-1-0.7-1.6-0.7c-0.6,0-1.1,0.2-1.5,0.7
		C801.1,1045.7,801.1,1047.3,802,1048.3z"
                />
                <path
                  className="st15"
                  d="M815.3,1042.1v2.4h-0.7c-0.6,0-1.2,0.2-1.6,0.6c-0.5,0.5-0.7,1.2-0.7,1.9v4H810v-8.8h2.3v1.3
		c0.5-0.9,1.5-1.5,2.5-1.3L815.3,1042.1z"
                />
                <path
                  className="st15"
                  d="M819.3,1045.9v5H817v-8.8h2.3v1.1c0.3-0.4,0.6-0.7,1-1c0.5-0.2,1-0.3,1.5-0.3c0.9-0.1,1.8,0.3,2.3,1
		c0.6,0.7,0.9,1.6,0.9,2.5v5.5h-2.4v-5.1c0-0.5-0.1-0.9-0.4-1.3c-0.3-0.3-0.7-0.5-1.2-0.5c-0.5,0-0.9,0.2-1.2,0.6
		C819.5,1044.9,819.3,1045.4,819.3,1045.9z"
                />
                <path
                  className="st15"
                  d="M833.2,1047.8l2,0.6c-0.3,0.8-0.8,1.5-1.4,2c-0.8,0.5-1.7,0.7-2.6,0.7c-1.2,0-2.3-0.4-3.2-1.2
		c-0.9-0.9-1.4-2.1-1.3-3.4c-0.1-1.2,0.4-2.4,1.3-3.3c0.8-0.9,1.9-1.3,3-1.3c1.2,0,2.3,0.4,3.2,1.2c0.8,0.9,1.1,2.1,1.1,3.3v0.6H829
		c0,0.6,0.3,1.1,0.7,1.5c0.4,0.3,1,0.5,1.5,0.5C832.1,1049.1,832.9,1048.6,833.2,1047.8z M829.1,1045.5h3.9c0-0.5-0.2-0.9-0.5-1.2
		c-0.4-0.3-1-0.5-1.5-0.5c-0.5,0-1,0.2-1.4,0.5C829.3,1044.6,829.1,1045.1,829.1,1045.5L829.1,1045.5z"
                />
                <path
                  className="st15"
                  d="M878.3,849.7l-2.5-4.8h-1.3v4.8H872v-12.6h5c1.1,0,2.1,0.4,2.9,1.1c0.7,0.8,1.1,1.8,1.1,2.8
		c0,0.8-0.3,1.6-0.7,2.3c-0.5,0.6-1.2,1.1-2,1.3l2.7,5.1L878.3,849.7z M874.5,842.8h2c0.5,0,1.1-0.2,1.5-0.5
		c0.3-0.3,0.5-0.8,0.5-1.3c0-0.5-0.2-0.9-0.5-1.2c-0.4-0.4-1-0.5-1.5-0.5h-2V842.8z"
                />
                <path
                  className="st15"
                  d="M882.7,838.1c0-0.8,0.6-1.4,1.4-1.4h0c0.4,0,0.8,0.1,1.1,0.4c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.1,0.8-0.4,1.1
		c-0.3,0.2-0.7,0.4-1.1,0.4c-0.4,0-0.7-0.2-1-0.4C882.8,838.9,882.7,838.5,882.7,838.1z M885.3,849.7H883V841h2.3V849.7z"
                />
                <path
                  className="st15"
                  d="M891.8,842.9c-0.6,0-1.2,0.2-1.6,0.7c-0.4,0.5-0.7,1.1-0.6,1.8c0,0.7,0.2,1.3,0.6,1.8c0.4,0.4,1,0.6,1.6,0.6
		c0.9,0,1.7-0.5,2-1.4l2.1,0.7c-0.2,0.8-0.7,1.5-1.4,2c-0.8,0.6-1.7,0.9-2.7,0.9c-2.4,0.1-4.5-1.8-4.6-4.2c0-0.1,0-0.3,0-0.4
		c-0.1-1.3,0.4-2.5,1.3-3.4c0.9-0.8,2-1.3,3.2-1.3c1,0,2,0.3,2.8,0.9c0.6,0.5,1.1,1.3,1.3,2.1l-2.1,0.7
		C893.5,843.5,892.7,842.8,891.8,842.9z"
                />
                <path
                  className="st15"
                  d="M900,844.6v5.1h-2.4v-12.8h2.4v4.8c0.6-0.6,1.4-1,2.3-0.9c0.9-0.1,1.8,0.3,2.5,0.9c0.5,0.7,0.8,1.6,0.8,2.5
		v5.5h-2.4v-5.1c0-0.4-0.1-0.9-0.4-1.2c-0.3-0.4-0.7-0.5-1.2-0.5c-0.4,0-0.8,0.2-1.1,0.5C900.2,843.7,900,844.1,900,844.6z"
                />
                <path
                  className="st15"
                  d="M910.4,849.7H908V841h2.3v1.1c0.2-0.4,0.6-0.8,1-1c0.5-0.2,1-0.3,1.5-0.3c1.1-0.1,2.1,0.4,2.6,1.4
		c0.6-1,1.7-1.5,2.8-1.4c0.8-0.1,1.6,0.2,2.2,0.8c0.6,0.7,1,1.6,0.9,2.5v5.6H919v-5.1c0-0.4-0.1-0.8-0.3-1.2c-0.7-0.7-1.7-0.7-2.4,0
		c-0.3,0.3-0.4,0.8-0.4,1.2v5.1h-2.4v-5.1c0-0.4-0.1-0.9-0.4-1.2c-0.3-0.3-0.7-0.5-1.1-0.5c-0.5,0-0.9,0.2-1.2,0.5
		c-0.3,0.3-0.4,0.8-0.4,1.2L910.4,849.7z"
                />
                <path
                  className="st15"
                  d="M924.4,842c0.9-0.8,2.1-1.3,3.3-1.3c1.2,0,2.4,0.4,3.2,1.3c0.9,0.9,1.4,2.1,1.3,3.4c0,1.2-0.4,2.4-1.3,3.3
		c-0.8,0.9-2,1.4-3.2,1.3c-1.2,0.1-2.4-0.4-3.3-1.3c-0.9-0.9-1.3-2.1-1.3-3.3C923,844.1,923.5,842.9,924.4,842z M926.1,847.2
		c0.4,0.4,1,0.7,1.6,0.7c1.3-0.1,2.3-1.2,2.2-2.5c0-0.7-0.2-1.4-0.7-1.9c-0.4-0.4-0.9-0.6-1.5-0.6c-0.6,0-1.2,0.2-1.6,0.6
		c-0.5,0.5-0.7,1.2-0.7,1.9C925.4,846.1,925.6,846.7,926.1,847.2L926.1,847.2z"
                />
                <path
                  className="st15"
                  d="M936.5,844.7v5h-2.4V841h2.3v1.1c0.2-0.5,0.6-0.8,1.1-1c0.4-0.2,0.9-0.3,1.4-0.3c0.9-0.1,1.8,0.3,2.4,0.9
		c0.5,0.7,0.8,1.6,0.8,2.5v5.5h-2.4v-5.1c0-0.4-0.1-0.9-0.4-1.2c-0.3-0.3-0.7-0.5-1.2-0.5c-0.5,0-0.9,0.2-1.2,0.5
		C936.6,843.8,936.5,844.2,936.5,844.7z"
                />
                <path
                  className="st15"
                  d="M952.8,836.9v11.3c0,0.5,0,1,0.1,1.5h-2.3c0-0.3-0.1-0.6-0.1-1c-0.2,0.4-0.5,0.7-0.9,0.9
		c-0.5,0.3-1,0.4-1.5,0.4c-1.2,0-2.3-0.5-3.1-1.4c-0.8-0.9-1.2-2-1.2-3.2c0-1.2,0.4-2.4,1.2-3.3c0.8-0.9,1.9-1.3,3-1.3
		c1.3,0,2.1,0.3,2.5,1.1v-5H952.8z M946.2,845.4c0,0.7,0.2,1.3,0.6,1.8c0.4,0.4,1,0.6,1.6,0.6c0.6,0,1.1-0.2,1.5-0.6
		c0.4-0.5,0.6-1.2,0.6-1.9c0-0.7-0.2-1.3-0.6-1.8c-0.4-0.4-0.9-0.6-1.5-0.6c-0.6,0-1.2,0.2-1.6,0.7
		C946.4,844.1,946.1,844.7,946.2,845.4z"
                />
                <path
                  className="st15"
                  d="M1218.6,695.8l-3.6-5.2l-1.6,1.7v3.5h-2.4v-12.6h2.4v5.7l5.1-5.7h3.2l-5,5.5l5,7.1H1218.6z"
                />
                <path
                  className="st15"
                  d="M1228.3,692.7l2,0.6c-0.3,0.8-0.7,1.5-1.4,2c-0.8,0.5-1.7,0.8-2.6,0.8c-2.5,0-4.5-2-4.5-4.5
		c0-0.1,0-0.1,0-0.2c0-1.2,0.4-2.4,1.3-3.3c0.8-0.8,1.9-1.3,3-1.3c1.2,0,2.3,0.4,3.2,1.2c0.8,1,1.2,2.2,1.1,3.4v0.6h-6.3
		c0,0.5,0.3,1.1,0.7,1.4c0.4,0.4,0.9,0.6,1.5,0.6C1227.2,694.1,1228,693.5,1228.3,692.7z M1224.2,690.5h3.9c0-0.5-0.2-0.9-0.5-1.3
		c-0.4-0.3-1-0.5-1.5-0.5c-0.5,0-1,0.2-1.4,0.6C1224.4,689.6,1224.2,690,1224.2,690.5L1224.2,690.5z"
                />
                <path
                  className="st15"
                  d="M1237.1,687.1h2.5l1.9,5.6l1.6-5.6h2.3l-2.7,8.7h-2.4l-2-5.9l-2,5.9h-2.4l-2.8-8.7h2.5l1.6,5.6L1237.1,687.1z
		"
                />
                <path
                  className="st16"
                  d="M1011.1,379.9v-1.2l2-1.2h0.9v8.4h-1.2V379L1011.1,379.9z"
                />
                <path
                  className="st16"
                  d="M1016.5,377.5h1.2v3.6l3.4-3.6h1.6l-3.8,3.9l4,4.5h-1.5l-3.7-4.2v4.2h-1.2V377.5z"
                />
                <path
                  className="st16"
                  d="M1028.8,384.1h-0.9l-2.4-3.8v5.6h-1.2v-8.4h0.8l3.3,5.2l3.2-5.2h0.8v8.4h-1.2v-5.6L1028.8,384.1z"
                />
                <path
                  className="st16"
                  d="M887.4,379.3c0.3-1.1,1.3-1.9,2.5-1.9c1.4,0,2.6,1.2,2.6,2.6c-0.1,0.9-0.5,1.8-1.1,2.4l-2.1,2.4h3.2v1.1h-5.1
		v-0.7l2.9-3.3c0.7-0.8,1-1.2,1-1.9c0-0.8-0.6-1.4-1.4-1.4l0,0c-0.7,0-1.3,0.4-1.4,1.1L887.4,379.3z"
                />
                <path
                  className="st16"
                  d="M894.3,377.5h1.2v3.6l3.5-3.6h1.6l-3.8,3.9l4,4.5h-1.5l-3.8-4.2v4.2h-1.2V377.5z"
                />
                <path
                  className="st16"
                  d="M906.6,384.1h-0.8l-2.5-3.8v5.6h-1.2v-8.4h0.9l3.2,5.2l3.2-5.2h0.9v8.4h-1.2v-5.6L906.6,384.1z"
                />
                <path
                  className="st16"
                  d="M752.7,384c0.5,0.8,1.7,1.1,2.5,0.5c0.5-0.3,0.8-0.8,0.8-1.3c0.1-0.9-0.7-1.7-1.6-1.8c-0.1,0-0.1,0-0.2,0
		c-0.3,0-0.7,0.1-1,0.2v-0.8l1.8-2.1h-2.9v-1.2h4.7v0.8l-1.9,2.1c1.3,0.2,2.3,1.4,2.3,2.8c0,1.6-1.3,2.9-2.9,2.9l0,0
		c-1.1,0-2.1-0.5-2.6-1.5L752.7,384z"
                />
                <path
                  className="st16"
                  d="M758.9,377.5h1.2v3.6l3.5-3.6h1.6l-3.8,3.9l4,4.5h-1.5l-3.8-4.2v4.2h-1.2V377.5z"
                />
                <path
                  className="st16"
                  d="M771.2,384.1h-0.8l-2.5-3.8v5.6h-1.2v-8.4h0.9l3.2,5.2l3.3-5.2h0.8v8.4h-1.2v-5.6L771.2,384.1z"
                />
                <path
                  className="st16"
                  d="M611.9,383.1l4.3-5.6h0.8v5.3h1.3v1.1H617v2h-1.2v-2h-3.9L611.9,383.1z M615.8,382.8v-2.9l-2.2,2.9H615.8z"
                />
                <path
                  className="st16"
                  d="M619.5,377.5h1.2v3.6l3.5-3.6h1.6l-3.8,3.9l4,4.5h-1.5l-3.8-4.2v4.2h-1.2V377.5z"
                />
                <path
                  className="st16"
                  d="M631.8,384.1H631l-2.5-3.8v5.6h-1.2v-8.4h0.9l3.2,5.2l3.2-5.2h0.9v8.4h-1.2v-5.6L631.8,384.1z"
                />
                <path
                  className="st16"
                  d="M478,378.7l-0.2,1.7h0.8c1.6,0,2.9,1.3,2.9,2.9c0,1.6-1.3,2.9-2.9,2.9c-1,0-1.9-0.4-2.5-1.2l0.9-0.7
		c0.4,0.5,1,0.7,1.6,0.7c0.9,0,1.6-0.7,1.6-1.6c0,0,0-0.1,0-0.1c0.1-0.9-0.7-1.7-1.6-1.8c-0.5,0-1,0.2-1.3,0.5h-0.9l0.6-4.3h4v1.2
		L478,378.7z"
                />
                <path
                  className="st16"
                  d="M483.3,377.5h1.2v3.6l3.5-3.6h1.5l-3.8,3.9l4.1,4.5h-1.6l-3.7-4.2v4.2h-1.2V377.5z"
                />
                <path
                  className="st16"
                  d="M495.6,384.1h-0.8l-2.5-3.8v5.6h-1.2v-8.4h0.8l3.3,5.2l3.2-5.2h0.9v8.4h-1.2v-5.6L495.6,384.1z"
                />
                <path
                  className="st16"
                  d="M341.1,380.4h0.5c1.6,0.1,2.8,1.3,2.8,2.9c0,1.6-1.3,2.9-2.9,2.9c-1.6,0-2.9-1.3-2.9-2.9c0-0.4,0-0.9,0.2-1.3
		l0.8-1.3l2-3.1h1.4L341.1,380.4z M339.8,383.2c-0.1,0.9,0.6,1.6,1.5,1.7c0.1,0,0.1,0,0.2,0c0.9,0,1.7-0.8,1.7-1.7v0
		c0-1-0.7-1.7-1.7-1.8c-0.5,0-0.9,0.2-1.3,0.5C339.9,382.3,339.8,382.7,339.8,383.2L339.8,383.2z"
                />
                <path
                  className="st16"
                  d="M346,377.5h1.2v3.6l3.5-3.6h1.5l-3.7,3.9l4,4.5h-1.6l-3.7-4.2v4.2H346V377.5z"
                />
                <path
                  className="st16"
                  d="M358.3,384.1h-0.8l-2.5-3.8v5.6h-1.2v-8.4h0.8l3.3,5.2l3.2-5.2h0.9v8.4h-1.2v-5.6L358.3,384.1z"
                />
                <path
                  className="st15"
                  d="M1232.7,174.9l-1.1-2.9h-5.1l-1.1,2.9h-2.5l4.8-12.6h2.8l4.8,12.6H1232.7z M1229.1,165l-1.8,4.8h3.5
		L1229.1,165z"
                />
                <path
                  className="st15"
                  d="M1239.1,174.9h-2.3v-12.8h2.3V174.9z"
                />
                <path
                  className="st15"
                  d="M1244,178.3h-2.4v-12.1h2.3v1c0.3-0.3,0.7-0.7,1.1-0.9c0.5-0.2,1.1-0.3,1.6-0.3c1.1-0.1,2.3,0.4,3,1.3
		c0.7,0.9,1.1,2,1.1,3.2c0.1,1.2-0.4,2.4-1.2,3.3c-0.7,0.9-1.9,1.4-3,1.3c-0.9,0.1-1.9-0.3-2.5-1V178.3z M1247.7,172.4
		c0.4-0.5,0.6-1.2,0.6-1.9c0-0.6-0.2-1.2-0.6-1.7c-0.4-0.5-0.9-0.7-1.5-0.7c-0.6,0-1.2,0.2-1.6,0.7c-0.4,0.5-0.6,1.1-0.6,1.7
		c-0.1,0.7,0.2,1.3,0.6,1.8c0.4,0.5,1,0.7,1.6,0.7C1246.8,173,1247.3,172.8,1247.7,172.4L1247.7,172.4z"
                />
                <path
                  className="st15"
                  d="M1254.9,169.8v5.1h-2.4v-12.8h2.4v4.8c0.6-0.7,1.4-1,2.3-1c0.9,0,1.8,0.3,2.5,1c0.5,0.7,0.8,1.6,0.8,2.5v5.5
		h-2.4v-5.1c0-0.4-0.1-0.9-0.4-1.2c-0.2-0.4-0.6-0.5-1.2-0.5s-0.9,0.1-1.1,0.5C1255.1,168.9,1254.9,169.3,1254.9,169.8z"
                />
                <path
                  className="st15"
                  d="M1262.6,163.3c0-0.4,0.2-0.7,0.4-1c0.3-0.3,0.7-0.5,1.1-0.5c0.4,0,0.8,0.2,1,0.5c0.6,0.5,0.6,1.4,0,2
		c0,0,0,0,0,0c-0.2,0.3-0.6,0.5-1,0.5c-0.4,0-0.8-0.2-1.1-0.5C1262.8,164,1262.6,163.7,1262.6,163.3z M1265.3,174.9h-2.4v-8.7h2.4
		V174.9z"
                />
                <path
                  className="st15"
                  d="M1270.1,169.9v5h-2.3v-8.7h2.3v1.1c0.2-0.4,0.6-0.8,1-1c0.5-0.2,1-0.4,1.5-0.4c0.9,0,1.7,0.3,2.3,1
		c0.6,0.7,0.9,1.6,0.9,2.5v5.5h-2.4v-5.1c0-0.4-0.1-0.9-0.4-1.2c-0.3-0.4-0.7-0.6-1.2-0.5c-0.5,0-0.9,0.2-1.2,0.5
		C1270.3,169,1270.1,169.4,1270.1,169.9z"
                />
                <path
                  className="st15"
                  d="M1277.5,175.4l2.2-0.6c0,0.5,0.2,0.9,0.6,1.2c0.4,0.3,0.9,0.5,1.4,0.5c1.6,0,2.3-0.8,2.3-2.5v-0.6
		c-0.2,0.3-0.5,0.6-0.9,0.8c-0.5,0.2-1,0.3-1.5,0.3c-1.1,0-2.2-0.4-2.9-1.2c-1.6-1.7-1.6-4.3,0-6c0.7-0.9,1.8-1.3,2.9-1.3
		c0.6,0,1.1,0.1,1.6,0.4c0.4,0.2,0.7,0.5,0.9,0.8v-1h2.3v7.8c0,1.2-0.4,2.4-1.2,3.3c-0.9,0.9-2.1,1.4-3.4,1.3
		c-1.1,0.1-2.1-0.3-2.9-1C1278.2,177.1,1277.7,176.3,1277.5,175.4z M1282,172.5c0.6,0,1.1-0.2,1.5-0.6c0.8-0.9,0.8-2.3,0-3.2
		c-0.8-0.8-2.2-0.8-3,0c-0.8,0.9-0.8,2.3,0,3.2C1280.9,172.3,1281.4,172.5,1282,172.5z"
                />
                <path
                  className="st15"
                  d="M1291.7,163.6v2.6h1.7v2.1h-1.7v3.6c0,0.3,0,0.6,0.2,0.8c0.2,0.2,0.4,0.2,0.8,0.2h0.7v1.9
		c-0.4,0.2-0.9,0.3-1.3,0.2c-0.7,0.1-1.5-0.2-2-0.7c-0.5-0.5-0.8-1.2-0.8-2v-4h-1.6v-2.1h0.5c0.4,0,0.7-0.1,1-0.4
		c0.2-0.3,0.3-0.6,0.3-1v-1.2L1291.7,163.6z"
                />
                <path
                  className="st15"
                  d="M1296,167.2c0.9-0.8,2.1-1.3,3.3-1.3c1.2,0,2.4,0.4,3.2,1.3c0.9,0.9,1.4,2.1,1.4,3.3c0,1.3-0.5,2.5-1.4,3.4
		c-0.8,0.9-2,1.3-3.2,1.3c-1.2,0-2.4-0.5-3.3-1.3c-0.9-0.9-1.4-2.1-1.3-3.4C1294.7,169.3,1295.1,168.1,1296,167.2z M1297.7,172.4
		c0.4,0.4,1,0.6,1.6,0.6c0.6,0,1.1-0.2,1.5-0.6c0.5-0.5,0.7-1.2,0.7-1.9c0-0.7-0.2-1.3-0.7-1.8c-0.4-0.4-0.9-0.6-1.5-0.6
		c-0.6,0-1.2,0.2-1.6,0.6c-0.4,0.5-0.6,1.1-0.6,1.8C1297.1,171.2,1297.3,171.9,1297.7,172.4z"
                />
                <path
                  className="st15"
                  d="M1308.1,169.9v5h-2.4v-8.7h2.3v1.1c0.2-0.5,0.6-0.8,1.1-1c0.4-0.2,0.9-0.4,1.4-0.4c0.9,0,1.8,0.3,2.4,1
		c0.5,0.7,0.8,1.6,0.8,2.5v5.5h-2.4v-5.1c0-0.4-0.1-0.9-0.4-1.2c-0.2-0.4-0.6-0.5-1.2-0.5c-0.5,0-0.9,0.2-1.2,0.5
		C1308.2,169,1308.1,169.4,1308.1,169.9z"
                />
                <path className="st15" d="M1530.6,189.6h-2.5V177h2.5V189.6z" />
                <path
                  className="st15"
                  d="M1541.5,180.9l-3.4,8.7h-2.4l-3.5-8.7h2.6l2.1,5.8l2.1-5.8H1541.5z"
                />
                <path
                  className="st15"
                  d="M1542.4,187.2c0-0.7,0.2-1.3,0.7-1.8c0.5-0.4,1.2-0.7,1.9-0.8l2.1-0.4c0.5,0,0.7-0.2,0.7-0.6
		c0-0.3-0.2-0.6-0.4-0.8c-0.3-0.2-0.7-0.3-1.1-0.3c-0.4,0-0.9,0.1-1.2,0.4c-0.3,0.3-0.4,0.6-0.5,1l-2.1-0.4c0.1-0.8,0.5-1.5,1.2-2
		c0.7-0.6,1.6-1,2.6-0.9c1-0.1,2.1,0.2,2.9,0.9c0.6,0.6,0.9,1.5,0.9,2.4v4.3c0,0.5,0,0.9,0.1,1.4h-2.2c0-0.3-0.1-0.6-0.1-1.1
		c-0.5,0.9-1.5,1.4-2.5,1.3c-0.8,0.1-1.6-0.2-2.2-0.7C1542.7,188.6,1542.4,187.9,1542.4,187.2z M1545.9,188.1c0.5,0,0.9-0.2,1.3-0.5
		c0.4-0.4,0.6-0.9,0.6-1.5v-0.4l-2,0.3c-0.7,0.1-1.1,0.4-1.1,1.1c0,0.3,0.1,0.5,0.3,0.7C1545.2,188,1545.6,188.1,1545.9,188.1
		L1545.9,188.1z"
                />
                <path
                  className="st15"
                  d="M1554.8,184.6v5h-2.3v-8.7h2.3v1c0.2-0.4,0.6-0.7,1-0.9c0.5-0.3,1-0.4,1.5-0.4c0.9-0.1,1.8,0.3,2.3,1
		c0.6,0.7,0.9,1.6,0.8,2.5v5.5h-2.3v-5.1c0-0.5-0.2-0.9-0.4-1.3c-0.3-0.3-0.8-0.4-1.2-0.4c-0.5-0.1-0.9,0.1-1.2,0.5
		C1555,183.6,1554.8,184.1,1554.8,184.6z"
                />
                <path
                  className="st15"
                  d="M1565.2,184.5v5.1h-2.4v-12.9h2.4v4.9c0.6-0.7,1.5-1.1,2.4-1c0.9,0,1.8,0.3,2.4,1c0.5,0.7,0.8,1.6,0.8,2.5
		v5.5h-2.3v-5.1c0-0.5-0.2-0.9-0.4-1.3c-0.4-0.3-0.8-0.5-1.3-0.4c-0.4,0-0.8,0.1-1.1,0.4C1565.4,183.6,1565.2,184,1565.2,184.5z"
                />
                <path
                  className="st15"
                  d="M1573.9,181.9c0.8-0.9,2-1.4,3.2-1.3c1.2-0.1,2.4,0.4,3.3,1.3c0.9,0.9,1.3,2.1,1.3,3.3
		c0.1,1.2-0.4,2.4-1.3,3.3c-0.9,0.9-2.1,1.4-3.3,1.4c-2.5-0.1-4.6-2.2-4.5-4.7c0,0,0,0,0,0C1572.6,184,1573,182.8,1573.9,181.9z
		 M1575.6,187.1c0.4,0.4,0.9,0.6,1.5,0.6c0.6,0,1.2-0.2,1.6-0.6c0.5-0.5,0.7-1.2,0.7-1.9c0-0.7-0.2-1.3-0.7-1.8
		c-0.4-0.4-1-0.7-1.6-0.7c-1.3,0.1-2.3,1.2-2.2,2.5C1574.9,185.9,1575.1,186.6,1575.6,187.1L1575.6,187.1z"
                />
                <path
                  className="st15"
                  d="M1589.4,186.5l2,0.6c-0.2,0.8-0.7,1.5-1.4,2c-0.8,0.5-1.7,0.8-2.6,0.8c-1.2,0-2.3-0.5-3.2-1.3
		c-0.9-0.9-1.3-2.1-1.3-3.4c0-1.2,0.4-2.4,1.3-3.3c0.8-0.8,1.9-1.3,3-1.3c1.2-0.1,2.4,0.4,3.2,1.2c0.8,0.9,1.2,2.1,1.1,3.3v0.6h-6.2
		c0,0.6,0.2,1.1,0.6,1.5c0.5,0.3,1,0.5,1.6,0.5C1588.3,187.8,1589.1,187.3,1589.4,186.5z M1585.3,184.2h3.9c0-0.5-0.2-0.9-0.5-1.2
		c-0.8-0.7-2-0.7-2.8,0C1585.5,183.3,1585.3,183.7,1585.3,184.2z"
                />
                <path
                  className="st15"
                  d="M597.2,628.9h-2.5v-12.6h8v2.4h-5.5v3.1h4.9v2.2h-4.9V628.9z"
                />
                <path
                  className="st15"
                  d="M604.2,617.3c0-0.4,0.2-0.7,0.4-1c0.3-0.3,0.7-0.4,1.1-0.4c0.8,0,1.4,0.6,1.4,1.4v0c0,0.4-0.1,0.8-0.4,1.1
		c-0.3,0.2-0.6,0.4-1,0.4c-0.8,0.1-1.4-0.5-1.5-1.3C604.2,617.4,604.2,617.4,604.2,617.3z M606.9,628.9h-2.4v-8.7h2.4V628.9z"
                />
                <path
                  className="st15"
                  d="M612.3,617.6v2.6h1.8v2.1h-1.8v3.7c0,0.6,0.4,1,1,1h0.8v1.9c-0.4,0.2-0.9,0.3-1.4,0.3c-0.7,0-1.5-0.3-2-0.8
		c-0.5-0.5-0.8-1.2-0.7-1.9v-4.1h-1.6v-2.1h0.4c0.4,0.1,0.8-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1v-1.2L612.3,617.6z"
                />
                <path
                  className="st15"
                  d="M623,628.9h-7.2v-2l4.2-4.7h-4.1v-2h7.1v2l-4.3,4.7h4.3V628.9z"
                />
                <path
                  className="st15"
                  d="M630.3,620.2v2.3h-0.7c-0.6,0-1.2,0.2-1.6,0.6c-0.5,0.4-0.8,1.1-0.7,1.8v4H625v-8.7h2.3v1.3
		c0.4-0.9,1.4-1.5,2.4-1.4L630.3,620.2z"
                />
                <path
                  className="st15"
                  d="M632.5,621.2c1.9-1.8,4.7-1.8,6.6,0c0.9,0.9,1.3,2.1,1.3,3.4c0,1.2-0.5,2.4-1.3,3.3c-1.9,1.8-4.7,1.8-6.6,0
		c-0.8-0.9-1.3-2.1-1.3-3.3C631.2,623.3,631.6,622.1,632.5,621.2z M634.2,626.4c0.8,0.9,2.2,0.9,3.1,0.1c0,0,0.1-0.1,0.1-0.1
		c0.4-0.5,0.7-1.1,0.6-1.8c0-0.7-0.2-1.4-0.6-1.9c-0.9-0.8-2.3-0.8-3.2,0c-0.4,0.5-0.6,1.2-0.6,1.9
		C633.5,625.3,633.8,625.9,634.2,626.4z"
                />
                <path
                  className="st15"
                  d="M644.9,632.4h-2.5l2-4.6l-3.7-7.6h2.7l2.3,5.1l2.1-5.1h2.5L644.9,632.4z"
                />
                <path
                  className="st15"
                  d="M613.3,447.4h-2.4v-12.6h7.9v2.3h-5.5v3.1h4.9v2.3h-4.9V447.4z"
                />
                <path
                  className="st15"
                  d="M620.4,435.8c0-0.4,0.1-0.7,0.4-1c0.2-0.3,0.6-0.5,1-0.5c0.4,0,0.7,0.1,1,0.4c0.3,0.3,0.5,0.7,0.5,1.1
		c0,0.4-0.2,0.8-0.5,1c-0.3,0.3-0.6,0.4-1,0.4C621,437.2,620.4,436.6,620.4,435.8C620.4,435.8,620.4,435.8,620.4,435.8z M623,447.4
		h-2.4v-8.7h2.4V447.4z"
                />
                <path
                  className="st15"
                  d="M628.4,436v2.7h1.8v2.1h-1.8v3.6c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.2,0.8,0.2h0.7v1.9l-1.3,0.2
		c-0.8,0.1-1.5-0.2-2.1-0.7c-0.5-0.5-0.8-1.3-0.7-2v-4h-1.6v-2.1h0.5c0.4,0,0.7-0.2,1-0.4c0.2-0.3,0.3-0.6,0.3-1V436H628.4z"
                />
                <path
                  className="st15"
                  d="M639.2,447.4H632v-2.1l4.1-4.6h-4v-2h7v1.9l-4.3,4.7h4.4V447.4z"
                />
                <path
                  className="st15"
                  d="M646.4,438.6v2.4h-0.7c-0.6,0-1.2,0.2-1.6,0.6c-0.5,0.5-0.7,1.2-0.6,1.9v4h-2.4v-8.7h2.3v1.2
		c0.4-1,1.4-1.6,2.5-1.4H646.4z"
                />
                <path
                  className="st15"
                  d="M648.7,439.7c0.8-0.9,2-1.4,3.2-1.3c2.4-0.1,4.5,1.8,4.6,4.2c0,0.1,0,0.3,0,0.4c0.1,1.2-0.4,2.4-1.3,3.3
		c-0.9,0.9-2.1,1.4-3.3,1.4c-1.2,0-2.4-0.5-3.2-1.4c-0.9-0.8-1.4-2-1.4-3.3C647.3,441.8,647.8,440.6,648.7,439.7z M650.4,444.9
		c0.4,0.4,0.9,0.6,1.5,0.6c0.6,0,1.2-0.2,1.6-0.6c0.5-0.5,0.7-1.2,0.7-1.9c0-0.7-0.2-1.3-0.7-1.8c-0.4-0.4-1-0.7-1.6-0.7
		c-1.3,0.1-2.3,1.2-2.2,2.5C649.7,443.7,649.9,444.4,650.4,444.9L650.4,444.9z"
                />
                <path
                  className="st15"
                  d="M661,450.8h-2.5l2-4.5l-3.7-7.6h2.7l2.3,5.1l2.2-5.1h2.5L661,450.8z"
                />
                <path
                  className="st15"
                  d="M683.2,447.4h-2.5l-5.8-8.9v8.9h-2.4v-12.6h3l5.3,8.3v-8.3h2.4V447.4z"
                />
                <path
                  className="st15"
                  d="M686.5,439.7c1.9-1.8,4.7-1.8,6.6,0c0.8,0.9,1.3,2.1,1.3,3.3c0,2.5-2.1,4.6-4.6,4.6c-2.5,0-4.6-2.1-4.6-4.6
		l0,0C685.2,441.8,685.7,440.6,686.5,439.7z M688.2,444.9c0.9,0.8,2.3,0.8,3.2,0c0.4-0.5,0.6-1.2,0.6-1.9c0.1-0.7-0.2-1.3-0.6-1.8
		c-0.8-0.9-2.2-0.9-3.1-0.1c0,0-0.1,0.1-0.1,0.1c-0.4,0.5-0.7,1.1-0.6,1.8C687.6,443.7,687.8,444.4,688.2,444.9L688.2,444.9z"
                />
                <path
                  className="st15"
                  d="M701.6,438.6v2.4h-0.7c-0.6,0-1.2,0.2-1.7,0.6c-0.5,0.5-0.7,1.2-0.6,1.9v4h-2.3v-8.7h2.2v1.2
		c0.5-0.9,1.5-1.5,2.5-1.4H701.6z"
                />
                <path
                  className="st15"
                  d="M706.5,436v2.7h1.8v2.1h-1.8v3.6c0,0.3,0.1,0.6,0.2,0.8l0.8,0.2h0.8v1.9l-1.4,0.2c-0.7,0-1.5-0.2-2-0.7
		c-0.5-0.5-0.8-1.3-0.7-2v-4h-1.6v-2.1h0.4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V436H706.5z"
                />
                <path
                  className="st15"
                  d="M712.2,442.3v5.1h-2.4v-12.9h2.4v4.9c0.6-0.7,1.5-1.1,2.4-1c0.9,0,1.8,0.3,2.4,1c0.5,0.7,0.8,1.6,0.8,2.5v5.5
		h-2.3v-5.1c0-0.5-0.2-0.9-0.4-1.3c-0.4-0.3-0.8-0.5-1.3-0.4c-0.4,0-0.8,0.1-1.1,0.4C712.4,441.4,712.2,441.8,712.2,442.3z"
                />
                <path
                  className="st15"
                  d="M467.3,582c-3.4,0.1-6.3-2.6-6.4-6c0-0.2,0-0.4,0-0.6c-0.1-3.5,2.6-6.4,6.1-6.5c2.7-0.1,5.2,1.6,6.1,4.1
		l-2.4,0.8c-0.1-0.7-0.5-1.4-1.1-1.8c-0.6-0.6-1.5-0.8-2.3-0.8c-1,0-2,0.4-2.7,1.1c-1.6,1.8-1.6,4.4,0,6.2c0.7,0.7,1.7,1.1,2.7,1.1
		c0.9,0,1.7-0.3,2.4-0.8c0.5-0.5,1-1.1,1.2-1.8l2.2,0.7c-0.1,0.5-0.3,1-0.6,1.5c-0.3,0.5-0.7,1-1.1,1.4c-0.6,0.4-1.2,0.7-1.8,1
		C468.9,581.9,468.1,582,467.3,582z"
                />
                <path
                  className="st15"
                  d="M474.2,579.4c0-0.7,0.3-1.4,0.8-1.8c0.5-0.5,1.1-0.8,1.8-0.9l2.2-0.3c0.4-0.1,0.6-0.3,0.6-0.6
		c0-0.3-0.1-0.6-0.3-0.9c-0.3-0.2-0.7-0.3-1.1-0.3c-0.4,0-0.9,0.1-1.2,0.4c-0.3,0.2-0.5,0.6-0.5,1l-2.1-0.4c0.1-0.8,0.5-1.5,1.1-2
		c0.8-0.6,1.7-0.9,2.7-0.9c1-0.1,2.1,0.3,2.8,1c0.6,0.6,1,1.4,1,2.3v4.3c0,0.5,0,0.9,0.1,1.4h-2.2c-0.1-0.3-0.1-0.7-0.1-1
		c-0.6,0.9-1.6,1.4-2.6,1.3c-0.8,0-1.5-0.3-2.1-0.8C474.5,580.8,474.2,580.1,474.2,579.4z M477.7,580.2c0.5,0,1-0.1,1.4-0.4
		c0.4-0.4,0.6-1,0.5-1.6v-0.4l-1.9,0.3c-0.7,0.1-1.1,0.5-1.1,1.1c0,0.3,0.1,0.5,0.3,0.7C477.1,580.1,477.4,580.2,477.7,580.2z"
                />
                <path
                  className="st15"
                  d="M489.7,573v2.3H489c-0.6,0-1.2,0.2-1.7,0.5c-0.4,0.5-0.6,1.2-0.6,1.9v4h-2.4V573h2.3v1.3
		c0.5-0.9,1.5-1.5,2.5-1.4L489.7,573z"
                />
                <path className="st15" d="M493.7,581.7h-2.4v-12.8h2.4V581.7z" />
                <path
                  className="st15"
                  d="M499.1,570.4v2.6h1.8v2.1h-1.8v3.7c0,0.3,0.1,0.5,0.3,0.7c0.1,0.2,0.4,0.3,0.8,0.3h0.7v1.9
		c-0.4,0.2-0.8,0.3-1.3,0.3c-0.8,0-1.5-0.3-2.1-0.8c-0.5-0.5-0.8-1.2-0.7-1.9v-4.1h-1.6V573h0.4c0.4,0,0.8-0.1,1.1-0.4
		c0.2-0.3,0.3-0.6,0.3-1v-1.2L499.1,570.4z"
                />
                <path
                  className="st15"
                  d="M503.5,574c0.8-0.9,2-1.3,3.2-1.3c1.2,0,2.4,0.5,3.3,1.3c0.9,0.9,1.4,2.1,1.3,3.4c0.1,2.4-1.8,4.5-4.2,4.6
		c-0.1,0-0.3,0-0.4,0c-1.2,0.1-2.4-0.4-3.2-1.3c-0.9-0.9-1.4-2.1-1.4-3.3C502.1,576.1,502.6,574.9,503.5,574z M505.2,579.2
		c0.4,0.4,0.9,0.7,1.5,0.7c0.6,0,1.2-0.3,1.6-0.7c0.4-0.5,0.7-1.1,0.7-1.8c0-0.7-0.2-1.4-0.7-1.9c-0.4-0.4-1-0.6-1.6-0.6
		c-0.6,0-1.1,0.2-1.5,0.6c-0.5,0.5-0.7,1.2-0.7,1.9C504.5,578.1,504.7,578.7,505.2,579.2z"
                />
                <path
                  className="st15"
                  d="M515.5,576.7v5h-2.3V573h2.3v1.1c0.2-0.4,0.6-0.8,1-1c0.5-0.2,1-0.3,1.5-0.3c0.9-0.1,1.7,0.3,2.3,0.9
		c0.6,0.7,0.9,1.6,0.9,2.5v5.5h-2.4v-5.1c0-0.4-0.1-0.9-0.4-1.2c-0.7-0.7-1.7-0.7-2.4,0C515.7,575.8,515.5,576.2,515.5,576.7z"
                />
                <path
                  className="st15"
                  d="M377.6,202.1h4.5c1-0.1,2,0.3,2.8,1c0.7,0.6,1,1.5,1,2.4c0,0.6-0.1,1.2-0.5,1.7c-0.3,0.5-0.8,0.8-1.3,1
		c1.4,0.3,2.3,1.6,2.2,3c0.1,0.9-0.3,1.9-1,2.5c-0.8,0.7-1.8,1.1-2.9,1h-4.8L377.6,202.1z M380,207.3h1.7c0.5,0.1,0.9-0.1,1.3-0.4
		c0.4-0.3,0.6-0.7,0.5-1.2c0-0.4-0.1-0.8-0.4-1.1c-0.4-0.3-0.9-0.4-1.4-0.4H380V207.3z M380,212.7h2c0.5,0,1-0.2,1.4-0.5
		c0.7-0.7,0.7-1.7,0-2.4c-0.4-0.3-0.9-0.5-1.4-0.5h-2V212.7z"
                />
                <path
                  className="st15"
                  d="M393.5,205.9v2.4h-0.7c-0.6,0-1.2,0.2-1.6,0.6c-0.5,0.5-0.7,1.2-0.6,1.9v4h-2.4V206h2.3v1.3
		c0.4-1,1.4-1.5,2.5-1.4L393.5,205.9z"
                />
                <path
                  className="st15"
                  d="M400.9,214.7c-0.1-0.3-0.1-0.6-0.1-0.9c-0.2,0.4-0.6,0.7-1,0.8c-0.4,0.2-0.9,0.3-1.4,0.3
		c-0.9,0-1.8-0.3-2.4-0.9c-0.6-0.7-0.9-1.6-0.9-2.5V206h2.3v5c0,0.5,0.2,0.9,0.5,1.3c0.3,0.3,0.7,0.5,1.1,0.5c0.5,0,1-0.2,1.3-0.5
		c0.3-0.4,0.4-0.8,0.4-1.3v-5h2.4v8.7H400.9z"
                />
                <path
                  className="st15"
                  d="M407.9,209.7v5h-2.3V206h2.3v1.1c0.2-0.4,0.6-0.8,1-1c0.5-0.2,1-0.4,1.5-0.4c0.9,0,1.7,0.3,2.3,1
		c0.6,0.7,0.9,1.6,0.9,2.5v5.5h-2.4v-5.1c0-0.4-0.1-0.9-0.4-1.2c-0.7-0.7-1.7-0.7-2.4,0C408.1,208.8,407.9,209.2,407.9,209.7z"
                />
                <path
                  className="st15"
                  d="M415.2,212.3l2-0.5c0.1,0.4,0.2,0.7,0.5,1c0.3,0.3,0.7,0.4,1.1,0.4c0.3,0,0.7-0.1,0.9-0.3
		c0.2-0.2,0.3-0.4,0.3-0.6c0-0.4-0.3-0.7-1-0.9l-1.1-0.2c-0.7-0.1-1.3-0.5-1.8-1c-0.5-0.4-0.7-1-0.7-1.6c0-0.8,0.4-1.6,1-2.1
		c0.7-0.5,1.5-0.8,2.3-0.8c0.5,0,1.1,0.1,1.6,0.3c0.4,0.1,0.7,0.3,1,0.6c0.2,0.2,0.4,0.5,0.6,0.8c0.1,0.3,0.2,0.5,0.2,0.8l-1.9,0.5
		c-0.1-0.3-0.2-0.6-0.5-0.8c-0.2-0.3-0.6-0.5-1-0.4l-0.8,0.2c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.4,0.3,0.7,0.7,0.7c0,0,0.1,0,0.1,0
		l1.2,0.3c0.8,0.1,1.4,0.5,2,1c0.4,0.5,0.6,1.1,0.6,1.7c0,0.7-0.3,1.5-0.8,2c-0.7,0.6-1.6,1-2.6,0.9c-0.5,0-1.1-0.1-1.6-0.3
		c-0.4-0.1-0.8-0.4-1.1-0.7c-0.3-0.3-0.5-0.6-0.6-0.9C415.3,212.9,415.2,212.6,415.2,212.3z"
                />
                <path
                  className="st15"
                  d="M429,206h2.4l1.9,5.6l1.6-5.6h2.4l-2.7,8.7h-2.4l-2.1-6l-2,6h-2.4L423,206h2.4l1.7,5.6L429,206z"
                />
                <path
                  className="st15"
                  d="M438.5,203.1c0-0.4,0.1-0.7,0.4-1c0.2-0.3,0.6-0.5,1-0.5c0.4,0,0.8,0.2,1.1,0.5c0.3,0.3,0.4,0.6,0.4,1
		c0,0.4-0.2,0.7-0.4,1c-0.3,0.3-0.7,0.4-1.1,0.4C439.1,204.5,438.5,203.9,438.5,203.1z M441.1,214.7h-2.3V206h2.3V214.7z"
                />
                <path
                  className="st15"
                  d="M447.6,207.9c-0.6,0-1.2,0.2-1.6,0.6c-0.4,0.5-0.6,1.1-0.6,1.8c-0.1,0.7,0.2,1.3,0.6,1.8
		c0.4,0.5,1,0.7,1.6,0.7c0.5,0,0.9-0.1,1.3-0.4c0.4-0.3,0.6-0.7,0.7-1.1l2.1,0.7c-0.2,0.8-0.7,1.6-1.4,2.1c-0.8,0.6-1.7,0.9-2.7,0.9
		c-1.2,0-2.4-0.5-3.3-1.3c-0.9-0.9-1.4-2.1-1.3-3.4c0-1.2,0.4-2.4,1.3-3.3c0.8-0.9,2-1.3,3.2-1.3c1,0,2,0.3,2.8,0.9
		c0.7,0.5,1.2,1.3,1.3,2.1l-2.1,0.7C449.3,208.5,448.5,207.8,447.6,207.9z"
                />
                <path
                  className="st15"
                  d="M461.9,206l-3.5,3.6l3.6,5.1h-2.9l-2.3-3.3l-1,1v2.3h-2.4v-12.9h2.4v7.4l3-3.2H461.9z"
                />
                <path
                  className="st15"
                  d="M1489.7,606.2l-3.6-5.2l-1.6,1.7v3.5h-2.4v-12.5h2.4v5.7l5.1-5.7h3.2l-5,5.4l5,7.1H1489.7z"
                />
                <path
                  className="st15"
                  d="M1499.4,603.2l2,0.5c-0.2,0.8-0.7,1.5-1.4,2c-0.7,0.6-1.7,0.9-2.6,0.8c-1.2,0-2.4-0.4-3.2-1.3
		c-0.9-0.9-1.4-2.1-1.3-3.4c0-1.2,0.4-2.4,1.3-3.3c0.8-0.8,1.9-1.3,3-1.3c1.2,0,2.3,0.4,3.2,1.2c0.7,1,1.1,2.2,1.1,3.4v0.6h-6.3
		c0,0.5,0.3,1.1,0.7,1.4c0.4,0.4,0.9,0.6,1.5,0.6C1498.3,604.5,1499.1,604,1499.4,603.2z M1495.3,600.9h3.9c0-0.5-0.2-0.9-0.5-1.2
		c-0.4-0.4-0.9-0.6-1.5-0.5c-0.5,0-1,0.2-1.4,0.5C1495.5,600,1495.3,600.4,1495.3,600.9z"
                />
                <path
                  className="st15"
                  d="M1508.2,597.5h2.5l1.9,5.6l1.6-5.6h2.3l-2.7,8.7h-2.4l-2-5.9l-2,5.9h-2.4l-2.8-8.7h2.5l1.6,5.6L1508.2,597.5z
		"
                />
                <path
                  className="st15"
                  d="M1530.4,606.2h-7.8v-12.5h7.8v2.3h-5.4v2.8h4.9v2.2h-4.9v2.9h5.4V606.2z"
                />
                <path
                  className="st15"
                  d="M1532.1,603.9c-0.1-0.7,0.2-1.3,0.7-1.8c0.5-0.5,1.2-0.8,1.9-0.9l2.1-0.3c0.5-0.1,0.7-0.3,0.7-0.6
		c0-0.3-0.1-0.6-0.4-0.8c-0.3-0.3-0.7-0.5-1.1-0.4c-0.4,0-0.9,0.1-1.2,0.4c-0.2,0.3-0.4,0.7-0.4,1.1l-2.1-0.5c0.1-0.8,0.5-1.5,1.1-2
		c0.7-0.6,1.6-1,2.6-0.9c1.1-0.1,2.1,0.3,2.9,1c0.6,0.6,0.9,1.5,0.9,2.4v4.3c0,0.4,0,0.9,0.1,1.3h-2.2v-1c-0.6,0.9-1.6,1.4-2.6,1.3
		c-0.8,0-1.6-0.3-2.2-0.8C1532.4,605.2,1532.1,604.6,1532.1,603.9z M1535.6,604.7c0.5,0,1-0.1,1.4-0.4c0.4-0.5,0.5-1,0.5-1.6v-0.4
		l-2,0.3c-0.7,0.1-1.1,0.5-1.1,1.1c0,0.3,0.1,0.5,0.3,0.7C1534.9,604.6,1535.3,604.7,1535.6,604.7z"
                />
                <path
                  className="st15"
                  d="M1541.4,603.8l2.1-0.4c0,0.3,0.1,0.7,0.4,0.9c0.3,0.3,0.8,0.4,1.2,0.4l0.8-0.2c0.2-0.2,0.3-0.4,0.3-0.7
		c0-0.4-0.3-0.7-0.9-0.8l-1.2-0.3c-0.7-0.1-1.3-0.4-1.8-0.9c-0.4-0.5-0.6-1.1-0.6-1.7c0-0.8,0.3-1.5,0.9-2c0.6-0.6,1.4-0.9,2.3-0.9
		c0.5,0,1.1,0.1,1.6,0.3c0.4,0.1,0.8,0.4,1.1,0.7c0.2,0.2,0.4,0.5,0.5,0.8c0.2,0.2,0.2,0.5,0.3,0.8l-2,0.4c0-0.3-0.2-0.6-0.4-0.8
		c-0.3-0.2-0.6-0.4-1-0.4c-0.3,0-0.6,0.1-0.8,0.3c-0.3,0.1-0.4,0.3-0.4,0.6c0,0.4,0.3,0.7,0.8,0.8l1.3,0.3c0.7,0.1,1.4,0.4,1.9,0.9
		c0.5,0.4,0.7,1.1,0.7,1.7c0,0.8-0.3,1.6-0.9,2.1c-0.7,0.6-1.6,0.8-2.5,0.8c-0.6,0-1.2-0.1-1.7-0.3c-0.4-0.1-0.8-0.4-1.1-0.7
		c-0.2-0.2-0.4-0.5-0.6-0.8L1541.4,603.8z"
                />
                <path
                  className="st15"
                  d="M1553.3,594.9v2.6h1.7v2.1h-1.7v3.7c0,0.2,0.1,0.5,0.2,0.7c0.2,0.2,0.5,0.3,0.8,0.3h0.7v2l-1.3,0.2
		c-0.7,0-1.4-0.2-2-0.7c-0.5-0.5-0.8-1.3-0.8-2v-4.1h-1.5v-2.1h0.4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1V595L1553.3,594.9z"
                />
                <path
                  className="st15"
                  d="M1058.3,272h-2.5v-12.6h8v2.4h-5.5v3.1h4.9v2.2h-4.9V272z"
                />
                <path
                  className="st15"
                  d="M1064.5,269.7c-0.1-0.7,0.2-1.3,0.7-1.8c0.5-0.5,1.2-0.8,1.9-0.9l2.1-0.3c0.5-0.1,0.7-0.3,0.7-0.6
		c0-0.3-0.2-0.7-0.4-0.9c-0.3-0.2-0.7-0.3-1.1-0.3c-0.4,0-0.9,0.1-1.2,0.4c-0.3,0.3-0.4,0.6-0.5,1l-2.1-0.4c0.1-0.8,0.5-1.5,1.2-2
		c0.7-0.6,1.6-1,2.6-0.9c1.1-0.1,2.1,0.3,2.9,1c0.6,0.6,0.9,1.4,0.9,2.3v4.3c0,0.5,0,0.9,0.1,1.4h-2.2c0-0.2-0.1-0.6-0.1-1
		c-0.6,0.8-1.5,1.3-2.5,1.3c-0.8,0-1.6-0.3-2.2-0.8C1064.8,271.1,1064.5,270.4,1064.5,269.7z M1068,270.5c0.5,0,0.9-0.1,1.3-0.4
		c0.4-0.4,0.6-1,0.6-1.6v-0.4l-2,0.3c-0.7,0.1-1.1,0.5-1.1,1.1c0,0.3,0.1,0.5,0.3,0.7C1067.3,270.4,1067.7,270.5,1068,270.5z"
                />
                <path
                  className="st15"
                  d="M1074.3,260.4c0-0.8,0.6-1.4,1.4-1.4l0,0c0.4,0,0.8,0.1,1.1,0.4c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.1,0.7-0.4,1
		c-0.3,0.3-0.7,0.5-1.1,0.5c-0.4,0-0.8-0.2-1-0.5C1074.4,261.1,1074.3,260.8,1074.3,260.4z M1076.9,272h-2.3v-8.7h2.3V272z"
                />
                <path
                  className="st15"
                  d="M1084.8,263.3v2.3h-0.7c-0.6,0-1.2,0.2-1.7,0.5c-0.4,0.5-0.6,1.2-0.6,1.9v4h-2.4v-8.7h2.3v1.3
		c0.5-0.9,1.5-1.5,2.5-1.4L1084.8,263.3z"
                />
                <path
                  className="st15"
                  d="M1092.7,265.3h-3.5v6.7h-2.4v-6.7h-1.4v-2h1.4v-1c0-0.9,0.3-1.8,0.9-2.4c0.6-0.6,1.4-0.9,2.3-0.9l1.2,0.2v2
		h-0.8c-0.3,0-0.6,0.1-0.8,0.3c-0.3,0.2-0.4,0.6-0.4,0.9v1h5.9v8.6h-2.4L1092.7,265.3z M1092.9,261.4c-0.3-0.2-0.5-0.6-0.5-1
		c0-0.4,0.2-0.8,0.5-1c0.2-0.3,0.6-0.5,1-0.5c0.4,0,0.8,0.2,1,0.5c0.3,0.3,0.4,0.6,0.4,1c0,0.4-0.1,0.7-0.4,1
		c-0.2,0.3-0.6,0.5-1,0.5C1093.5,261.9,1093.1,261.7,1092.9,261.4L1092.9,261.4z"
                />
                <path
                  className="st15"
                  d="M1103.5,268.9l1.9,0.6c-0.2,0.8-0.7,1.5-1.4,2c-0.7,0.5-1.6,0.8-2.5,0.8c-1.2,0.1-2.4-0.4-3.2-1.3
		c-0.9-0.9-1.5-2.1-1.4-3.4c0-1.2,0.5-2.4,1.3-3.3c0.8-0.8,1.9-1.3,3-1.3c1.2-0.1,2.4,0.4,3.2,1.2c0.9,0.9,1.3,2.1,1.2,3.4v0.3
		c-0.1,0.1-0.1,0.2-0.1,0.3h-6.2c0,0.5,0.2,1,0.6,1.4c0.4,0.4,1,0.6,1.6,0.6C1102.4,270.3,1103.2,269.7,1103.5,268.9z M1099.3,266.7
		h3.9c0-0.5-0.2-0.9-0.5-1.3c-0.4-0.3-0.9-0.5-1.4-0.5c-0.5,0-1.1,0.2-1.4,0.6C1099.5,265.8,1099.3,266.2,1099.3,266.7L1099.3,266.7
		z"
                />
                <path className="st15" d="M1109.8,272h-2.4v-12.8h2.4V272z" />
                <path
                  className="st15"
                  d="M1120.6,259.2v11.3c0,0.5,0.1,1.1,0.1,1.5h-2.2c-0.1-0.3-0.1-0.7-0.1-1c-0.2,0.4-0.6,0.7-1,0.9
		c-0.5,0.2-1,0.3-1.5,0.3c-1.1,0-2.2-0.4-3-1.3c-0.8-0.9-1.3-2.1-1.2-3.3c-0.1-1.2,0.3-2.3,1.1-3.2c0.8-0.9,1.9-1.3,3-1.3
		c1.3,0,2.1,0.3,2.5,1.1v-5H1120.6z M1114,267.6c0,0.7,0.2,1.4,0.6,1.9c0.4,0.4,1,0.6,1.6,0.6c0.6,0,1.1-0.2,1.5-0.6
		c0.4-0.5,0.6-1.2,0.6-1.9c0-0.7-0.2-1.3-0.6-1.8c-0.4-0.4-0.9-0.6-1.5-0.6c-0.6,0-1.2,0.2-1.6,0.7
		C1114.2,266.4,1114,267,1114,267.6z"
                />
                <path
                  className="st15"
                  d="M639.1,684c-1.7,0-3.4-0.7-4.6-1.9c-1.3-1.2-2-2.9-1.9-4.7c-0.1-3.6,2.8-6.5,6.4-6.6c0,0,0,0,0,0
		c1.4-0.1,2.8,0.4,3.9,1.3c0.9,0.7,1.6,1.8,1.9,2.9l-2.3,0.7c-0.2-0.7-0.6-1.3-1.1-1.8c-0.7-0.5-1.5-0.8-2.4-0.7c-1,0-2,0.4-2.7,1.1
		c-0.8,0.8-1.2,2-1.1,3.1c-0.1,1.1,0.3,2.2,1.1,3c0.7,0.8,1.7,1.2,2.8,1.2c1.6,0,3.1-1,3.5-2.6l2.3,0.7c-0.1,0.5-0.3,1-0.6,1.5
		c-0.3,0.5-0.7,0.9-1.2,1.3c-0.5,0.5-1.1,0.9-1.7,1.1C640.7,683.8,639.9,684,639.1,684z"
                />
                <path
                  className="st15"
                  d="M647.1,676c1.9-1.8,4.7-1.8,6.6,0c0.8,0.9,1.3,2.1,1.3,3.3c0.1,2.5-2,4.6-4.5,4.7c-1.3,0-2.5-0.5-3.4-1.4
		c-0.9-0.9-1.4-2.1-1.3-3.3C645.8,678.1,646.2,676.9,647.1,676z M648.8,681.1c0.4,0.5,1,0.7,1.6,0.7c0.6,0,1.2-0.2,1.6-0.7
		c0.8-1.1,0.8-2.5,0-3.6c-0.4-0.5-1-0.7-1.6-0.7c-0.6,0-1.2,0.2-1.6,0.7C648,678.6,648,680,648.8,681.1z"
                />
                <path className="st15" d="M659.2,683.7h-2.4v-12.9h2.4V683.7z" />
                <path className="st15" d="M664.1,683.7h-2.4v-12.9h2.4V683.7z" />
                <path
                  className="st15"
                  d="M666.3,672.1c-0.1-0.8,0.5-1.4,1.3-1.5c0.1,0,0.1,0,0.2,0c0.4,0,0.7,0.2,1,0.4c0.3,0.3,0.4,0.7,0.4,1.1
		c0,0.8-0.6,1.4-1.4,1.4h0c-0.4,0-0.8-0.1-1.1-0.4C666.5,672.8,666.3,672.5,666.3,672.1z M669,683.7h-2.4v-8.8h2.4V683.7z"
                />
                <path
                  className="st15"
                  d="M673.8,678.7v5h-2.3v-8.8h2.3v1.1c0.2-0.4,0.6-0.7,1-0.9c0.5-0.3,1-0.4,1.5-0.4c0.9,0,1.8,0.3,2.4,1
		c0.5,0.7,0.8,1.6,0.8,2.5v5.5h-2.4v-5.1c0-0.5-0.1-0.9-0.4-1.3c-0.3-0.3-0.7-0.5-1.2-0.5c-0.5,0-0.9,0.2-1.2,0.6
		C674,677.7,673.8,678.2,673.8,678.7z"
                />
                <path
                  className="st15"
                  d="M681.2,684.2l2.2-0.6c0,0.5,0.2,0.9,0.6,1.2c0.4,0.3,0.9,0.4,1.4,0.4c1.6,0,2.3-0.8,2.3-2.4v-0.6
		c-0.2,0.3-0.5,0.6-0.9,0.8c-0.5,0.2-1,0.3-1.5,0.3c-1.1,0-2.2-0.4-2.9-1.2c-0.8-0.8-1.3-1.9-1.2-3.1c0-1.1,0.4-2.2,1.2-3
		c0.7-0.8,1.8-1.2,2.9-1.2c0.5,0,1.1,0.1,1.6,0.3c0.4,0.2,0.7,0.5,0.9,0.9v-1.1h2.3v7.8c0.1,1.2-0.4,2.4-1.2,3.3
		c-0.9,0.9-2.1,1.4-3.4,1.3c-1,0-2.1-0.3-2.9-0.9C681.9,685.9,681.4,685.1,681.2,684.2z M685.7,681.3c0.6,0,1.1-0.2,1.5-0.6
		c0.4-0.5,0.6-1.1,0.6-1.7c0-0.6-0.2-1.2-0.6-1.6c-0.8-0.8-2.2-0.8-3,0c-0.4,0.4-0.6,1-0.6,1.6c0,0.6,0.2,1.2,0.6,1.7
		C684.6,681.1,685.1,681.3,685.7,681.3z"
                />
                <path
                  className="st15"
                  d="M697.3,674.9h2.5l1.9,5.7l1.6-5.7h2.4l-2.8,8.8h-2.3l-2.1-6l-2,6h-2.4l-2.8-8.8h2.5l1.6,5.7L697.3,674.9z"
                />
                <path
                  className="st15"
                  d="M707.5,676c1.8-1.8,4.7-1.9,6.5-0.1c0.9,0.9,1.4,2.1,1.4,3.4c0.1,1.2-0.4,2.4-1.3,3.3
		c-1.8,1.8-4.7,1.9-6.5,0.1c-0.9-0.9-1.4-2.1-1.4-3.4C706.2,678.1,706.7,676.9,707.5,676z M709.3,681.1c0.4,0.5,0.9,0.7,1.5,0.7
		c0.6,0,1.2-0.2,1.6-0.7c0.8-1.1,0.8-2.5,0-3.6c-0.4-0.5-1-0.7-1.6-0.7c-0.6,0-1.1,0.2-1.5,0.7C708.4,678.5,708.4,680.1,709.3,681.1
		z"
                />
                <path
                  className="st15"
                  d="M717.9,676c1.9-1.8,4.7-1.8,6.6,0c0.8,0.9,1.3,2.1,1.3,3.3c0,2.5-2.1,4.6-4.6,4.6c-2.5,0-4.6-2.1-4.6-4.6
		C716.6,678.1,717.1,676.9,717.9,676z M719.6,681.1c0.8,0.9,2.2,0.9,3.1,0.1c0,0,0.1-0.1,0.1-0.1c0.8-1.1,0.8-2.5,0-3.6
		c-0.8-0.9-2.2-0.9-3.1-0.1c0,0-0.1,0.1-0.1,0.1C718.8,678.6,718.8,680,719.6,681.1z"
                />
                <path
                  className="st15"
                  d="M736,670.8v11.3c0,0.5,0,1.1,0.1,1.6h-2.3c-0.1-0.3-0.1-0.7-0.1-1c-0.2,0.3-0.6,0.7-0.9,0.9
		c-0.5,0.2-1,0.3-1.5,0.3c-1.2,0.1-2.3-0.4-3.1-1.3c-1.6-1.9-1.6-4.7,0-6.6c0.8-0.8,1.9-1.3,3-1.3c1-0.1,1.9,0.3,2.5,1.1v-5H736z
		 M729.4,679.3c-0.1,0.7,0.2,1.3,0.6,1.8c0.4,0.5,0.9,0.7,1.5,0.7c0.6,0,1.2-0.2,1.6-0.7c0.4-0.5,0.6-1.1,0.6-1.8
		c0.1-0.7-0.2-1.3-0.6-1.8c-0.4-0.4-1-0.7-1.6-0.7c-0.6,0-1.1,0.3-1.5,0.7C729.6,678,729.3,678.6,729.4,679.3z"
                />
                <path
                  className="st15"
                  d="M505.9,343.4h-2.2v4.8h-2.5v-12.6h4.7c1.1-0.1,2.2,0.3,3,1.1c0.8,0.7,1.2,1.7,1.2,2.8c0,1.1-0.4,2.1-1.2,2.8
		C508.1,343.1,507,343.5,505.9,343.4z M503.7,341.3h1.9c0.5,0,1.1-0.1,1.5-0.5c0.3-0.3,0.5-0.8,0.5-1.3c0-0.5-0.2-0.9-0.5-1.3
		c-0.4-0.3-1-0.5-1.5-0.5h-1.9V341.3z"
                />
                <path
                  className="st15"
                  d="M516.9,339.4v2.4h-0.7c-0.6,0-1.2,0.2-1.6,0.6c-0.5,0.5-0.7,1.2-0.6,1.9v4h-2.4v-8.8h2.3v1.3
		c0.5-0.9,1.5-1.5,2.5-1.3L516.9,339.4z"
                />
                <path
                  className="st15"
                  d="M518.3,336.6c-0.1-0.8,0.5-1.4,1.3-1.5c0.1,0,0.1,0,0.2,0c0.4,0,0.7,0.1,1,0.4c0.3,0.3,0.4,0.7,0.4,1.1
		c0,0.8-0.6,1.4-1.4,1.4l0,0c-0.4,0-0.8-0.1-1.1-0.4C518.5,337.3,518.3,337,518.3,336.6z M521,348.2h-2.4v-8.8h2.4V348.2z"
                />
                <path
                  className="st15"
                  d="M525.8,343.2v5h-2.3v-8.8h2.3v1.1c0.3-0.4,0.6-0.7,1-1c0.5-0.2,1-0.3,1.5-0.3c0.9-0.1,1.8,0.3,2.3,1
		c0.6,0.7,0.9,1.6,0.9,2.5v5.5h-2.4v-5.1c0-0.5-0.1-0.9-0.4-1.3c-0.3-0.3-0.7-0.5-1.2-0.5c-0.5,0-0.9,0.2-1.2,0.6
		C526,342.2,525.8,342.7,525.8,343.2z"
                />
                <path
                  className="st15"
                  d="M537.8,341.4c-0.6,0-1.2,0.2-1.6,0.6c-0.4,0.5-0.6,1.1-0.6,1.8c-0.1,0.7,0.2,1.3,0.6,1.8
		c0.4,0.5,1,0.7,1.6,0.7c0.5,0,1-0.2,1.3-0.5c0.4-0.2,0.6-0.6,0.7-1l2.1,0.7c-0.2,0.8-0.7,1.6-1.4,2.1c-0.8,0.6-1.7,0.9-2.7,0.8
		c-2.6-0.1-4.6-2.2-4.6-4.8c0-1.1,0.5-2.2,1.3-3.1c0.8-0.9,2-1.3,3.2-1.3c1,0,2,0.3,2.8,0.8c0.6,0.5,1.1,1.3,1.3,2.1l-2.1,0.7
		C539.5,341.9,538.7,341.3,537.8,341.4z"
                />
                <path
                  className="st15"
                  d="M549.4,345.1l2,0.6c-0.3,0.8-0.8,1.5-1.4,2c-0.8,0.5-1.7,0.7-2.6,0.7c-2.4,0.1-4.4-1.7-4.5-4.1
		c0-0.2,0-0.3,0-0.5c-0.1-1.2,0.4-2.4,1.3-3.3c0.8-0.9,1.9-1.3,3-1.3c1.2-0.1,2.3,0.4,3.1,1.2c0.8,0.9,1.3,2.1,1.2,3.3v0.6h-6.3
		c0,0.6,0.3,1.1,0.7,1.5c0.4,0.3,1,0.5,1.5,0.5C548.3,346.4,549.1,345.9,549.4,345.1z M545.3,342.8h3.9c0-0.5-0.2-0.9-0.6-1.2
		c-0.4-0.3-0.9-0.5-1.4-0.5c-0.5,0-1,0.2-1.4,0.5C545.5,341.9,545.3,342.4,545.3,342.8L545.3,342.8z"
                />
                <path
                  className="st15"
                  d="M552.6,345.7l2-0.4c0.1,0.4,0.2,0.7,0.5,1c0.3,0.2,0.7,0.3,1.1,0.3c0.4,0,0.7,0,0.9-0.2
		c0.2-0.2,0.3-0.4,0.3-0.6c0-0.5-0.3-0.8-1-0.9l-1.1-0.3c-0.7-0.1-1.3-0.4-1.8-0.9c-0.5-0.4-0.7-1.1-0.7-1.7c0-0.8,0.4-1.5,1-2
		c0.7-0.5,1.5-0.8,2.3-0.8l1.6,0.2c0.4,0.2,0.7,0.4,1,0.7c0.3,0.2,0.5,0.5,0.6,0.8c0.1,0.3,0.2,0.5,0.2,0.8l-1.9,0.4l-0.4-0.8
		c-0.3-0.2-0.7-0.3-1.1-0.3l-0.8,0.2c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.5,0.3,0.7,0.8,0.8l1.3,0.3c0.7,0.1,1.4,0.5,1.9,1
		c0.4,0.5,0.6,1.1,0.6,1.7c0,0.7-0.3,1.4-0.8,2c-0.7,0.6-1.6,0.9-2.5,0.8c-0.6,0-1.2,0-1.7-0.2c-0.4-0.2-0.8-0.4-1.1-0.7
		c-0.3-0.3-0.5-0.6-0.6-0.9C552.7,346.3,552.6,346,552.6,345.7z"
                />
                <path
                  className="st15"
                  d="M576.5,348.2h-2.4V343h-5.5v5.2h-2.5v-12.6h2.5v5h5.5v-5h2.4V348.2z"
                />
                <path
                  className="st15"
                  d="M578.9,336.6c0-0.4,0.2-0.8,0.5-1.1c0.3-0.3,0.6-0.4,1-0.4c0.4,0,0.7,0.1,1,0.4c0.3,0.3,0.4,0.7,0.4,1.1
		c0,0.8-0.6,1.4-1.4,1.4l0,0c-0.4,0-0.7-0.1-1-0.4C579.1,337.4,578.9,337,578.9,336.6z M581.6,348.2h-2.4v-8.8h2.4V348.2z"
                />
                <path className="st15" d="M586.5,348.2h-2.4v-12.9h2.4V348.2z" />
                <path className="st15" d="M591.4,348.2H589v-12.9h2.4V348.2z" />
                <path
                  className="st15"
                  d="M830.4,207.7h-2.6l-5.7-8.9v8.9h-2.4v-12.6h3l5.3,8.3v-8.3h2.4V207.7z"
                />
                <path
                  className="st15"
                  d="M833.7,200c1.9-1.8,4.7-1.8,6.6,0c0.8,0.9,1.3,2.1,1.3,3.3c0.1,2.5-2,4.6-4.5,4.7c-1.3,0-2.5-0.5-3.4-1.4
		c-0.9-0.9-1.4-2.1-1.3-3.3C832.4,202.1,832.8,200.9,833.7,200z M835.4,205.1c0.4,0.5,1,0.7,1.6,0.7c0.6,0,1.2-0.2,1.6-0.7
		c0.8-1.1,0.8-2.5,0-3.6c-0.4-0.4-1-0.7-1.6-0.7c-0.6,0-1.2,0.3-1.6,0.7C834.6,202.6,834.6,204,835.4,205.1z"
                />
                <path
                  className="st15"
                  d="M848.8,198.9v2.4h-0.7c-0.6,0-1.2,0.2-1.7,0.6c-0.5,0.5-0.7,1.2-0.6,1.9v4h-2.4V199h2.3v1.2
		c0.5-0.9,1.5-1.4,2.5-1.3H848.8z"
                />
                <path
                  className="st15"
                  d="M853.7,196.3v2.7h1.7v2h-1.7v3.7c0,0.3,0.1,0.6,0.2,0.8l0.8,0.2h0.7v2l-1.3,0.2c-0.7,0-1.5-0.2-2-0.7
		c-0.5-0.5-0.8-1.2-0.8-2V201h-1.5v-2h0.4c0.4,0,0.7-0.1,1-0.4c0.2-0.3,0.4-0.6,0.4-1v-1.3H853.7z"
                />
                <path
                  className="st15"
                  d="M859.4,202.6v5.1H857v-12.9h2.4v4.9c0.5-0.7,1.4-1.1,2.3-1c0.9-0.1,1.9,0.3,2.5,1c0.5,0.7,0.8,1.6,0.8,2.5
		v5.5h-2.4v-5.1c0-0.5-0.1-0.9-0.4-1.3c-0.2-0.3-0.6-0.4-1.2-0.4c-0.4-0.1-0.8,0.1-1.1,0.4C859.6,201.7,859.4,202.1,859.4,202.6z"
                />
                <path
                  className="st15"
                  d="M871.3,200.9c-0.6,0-1.2,0.2-1.6,0.6c-0.4,0.5-0.6,1.1-0.6,1.8c-0.1,0.7,0.2,1.3,0.6,1.8
		c0.4,0.5,1,0.7,1.6,0.7c0.5,0,1-0.1,1.4-0.4c0.3-0.3,0.5-0.7,0.6-1.1l2.1,0.7c-0.2,0.8-0.7,1.6-1.4,2.1c-0.8,0.6-1.7,0.9-2.7,0.9
		c-1.2,0-2.4-0.5-3.2-1.4c-0.9-0.9-1.4-2.1-1.4-3.3c0-1.2,0.5-2.4,1.3-3.3c0.9-0.9,2.1-1.3,3.3-1.3c1,0,1.9,0.3,2.7,0.8
		c0.7,0.5,1.2,1.3,1.4,2.1l-2.1,0.7C873,201.4,872.2,200.9,871.3,200.9z"
                />
                <path
                  className="st15"
                  d="M877.7,200c1.9-1.8,4.7-1.8,6.6,0c0.8,0.9,1.3,2.1,1.3,3.3c0,2.5-2.1,4.6-4.6,4.6c-2.5,0-4.6-2.1-4.6-4.6
		C876.4,202.1,876.9,200.9,877.7,200z M879.4,205.1c0.8,0.9,2.2,0.9,3.1,0.1c0,0,0.1-0.1,0.1-0.1c0.8-1.1,0.8-2.5,0-3.6
		c-0.8-0.9-2.2-0.9-3.1-0.1c0,0-0.1,0.1-0.1,0.1C878.6,202.6,878.6,204,879.4,205.1z"
                />
                <path
                  className="st15"
                  d="M890.3,196.3v2.7h1.8v2h-1.8v3.7c0,0.3,0.1,0.6,0.3,0.8l0.8,0.2h0.7v2l-1.3,0.2c-0.8,0.1-1.5-0.2-2.1-0.7
		c-0.5-0.5-0.8-1.3-0.7-2V201h-1.6v-2h0.4c0.4,0,0.7-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1v-1.3H890.3z"
                />
                <path
                  className="st15"
                  d="M899.9,204.6l1.9,0.6c-0.2,0.8-0.7,1.5-1.4,2c-0.7,0.5-1.6,0.8-2.5,0.8c-1.2,0-2.4-0.4-3.2-1.3
		c-0.9-0.9-1.4-2.1-1.4-3.4c0-1.2,0.4-2.4,1.3-3.3c1.7-1.7,4.4-1.7,6.2-0.1c0.8,0.9,1.3,2.1,1.2,3.3v0.3c-0.1,0.2-0.1,0.2-0.1,0.3
		h-6.2c0,0.6,0.2,1.1,0.6,1.5c0.5,0.3,1,0.5,1.6,0.5C898.8,205.9,899.6,205.4,899.9,204.6z M895.7,202.3h3.9c0-0.5-0.2-0.9-0.5-1.2
		c-0.8-0.7-2-0.7-2.8,0C895.9,201.4,895.7,201.8,895.7,202.3z"
                />
                <path
                  className="st15"
                  d="M1218.7,923.5h-2.5v-5.2h-5.5v5.2h-2.4V911h2.4v5h5.5v-5h2.5V923.5z"
                />
                <path
                  className="st15"
                  d="M1220.8,921.2c0-0.7,0.3-1.4,0.8-1.8c0.5-0.5,1.1-0.8,1.8-0.9l2.2-0.3c0.4-0.1,0.6-0.3,0.6-0.6
		c0-0.3-0.1-0.6-0.3-0.8c-0.3-0.3-0.7-0.4-1.1-0.4c-0.4,0-0.9,0.1-1.2,0.4c-0.3,0.3-0.5,0.7-0.5,1.1l-2.1-0.5c0.1-0.8,0.5-1.5,1.1-2
		c0.8-0.6,1.7-0.9,2.7-0.9c1-0.1,2,0.3,2.8,1c0.7,0.6,1,1.5,1,2.4v4.3c0,0.4,0,0.9,0.1,1.3h-2.2c-0.1-0.3-0.1-0.7-0.1-1
		c-0.5,0.9-1.6,1.4-2.6,1.3c-0.8,0-1.5-0.3-2.1-0.8C1221.1,922.6,1220.8,921.9,1220.8,921.2z M1224.3,922c0.5,0,1-0.1,1.4-0.4
		c0.4-0.4,0.6-1,0.5-1.6v-0.4l-1.9,0.3c-0.7,0.1-1.1,0.5-1.1,1.1c0,0.3,0.1,0.5,0.3,0.7C1223.7,921.9,1224,922,1224.3,922z"
                />
                <path
                  className="st15"
                  d="M1235.8,914.8h2.5l1.9,5.6l1.6-5.6h2.3l-2.7,8.7h-2.4l-2-5.9l-2,5.9h-2.4l-2.8-8.7h2.5l1.6,5.6L1235.8,914.8z
		"
                />
                <path
                  className="st15"
                  d="M1248.8,912.2v2.6h1.8v2.1h-1.8v3.7c0,0.3,0.1,0.5,0.3,0.7c0.1,0.2,0.4,0.3,0.8,0.3h0.7v2l-1.3,0.2
		c-0.8,0-1.5-0.3-2.1-0.8c-0.5-0.5-0.8-1.2-0.7-1.9V917h-1.6v-2.1h0.4c0.4,0.1,0.8-0.1,1-0.4c0.3-0.3,0.4-0.6,0.4-1v-1.2
		L1248.8,912.2z"
                />
                <path
                  className="st15"
                  d="M1254.5,918.4v5.1h-2.3v-12.8h2.3v4.8c0.6-0.6,1.5-1,2.4-0.9c0.9-0.1,1.8,0.3,2.4,0.9
		c0.6,0.7,0.9,1.6,0.8,2.5v5.5h-2.3v-5.1c0-0.4-0.1-0.9-0.4-1.2c-0.7-0.7-1.7-0.7-2.4,0C1254.7,917.5,1254.5,918,1254.5,918.4z"
                />
                <path
                  className="st15"
                  d="M1263.2,915.9c0.9-0.9,2.1-1.4,3.3-1.4c2.5,0.1,4.6,2.2,4.5,4.7c0,0,0,0,0,0c0,1.2-0.4,2.4-1.3,3.3
		c-0.8,0.9-2,1.4-3.2,1.3c-1.2,0.1-2.4-0.4-3.3-1.3c-0.9-0.9-1.3-2.1-1.3-3.3C1261.8,918,1262.3,916.8,1263.2,915.9z M1264.9,921
		c0.4,0.4,1,0.7,1.6,0.7c1.3-0.1,2.3-1.2,2.2-2.5c0-0.7-0.2-1.4-0.7-1.9c-0.4-0.4-0.9-0.6-1.5-0.6c-0.6,0-1.2,0.2-1.6,0.6
		c-0.5,0.5-0.7,1.2-0.7,1.9C1264.2,919.9,1264.4,920.5,1264.9,921L1264.9,921z"
                />
                <path
                  className="st15"
                  d="M1278.2,914.8v2.3h-0.7c-0.6,0-1.2,0.2-1.6,0.6c-0.4,0.5-0.7,1.1-0.6,1.8v4h-2.4v-8.7h2.3v1.3
		c0.5-0.9,1.5-1.5,2.5-1.4L1278.2,914.8z"
                />
                <path
                  className="st15"
                  d="M1282.3,918.5v5h-2.4v-8.7h2.3v1.1c0.2-0.5,0.6-0.8,1.1-1c0.4-0.2,0.9-0.3,1.4-0.3c0.9-0.1,1.8,0.3,2.4,0.9
		c0.5,0.7,0.8,1.6,0.8,2.5v5.5h-2.4v-5.1c0-0.4-0.1-0.9-0.4-1.2c-0.3-0.3-0.7-0.5-1.2-0.5c-0.5,0-0.9,0.2-1.2,0.5
		C1282.4,917.6,1282.3,918,1282.3,918.5z"
                />
                <path
                  className="st15"
                  d="M1752.1,376.8l0.3,0.7l-1.6,0.7l0.8,1.7l2.2-1l0.3,0.7l-2.9,1.4l-2.4-5.1l2.9-1.3l0.3,0.6l-2.2,1.1l0.7,1.3
		L1752.1,376.8z"
                />
                <path
                  className="st15"
                  d="M1758,376.2l-2.2,1v1.6l-0.8,0.3l-0.2-6l0.5-0.3l4.5,4.1l-0.8,0.4L1758,376.2z M1755.8,376.4l1.6-0.7
		l-1.7-1.6L1755.8,376.4z"
                />
                <path
                  className="st15"
                  d="M1760.7,375c0.5,0.2,1,0.3,1.5,0.1c0.5-0.1,0.8-0.6,0.6-1.1c0,0,0-0.1,0-0.1c-0.4-0.8-1.5-0.4-2.4-0.5
		c-0.5-0.1-0.9-0.4-1.2-0.8c-0.3-0.8,0.1-1.7,0.9-2.1c0.5-0.2,1.1-0.3,1.6-0.1v0.7c-0.4-0.1-0.8,0-1.1,0.1c-0.4,0.2-0.6,0.7-0.5,1.1
		c0.3,0.6,1.4,0.3,2.3,0.4c0.5,0.1,1,0.4,1.2,0.9c0.3,0.9-0.1,1.8-0.9,2.2c-0.7,0.3-1.5,0.3-2.2-0.1L1760.7,375z"
                />
                <path
                  className="st15"
                  d="M1762.6,369.5l3.4-1.6l0.4,0.7l-1.4,0.6l2,4.4l-0.7,0.3l-2-4.3l-1.4,0.6L1762.6,369.5z"
                />
                <path
                  className="st15"
                  d="M1770.7,368.2l0.3,0.7l-1.7,0.7l0.8,1.7l2.3-1l0.3,0.7l-3,1.4l-2.3-5.1l2.9-1.4l0.3,0.7l-2.2,1l0.6,1.3
		L1770.7,368.2z"
                />
                <path
                  className="st15"
                  d="M1773.8,367.6l1.1,2.3l-0.7,0.4l-2.4-5.1l1.8-0.8c0.3-0.2,0.7-0.3,1.1-0.2c0.4,0.1,0.8,0.4,1,0.8
		c0.2,0.4,0.2,0.9,0,1.3l-0.5,0.6l3,1.5l-0.9,0.4l-2.9-1.5L1773.8,367.6z M1774.5,366.4c0.2-0.1,0.4-0.3,0.5-0.5
		c0.1-0.1,0.1-0.4,0-0.5c-0.1-0.2-0.3-0.3-0.4-0.4c-0.2-0.1-0.5-0.1-0.7,0.1l-1,0.5l0.6,1.3L1774.5,366.4z"
                />
                <path
                  className="st15"
                  d="M1778.4,363.8l1.7,3.7l-0.7,0.4l-2.4-5.1l0.5-0.2l4.8,2.3l-1.7-3.8l0.7-0.3l2.3,5.1l-0.5,0.2L1778.4,363.8z"
                />
                <path
                  className="st15"
                  d="M1789,359.7l0.3,0.7l-1.7,0.7l1.1,2.4l-0.7,0.4l-2.4-5.1l2.9-1.4l0.4,0.7l-2.2,1l0.6,1.3L1789,359.7z"
                />
                <path
                  className="st15"
                  d="M1791.8,359.2l1.2,2.4l-0.8,0.3l-2.3-5.1l1.8-0.8c0.3-0.2,0.7-0.3,1.1-0.2c0.4,0.1,0.8,0.4,1,0.8
		c0.2,0.4,0.1,0.9-0.1,1.3c-0.1,0.2-0.2,0.4-0.4,0.6l2.9,1.5l-0.9,0.4l-2.9-1.5L1791.8,359.2z M1792.5,358c0.3-0.1,0.5-0.2,0.6-0.5
		c0-0.2,0-0.3-0.1-0.5c0-0.2-0.2-0.3-0.4-0.4s-0.3-0.1-0.7,0.1l-1,0.5l0.6,1.3L1792.5,358z"
                />
                <path
                  className="st15"
                  d="M1798.4,355.3l0.3,0.7l-1.7,0.8l0.8,1.7l2.3-1.1l0.3,0.7l-3,1.4l-2.3-5.1l2.9-1.3l0.3,0.6l-2.2,1.1l0.6,1.3
		L1798.4,355.3z"
                />
                <path
                  className="st15"
                  d="M1802.8,353.2l0.4,0.7l-1.7,0.8l0.8,1.7l2.2-1.1l0.4,0.7l-3,1.4l-2.4-5.1l2.9-1.3l0.3,0.7l-2.1,1l0.6,1.3
		L1802.8,353.2z"
                />
                <path
                  className="st15"
                  d="M1807.9,354.6l-0.5,0.3l-4-4.4l0.7-0.3l2.9,3.1l-0.5-4.2l0.5-0.3l3,3.1l-0.6-4.2l0.8-0.3l0.7,5.8l-0.5,0.2
		l-3-3.1L1807.9,354.6z"
                />
                <path
                  className="st15"
                  d="M1815.7,349.4l-2.1,1v1.6l-0.7,0.3l-0.3-6.1l0.5-0.2l4.5,4.1l-0.8,0.4L1815.7,349.4z M1813.5,349.6l1.6-0.8
		l-1.7-1.5L1813.5,349.6z"
                />
                <path
                  className="st15"
                  d="M1819.1,346.6l1,2.3l-0.7,0.4l-1.1-2.4l-3-1.9l0.8-0.4l2.3,1.5l0.3-2.7l0.8-0.4L1819.1,346.6z"
                />
                <path
                  className="st15"
                  d="M130.5,296.6c0.3,0.7,0.3,1.6-0.1,2.3l-0.6-0.4c0.2-0.5,0.2-1.1,0-1.6c-0.4-1-1.6-1.5-2.6-1.1
		c0,0-0.1,0-0.1,0c-1,0.3-1.6,1.5-1.3,2.5c0,0.1,0,0.1,0.1,0.2c0.2,0.6,0.7,1,1.3,1.2l-0.3,0.7c-0.8-0.3-1.4-0.9-1.7-1.7
		c-0.6-1.4,0.1-3.1,1.5-3.7c0,0,0.1,0,0.1,0C128.2,294.4,129.9,295.1,130.5,296.6C130.5,296.5,130.5,296.6,130.5,296.6z"
                />
                <path
                  className="st15"
                  d="M131.8,300.2l0.3,0.7l-5.3,2l-0.3-0.8L131.8,300.2z"
                />
                <path
                  className="st15"
                  d="M132.6,302.2l1.3,3.6l-0.7,0.3l-0.5-1.4l-4.6,1.7l-0.2-0.8l4.5-1.7l-0.6-1.4L132.6,302.2z"
                />
                <path
                  className="st15"
                  d="M132.4,310.4l-2.4,0.9l-0.3-0.7l2.4-0.9l2.2-2.9l0.3,0.8l-1.6,2.2l2.6,0.5l0.3,0.8L132.4,310.4z"
                />
                <path
                  className="st15"
                  d="M132.2,314.9l0.9,2.3l-0.8,0.3l-1.1-3.1l5.2-1.9l0.3,0.7L132.2,314.9z"
                />
                <path
                  className="st15"
                  d="M138.1,316.9l0.3,0.8l-5.2,1.9l-0.3-0.7L138.1,316.9z"
                />
                <path
                  className="st15"
                  d="M138,320.8l-3.8,1.5l-0.3-0.8l5.2-1.9l0.2,0.5l-2.6,4.6l3.8-1.5l0.3,0.8l-5.3,2l-0.2-0.6L138,320.8z"
                />
                <path
                  className="st15"
                  d="M141.5,325.9l0.3,0.7l-2.2,0.9l3,1.3l0.4,1l-3.4-1.5l-1.8,3.6l-0.4-0.9l1.8-3.4l-2.6,1l-0.3-0.7L141.5,325.9z
		"
                />
                <path
                  className="st15"
                  d="M902,789.7h-0.6l-1.4-5.8h0.8l1.1,4.4l2.2-4h0.8L902,789.7z"
                />
                <path
                  className="st15"
                  d="M906.3,784.6h0.8l-0.7,5.5h-0.8L906.3,784.6z"
                />
                <path
                  className="st15"
                  d="M911.5,785.2c0.8,0.1,1.5,0.5,1.9,1.1l-0.6,0.4c-0.3-0.4-0.8-0.7-1.4-0.8c-1.2-0.1-2.2,0.7-2.3,1.9
		c0,0,0,0,0,0c-0.2,1,0.4,2,1.5,2.3c0.1,0,0.2,0,0.3,0c0.6,0.1,1.2-0.1,1.7-0.5l0.5,0.5c-0.6,0.6-1.4,0.9-2.3,0.8
		c-1.5-0.4-2.5-2-2-3.6C909.1,786.1,910.2,785.2,911.5,785.2L911.5,785.2z"
                />
                <path
                  className="st15"
                  d="M914.6,785.6l3.8,0.5v0.8l-1.5-0.2l-0.6,4.8h-0.8l0.6-4.8l-1.5-0.2V785.6z"
                />
                <path
                  className="st15"
                  d="M921.9,786.5c1.6,0.1,2.8,1.5,2.7,3.1s-1.5,2.8-3.1,2.7s-2.8-1.5-2.7-3.1c0-0.1,0-0.1,0-0.2
		C919,787.5,920.3,786.3,921.9,786.5C921.9,786.5,921.9,786.5,921.9,786.5z M921.3,791.5c1.1,0.1,2.1-0.7,2.2-1.8c0,0,0-0.1,0-0.1
		c0.2-1.1-0.5-2.1-1.5-2.4c-0.1,0-0.1,0-0.2,0c-1.1-0.1-2.1,0.7-2.2,1.8c0,0,0,0.1,0,0.1C919.4,790.2,920.2,791.3,921.3,791.5
		L921.3,791.5z"
                />
                <path
                  className="st15"
                  d="M926.7,790.2l-0.3,2.6h-0.8l0.7-5.6l1.9,0.3c0.4,0,0.8,0.1,1.1,0.4c0.3,0.3,0.4,0.8,0.4,1.2
		c-0.1,0.4-0.3,0.8-0.7,1.1l-0.7,0.2l1.6,2.9H929l-1.7-2.9L926.7,790.2z M927.9,789.6c0.3,0,0.5,0,0.7-0.2l0.3-0.5
		c0-0.2-0.1-0.3-0.2-0.5l-0.6-0.3H927l-0.2,1.4L927.9,789.6z"
                />
                <path
                  className="st15"
                  d="M932,787.8h0.7l-0.7,5.6h-0.7L932,787.8z"
                />
                <path
                  className="st15"
                  d="M937.3,792.7l-2.3-0.3l-0.8,1.4h-0.8l3-5.3h0.6l1.6,5.8h-0.9L937.3,792.7z M935.4,791.7l1.7,0.2l-0.6-2.1
		L935.4,791.7z"
                />
                <path
                  className="st15"
                  d="M942.6,793.4c0.2,0.5,0.7,0.8,1.2,0.9c0.5,0.1,1-0.2,1.1-0.7c0,0,0,0,0,0c0.1-0.8-1-1.1-1.7-1.7
		c-0.4-0.3-0.6-0.8-0.6-1.3c0.1-0.8,0.9-1.4,1.7-1.2c0.1,0,0.1,0,0.2,0c0.6,0,1.1,0.3,1.4,0.7l-0.5,0.5c-0.3-0.3-0.6-0.4-1-0.5
		c-0.4,0-0.8,0.2-1,0.6c-0.1,0.7,1.1,1,1.7,1.6c0.5,0.3,0.7,0.9,0.6,1.4c-0.1,0.9-0.9,1.5-1.8,1.4c0,0-0.1,0-0.1,0
		c-0.8-0.1-1.4-0.5-1.8-1.2L942.6,793.4z"
                />
                <path
                  className="st15"
                  d="M947.1,789.8l3.8,0.4v0.8l-1.5-0.2l-0.6,4.8H948l0.6-4.8l-1.5-0.2V789.8z"
                />
                <path
                  className="st15"
                  d="M952.8,793.5l-0.4,2.6h-0.8l0.7-5.6l2,0.3c0.4,0,0.7,0.1,1,0.4c0.3,0.3,0.5,0.8,0.4,1.2
		c0,0.5-0.3,0.9-0.7,1.1l-0.7,0.2l1.7,2.9h-1l-1.6-2.9L952.8,793.5z M954,792.9l0.6-0.2c0.2-0.1,0.3-0.3,0.3-0.5
		c0-0.2,0-0.3-0.1-0.5l-0.7-0.3H953l-0.2,1.4L954,792.9z"
                />
                <path
                  className="st15"
                  d="M960.3,793.7v0.7l-1.8-0.2l-0.2,1.8l2.4,0.4v0.7l-3.3-0.4l0.7-5.6l3.2,0.4v0.8l-2.4-0.3l-0.2,1.4L960.3,793.7
		z"
                />
                <path
                  className="st15"
                  d="M965.2,794.3v0.7l-1.8-0.2l-0.2,1.9l2.4,0.3v0.7l-3.2-0.4l0.7-5.5l3.2,0.4v0.7l-2.4-0.3l-0.2,1.4L965.2,794.3
		z"
                />
                <path
                  className="st15"
                  d="M967.2,792.3l3.8,0.5v0.7h-1.5l-0.6,4.8H968l0.6-4.8l-1.5-0.2L967.2,792.3z"
                />
                <path
                  className="st15"
                  d="M1418.8,748.8c0.8,0.1,1.5,0.5,2,1.1l-0.6,0.4c-0.4-0.4-0.9-0.7-1.4-0.8c-1.2-0.1-2.2,0.7-2.3,1.9
		c0,0,0,0,0,0c-0.2,1,0.4,2,1.5,2.3c0.1,0,0.2,0,0.3,0c0.6,0.1,1.3-0.1,1.7-0.6l0.5,0.6c-0.6,0.6-1.4,0.9-2.3,0.8
		c-1.5-0.4-2.5-2-2.1-3.5C1416.5,749.7,1417.5,748.9,1418.8,748.8L1418.8,748.8z"
                />
                <path
                  className="st15"
                  d="M1424.8,749.5c1.6,0.1,2.8,1.5,2.7,3.1s-1.5,2.8-3.1,2.7c-1.6-0.1-2.8-1.5-2.7-3.1c0-0.1,0-0.1,0-0.2
		C1421.9,750.5,1423.2,749.3,1424.8,749.5C1424.8,749.5,1424.8,749.5,1424.8,749.5z M1424.2,754.5c1.1,0.1,2.1-0.7,2.2-1.8
		c0,0,0-0.1,0-0.1c0.2-1-0.4-2-1.4-2.3c-0.1,0-0.2,0-0.3,0c-1-0.2-2,0.5-2.2,1.6c0,0.1,0,0.1,0,0.2c-0.2,1.1,0.5,2.1,1.5,2.4
		C1424.1,754.5,1424.1,754.5,1424.2,754.5L1424.2,754.5z"
                />
                <path
                  className="st15"
                  d="M1428.3,750l3.8,0.5v0.8l-1.5-0.2l-0.6,4.8h-0.8l0.6-4.8l-1.5-0.2V750z"
                />
                <path
                  className="st15"
                  d="M1437.1,754.1l-3.1-0.4l-0.3,2.7h-0.8l0.7-5.6h0.8l-0.3,2.2l3.1,0.4l0.3-2.2h0.7l-0.7,5.6h-0.7L1437.1,754.1z
		"
                />
                <path
                  className="st15"
                  d="M1442.8,756.1l-2.3-0.3l-0.8,1.3h-0.8l3-5.2h0.6l1.6,5.9h-0.9L1442.8,756.1z M1440.9,755.1l1.7,0.2l-0.6-2.2
		L1440.9,755.1z"
                />
                <path
                  className="st15"
                  d="M1448.5,757h-0.5l-1.3-2.8l-0.5,3.8h-0.8l0.7-5.6h0.6l1.7,3.6l2.5-3.1h0.6l-0.7,5.5h-0.8l0.5-3.7L1448.5,757z
		"
                />
                <path
                  className="st15"
                  d="M1456.7,756.6l-0.3,2.6h-0.8l0.7-5.5l1.9,0.2c0.4,0.1,0.7,0.2,1,0.5c0.3,0.3,0.5,0.8,0.4,1.2
		c0,0.4-0.2,0.8-0.6,1.1l-0.7,0.2l1.6,2.9h-0.9l-1.7-2.9L1456.7,756.6z M1457.9,756c0.2,0.1,0.5,0,0.7-0.1l0.3-0.5
		c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.2-0.4-0.3-0.6-0.3l-1.1-0.2l-0.2,1.5L1457.9,756z"
                />
                <path
                  className="st15"
                  d="M1464.1,754.5c1.5,0.2,2.6,1.6,2.4,3.1c0,0,0,0,0,0.1c-0.2,1.5-1.5,2.7-3.1,2.5c0,0,0,0,0,0
		c-1.5-0.1-2.6-1.5-2.4-2.9c0-0.1,0-0.2,0-0.3c0.1-1.5,1.4-2.6,2.9-2.5C1463.9,754.5,1464,754.5,1464.1,754.5z M1463.5,759.5
		c1.1,0.1,2.1-0.7,2.2-1.8c0,0,0-0.1,0-0.1c0.2-1.1-0.6-2.2-1.7-2.4c-1.1-0.1-2.1,0.8-2.3,1.9
		C1461.5,758.2,1462.3,759.3,1463.5,759.5C1463.5,759.5,1463.5,759.5,1463.5,759.5z"
                />
                <path
                  className="st15"
                  d="M1470.9,759.6l-2.4-0.3l-0.7,1.4h-0.8l3-5.3h0.5l1.6,5.8h-0.8L1470.9,759.6z M1468.9,758.6l1.8,0.2l-0.6-2.1
		L1468.9,758.6z"
                />
                <path
                  className="st15"
                  d="M1473.5,761.4l0.7-5.5l1.6,0.2c0.7,0,1.4,0.3,1.9,0.7c0.6,0.6,0.9,1.5,0.8,2.4c-0.1,0.9-0.6,1.7-1.4,2.1
		c-0.6,0.3-1.3,0.4-2,0.3L1473.5,761.4z M1477.2,757.5c-0.4-0.5-0.9-0.7-1.5-0.7h-0.8l-0.6,4.1h0.9c0.6,0.1,1.1,0,1.6-0.3
		c0.5-0.3,0.8-0.9,0.9-1.5C1477.8,758.5,1477.6,757.9,1477.2,757.5z"
                />
                <path
                  className="st15"
                  d="M885.9,907.5l0.7-5.6l1.9,0.3c0.4,0,0.8,0.2,1.1,0.5c0.3,0.3,0.4,0.7,0.3,1.1c-0.1,0.4-0.2,0.7-0.5,1
		c0.5,0.3,0.7,0.9,0.7,1.5c-0.1,0.5-0.4,0.9-0.8,1.2c-0.4,0.2-0.8,0.3-1.3,0.3L885.9,907.5z M888,907c0.5,0,0.7,0,0.9-0.2
		c0.2-0.1,0.4-0.3,0.4-0.6c0-0.2-0.1-0.5-0.2-0.7c-0.1-0.2-0.4-0.3-0.9-0.4H887l-0.2,1.8L888,907z M888.1,904.3
		c0.3,0.1,0.6,0,0.8-0.1c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2,0-0.3-0.1-0.5l-0.7-0.3h-1l-0.2,1.4L888.1,904.3z"
                />
                <path
                  className="st15"
                  d="M892.6,905.7l-0.3,2.6h-0.8l0.7-5.6l1.9,0.3c0.4,0,0.7,0.1,1,0.4c0.3,0.4,0.5,0.8,0.4,1.3
		c0,0.4-0.3,0.8-0.6,1l-0.7,0.2l1.6,2.9h-0.9l-1.7-2.9L892.6,905.7z M893.8,905.1l0.7-0.2l0.3-0.4c0-0.2-0.1-0.4-0.2-0.6l-0.6-0.3
		h-1.1l-0.2,1.4L893.8,905.1z"
                />
                <path
                  className="st15"
                  d="M897.8,903.4h0.8l-0.7,5.5h-0.8L897.8,903.4z"
                />
                <path
                  className="st15"
                  d="M900,909.3l0.7-5.6l1.6,0.2c0.7,0.1,1.4,0.3,1.9,0.8c0.6,0.6,0.9,1.5,0.8,2.4c-0.1,0.9-0.6,1.7-1.4,2.1
		c-0.6,0.3-1.3,0.4-2,0.3L900,909.3z M903.7,905.3c-0.4-0.4-0.9-0.6-1.5-0.6h-0.8l-0.6,4h0.9c0.6,0.1,1.1,0,1.6-0.3
		c0.5-0.3,0.8-0.8,0.9-1.4C904.3,906.4,904.1,905.8,903.7,905.3z"
                />
                <path
                  className="st15"
                  d="M911.1,909.7c-0.6,0.6-1.5,0.9-2.3,0.8c-1.6-0.2-2.7-1.7-2.5-3.2c0,0,0,0,0-0.1c0.1-1.5,1.5-2.7,3.1-2.5
		c0,0,0.1,0,0.1,0c0.8,0.1,1.5,0.6,1.9,1.2l-0.6,0.4c-0.3-0.4-0.8-0.7-1.4-0.8c-1.2-0.1-2.2,0.7-2.4,1.8c-0.1,1.2,0.7,2.2,1.9,2.4
		l0,0c0.5,0.1,1,0,1.4-0.3l0.2-1.5l-1.6-0.2V907l2.4,0.3L911.1,909.7z"
                />
                <path
                  className="st15"
                  d="M915.9,907.8v0.8l-1.9-0.2l-0.2,1.8l2.5,0.3v0.8l-3.3-0.4l0.7-5.6l3.2,0.4v0.8l-2.4-0.3l-0.2,1.4L915.9,907.8
		z"
                />
                <path
                  className="st15"
                  d="M921.6,909.3l-0.4,2.7h-0.8l0.7-5.6l2,0.2c0.4,0.1,0.7,0.2,1,0.5c0.3,0.3,0.5,0.8,0.4,1.2
		c0,0.5-0.3,0.9-0.7,1.1l-0.7,0.2l1.7,2.9h-1l-1.6-2.9L921.6,909.3z M922.8,908.7c0.2,0.1,0.4,0,0.6-0.1c0.2-0.1,0.3-0.3,0.3-0.5
		c0-0.2,0-0.4-0.1-0.5c-0.1-0.2-0.3-0.3-0.7-0.3h-1.1l-0.2,1.4L922.8,908.7z"
                />
                <path
                  className="st15"
                  d="M929,907.2c1.6,0.2,2.7,1.6,2.6,3.2c-0.2,1.6-1.6,2.7-3.2,2.6c-1.6-0.2-2.7-1.6-2.6-3.2c0,0,0,0,0-0.1
		c0.1-1.5,1.5-2.7,3.1-2.5C928.9,907.2,929,907.2,929,907.2z M928.3,912.2c1.2,0.1,2.2-0.7,2.3-1.9c0,0,0,0,0,0
		c0.1-1.1-0.6-2.1-1.8-2.2s-2.1,0.6-2.2,1.8C926.4,910.9,927.2,912,928.3,912.2z"
                />
                <path
                  className="st15"
                  d="M935.7,912.3l-2.3-0.3l-0.8,1.4h-0.8l3-5.3h0.6l1.6,5.8h-0.9L935.7,912.3z M933.8,911.3l1.7,0.3l-0.6-2.2
		L933.8,911.3z"
                />
                <path
                  className="st15"
                  d="M938.3,914.1l0.7-5.5l1.7,0.2c0.7,0.1,1.3,0.3,1.8,0.7c0.6,0.6,1,1.5,0.9,2.4c-0.2,0.9-0.7,1.7-1.4,2.2
		c-0.6,0.2-1.3,0.3-2,0.2L938.3,914.1z M942.1,910.2c-0.4-0.4-0.9-0.6-1.5-0.7h-0.9l-0.5,4.1h0.8c0.6,0.1,1.2,0,1.7-0.3
		c0.5-0.3,0.8-0.9,0.9-1.5C942.7,911.2,942.5,910.6,942.1,910.2L942.1,910.2z"
                />
                <path
                  className="st15"
                  d="M1260.6,1054l-0.3,2.6h-0.8l0.7-5.6l1.9,0.3c0.4,0,0.8,0.1,1.1,0.4c0.3,0.3,0.4,0.8,0.4,1.2
		c-0.1,0.4-0.3,0.8-0.7,1.1l-0.7,0.2l1.6,2.9h-0.9l-1.7-2.9L1260.6,1054z M1261.8,1053.4c0.3,0,0.5,0,0.7-0.2
		c0.2-0.1,0.3-0.3,0.3-0.5c0-0.2-0.1-0.3-0.2-0.5l-0.6-0.3h-1.1l-0.2,1.4L1261.8,1053.4z"
                />
                <path
                  className="st15"
                  d="M1265.9,1051.6h0.8l-0.8,5.6h-0.7L1265.9,1051.6z"
                />
                <path
                  className="st15"
                  d="M1270.1,1057.8h-0.6l-1.5-5.9h0.9l1.1,4.4l2.1-4h0.9L1270.1,1057.8z"
                />
                <path
                  className="st15"
                  d="M1276.7,1055.2v0.8l-1.8-0.2l-0.3,1.8l2.5,0.3v0.8l-3.3-0.4l0.8-5.6l3.1,0.4v0.8l-2.3-0.3l-0.2,1.4
		L1276.7,1055.2z"
                />
                <path
                  className="st15"
                  d="M1279.7,1056.4l-0.4,2.6h-0.8l0.7-5.6l2,0.3c0.4,0,0.7,0.2,1,0.4c0.3,0.4,0.5,0.8,0.4,1.3
		c0,0.4-0.3,0.8-0.7,1c-0.2,0.2-0.4,0.2-0.7,0.2l1.7,2.9h-1l-1.6-2.8L1279.7,1056.4z M1280.9,1055.8c0.3,0,0.5,0,0.7-0.2
		c0.1-0.1,0.2-0.2,0.2-0.4c0-0.2,0-0.4-0.1-0.6l-0.7-0.3h-1.1l-0.2,1.4L1280.9,1055.8z"
                />
                <path
                  className="st15"
                  d="M1284.4,1058.2c0.3,0.5,0.8,0.8,1.3,0.9c0.5,0.1,1-0.2,1.1-0.7c0,0,0,0,0,0c0.1-0.8-1.1-1.1-1.8-1.7
		c-0.4-0.3-0.6-0.8-0.5-1.3c0.1-0.8,0.9-1.4,1.7-1.2c0,0,0,0,0.1,0c0.6,0,1.1,0.3,1.5,0.7l-0.6,0.5c-0.3-0.2-0.6-0.4-0.9-0.5
		c-0.5,0-1,0.2-1,0.6s1,1.1,1.7,1.6c0.4,0.3,0.6,0.9,0.5,1.4c-0.1,0.9-0.9,1.5-1.8,1.4c0,0-0.1,0-0.1,0c-0.8-0.1-1.4-0.5-1.8-1.2
		L1284.4,1058.2z"
                />
                <path
                  className="st15"
                  d="M1289,1060.2l0.7-5.5l1.7,0.2c1.4,0,2.6,1.1,2.6,2.6c0,0.2,0,0.4,0,0.5c-0.1,0.9-0.6,1.7-1.4,2.1
		c-0.6,0.3-1.3,0.4-2,0.3L1289,1060.2z M1292.7,1056.3c-0.4-0.5-0.9-0.7-1.5-0.7h-0.8l-0.5,4.1h0.8c0.6,0.1,1.1,0,1.6-0.3
		c0.5-0.3,0.8-0.9,0.9-1.5C1293.3,1057.3,1293.1,1056.7,1292.7,1056.3L1292.7,1056.3z"
                />
                <path
                  className="st15"
                  d="M1298.4,1060l-2.4-0.3l-0.7,1.3h-0.8l3-5.3h0.5l1.6,5.9h-0.8L1298.4,1060z M1296.5,1058.9l1.7,0.3l-0.6-2.2
		L1296.5,1058.9z"
                />
                <path
                  className="st15"
                  d="M1301.9,1061.1l2.4,0.3v0.7l-3.2-0.4l0.7-5.5h0.8L1301.9,1061.1z"
                />
                <path
                  className="st15"
                  d="M1308.7,1059.3v0.7l-1.8-0.2l-0.2,1.9l2.4,0.3v0.7l-3.2-0.4l0.7-5.5l3.2,0.4v0.7l-2.4-0.3l-0.2,1.5
		L1308.7,1059.3z"
                />
                <path
                  className="st15"
                  d="M1314.4,1060.8l-0.3,2.6h-0.8l0.7-5.6l2,0.3c0.5,0.1,0.8,0.2,1,0.5c0.3,0.3,0.5,0.8,0.4,1.2
		c-0.1,0.4-0.3,0.8-0.7,1c-0.2,0.2-0.4,0.2-0.7,0.2l1.7,3l-1-0.2l-1.6-2.8L1314.4,1060.8z M1315.6,1060.2c0.4,0,0.6,0,0.7-0.2
		s0.3-0.2,0.3-0.4c0-0.2,0-0.4-0.1-0.6l-0.7-0.3h-1.1l-0.2,1.4L1315.6,1060.2z"
                />
                <path
                  className="st15"
                  d="M1321.8,1058.7c1.5,0.1,2.7,1.5,2.5,3.1c0,0,0,0.1,0,0.1c-0.2,1.6-1.6,2.7-3.2,2.5c-1.5-0.2-2.6-1.6-2.4-3.1
		c0,0,0,0,0-0.1c0.1-1.5,1.4-2.6,2.9-2.5C1321.6,1058.7,1321.7,1058.7,1321.8,1058.7z M1321.2,1063.6c1.1,0.2,2.1-0.6,2.3-1.7
		c0,0,0-0.1,0-0.1c0.2-1.1-0.6-2.2-1.8-2.4c0,0,0,0,0,0c-1.1-0.1-2.1,0.7-2.2,1.8c0,0,0,0.1,0,0.1c-0.2,1,0.4,2,1.4,2.3
		C1321,1063.6,1321.1,1063.6,1321.2,1063.6L1321.2,1063.6z"
                />
                <path
                  className="st15"
                  d="M1328.6,1063.8l-2.3-0.3l-0.8,1.3h-0.8l3-5.2h0.6l1.6,5.8h-0.9L1328.6,1063.8z M1326.7,1062.8l1.7,0.2
		l-0.6-2.2L1326.7,1062.8z"
                />
                <path
                  className="st15"
                  d="M1331.2,1065.6l0.7-5.6l1.7,0.2c0.7,0,1.3,0.3,1.8,0.8c0.6,0.6,0.9,1.5,0.8,2.4c-0.2,1.5-1.6,2.6-3.1,2.4
		c-0.1,0-0.1,0-0.2,0L1331.2,1065.6z M1335,1061.6c-0.5-0.4-1-0.6-1.6-0.6h-0.8l-0.5,4h0.8c0.6,0.1,1.2,0,1.7-0.3
		c0.5-0.3,0.8-0.8,0.8-1.4C1335.5,1062.7,1335.3,1062.1,1335,1061.6z"
                />
                <path
                  className="st15"
                  d="M234.3,255.4l0.8-5.5l1.8,0.2c0.4,0,0.8,0.2,1.1,0.5c0.3,0.3,0.4,0.7,0.4,1.1c-0.1,0.4-0.3,0.7-0.6,1
		c0.5,0.3,0.8,1,0.7,1.6c0,0.5-0.3,0.9-0.7,1.2c-0.4,0.2-0.9,0.3-1.3,0.2L234.3,255.4z M236.4,254.9c0.3,0.1,0.7,0,1-0.2
		c0.2-0.1,0.3-0.4,0.3-0.6c0.1-0.2,0-0.5-0.1-0.7c-0.3-0.2-0.6-0.3-0.9-0.4h-1.2l-0.3,1.9H236.4z M236.5,252.3c0.5,0,0.7,0,0.8-0.2
		l0.3-0.4c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.2-0.3-0.3-0.7-0.4h-0.9l-0.2,1.4L236.5,252.3z"
                />
                <path
                  className="st15"
                  d="M241,253.6l-0.3,2.6h-0.8l0.7-5.5l2,0.2c0.5,0.1,0.8,0.2,1,0.5c0.3,0.3,0.5,0.8,0.4,1.2
		c-0.1,0.4-0.3,0.8-0.7,1.1l-0.7,0.2l1.7,2.9l-1-0.2l-1.6-2.8L241,253.6z M242.2,253h0.7c0.2-0.1,0.3-0.3,0.3-0.5
		c0-0.2,0-0.4-0.1-0.6c-0.2-0.1-0.5-0.2-0.7-0.2l-1.1-0.2l-0.2,1.4L242.2,253z"
                />
                <path
                  className="st15"
                  d="M246,256.2c-0.4-0.5-0.5-1.1-0.4-1.7l0.4-3.2h0.8l-0.4,3.2c-0.1,0.4,0,0.8,0.2,1.2c0.3,0.3,0.7,0.5,1.1,0.6
		c0.4,0.1,0.9,0,1.2-0.3c0.3-0.3,0.5-0.7,0.5-1.1l0.5-3.3h0.7l-0.4,3.3c0,0.6-0.3,1.2-0.8,1.6c-0.5,0.4-1.2,0.6-1.8,0.5
		C247,256.9,246.4,256.7,246,256.2z"
                />
                <path
                  className="st15"
                  d="M253.2,253.7l-0.5,4h-0.8l0.7-5.5h0.5l2.9,4.4l0.5-4h0.8l-0.7,5.5H256L253.2,253.7z"
                />
                <path
                  className="st15"
                  d="M258.8,257.1c0.3,0.5,0.8,0.8,1.3,0.9c0.5,0.1,1-0.2,1.1-0.7c0,0,0,0,0,0c0.1-0.9-1.1-1.1-1.7-1.7
		c-0.4-0.3-0.7-0.8-0.6-1.3c0.1-0.9,1-1.5,1.8-1.3c0,0,0,0,0.1,0c0.5,0.1,1,0.4,1.4,0.8l-0.6,0.5c-0.2-0.3-0.5-0.5-0.9-0.5
		c-0.4-0.1-0.9,0.1-1,0.6c0,0,0,0,0,0c-0.1,0.7,1.1,1,1.7,1.6c0.5,0.3,0.7,0.9,0.6,1.4c-0.1,0.9-1,1.5-1.8,1.3c0,0,0,0-0.1,0
		c-0.8,0-1.5-0.4-1.9-1.1L258.8,257.1z"
                />
                <path
                  className="st15"
                  d="M265,259.3h-0.6l-1-5.8l0.8,0.2l0.7,4.1l1.9-3.8h0.6l0.8,4.1l1.8-3.8h0.8l-2.5,5.3h-0.5l-0.9-4.2L265,259.3z"
                />
                <path
                  className="st15"
                  d="M272.2,254.6h0.8l-0.7,5.5h-0.8L272.2,254.6z"
                />
                <path
                  className="st15"
                  d="M277.4,255.1c0.8,0.1,1.5,0.6,1.9,1.2l-0.6,0.4c-0.3-0.4-0.8-0.7-1.4-0.8c-1-0.2-2,0.4-2.3,1.5
		c0,0.1,0,0.2,0,0.3c-0.2,1.1,0.5,2.1,1.6,2.4c0.1,0,0.2,0,0.2,0c0.6,0.1,1.3-0.1,1.7-0.6l0.5,0.6c-0.6,0.6-1.4,0.9-2.3,0.8
		c-1.6-0.2-2.7-1.7-2.5-3.2c0,0,0,0,0-0.1c0.1-1.5,1.5-2.7,3.1-2.5C277.3,255.1,277.4,255.1,277.4,255.1z"
                />
                <path
                  className="st15"
                  d="M281.1,255.7h0.8l-0.3,2.3l2.5-2h1.1l-2.8,2.3l2.2,3.3h-1l-2.1-3.1l-0.3,2.7h-0.8L281.1,255.7z"
                />
                <path
                  className="st15"
                  d="M289.7,259.8l-0.3,2.6h-0.8l0.7-5.6l2,0.3c0.4,0,0.7,0.1,1,0.4c0.3,0.4,0.5,0.8,0.4,1.3
		c-0.1,0.4-0.3,0.8-0.7,1l-0.7,0.2l1.7,2.9h-1l-1.6-2.9L289.7,259.8z M290.9,259.2c0.3,0,0.5,0,0.7-0.2c0.2-0.1,0.3-0.2,0.3-0.4
		c0-0.2,0-0.4-0.1-0.6l-0.7-0.3H290l-0.2,1.4L290.9,259.2z"
                />
                <path
                  className="st15"
                  d="M297.1,257.6c1.6,0.2,2.7,1.7,2.5,3.2c0,0,0,0,0,0.1c-0.2,1.5-1.7,2.6-3.2,2.4c-1.5-0.2-2.6-1.7-2.4-3.2
		C294.2,258.6,295.5,257.4,297.1,257.6C297.1,257.6,297.1,257.6,297.1,257.6z M296.5,262.6c1.2,0.1,2.2-0.7,2.3-1.9c0,0,0,0,0,0
		c0.2-1.1-0.6-2.1-1.7-2.3c0,0-0.1,0-0.1,0c-1.2-0.1-2.2,0.7-2.4,1.9S295.3,262.5,296.5,262.6L296.5,262.6z"
                />
                <path
                  className="st15"
                  d="M303.9,262.8l-2.3-0.3l-0.8,1.3H300l3-5.2h0.6l1.6,5.9h-0.9L303.9,262.8z M302,261.8l1.7,0.2l-0.6-2.2
		L302,261.8z"
                />
                <path
                  className="st15"
                  d="M306.5,264.6l0.7-5.6l1.7,0.2c0.7,0,1.3,0.3,1.8,0.8c0.7,0.6,1,1.5,0.8,2.4c-0.1,0.9-0.6,1.6-1.3,2.1
		c-0.6,0.3-1.3,0.4-2,0.3L306.5,264.6z M310.3,260.6c-0.5-0.4-1-0.6-1.6-0.6h-0.8l-0.5,4h0.8c0.6,0.1,1.2,0,1.7-0.3
		c0.5-0.3,0.8-0.8,0.8-1.4C310.8,261.7,310.6,261.1,310.3,260.6z"
                />
                <path
                  className="st15"
                  d="M668.2,529.4l-2.4-0.3l-0.7,1.3h-0.9l3-5.2h0.6l1.6,5.9h-0.8L668.2,529.4z M666.2,528.4l1.7,0.2l-0.6-2.2
		L666.2,528.4z"
                />
                <path
                  className="st15"
                  d="M671.6,530.5l2.5,0.3v0.8l-3.3-0.4l0.7-5.6h0.8L671.6,530.5z"
                />
                <path
                  className="st15"
                  d="M678.5,528.7v0.8l-1.8-0.3l-0.3,1.9l2.5,0.3v0.8l-3.2-0.5l0.7-5.5l3.1,0.4v0.8l-2.3-0.3l-0.2,1.4L678.5,528.7
		z"
                />
                <path
                  className="st15"
                  d="M679.7,532.3l2.4-2.8l-1.3-2.7h0.9l1,2l1.4-1.7h1l-2,2.3l1.6,3.3h-0.9l-1.3-2.6l-1.8,2.2H679.7z"
                />
                <path
                  className="st15"
                  d="M689.4,532.1l-2.3-0.3l-0.8,1.3h-0.8l3-5.2h0.5l1.6,5.9h-0.8L689.4,532.1z M687.5,531.1l1.7,0.2l-0.6-2.2
		L687.5,531.1z"
                />
                <path
                  className="st15"
                  d="M693.3,529.9l-0.5,4H692l0.7-5.5h0.6l2.8,4.5l0.5-4.1h0.8l-0.7,5.5h-0.6L693.3,529.9z"
                />
                <path
                  className="st15"
                  d="M698.7,534.7l0.7-5.6l1.7,0.3c0.7,0,1.3,0.3,1.8,0.7c0.6,0.6,0.9,1.5,0.8,2.4c-0.1,0.9-0.6,1.7-1.4,2.1
		c-0.6,0.3-1.3,0.4-1.9,0.3L698.7,534.7z M702.5,530.8c-0.4-0.4-1-0.7-1.6-0.7h-0.8l-0.5,4h0.8c0.6,0.1,1.2,0,1.7-0.2
		c0.5-0.4,0.8-0.9,0.8-1.5C703,531.8,702.8,531.3,702.5,530.8z"
                />
                <path
                  className="st15"
                  d="M706.1,533l-0.3,2.6H705l0.7-5.6l1.9,0.3c0.4,0,0.8,0.1,1.1,0.4c0.3,0.4,0.4,0.8,0.4,1.3
		c-0.1,0.4-0.4,0.8-0.7,1l-0.7,0.2l1.6,2.9h-0.9l-1.7-2.8L706.1,533z M707.3,532.4c0.3,0,0.5,0,0.7-0.2l0.3-0.4
		c0-0.2-0.1-0.4-0.2-0.6l-0.6-0.3h-1.1l-0.2,1.4L707.3,532.4z"
                />
                <path
                  className="st15"
                  d="M714,535.2l-2.3-0.3l-0.8,1.3h-0.8l3-5.2h0.6l1.5,5.9h-0.8L714,535.2z M712.1,534.2l1.7,0.2l-0.6-2.2
		L712.1,534.2z"
                />
                <path
                  className="st15"
                  d="M720.3,534.9l-0.3,2.5h-0.8l0.7-5.6l2.1,0.3c0.4,0,0.8,0.2,1.1,0.5c0.3,0.3,0.5,0.8,0.4,1.3
		c-0.1,0.4-0.3,0.8-0.7,1.1c-0.4,0.2-0.8,0.3-1.2,0.2L720.3,534.9z M721.6,534.3c0.3,0.1,0.6,0,0.8-0.1c0.2-0.1,0.3-0.3,0.3-0.5
		c0-0.3,0-0.5-0.2-0.6s-0.3-0.3-0.7-0.4h-1.2l-0.2,1.6H721.6z"
                />
                <path
                  className="st15"
                  d="M727.1,536.8l-2.3-0.3l-0.8,1.4h-0.8l3-5.3h0.5l1.6,5.8h-0.8L727.1,536.8z M725.2,535.8l1.7,0.2l-0.6-2.1
		L725.2,535.8z"
                />
                <path
                  className="st15"
                  d="M730.8,536.1l-0.3,2.6h-0.8l0.7-5.5l1.9,0.2c0.4,0,0.8,0.2,1.1,0.5c0.3,0.3,0.4,0.8,0.4,1.2
		c-0.1,0.4-0.3,0.8-0.7,1.1l-0.7,0.2l1.7,2.9l-1-0.2l-1.6-2.8L730.8,536.1z M732,535.5h0.7c0.2-0.1,0.3-0.3,0.3-0.5
		c0-0.2,0-0.4-0.2-0.5s-0.2-0.3-0.6-0.3l-1.1-0.2l-0.2,1.4L732,535.5z"
                />
                <path
                  className="st15"
                  d="M738.7,538.3l-2.3-0.3l-0.8,1.4h-0.8l3-5.3h0.6l1.6,5.8h-0.9L738.7,538.3z M736.8,537.3l1.7,0.2l-0.6-2.1
		L736.8,537.3z"
                />
                <path
                  className="st15"
                  d="M741.3,540.1l0.7-5.6l1.7,0.3c0.7,0,1.3,0.3,1.8,0.7c0.6,0.6,1,1.5,0.9,2.4c-0.2,0.9-0.7,1.6-1.4,2.1
		c-0.6,0.3-1.3,0.4-2,0.3L741.3,540.1z M745.1,536.2c-0.4-0.4-0.9-0.7-1.5-0.7h-0.9l-0.5,4h0.8c0.6,0.1,1.2,0,1.7-0.2
		c0.5-0.3,0.8-0.9,0.9-1.5C745.7,537.2,745.5,536.6,745.1,536.2L745.1,536.2z"
                />
                <path
                  className="st15"
                  d="M750.6,537.8v0.8l-1.8-0.2l-0.2,1.8l2.4,0.3v0.8l-3.2-0.4l0.7-5.6l3.2,0.4v0.8l-2.4-0.3l-0.2,1.4L750.6,537.8
		z"
                />
                <path
                  className="st15"
                  d="M709.2,480.1l-2.8,1.4l1.2,2.4l-0.7,0.3l-2.6-5l0.8-0.3l1,1.9l2.7-1.4l-1-1.9l0.8-0.4l2.5,5l-0.7,0.4
		L709.2,480.1z"
                />
                <path
                  className="st15"
                  d="M713.7,477l0.4,0.6l-1.7,0.9l0.9,1.6l2.2-1.1l0.3,0.7l-2.9,1.5l-2.5-5l2.8-1.5l0.4,0.7l-2.2,1.1l0.7,1.3
		L713.7,477z"
                />
                <path
                  className="st15"
                  d="M714.8,474l0.7-0.4l2.5,5l-0.7,0.4L714.8,474z"
                />
                <path
                  className="st15"
                  d="M719.8,477.7l-2.5-5l1.5-0.8c0.6-0.4,1.3-0.5,2-0.4c0.9,0.2,1.6,0.7,2,1.5c0.4,0.8,0.4,1.8,0,2.6
		c-0.3,0.6-0.9,1.1-1.5,1.3L719.8,477.7z M720.7,472.3c-0.6-0.1-1.1,0-1.6,0.3l-0.7,0.4l1.8,3.6l0.7-0.4c0.5-0.2,1-0.6,1.3-1.1
		c0.2-0.6,0.1-1.2-0.1-1.7C721.8,472.9,721.3,472.5,720.7,472.3L720.7,472.3z"
                />
                <path
                  className="st15"
                  d="M726.3,470.6l0.3,0.7l-1.6,0.8l0.8,1.7l2.3-1.1l0.3,0.6l-2.9,1.5l-2.6-5l2.9-1.4l0.3,0.7l-2.1,1l0.6,1.3
		L726.3,470.6z"
                />
                <path
                  className="st15"
                  d="M730.2,471.5l2.2-1.1l0.4,0.7l-2.9,1.5l-2.6-5l0.7-0.4L730.2,471.5z"
                />
                <path
                  className="st15"
                  d="M734.1,470.4l-2.5-5l1.7-0.8c0.3-0.2,0.8-0.3,1.2-0.2c0.4,0.1,0.7,0.4,0.9,0.8c0.1,0.3,0.1,0.7,0,1
		c0.6,0,1.2,0.4,1.5,0.9c0.2,0.5,0.3,1,0.1,1.5c-0.3,0.4-0.6,0.7-1,0.9L734.1,470.4z M734.1,466.6c0.4-0.2,0.6-0.4,0.6-0.5
		c0.1-0.2,0.1-0.4,0-0.6l-0.4-0.3c-0.2-0.1-0.4-0.1-0.8,0.1l-0.9,0.5l0.7,1.2L734.1,466.6z M735.6,468.8c0.4-0.2,0.6-0.4,0.6-0.6
		c0.1-0.2,0.1-0.5,0-0.7c-0.1-0.2-0.3-0.4-0.5-0.5c-0.3-0.1-0.5-0.1-1,0.2l-1.1,0.5l0.9,1.7L735.6,468.8z"
                />
                <path
                  className="st15"
                  d="M739.9,463.7l0.4,0.7l-1.7,0.8l0.9,1.7l2.2-1.2l0.3,0.7l-2.9,1.5l-2.5-5l2.8-1.4l0.4,0.6l-2.2,1.1l0.7,1.3
		L739.9,463.7z"
                />
                <path
                  className="st15"
                  d="M743,463l1.2,2.3l-0.7,0.4l-2.5-5l1.7-0.9c0.3-0.2,0.7-0.3,1.1-0.2c0.4,0.1,0.8,0.4,1,0.8
		c0.2,0.4,0.2,0.9,0.1,1.3c-0.1,0.2-0.3,0.4-0.5,0.5l3,1.5l-0.9,0.4l-2.9-1.4L743,463z M743.7,461.8l0.5-0.5c0-0.2,0-0.4-0.1-0.6
		c-0.1-0.1-0.2-0.3-0.4-0.3c-0.2-0.1-0.5-0.1-0.7,0.1l-1,0.5l0.7,1.3L743.7,461.8z"
                />
                <path
                  className="st15"
                  d="M752.1,460.2c-0.1,0.9-0.7,1.6-1.5,1.9c-1.3,0.7-2.9,0.3-3.7-1c0-0.1-0.1-0.1-0.1-0.2
		c-0.8-1.3-0.3-3.1,1.1-3.8c0.7-0.4,1.6-0.5,2.3-0.2l-0.2,0.7c-0.6-0.2-1.2-0.1-1.7,0.1c-1,0.5-1.4,1.7-0.9,2.7c0,0,0,0.1,0.1,0.1
		c0.4,1,1.6,1.5,2.6,1.1c0.1,0,0.1-0.1,0.2-0.1c0.5-0.2,0.8-0.6,1-1.1l-0.7-1.3l-1.4,0.7l-0.3-0.7l2.1-1L752.1,460.2z"
                />
                <path
                  className="st15"
                  d="M756.2,456.3l1.2,2.4l-0.7,0.3l-2.6-5l1.8-0.9c0.3-0.2,0.7-0.2,1.1-0.2c0.4,0.1,0.8,0.4,1,0.8
		c0.2,0.4,0.2,0.9,0,1.3l-0.4,0.6l3,1.4l-0.9,0.5l-3-1.5L756.2,456.3z M756.8,455.1c0.4-0.1,0.5-0.3,0.5-0.5c0.1-0.1,0.1-0.4,0-0.5
		c-0.1-0.2-0.3-0.3-0.4-0.4h-0.7l-1,0.5l0.6,1.3L756.8,455.1z"
                />
                <path
                  className="st15"
                  d="M761.1,450.4c1.4-0.7,3.1-0.2,3.8,1.2c0,0,0,0,0,0.1c0.7,1.3,0.3,2.9-1,3.7c-0.1,0-0.1,0.1-0.2,0.1
		c-1.5,0.5-3.2-0.4-3.6-1.9C759.7,452.4,760.1,451.1,761.1,450.4L761.1,450.4z M763.4,454.8c0.9-0.5,1.3-1.6,0.9-2.5
		c0-0.1-0.1-0.1-0.1-0.2c-0.4-1-1.6-1.5-2.6-1c0,0,0,0-0.1,0c-1,0.5-1.4,1.7-1,2.7c0,0,0,0.1,0.1,0.1
		C761.1,454.9,762.4,455.3,763.4,454.8L763.4,454.8z"
                />
                <path
                  className="st15"
                  d="M769.6,450.8l-2.1,1.1v1.6l-0.7,0.3l-0.5-6l0.5-0.3l4.6,4l-0.7,0.4L769.6,450.8z M767.5,451.1l1.5-0.8
		l-1.7-1.5L767.5,451.1z"
                />
                <path
                  className="st15"
                  d="M772.8,450.9l-2.6-5l1.5-0.8c0.6-0.4,1.3-0.5,2-0.4c0.9,0.2,1.6,0.7,2,1.5c0.4,0.8,0.4,1.8,0,2.6
		c-0.3,0.6-0.9,1.1-1.5,1.3L772.8,450.9z M773.7,445.5c-0.6-0.1-1.2,0-1.7,0.3l-0.7,0.4l1.8,3.6l0.8-0.4c0.5-0.2,1-0.6,1.2-1.1
		c0.2-0.6,0.2-1.2-0.1-1.7C774.8,446.1,774.3,445.7,773.7,445.5z"
                />
                <path
                  className="st15"
                  d="M581.1,496.6l4,0.6v0.8l-5.5-0.8v-0.6l4.5-2.7l-4.1-0.6l0.2-0.8l5.5,0.8v0.6L581.1,496.6z"
                />
                <path
                  className="st15"
                  d="M580.4,490.5l0.2-0.8l5.5,0.8v0.8L580.4,490.5z"
                />
                <path
                  className="st15"
                  d="M581.1,485.3c0.1-0.8,0.6-1.5,1.2-1.9l0.4,0.6c-0.4,0.3-0.7,0.8-0.8,1.4c-0.2,1,0.4,2,1.5,2.3
		c0.1,0,0.2,0,0.3,0c1.1,0.2,2.1-0.5,2.4-1.5c0.1-0.7-0.1-1.4-0.6-1.9l0.6-0.5c0.6,0.6,0.8,1.5,0.7,2.3c-0.1,1.5-1.5,2.6-2.9,2.4
		c-0.1,0-0.2,0-0.3,0c-1.5-0.1-2.7-1.5-2.5-3.1C581.1,485.4,581.1,485.3,581.1,485.3z"
                />
                <path
                  className="st15"
                  d="M585.2,478.2l-0.4,3.1l2.6,0.3v0.8l-5.6-0.8v-0.8l2.2,0.4l0.5-3.1l-2.2-0.3V477l5.5,0.8v0.8L585.2,478.2z"
                />
                <path
                  className="st15"
                  d="M582.9,472.6c0.3-1.6,1.7-2.6,3.3-2.4c1.5,0.2,2.6,1.6,2.4,3.1c0,0,0,0,0,0.1c-0.2,1.5-1.6,2.6-3.1,2.4
		c0,0,0,0-0.1,0C583.8,475.6,582.7,474.2,582.9,472.6z M587.9,473.3c0.2-1.1-0.6-2.1-1.7-2.3c0,0-0.1,0-0.1,0
		c-1.1-0.2-2.2,0.6-2.4,1.7c-0.2,1.1,0.6,2.1,1.7,2.3c0,0,0.1,0,0.1,0C586.6,475.2,587.7,474.4,587.9,473.3L587.9,473.3z"
                />
                <path
                  className="st15"
                  d="M588.5,468.1l0.4-2.4h0.8l-0.5,3.2l-5.6-0.7l0.2-0.8L588.5,468.1z"
                />
                <path
                  className="st15"
                  d="M588.5,464.1c0.5-0.3,0.8-0.8,0.9-1.3c0.1-0.5-0.2-1-0.7-1.1c0,0,0,0,0,0c-0.8-0.1-1.1,1.1-1.7,1.7
		c-0.3,0.4-0.8,0.6-1.3,0.6c-0.9-0.2-1.4-1-1.2-1.9c0-0.5,0.3-1,0.7-1.4l0.5,0.5c-0.2,0.3-0.4,0.6-0.5,0.9c-0.1,0.5,0.1,1,0.6,1.1
		c0.7,0.1,1-1.1,1.6-1.7c0.3-0.5,0.9-0.7,1.4-0.6c0.9,0.1,1.6,1,1.4,1.9c0,0,0,0,0,0.1c-0.2,0.7-0.6,1.4-1.3,1.8L588.5,464.1z"
                />
                <path
                  className="st15"
                  d="M585.3,456.4c0.2-1.5,1.6-2.6,3.1-2.4c0,0,0,0,0.1,0c1.5,0.2,2.6,1.7,2.4,3.2c-0.2,1.5-1.7,2.6-3.2,2.4
		c-1.5-0.1-2.6-1.5-2.4-2.9C585.3,456.6,585.3,456.5,585.3,456.4z M590.2,457.1c0.2-1.1-0.6-2.1-1.7-2.3c0,0-0.1,0-0.1,0
		c-1.1-0.2-2.2,0.6-2.4,1.7c-0.2,1.2,0.6,2.2,1.8,2.4C589,459.1,590,458.3,590.2,457.1L590.2,457.1L590.2,457.1z"
                />
                <path
                  className="st15"
                  d="M587.6,451.5l4,0.5v0.8L586,452v-0.5l4.5-2.8l-4.1-0.5v-0.8l5.6,0.8v0.5L587.6,451.5z"
                />
                <path
                  className="st15"
                  d="M591.5,443.3c0.4-0.3,0.7-0.7,0.9-1.2c0.1-0.6-0.2-1.1-0.7-1.1s-1.1,1-1.7,1.7c-0.3,0.4-0.8,0.6-1.3,0.5
		c-0.9-0.1-1.5-1-1.3-1.8c0,0,0,0,0-0.1c0.1-0.5,0.4-1,0.8-1.4l0.5,0.6c-0.3,0.2-0.5,0.5-0.5,0.9c-0.1,0.4,0.1,0.9,0.6,1
		c0,0,0,0,0,0c0.7,0.1,1-1,1.6-1.7c0.3-0.4,0.9-0.6,1.4-0.5c0.8,0.1,1.4,0.8,1.3,1.6c0,0.1,0,0.2,0,0.3c-0.1,0.8-0.5,1.4-1.2,1.8
		L591.5,443.3z"
                />
                <path
                  className="st15"
                  d="M587.9,438.7l0.5-3.8h0.8l-0.2,1.5l4.8,0.7l-0.2,0.8l-4.7-0.7l-0.3,1.5H587.9z"
                />
                <path
                  className="st15"
                  d="M591.7,433.1l2.6,0.4v0.8l-5.6-0.8l0.3-1.9c0.1-0.4,0.3-0.8,0.5-1.1c0.3-0.3,0.8-0.4,1.2-0.4
		c0.5,0.1,0.9,0.4,1.1,0.8c0.1,0.2,0.2,0.4,0.2,0.6l2.9-1.6v1l-2.9,1.6L591.7,433.1z M591.1,431.9c0-0.2,0-0.5-0.1-0.7l-0.5-0.3
		l-0.5,0.2c-0.2,0.1-0.3,0.4-0.3,0.6l-0.2,1.1l1.4,0.2L591.1,431.9z"
                />
                <path
                  className="st15"
                  d="M592,425.5h0.8l-0.3,1.9l1.9,0.2l0.3-2.4h0.8l-0.5,3.2l-5.5-0.8l0.4-3.1h0.8l-0.4,2.4l1.4,0.2L592,425.5z"
                />
                <path
                  className="st15"
                  d="M592.7,420.7h0.8l-0.3,1.8l1.9,0.3l0.3-2.5h0.8l-0.5,3.3l-5.5-0.8l0.4-3.2h0.8L591,422l1.4,0.2L592.7,420.7z"
                />
                <path
                  className="st15"
                  d="M590.8,418.7l0.5-3.8h0.8l-0.2,1.5l4.7,0.7v0.8l-4.8-0.7l-0.2,1.5H590.8z"
                />
                <path
                  className="st15"
                  d="M471.3,673.1l0.3-2.4h0.8l-0.5,3.2l-5.5-0.8v-0.8L471.3,673.1z"
                />
                <path
                  className="st15"
                  d="M470.3,667.3l2.5,0.3v0.8l-2.5-0.3l-3.3,1.4v-0.9l2.5-1l-2.1-1.8l0.2-0.9L470.3,667.3z"
                />
                <path
                  className="st15"
                  d="M473,659.9c0.5,0.6,0.8,1.5,0.7,2.3c-0.2,1.6-1.7,2.7-3.2,2.5c0,0,0,0-0.1,0c-1.5-0.1-2.6-1.5-2.4-2.9
		c0-0.1,0-0.2,0-0.3c0.1-0.8,0.5-1.5,1.1-1.9l0.5,0.6c-0.5,0.3-0.8,0.8-0.9,1.4c-0.1,1.1,0.7,2.1,1.8,2.3c1.1,0.2,2.1-0.5,2.4-1.6
		c0-0.1,0-0.2,0-0.2c0.1-0.5,0-1-0.3-1.4l-1.4-0.2l-0.2,1.6h-0.8l0.4-2.4L473,659.9z"
                />
                <path
                  className="st15"
                  d="M468.9,655c0.2-1.6,1.6-2.7,3.2-2.6s2.7,1.6,2.6,3.2c-0.2,1.6-1.6,2.7-3.2,2.6c0,0,0,0-0.1,0
		c-1.5-0.1-2.6-1.4-2.5-2.8C468.9,655.2,468.9,655.1,468.9,655z M473.9,655.7c0.1-1.1-0.7-2.1-1.8-2.2c0,0-0.1,0-0.1,0
		c-1-0.2-2,0.4-2.3,1.4c0,0.1,0,0.1,0,0.2c-0.2,1,0.4,2,1.5,2.3c0.1,0,0.2,0,0.3,0c1.1,0.2,2.1-0.5,2.4-1.5
		C473.9,655.8,473.9,655.8,473.9,655.7z"
                />
                <path
                  className="st15"
                  d="M471.2,650.1l4.1,0.6v0.8l-5.6-0.8v-0.6l4.5-2.7l-4-0.6V646l5.5,0.8v0.6L471.2,650.1z"
                />
                <path
                  className="st15"
                  d="M475.1,642c0.5-0.3,0.8-0.8,0.9-1.3c0.1-0.5-0.2-1-0.7-1.1c0,0,0,0,0,0c-0.8-0.1-1.1,1.1-1.7,1.7
		c-0.3,0.4-0.8,0.6-1.3,0.5c-0.8-0.1-1.4-0.9-1.2-1.7c0,0,0,0,0-0.1c0.1-0.5,0.4-1.1,0.7-1.5l0.6,0.6c-0.3,0.3-0.5,0.6-0.6,0.9
		c0,0.5,0.2,1,0.6,1.1s1.1-1.1,1.6-1.7c0.3-0.5,0.9-0.7,1.4-0.6c0.9,0.1,1.6,1,1.4,1.9c0,0,0,0,0,0.1c-0.1,0.7-0.6,1.4-1.2,1.8
		L475.1,642z"
                />
                <path
                  className="st15"
                  d="M471.5,637.4l0.6-3.8h0.7l-0.2,1.5l4.8,0.7v0.8l-4.8-0.7l-0.2,1.5H471.5z"
                />
                <path
                  className="st15"
                  d="M475.3,631.8l2.6,0.3v0.8l-5.5-0.8l0.3-1.9c0-0.4,0.1-0.7,0.4-1c0.4-0.3,0.8-0.5,1.3-0.4
		c0.7,0.1,1.2,0.7,1.2,1.4l2.9-1.6v0.9l-2.9,1.6L475.3,631.8z M474.7,630.6c0.1-0.4,0-0.6-0.1-0.7c-0.1-0.2-0.3-0.3-0.5-0.3h-0.5
		c-0.2,0.2-0.3,0.4-0.3,0.7l-0.2,1.1l1.5,0.2L474.7,630.6z"
                />
                <path
                  className="st15"
                  d="M475.6,624.2h0.8l-0.3,1.8l1.9,0.3l0.3-2.5h0.8l-0.5,3.3l-5.5-0.8l0.4-3.2h0.8l-0.3,2.4l1.4,0.2L475.6,624.2z
		"
                />
                <path
                  className="st15"
                  d="M476.3,619.3h0.8l-0.3,1.8l1.9,0.3l0.3-2.4h0.8l-0.5,3.2l-5.5-0.8l0.4-3.2l0.8,0.2l-0.3,2.3l1.4,0.2
		L476.3,619.3z"
                />
                <path
                  className="st15"
                  d="M474.4,617.3l0.6-3.8h0.7l-0.2,1.5l4.8,0.7v0.8l-4.8-0.7l-0.2,1.5H474.4z"
                />
                <path
                  className="st15"
                  d="M362.8,612l2.6,0.3v0.8l-5.6-0.6l0.2-1.9c0-0.4,0.1-0.8,0.4-1.1c0.3-0.3,0.8-0.4,1.2-0.4
		c0.5,0,0.9,0.3,1.1,0.7c0.1,0.2,0.2,0.4,0.2,0.6l2.9-1.7v1l-2.8,1.7L362.8,612z M362.2,610.8c0-0.2-0.1-0.5-0.2-0.7l-0.5-0.2
		c-0.2,0-0.4,0-0.5,0.2c-0.2,0.2-0.3,0.4-0.3,0.6v1.1l1.5,0.2V610.8z"
                />
                <path
                  className="st15"
                  d="M360.5,604.7c0.1-1.5,1.4-2.6,2.9-2.5c0.1,0,0.2,0,0.2,0c1.5,0.1,2.7,1.4,2.6,3c0,0,0,0,0,0
		c-0.1,1.5-1.4,2.6-2.9,2.5c-0.1,0-0.2,0-0.2,0c-1.4,0-2.6-1.1-2.6-2.6C360.5,605,360.5,604.8,360.5,604.7z M365.4,605.2
		c0.1-1.2-0.7-2.2-1.9-2.3c-1.2-0.1-2.2,0.7-2.3,1.9l0,0c-0.1,1.2,0.7,2.2,1.9,2.3C364.3,607.2,365.3,606.4,365.4,605.2z"
                />
                <path
                  className="st15"
                  d="M364.1,598.8l2.6,0.3v0.8l-2.5-0.3l-3.2,1.7v-0.9l2.4-1.2l-2.1-1.7v-0.8L364.1,598.8z"
                />
                <path
                  className="st15"
                  d="M365.8,593.2l-0.2,2.4l1.4,0.7v0.8l-5.4-2.8v-0.6l5.8-1.8v0.9L365.8,593.2z M364.9,595.2v-1.8l-2.1,0.7
		L364.9,595.2z"
                />
                <path
                  className="st15"
                  d="M366.8,589.7l0.2-2.5h0.8l-0.3,3.3l-5.6-0.6v-0.8L366.8,589.7z"
                />
                <path
                  className="st15"
                  d="M365.8,582.1l2.5,0.2v0.8l-5.6-0.5l0.2-2.2c0-0.4,0.2-0.8,0.5-1.1c0.3-0.3,0.8-0.5,1.2-0.4
		c0.5,0,0.9,0.2,1.2,0.6c0.2,0.4,0.3,0.8,0.2,1.2L365.8,582.1z M365.2,580.7c0-0.3-0.1-0.6-0.2-0.8l-0.5-0.2h-0.6
		c-0.2,0.2-0.3,0.5-0.3,0.8v1.2l1.5,0.2L365.2,580.7z"
                />
                <path
                  className="st15"
                  d="M367.5,575.2l-0.2,2.3l1.4,0.7v0.9l-5.4-2.9v-0.5l5.8-1.8v0.8L367.5,575.2z M366.6,577.1v-1.7l-2.1,0.7
		L366.6,577.1z"
                />
                <path
                  className="st15"
                  d="M366.6,571.5l2.7,0.2v0.8l-5.6-0.5l0.2-1.9c0-0.4,0.2-0.8,0.4-1.1c0.3-0.3,0.8-0.5,1.2-0.4
		c0.4,0,0.8,0.2,1.1,0.6c0.2,0.2,0.2,0.4,0.3,0.7l2.8-1.8v1l-2.8,1.7L366.6,571.5z M366,570.3c0-0.4,0-0.6-0.2-0.7
		c-0.1-0.1-0.2-0.2-0.4-0.2c-0.2-0.1-0.4,0-0.6,0.1c-0.2,0.2-0.2,0.4-0.2,0.7v1.1h1.4L366,570.3z"
                />
                <path
                  className="st15"
                  d="M368.6,563.5l-0.2,2.3l1.4,0.8v0.8l-5.4-2.8V564l5.8-1.8v0.8L368.6,563.5z M367.7,565.5v-1.8l-2.1,0.7
		L367.7,565.5z"
                />
                <path
                  className="st15"
                  d="M370.3,560.9l-5.6-0.6l0.2-1.6c0-0.7,0.3-1.4,0.7-1.9c1.1-1.2,2.9-1.2,4.1-0.1c0.1,0.1,0.3,0.3,0.4,0.5
		c0.3,0.6,0.4,1.3,0.3,2L370.3,560.9z M366.2,557.2c-0.4,0.5-0.6,1-0.6,1.6v0.8l4,0.4v-0.8c0.3-1.1-0.4-2.2-1.4-2.4
		c-0.1,0-0.2-0.1-0.4-0.1C367.2,556.6,366.6,556.8,366.2,557.2L366.2,557.2z"
                />
                <path
                  className="st15"
                  d="M367.7,551.6h0.8l-0.2,1.8l1.9,0.2l0.2-2.5h0.8l-0.3,3.3l-5.6-0.6l0.3-3.1h0.8l-0.3,2.4l1.5,0.2L367.7,551.6z
		"
                />
                <path
                  className="st15"
                  d="M784.8,655.8l-0.4,3.1l2.6,0.3v0.8l-5.6-0.8v-0.8l2.2,0.3l0.5-3l-2.2-0.4v-0.7l5.5,0.8v0.7L784.8,655.8z"
                />
                <path
                  className="st15"
                  d="M782.5,650.2c0.3-1.6,1.7-2.6,3.3-2.4c1.5,0.2,2.6,1.7,2.4,3.2c-0.2,1.5-1.7,2.6-3.2,2.4
		C783.4,653.2,782.3,651.8,782.5,650.2z M787.5,650.9c0.2-1.1-0.6-2.1-1.7-2.3c0,0-0.1,0-0.1,0c-1.1-0.2-2.2,0.6-2.4,1.7
		c-0.2,1.1,0.6,2.1,1.7,2.3c0,0,0.1,0,0.1,0C786.2,652.8,787.3,652,787.5,650.9z"
                />
                <path
                  className="st15"
                  d="M788.8,646.6l-5.6-0.8l0.3-1.6c0-0.7,0.3-1.3,0.8-1.8c0.6-0.6,1.5-0.9,2.4-0.8c0.9,0.1,1.7,0.6,2.1,1.4
		c0.3,0.6,0.4,1.3,0.2,2L788.8,646.6z M784.9,642.8c-0.4,0.4-0.6,0.9-0.7,1.5v0.9l4,0.5l0.2-0.8c0.2-1.1-0.5-2.2-1.6-2.5
		c0,0,0,0-0.1,0C786.1,642.2,785.4,642.4,784.9,642.8L784.9,642.8z"
                />
                <path
                  className="st15"
                  d="M789.7,640.4l-5.6-0.8l0.3-1.7c0-0.7,0.3-1.3,0.8-1.8c0.6-0.6,1.5-0.9,2.4-0.8c0.9,0.2,1.6,0.7,2.1,1.4
		c0.3,0.6,0.4,1.3,0.2,2L789.7,640.4z M785.8,636.6c-0.4,0.4-0.7,0.9-0.7,1.5v0.8l4,0.6l0.2-0.8c0.1-0.6,0-1.2-0.3-1.7
		c-0.3-0.5-0.8-0.8-1.4-0.9C787,636,786.3,636.2,785.8,636.6L785.8,636.6z"
                />
                <path
                  className="st15"
                  d="M789.9,633.2l0.4-2.4h0.8l-0.5,3.2l-5.6-0.8l0.2-0.8L789.9,633.2z"
                />
                <path
                  className="st15"
                  d="M788.3,626.3h0.7l-0.2,1.9l1.8,0.2l0.4-2.4h0.7l-0.4,3.2l-5.6-0.8l0.5-3.1h0.7l-0.3,2.3l1.4,0.2L788.3,626.3z
		"
                />
                <path
                  className="st15"
                  d="M791,621.7c0.4-0.3,0.7-0.7,0.9-1.2c0-0.6-0.2-1.1-0.7-1.1s-1.1,1-1.7,1.7c-0.3,0.4-0.8,0.6-1.3,0.5
		c-0.9-0.1-1.5-1-1.3-1.8c0,0,0,0,0-0.1c0.1-0.5,0.4-1,0.8-1.4l0.5,0.6c-0.3,0.2-0.5,0.5-0.5,0.9c-0.1,0.4,0.1,0.9,0.6,1
		c0,0,0,0,0,0c0.7,0.1,1-1,1.6-1.7c0.3-0.4,0.9-0.6,1.4-0.5c0.9,0.1,1.5,1,1.3,1.8c0,0,0,0,0,0.1c-0.1,0.8-0.5,1.4-1.2,1.8
		L791,621.7z"
                />
                <path
                  className="st15"
                  d="M787.4,617.1l0.5-3.8h0.8l-0.2,1.5l4.7,0.7v0.8l-4.8-0.7l-0.2,1.5H787.4z"
                />
                <path
                  className="st15"
                  d="M791.2,611.5l2.6,0.4v0.8l-5.6-0.8l0.3-1.9c0-0.4,0.2-0.8,0.5-1.1c0.3-0.3,0.8-0.4,1.2-0.4
		c0.5,0.1,0.9,0.4,1.1,0.8c0.1,0.2,0.2,0.4,0.2,0.6l2.9-1.6v1l-2.9,1.6L791.2,611.5z M790.6,610.3c0-0.2,0-0.5-0.1-0.7l-0.5-0.3
		l-0.5,0.2c-0.2,0.1-0.3,0.4-0.3,0.6l-0.2,1.1l1.4,0.2L790.6,610.3z"
                />
                <path
                  className="st15"
                  d="M791.5,603.9h0.7l-0.2,1.9l1.8,0.2l0.4-2.4h0.7l-0.4,3.2l-5.6-0.8l0.5-3.1h0.7l-0.3,2.4l1.4,0.2L791.5,603.9z
		"
                />
                <path
                  className="st15"
                  d="M792.2,599.1h0.7l-0.2,1.8l1.8,0.3l0.4-2.5h0.7l-0.4,3.3l-5.6-0.8l0.5-3.2h0.7l-0.3,2.4l1.4,0.2L792.2,599.1z
		"
                />
                <path
                  className="st15"
                  d="M790.3,597.1l0.5-3.8h0.8l-0.3,1.5l4.8,0.7v0.8l-4.8-0.7l-0.2,1.5H790.3z"
                />
                <path
                  className="st15"
                  d="M749.3,257.9c0.5-0.2,0.8-0.7,0.9-1.2c0.1-0.5-0.2-1-0.7-1.1c-0.9-0.1-1.1,1-1.7,1.7
		c-0.3,0.4-0.8,0.6-1.3,0.5c-0.8-0.2-1.4-0.9-1.3-1.8c0.1-0.6,0.4-1.1,0.8-1.5l0.5,0.6c-0.3,0.2-0.5,0.5-0.5,0.9
		c-0.1,0.5,0.1,1,0.6,1.1c0.7,0.1,1-1.1,1.6-1.7c0.3-0.5,0.9-0.7,1.4-0.6c0.9,0.2,1.5,1.1,1.3,2c-0.1,0.8-0.5,1.4-1.2,1.8
		L749.3,257.9z"
                />
                <path
                  className="st15"
                  d="M745.7,253.4l0.5-3.8h0.8l-0.2,1.5l4.8,0.7l-0.2,0.8l-4.8-0.7l-0.2,1.5H745.7z"
                />
                <path
                  className="st15"
                  d="M752,241.7c0.6,0.6,0.9,1.5,0.8,2.3c-0.2,1.6-1.7,2.7-3.2,2.5c0,0,0,0-0.1,0c-1.5-0.1-2.6-1.5-2.4-2.9
		c0-0.1,0-0.2,0-0.3c0.1-0.8,0.5-1.5,1.1-1.9l0.4,0.6c-0.5,0.3-0.7,0.8-0.8,1.4c-0.1,1.2,0.7,2.2,1.8,2.4c1.2,0.1,2.2-0.7,2.4-1.9
		c0.1-0.5,0-1-0.3-1.4l-1.4-0.2l-0.3,1.5h-0.7l0.3-2.3L752,241.7z"
                />
                <path
                  className="st15"
                  d="M750.3,236.9h0.7l-0.2,1.9l1.8,0.2l0.4-2.4h0.7l-0.4,3.2l-5.6-0.8l0.5-3.1h0.7l-0.3,2.3l1.4,0.2L750.3,236.9z
		"
                />
                <path
                  className="st15"
                  d="M748.6,232.2c0.3-1.6,1.7-2.6,3.3-2.4c1.5,0.1,2.6,1.5,2.4,2.9c0,0.1,0,0.2,0,0.3c-0.2,1.5-1.6,2.6-3.1,2.4
		c0,0,0,0-0.1,0C749.6,235.1,748.5,233.8,748.6,232.2z M753.6,232.9c0.2-1.1-0.6-2.1-1.7-2.3c0,0-0.1,0-0.1,0
		c-1.1-0.2-2.1,0.5-2.4,1.5c0,0.1,0,0.1,0,0.2c-0.2,1.1,0.6,2.1,1.7,2.3c0,0,0.1,0,0.1,0C752.3,234.8,753.4,234,753.6,232.9z"
                />
                <path
                  className="st15"
                  d="M752.4,227.5l2.6,0.3v0.8l-5.6-0.8l0.3-1.9c0.1-0.4,0.2-0.7,0.5-1c0.3-0.3,0.8-0.5,1.2-0.4
		c0.5,0,0.9,0.3,1.1,0.7c0.1,0.2,0.2,0.5,0.2,0.7l2.9-1.6v0.9l-2.9,1.6L752.4,227.5z M751.8,226.2c0.1-0.2,0-0.5-0.1-0.7l-0.5-0.2
		c-0.2-0.1-0.4,0-0.5,0.1c-0.2,0.1-0.3,0.4-0.3,0.6l-0.2,1.1l1.4,0.2L751.8,226.2z"
                />
                <path
                  className="st15"
                  d="M755.4,218.4c0.5,0.6,0.8,1.5,0.7,2.3c-0.1,1.5-1.5,2.7-3,2.5c-0.1,0-0.2,0-0.3,0c-1.5-0.2-2.6-1.6-2.4-3.1
		c0,0,0,0,0-0.1c0.1-0.8,0.5-1.5,1.1-1.9l0.5,0.6c-0.5,0.3-0.8,0.8-0.9,1.4c-0.1,1.1,0.8,2.1,1.9,2.3c1.1,0.2,2.2-0.6,2.4-1.8
		c0,0,0,0,0,0c0-0.5-0.1-1-0.4-1.4l-1.4-0.2l-0.2,1.6h-0.8l0.4-2.4L755.4,218.4z"
                />
                <path
                  className="st15"
                  d="M753.6,213.6l0.8,0.2l-0.3,1.8l1.9,0.2l0.3-2.4h0.8l-0.5,3.2l-5.5-0.8l0.4-3.1h0.8l-0.4,2.4l1.4,0.2
		L753.6,213.6z"
                />
                <path
                  className="st15"
                  d="M755.9,211.6c0.5-0.2,0.8-0.7,0.9-1.2c0.1-0.6-0.2-1.1-0.7-1.1s-1.1,1-1.7,1.7c-0.3,0.4-0.8,0.6-1.3,0.5
		c-0.8-0.1-1.4-0.9-1.2-1.7c0-0.1,0-0.1,0-0.2c0.1-0.5,0.4-1,0.8-1.4l0.5,0.6c-0.3,0.2-0.5,0.5-0.6,0.9c0,0.5,0.3,0.9,0.7,1
		c0.7,0.1,1-1,1.6-1.7c0.3-0.4,0.8-0.6,1.3-0.5c0.9,0.1,1.5,0.9,1.4,1.8c0,0,0,0.1,0,0.1c-0.1,0.7-0.6,1.4-1.2,1.8L755.9,211.6z"
                />
                <path
                  className="st15"
                  d="M755.9,203.2l2.6,0.3v0.8l-5.6-0.8l0.3-1.9c0.1-0.4,0.2-0.7,0.5-1c0.3-0.3,0.8-0.5,1.2-0.4
		c0.7,0.1,1.3,0.7,1.3,1.4l2.8-1.6v0.9l-2.9,1.6L755.9,203.2z M755.3,202c0-0.4,0-0.6-0.1-0.7c-0.1-0.2-0.3-0.3-0.5-0.3h-0.5
		c-0.2,0.1-0.3,0.4-0.3,0.6l-0.2,1.2l1.4,0.2L755.3,202z"
                />
                <path
                  className="st15"
                  d="M753.9,195.7c0.2-1.5,1.5-2.5,3-2.3c0.1,0,0.1,0,0.2,0c1.5,0.2,2.7,1.5,2.5,3.1c0,0,0,0,0,0
		c-0.3,1.6-1.7,2.6-3.3,2.4C754.8,198.7,753.7,197.3,753.9,195.7C753.9,195.7,753.9,195.7,753.9,195.7z M758.8,196.4
		c0.2-1-0.5-2-1.6-2.2c-0.1,0-0.2,0-0.2,0c-1.1-0.2-2.1,0.4-2.4,1.5c0,0,0,0.1,0,0.1c-0.1,1.1,0.7,2.1,1.8,2.3
		c1,0.3,2.1-0.3,2.3-1.3C758.8,196.7,758.8,196.5,758.8,196.4L758.8,196.4z"
                />
                <path
                  className="st15"
                  d="M759.1,189l-0.3,2.4l1.3,0.7v0.9l-5.2-3.1v-0.6l5.9-1.5l-0.2,0.9L759.1,189z M758.1,190.9l0.2-1.7l-2.2,0.6
		L758.1,190.9z"
                />
                <path
                  className="st15"
                  d="M760.9,186.5l-5.5-0.8l0.2-1.7c0.1-0.7,0.4-1.3,0.8-1.8c0.6-0.6,1.5-0.9,2.4-0.8c0.9,0.1,1.7,0.6,2.1,1.4
		c0.3,0.6,0.4,1.3,0.3,2L760.9,186.5z M757.1,182.7c-0.5,0.4-0.7,0.9-0.7,1.5v0.8l4,0.6v-0.9c0.1-0.5,0-1.1-0.2-1.6
		c-0.3-0.5-0.9-0.8-1.5-0.9C758.1,182.1,757.5,182.3,757.1,182.7L757.1,182.7z"
                />
                <path
                  className="st15"
                  d="M836.3,289l-0.4,3l2.6,0.4l-0.2,0.8l-5.5-0.8v-0.8l2.2,0.3l0.4-3l-2.1-0.4v-0.8l5.5,0.8v0.8L836.3,289z"
                />
                <path
                  className="st15"
                  d="M833.8,285.7v-0.8l5.5,0.8v0.8L833.8,285.7z"
                />
                <path
                  className="st15"
                  d="M839.4,279c0.6,0.6,0.9,1.5,0.7,2.3c-0.1,1.5-1.5,2.6-2.9,2.4c-0.1,0-0.2,0-0.3,0c-1.5-0.1-2.7-1.5-2.5-3.1
		c0,0,0-0.1,0-0.1c0.1-0.8,0.6-1.4,1.2-1.9l0.4,0.6c-0.4,0.4-0.7,0.9-0.8,1.4c-0.2,1.1,0.6,2.2,1.8,2.4c0,0,0,0,0,0
		c1.1,0.2,2.2-0.6,2.4-1.8c0,0,0,0,0,0c0.1-0.5,0-1-0.3-1.5l-1.5-0.2l-0.2,1.6h-0.7l0.3-2.4L839.4,279z"
                />
                <path
                  className="st15"
                  d="M838.6,273l-0.5,3.1l2.7,0.4l-0.2,0.8l-5.5-0.8v-0.8l2.2,0.3l0.4-3.1l-2.1-0.3v-0.8l5.5,0.8v0.8L838.6,273z"
                />
                <path
                  className="st15"
                  d="M840.6,267.8c0.5-0.3,0.8-0.8,0.9-1.3c0.1-0.5-0.2-1-0.7-1.1c0,0,0,0,0,0c-0.8-0.1-1.1,1.1-1.7,1.7
		c-0.3,0.4-0.8,0.6-1.3,0.6c-0.9-0.2-1.4-1-1.2-1.9c0-0.5,0.3-1,0.7-1.4l0.5,0.5c-0.2,0.3-0.4,0.6-0.5,0.9c-0.1,0.5,0.1,1,0.6,1.1
		c0.7,0.1,1.1-1.1,1.6-1.7c0.3-0.5,0.9-0.7,1.4-0.6c0.9,0.1,1.6,1,1.4,1.9c0,0,0,0,0,0.1c-0.2,0.7-0.6,1.4-1.2,1.8L840.6,267.8z"
                />
                <path
                  className="st15"
                  d="M837,263.2l0.6-3.8h0.7l-0.2,1.5l4.8,0.7v0.8l-4.8-0.7l-0.2,1.5H837z"
                />
                <path
                  className="st15"
                  d="M840.8,257.6l2.6,0.4v0.8l-5.5-0.8l0.2-2c0.1-0.4,0.2-0.7,0.5-1c0.3-0.3,0.8-0.5,1.2-0.4
		c0.7,0.1,1.2,0.7,1.2,1.4l2.9-1.6v1L841,257L840.8,257.6z M840.2,256.4c0.1-0.4,0-0.6-0.1-0.7c-0.1-0.2-0.3-0.3-0.5-0.3h-0.5
		c-0.2,0.1-0.3,0.3-0.3,0.7l-0.2,1.1l1.5,0.2L840.2,256.4z"
                />
                <path
                  className="st15"
                  d="M841.1,250h0.8l-0.3,1.8l1.9,0.3l0.3-2.5h0.8l-0.5,3.3l-5.5-0.8l0.4-3.2h0.8l-0.4,2.4l1.5,0.2L841.1,250z"
                />
                <path
                  className="st15"
                  d="M841.8,245.1h0.8l-0.3,1.9l1.9,0.2l0.3-2.4h0.8l-0.5,3.2l-5.5-0.8l0.4-3.1h0.8l-0.4,2.3l1.5,0.2L841.8,245.1z
		"
                />
                <path
                  className="st15"
                  d="M839.9,243.1l0.5-3.8l0.8,0.2L841,241l4.8,0.6l-0.2,0.8l-4.7-0.6l-0.3,1.5L839.9,243.1z"
                />
                <path
                  className="st15"
                  d="M204.1,497.9l-0.5,0.5l-1.3-1.3l-1.9,1.9l-0.5-0.6l3.9-4l2.3,2.3l-0.6,0.5l-1.6-1.7l-1.1,1.1L204.1,497.9z"
                />
                <path
                  className="st15"
                  d="M204.3,501.7l1.7,1.8l-0.5,0.5l-2.3-2.3l3.9-3.9l0.6,0.5L204.3,501.7z"
                />
                <path
                  className="st15"
                  d="M210.8,504.6l-0.6,0.5l-1.3-1.3l-1.3,1.3l1.8,1.8l-0.6,0.5l-2.3-2.3l4-4l2.2,2.3l-0.5,0.5l-1.7-1.7l-1,1.1
		L210.8,504.6z"
                />
                <path
                  className="st15"
                  d="M212.9,509.9l-0.4-0.4l0.7-3l-2.7,2.6l-0.5-0.5l3.9-4l0.4,0.4l-0.9,4l4-0.9l0.4,0.4l-4,3.9l-0.6-0.5l2.7-2.7
		L212.9,509.9z"
                />
                <path
                  className="st15"
                  d="M219.2,509.9l0.6,0.6l-4,3.9l-0.5-0.5L219.2,509.9z"
                />
                <path
                  className="st15"
                  d="M220.7,513.6l-2.9,2.9l-0.5-0.6l3.9-4l0.4,0.4l-0.5,5.3l2.9-2.9l0.5,0.6l-3.9,3.9l-0.4-0.4L220.7,513.6z"
                />
                <path
                  className="st15"
                  d="M226,523.3c-0.8,0.1-1.7-0.2-2.3-0.8c-1.1-1.1-1.2-2.8-0.1-4c0,0,0.1-0.1,0.1-0.1c1.1-1.1,2.9-1.1,4,0
		c0,0,0,0,0,0c0.6,0.5,0.9,1.2,0.9,2h-0.8c0-0.6-0.2-1.1-0.6-1.5c-0.8-0.8-2.1-0.8-2.8,0c0,0,0,0.1-0.1,0.1c-0.9,0.8-0.9,2.1-0.1,3
		c0,0,0,0,0,0c0.4,0.3,0.9,0.6,1.4,0.6l1-1l-1.1-1.2l0.5-0.5l1.7,1.7L226,523.3z"
                />
                <path
                  className="st15"
                  d="M230,520.8l2.7,2.7l-0.5,0.6l-1.1-1.1l-3.4,3.4l-0.6-0.6l3.5-3.4l-1.1-1.1L230,520.8z"
                />
                <path
                  className="st15"
                  d="M235.3,526c1.1,1.2,1.1,3-0.1,4.1c-1.1,1.1-2.9,1.1-4,0c-1.1-1.2-1.1-3,0.1-4.1
		C232.4,524.9,234.2,524.9,235.3,526C235.3,526,235.3,526,235.3,526z M231.7,529.5c0.8,0.8,2.2,0.8,3-0.1c0,0,0,0,0,0
		c0.8-0.8,0.8-2.1,0.1-2.9c-0.9-0.8-2.2-0.7-3,0.1C231,527.4,231,528.7,231.7,529.5z"
                />
                <path
                  className="st15"
                  d="M237.8,530.8l-2.9,2.9l-0.5-0.6l3.9-3.9l0.4,0.4l-0.5,5.2l2.9-2.8l0.6,0.5l-4,4l-0.4-0.4L237.8,530.8z"
                />
                <path
                  className="st15"
                  d="M243.5,538.6l-1.9,1.8l-0.5-0.5l3.9-4l1.4,1.4c0.3,0.3,0.5,0.6,0.6,1c0.1,0.5-0.1,0.9-0.5,1.2
		c-0.3,0.4-0.8,0.5-1.2,0.4c-0.2,0-0.4,0-0.6-0.2l-0.5,3.3l-0.7-0.7l0.5-3.3L243.5,538.6z M244.8,538.8c0.3,0.3,0.5,0.4,0.7,0.4
		l0.5-0.2c0.1-0.2,0.2-0.4,0.2-0.6c-0.1-0.2-0.2-0.4-0.3-0.6l-0.8-0.8l-1.1,1L244.8,538.8z"
                />
                <path
                  className="st15"
                  d="M250.7,541.5c1.1,1.1,1.1,3,0,4.1c-1.1,1.1-3,1.1-4.1,0c-1.1-1.1-1.1-3,0-4.1c0,0,0,0,0,0
		c1.1-1.1,2.8-1.2,4-0.1C250.6,541.4,250.7,541.5,250.7,541.5z M247.1,545c0.8,0.9,2.1,0.9,3,0.2s0.9-2.1,0.2-3
		c-0.8-0.9-2.1-0.9-3-0.2c0,0,0,0-0.1,0.1C246.4,542.8,246.3,544.1,247.1,545C247.1,544.9,247.1,545,247.1,545L247.1,545z"
                />
                <path
                  className="st15"
                  d="M252.8,549.7l-1.6-1.7l-1.5,0.6l-0.5-0.6l5.6-2.3l0.4,0.4l-2.4,5.6l-0.6-0.6L252.8,549.7z M251.9,547.7
		l1.3,1.2l0.8-2.1L251.9,547.7z"
                />
                <path
                  className="st15"
                  d="M253.8,552.7l4-4l1.1,1.2c0.5,0.5,0.9,1.1,1,1.8c0.1,0.9-0.2,1.7-0.8,2.3c-0.6,0.7-1.5,1-2.4,0.9
		c-0.7-0.1-1.3-0.5-1.7-1L253.8,552.7z M259.2,551.9c-0.1-0.6-0.4-1.1-0.8-1.5l-0.6-0.6l-2.9,2.9l0.6,0.6c0.3,0.5,0.8,0.8,1.4,0.8
		c0.6,0,1.2-0.2,1.6-0.6C259,553.1,259.2,552.5,259.2,551.9z"
                />
                <path
                  className="st15"
                  d="M1225.3,641.3l2.5,0.4v0.8l-5.6-0.8l0.4-2.1c0-0.4,0.1-0.9,0.5-1.1c0.3-0.3,0.8-0.5,1.3-0.4
		c0.4,0.1,0.8,0.4,1,0.7c0.2,0.4,0.3,0.8,0.2,1.2L1225.3,641.3z M1224.8,640c0-0.4,0-0.6-0.2-0.8c-0.1-0.2-0.3-0.3-0.5-0.3h-0.5
		c-0.2,0.2-0.4,0.4-0.4,0.7l-0.2,1.3l1.6,0.2L1224.8,640z"
                />
                <path
                  className="st15"
                  d="M1226,636l2.6,0.4v0.8l-5.6-0.9l0.3-1.9c0.1-0.4,0.2-0.7,0.5-1c0.3-0.3,0.8-0.5,1.2-0.4
		c0.7,0.1,1.3,0.7,1.3,1.4l2.9-1.6v1l-2.9,1.5L1226,636z M1225.4,634.8c0.1-0.4,0-0.6-0.1-0.7c-0.1-0.2-0.3-0.3-0.5-0.3h-0.5
		c-0.2,0.1-0.3,0.4-0.3,0.6l-0.2,1.2l1.4,0.2L1225.4,634.8z"
                />
                <path
                  className="st15"
                  d="M1223.8,630.7v-0.8l5.6,0.8l-0.2,0.8L1223.8,630.7z"
                />
                <path
                  className="st15"
                  d="M1225.8,627.3l4.1,0.6v0.8l-5.6-0.8v-0.6l4.6-2.7l-4.1-0.6v-0.8l5.6,0.8v0.6L1225.8,627.3z"
                />
                <path
                  className="st15"
                  d="M1225.5,618.8c0.1-0.8,0.6-1.5,1.2-1.9l0.4,0.6c-0.4,0.3-0.7,0.8-0.8,1.4c-0.2,1.1,0.6,2.1,1.7,2.3
		c0,0,0.1,0,0.1,0c1.1,0.2,2.1-0.5,2.4-1.5c0-0.1,0-0.1,0-0.2c0.1-0.6-0.2-1.3-0.6-1.7l0.6-0.5c0.6,0.6,0.8,1.5,0.7,2.3
		c-0.4,1.5-2,2.5-3.6,2C1226.4,621.3,1225.5,620.1,1225.5,618.8L1225.5,618.8z"
                />
                <path
                  className="st15"
                  d="M1228.7,612.8l0.8,0.2l-0.3,1.8l1.9,0.3l0.3-2.5h0.8l-0.5,3.3l-5.5-0.9l0.4-3.1h0.8l-0.4,2.4l1.4,0.2
		L1228.7,612.8z"
                />
                <path
                  className="st15"
                  d="M1231,610.8c0.5-0.2,0.9-0.7,1-1.2c0.1-0.5-0.2-1-0.7-1.1c-0.9-0.1-1.1,1-1.7,1.7c-0.4,0.4-0.9,0.6-1.4,0.5
		c-0.9-0.2-1.4-1-1.2-1.9c0.1-0.5,0.4-1,0.8-1.4l0.5,0.5c-0.3,0.2-0.5,0.6-0.5,1c-0.1,0.4,0.1,0.9,0.6,1c0,0,0,0,0,0
		c0.7,0.1,1-1,1.6-1.7c0.3-0.4,0.9-0.6,1.4-0.5c0.9,0.1,1.5,1,1.3,1.8c0,0,0,0,0,0.1c-0.1,0.8-0.5,1.4-1.2,1.8L1231,610.8z"
                />
                <path
                  className="st15"
                  d="M1231.8,606.1c0.4-0.3,0.7-0.7,0.9-1.2c0.1-0.6-0.2-1.1-0.7-1.1s-1.1,1-1.7,1.7c-0.3,0.4-0.8,0.6-1.3,0.5
		c-0.9-0.2-1.4-1-1.3-1.9c0.1-0.6,0.4-1.1,0.8-1.4l0.5,0.5c-0.3,0.2-0.5,0.6-0.5,1c-0.1,0.4,0.1,0.9,0.6,1c0,0,0,0,0,0
		c0.7,0.1,1-1.1,1.6-1.7c0.4-0.4,0.9-0.6,1.4-0.5c0.8,0.1,1.4,0.8,1.3,1.6c0,0.1,0,0.2,0,0.3c-0.1,0.8-0.5,1.4-1.2,1.8L1231.8,606.1
		z"
                />
                <path
                  className="st15"
                  d="M1232.9,598.7c0.5-0.2,0.8-0.7,0.9-1.2c0.1-0.5-0.2-1-0.7-1.1c0,0,0,0,0,0c-0.8-0.1-1.1,1-1.7,1.7
		c-0.3,0.4-0.8,0.6-1.3,0.5c-0.8-0.1-1.4-0.9-1.2-1.7c0-0.1,0-0.1,0-0.2c0.1-0.5,0.3-1,0.7-1.4l0.5,0.6c-0.3,0.2-0.5,0.5-0.5,0.9
		c-0.1,0.4,0.1,0.9,0.6,1c0,0,0,0,0,0c0.7,0.1,1-1,1.6-1.7c0.4-0.4,0.9-0.6,1.4-0.5c0.8,0.1,1.4,0.8,1.4,1.6c0,0.1,0,0.3-0.1,0.4
		c-0.1,0.8-0.5,1.4-1.2,1.8L1232.9,598.7z"
                />
                <path
                  className="st15"
                  d="M1229.3,594.1l0.6-3.8h0.8l-0.3,1.5l4.8,0.8v0.8l-4.8-0.8l-0.2,1.5H1229.3z"
                />
                <path
                  className="st15"
                  d="M1233.2,588.6l2.6,0.3l-0.2,0.8l-5.5-0.8l0.3-1.9c0.1-0.4,0.3-0.8,0.5-1.1c0.3-0.3,0.8-0.4,1.2-0.3
		c0.5,0,0.9,0.3,1.1,0.7c0.1,0.2,0.2,0.5,0.2,0.7l2.9-1.6v0.9l-2.9,1.6L1233.2,588.6z M1232.6,587.3c0-0.2,0-0.5-0.1-0.7l-0.5-0.2
		c-0.2-0.1-0.4,0-0.5,0.1c-0.2,0.1-0.3,0.4-0.3,0.6l-0.2,1.1l1.4,0.2L1232.6,587.3z"
                />
                <path
                  className="st15"
                  d="M1233.5,581h0.8l-0.3,1.8l1.9,0.3l0.3-2.5h0.8l-0.5,3.3l-5.5-0.9l0.4-3.1h0.8l-0.4,2.4l1.5,0.2L1233.5,581z"
                />
                <path
                  className="st15"
                  d="M1234.3,576.1h0.7l-0.2,1.8l1.8,0.3l0.4-2.4h0.7l-0.5,3.2l-5.5-0.8l0.5-3.2h0.7l-0.3,2.4l1.4,0.2
		L1234.3,576.1z"
                />
                <path
                  className="st15"
                  d="M1232.3,574.1l0.6-3.8h0.8l-0.3,1.5l4.8,0.8v0.7l-4.8-0.7l-0.2,1.5H1232.3z"
                />
                <path
                  className="st15"
                  d="M1574.3,898.9l-5.5-0.8l0.3-1.9c0-0.4,0.1-0.9,0.5-1.1c0.3-0.3,0.7-0.4,1.1-0.3c0.4,0.1,0.7,0.3,1,0.6
		c0.3-0.5,0.9-0.8,1.5-0.7c0.5,0,1,0.3,1.2,0.8c0.2,0.4,0.3,0.9,0.2,1.3L1574.3,898.9z M1571.2,896.6c0.1-0.4,0-0.6-0.1-0.7
		c-0.1-0.2-0.3-0.3-0.5-0.3h-0.5c-0.2,0.2-0.3,0.4-0.3,0.7l-0.2,1l1.5,0.2L1571.2,896.6z M1573.8,896.8c0.1-0.5,0.1-0.8-0.1-1
		c-0.2-0.2-0.4-0.3-0.6-0.3c-0.2-0.1-0.5,0-0.7,0.1c-0.2,0.2-0.4,0.6-0.4,0.9l-0.2,1.2l1.9,0.3L1573.8,896.8z"
                />
                <path
                  className="st15"
                  d="M1574.6,892.8c-0.5,0.3-1.2,0.4-1.8,0.3l-3.2-0.5v-0.7l3.3,0.4c0.4,0.1,0.8,0,1.1-0.1
		c0.4-0.3,0.6-0.7,0.7-1.1c0.1-0.4,0-0.9-0.3-1.2c-0.3-0.4-0.7-0.6-1.1-0.6l-3.2-0.5v-0.7l3.2,0.4c0.6,0.1,1.2,0.4,1.6,0.9
		c0.4,0.5,0.5,1.2,0.4,1.8C1575.3,891.8,1575,892.4,1574.6,892.8z"
                />
                <path
                  className="st15"
                  d="M1573.6,885.8l2.6,0.4v0.8l-5.5-0.9l0.3-1.9c0-0.4,0.2-0.8,0.5-1c0.3-0.3,0.8-0.5,1.2-0.4
		c0.4,0,0.8,0.3,1,0.7c0.1,0.2,0.2,0.5,0.2,0.7l3-1.6l-0.2,1l-2.9,1.5L1573.6,885.8z M1573,884.5c0.1-0.2,0-0.4-0.1-0.6
		c-0.1-0.2-0.2-0.3-0.4-0.3c-0.2-0.1-0.4,0-0.6,0.1c-0.1,0.2-0.2,0.4-0.3,0.6l-0.2,1.1l1.5,0.3L1573,884.5z"
                />
                <path
                  className="st15"
                  d="M1571.4,880.5v-0.8l2.4,0.3l-2-2.6v-1.1l2.2,2.9l3.4-2.2v1l-3.2,2.1l2.8,0.4v0.8L1571.4,880.5z"
                />
                <path
                  className="st15"
                  d="M1574.9,872.4l0.7,0.2l-0.3,1.8l1.9,0.3l0.4-2.5h0.7l-0.5,3.3l-5.5-0.9l0.5-3.1h0.7l-0.3,2.3l1.4,0.3
		L1574.9,872.4z"
                />
                <path
                  className="st15"
                  d="M1576.5,866.8l2.6,0.4v0.8l-5.6-0.9l0.3-1.9c0.1-0.4,0.2-0.7,0.5-1c0.3-0.3,0.8-0.5,1.2-0.4
		c0.7,0.1,1.3,0.7,1.3,1.4l2.9-1.6v1l-2.9,1.5L1576.5,866.8z M1575.9,865.6c0.1-0.4,0-0.6-0.1-0.7c-0.1-0.2-0.3-0.3-0.5-0.3h-0.5
		c-0.2,0.1-0.3,0.4-0.3,0.6l-0.2,1.2l1.4,0.2L1575.9,865.6z"
                />
                <path
                  className="st15"
                  d="M1574.5,859.3c0.2-1.5,1.7-2.6,3.2-2.3c0,0,0.1,0,0.1,0c1.5,0.1,2.6,1.5,2.4,2.9c0,0.1,0,0.2,0,0.3
		c-0.1,1.4-1.4,2.5-2.8,2.4c-0.1,0-0.3,0-0.4-0.1c-1.5-0.1-2.7-1.5-2.5-3.1C1574.5,859.4,1574.5,859.3,1574.5,859.3z M1579.5,860.1
		c0.2-1.1-0.6-2.1-1.7-2.3c0,0-0.1,0-0.1,0c-1.1-0.2-2.1,0.4-2.4,1.5c0,0,0,0.1,0,0.1c-0.2,1,0.4,2,1.5,2.3c0.1,0,0.2,0,0.3,0
		C1578.2,861.9,1579.2,861.3,1579.5,860.1C1579.5,860.2,1579.5,860.1,1579.5,860.1z"
                />
                <path
                  className="st15"
                  d="M1579.8,852.7l-0.3,2.3l1.3,0.8v0.8l-5.2-3.1v-0.6l5.9-1.4l-0.2,0.8L1579.8,852.7z M1578.8,854.6l0.2-1.7
		l-2.2,0.5L1578.8,854.6z"
                />
                <path
                  className="st15"
                  d="M1581.7,850.1l-5.6-0.8l0.3-1.7c0.1-0.7,0.3-1.3,0.8-1.8c0.6-0.6,1.5-0.9,2.4-0.8c0.9,0.2,1.7,0.7,2.1,1.5
		c0.3,0.6,0.4,1.3,0.2,2L1581.7,850.1z M1577.8,846.3c-0.4,0.4-0.6,0.9-0.7,1.5v0.8l4,0.6l0.2-0.8c0.1-0.6,0-1.2-0.3-1.7
		c-0.3-0.5-0.8-0.8-1.4-0.9C1579,845.7,1578.3,845.9,1577.8,846.3L1577.8,846.3z"
                />
                <path
                  className="st15"
                  d="M1184.2,202.2c0.5,0.7,0.8,1.5,0.7,2.4c-0.2,1.5-1.6,2.6-3.1,2.4c-0.1,0-0.1,0-0.2,0
		c-1.5-0.2-2.6-1.6-2.4-3.1c0.1-0.8,0.5-1.5,1.2-2l0.4,0.6c-0.5,0.3-0.8,0.8-0.9,1.4c-0.2,1.2,0.5,2.4,1.7,2.6s2.4-0.5,2.6-1.7
		c0.1-0.6,0-1.3-0.4-1.8l-1.4-0.2l-0.2,1.6h-0.8l0.4-2.4L1184.2,202.2z"
                />
                <path
                  className="st15"
                  d="M1182.9,199.4l2.6,0.4v0.8l-5.5-0.9l0.3-1.9c0.1-0.5,0.2-0.8,0.5-1c0.3-0.3,0.8-0.5,1.2-0.4
		c0.4,0.1,0.8,0.3,1,0.7c0.2,0.2,0.2,0.4,0.2,0.7l3-1.6l-0.2,1l-2.9,1.6L1182.9,199.4z M1182.3,198.2c0.1-0.4,0.1-0.6-0.1-0.7
		s-0.2-0.3-0.4-0.3h-0.6c-0.2,0.2-0.3,0.4-0.3,0.7v1.1l1.4,0.2V198.2z"
                />
                <path
                  className="st15"
                  d="M1185.3,191.5l-0.3,2.4l1.3,0.7v0.9l-5.2-3.2v-0.5l5.9-1.5l-0.2,0.9L1185.3,191.5z M1184.3,193.4l0.2-1.7
		l-2.1,0.6L1184.3,193.4z"
                />
                <path
                  className="st15"
                  d="M1183.2,187.6l4.1,0.6v0.8l-5.6-0.9v-0.5l4.6-2.7l-4.1-0.6v-0.8l5.6,0.8v0.6L1183.2,187.6z"
                />
                <path
                  className="st15"
                  d="M1187.9,177.6c0.6,0.6,0.9,1.5,0.7,2.3c-0.1,1.5-1.5,2.6-2.9,2.4c-0.1,0-0.2,0-0.3,0
		c-1.5-0.1-2.7-1.5-2.5-3.1c0,0,0-0.1,0-0.1c0.1-0.8,0.6-1.5,1.2-1.9l0.4,0.6c-0.4,0.3-0.7,0.8-0.8,1.4c-0.2,1.1,0.6,2.1,1.7,2.3
		c0,0,0.1,0,0.1,0c1.1,0.2,2.2-0.6,2.4-1.7c0.1-0.5,0-1-0.3-1.5l-1.5-0.2l-0.2,1.6h-0.7l0.3-2.4L1187.9,177.6z"
                />
                <path
                  className="st15"
                  d="M1186.2,172.8h0.7l-0.2,1.8l1.8,0.3l0.4-2.5l0.7,0.2l-0.4,3.2l-5.6-0.8l0.5-3.2h0.7l-0.3,2.4l1.4,0.2
		L1186.2,172.8z"
                />
                <path
                  className="st15"
                  d="M1187.8,167.1l2.6,0.4v0.8l-5.5-0.8l0.3-2c0-0.4,0.1-0.7,0.4-1c0.4-0.3,0.8-0.4,1.3-0.4
		c0.4,0.1,0.8,0.4,1,0.7c0.1,0.2,0.2,0.5,0.2,0.7l3-1.5l-0.2,0.9l-2.9,1.6L1187.8,167.1z M1187.2,165.9c0.1-0.4,0-0.6-0.1-0.7
		c-0.1-0.2-0.3-0.3-0.5-0.3h-0.5c-0.1,0.2-0.2,0.5-0.3,0.7l-0.2,1.1l1.5,0.2L1187.2,165.9z"
                />
                <path
                  className="st15"
                  d="M1185.9,159.7c0.2-1.5,1.6-2.6,3.1-2.4c0,0,0,0,0.1,0c1.5,0.3,2.6,1.6,2.5,3.2c-0.3,1.6-1.7,2.6-3.3,2.4
		C1186.8,162.7,1185.7,161.3,1185.9,159.7C1185.9,159.7,1185.9,159.7,1185.9,159.7z M1190.8,160.4c0.2-1.1-0.6-2.1-1.7-2.3
		c0,0-0.1,0-0.1,0c-1.1-0.2-2.1,0.5-2.4,1.5c0,0.1,0,0.1,0,0.2c-0.2,1.1,0.6,2.1,1.7,2.3c0,0,0.1,0,0.1,0
		C1189.5,162.3,1190.6,161.5,1190.8,160.4z"
                />
                <path
                  className="st15"
                  d="M1191.2,153l-0.4,2.3l1.3,0.8v0.8l-5.2-3.1v-0.5l5.9-1.5v0.8L1191.2,153z M1190.1,154.9l0.3-1.7l-2.2,0.5
		L1190.1,154.9z"
                />
                <path
                  className="st15"
                  d="M1193,150.5l-5.5-0.9l0.2-1.6c0-0.7,0.3-1.4,0.8-1.9c0.6-0.6,1.5-0.9,2.4-0.7c0.9,0.1,1.7,0.6,2.1,1.4
		c0.3,0.6,0.4,1.3,0.2,2L1193,150.5z M1189.2,146.6c-0.5,0.4-0.7,0.9-0.7,1.5l-0.2,0.8l4.1,0.7v-0.9c0.1-0.5,0-1.1-0.2-1.6
		c-0.3-0.5-0.9-0.8-1.5-0.9C1190.2,146.1,1189.6,146.2,1189.2,146.6z"
                />
                <path
                  className="st15"
                  d="M1339.3,680.3l-2.8,1.4l1.2,2.3l-0.7,0.4l-2.5-5l0.7-0.4l1,2l2.8-1.4l-1-2l0.8-0.3l2.4,5l-0.7,0.4
		L1339.3,680.3z"
                />
                <path
                  className="st15"
                  d="M1340.6,676.4l0.7-0.4l2.5,5.1l-0.8,0.3L1340.6,676.4z"
                />
                <path
                  className="st15"
                  d="M1349.3,677.3c-0.2,0.8-0.7,1.5-1.5,1.9c-1.4,0.7-3.1,0.2-3.8-1.2c0,0,0,0,0-0.1c-0.7-1.4-0.3-3.1,1.1-3.8
		c0.1,0,0.1-0.1,0.2-0.1c0.7-0.3,1.5-0.4,2.2-0.1l-0.3,0.7c-0.5-0.2-1.1-0.2-1.6,0.1c-1,0.5-1.4,1.8-0.9,2.8c0.4,1,1.6,1.5,2.6,1.1
		c0.1,0,0.1-0.1,0.2-0.1c0.5-0.2,0.8-0.6,1-1.1l-0.6-1.3l-1.4,0.7l-0.4-0.7l2.2-1L1349.3,677.3z"
                />
                <path
                  className="st15"
                  d="M1353.8,673.2l-2.8,1.4l1.1,2.4l-0.7,0.3l-2.4-5l0.7-0.3l0.9,1.9l2.9-1.3l-1-2l0.7-0.4l2.5,5.1l-0.8,0.3
		L1353.8,673.2z"
                />
                <path
                  className="st15"
                  d="M1359.3,671.9c0.5,0.3,1,0.3,1.5,0.1c0.4-0.1,0.7-0.5,0.6-1c0-0.1-0.1-0.2-0.1-0.2c-0.3-0.8-1.4-0.3-2.3-0.4
		c-0.5-0.1-0.9-0.4-1.2-0.8c-0.4-0.7-0.1-1.6,0.7-2c0.1,0,0.1-0.1,0.2-0.1c0.5-0.2,1.1-0.3,1.6-0.2l-0.2,0.8c-0.4-0.1-0.7-0.1-1.1,0
		c-0.4,0.3-0.7,0.7-0.5,1.1s1.5,0.3,2.3,0.4c0.5,0,1,0.3,1.2,0.8c0.4,0.7,0.2,1.6-0.5,2.1c-0.1,0.1-0.2,0.1-0.3,0.1
		c-0.7,0.4-1.5,0.4-2.2,0.1L1359.3,671.9z"
                />
                <path
                  className="st15"
                  d="M1361.1,666.4l3.4-1.7l0.3,0.7l-1.3,0.7l2.1,4.3l-0.7,0.4l-2.1-4.4l-1.4,0.7L1361.1,666.4z"
                />
                <path
                  className="st15"
                  d="M1367.8,666.4l1.2,2.4l-0.7,0.3l-2.5-5l1.8-0.9c0.3-0.2,0.7-0.2,1.1-0.2c0.4,0.1,0.8,0.4,1,0.8
		c0.2,0.4,0.2,0.9,0,1.3c-0.1,0.2-0.3,0.5-0.5,0.6l3,1.5l-0.9,0.4l-2.9-1.5L1367.8,666.4z M1368.5,665.2c0.2-0.1,0.4-0.3,0.5-0.5
		c0.1-0.1,0.1-0.4,0-0.5c-0.1-0.2-0.3-0.3-0.4-0.4h-0.7l-1,0.5l0.6,1.3L1368.5,665.2z"
                />
                <path
                  className="st15"
                  d="M1374.3,662.4l0.3,0.7l-1.6,0.8l0.8,1.7l2.2-1.1l0.3,0.7l-2.9,1.4l-2.5-5l2.9-1.4l0.4,0.7l-2.2,1l0.6,1.3
		L1374.3,662.4z"
                />
                <path
                  className="st15"
                  d="M1378.7,660.2l0.3,0.7l-1.6,0.8l0.8,1.7l2.2-1.1l0.4,0.7l-3,1.4l-2.4-5l2.8-1.4l0.4,0.7l-2.2,1l0.6,1.3
		L1378.7,660.2z"
                />
                <path
                  className="st15"
                  d="M1379.2,657.5l3.5-1.7l0.3,0.7l-1.3,0.7l2.1,4.3l-0.7,0.4l-2.2-4.4l-1.3,0.7L1379.2,657.5z"
                />
                <path
                  className="st15"
                  d="M1264.4,304.3h-2.7l-0.6,1.6h-1l2.6-6.3h0.7l2.6,6.3h-1L1264.4,304.3z M1262.1,303.5h1.9l-0.9-2.4
		L1262.1,303.5z"
                />
                <path
                  className="st15"
                  d="M1268.4,305.1h2.8v0.8h-3.7v-6.3h0.9L1268.4,305.1z"
                />
                <path
                  className="st15"
                  d="M1273.8,303.2v2.7h-0.9v-6.3h2.4c0.5,0,1,0.2,1.3,0.5c0.7,0.6,0.8,1.7,0.2,2.4c-0.1,0.1-0.1,0.1-0.2,0.2
		c-0.3,0.3-0.8,0.5-1.3,0.5L1273.8,303.2z M1275.2,302.3c0.4,0,0.7-0.1,0.8-0.3c0.3-0.3,0.4-0.8,0.1-1.1c0,0,0,0-0.1-0.1
		c-0.1-0.2-0.4-0.3-0.8-0.3h-1.4v1.8H1275.2z"
                />
                <path
                  className="st15"
                  d="M1283.4,303h-3.6v2.9h-0.9v-6.3h0.9v2.5h3.6v-2.5h0.9v6.3h-0.9V303z"
                />
                <path className="st15" d="M1286.5,299.6h0.9v6.3h-0.9V299.6z" />
                <path
                  className="st15"
                  d="M1290.6,301.3v4.6h-0.9v-6.3h0.7l3.8,4.7v-4.7h0.9v6.3h-0.7L1290.6,301.3z"
                />
                <path
                  className="st15"
                  d="M1302.6,304.9c-0.7,0.7-1.6,1.1-2.5,1.1c-1.7,0.1-3.2-1.2-3.3-2.9c0-0.1,0-0.2,0-0.3c0-1.8,1.4-3.2,3.2-3.2
		c0.9,0,1.7,0.3,2.3,0.9l-0.6,0.6c-0.4-0.5-1.1-0.7-1.7-0.7c-1.3,0-2.3,1-2.3,2.3c0,0,0,0.1,0,0.1c0,1.3,1.1,2.4,2.4,2.4l0,0
		c0.6,0,1.1-0.2,1.6-0.6V303h-1.8v-0.9h2.7L1302.6,304.9z"
                />
                <path
                  className="st15"
                  d="M1303.8,299.6h4.3v0.9h-1.7v5.4h-0.9v-5.4h-1.7L1303.8,299.6z"
                />
                <path
                  className="st15"
                  d="M1312.1,299.6c1.8,0,3.2,1.4,3.2,3.2c0,1.8-1.4,3.2-3.2,3.2c0,0,0,0,0,0c-1.8,0-3.2-1.4-3.2-3.2
		C1308.9,301,1310.3,299.6,1312.1,299.6z M1312.1,305.2c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4c-1.3,0-2.4,1.1-2.4,2.4
		C1309.7,304.1,1310.8,305.2,1312.1,305.2z"
                />
                <path
                  className="st15"
                  d="M1318,301.3v4.6h-0.9v-6.3h0.6l3.8,4.7v-4.7h0.9v6.3h-0.7L1318,301.3z"
                />
                <path
                  className="st15"
                  d="M1261,313.4c0.4,0.5,0.9,0.8,1.5,0.8c0.5,0.1,1-0.3,1.1-0.9c0,0,0-0.1,0-0.1c0-0.9-1.3-1-2.2-1.6
		c-0.5-0.3-0.8-0.8-0.8-1.4c0.1-1,1-1.7,2-1.6c0,0,0,0,0,0c0.6,0,1.2,0.2,1.6,0.6l-0.5,0.6c-0.3-0.2-0.7-0.4-1.1-0.4
		c-0.5-0.1-1,0.3-1.1,0.9c0,0,0,0,0,0c0,0.8,1.4,0.9,2.2,1.5c0.5,0.3,0.8,0.8,0.8,1.4c0,1-0.8,1.8-1.8,1.8c0,0-0.1,0-0.1,0
		c-0.9,0-1.7-0.3-2.2-1L1261,313.4z"
                />
                <path
                  className="st15"
                  d="M1265.5,308.6h4.3v0.9h-1.7v5.4h-0.9v-5.4h-1.7L1265.5,308.6z"
                />
                <path
                  className="st15"
                  d="M1274.4,313.3h-2.7l-0.6,1.6h-1l2.6-6.3h0.7l2.6,6.3h-0.9L1274.4,313.3z M1272.1,312.5h1.9l-0.9-2.4
		L1272.1,312.5z"
                />
                <path
                  className="st15"
                  d="M1276.3,308.6h4.3v0.9h-1.7v5.4h-0.9v-5.4h-1.7L1276.3,308.6z"
                />
                <path className="st15" d="M1282.2,308.6h0.9v6.3h-0.9V308.6z" />
                <path
                  className="st15"
                  d="M1288.1,308.6c1.8,0,3.2,1.4,3.2,3.2c0,1.8-1.4,3.2-3.2,3.2c-1.8,0-3.2-1.4-3.2-3.2
		C1284.9,310,1286.3,308.6,1288.1,308.6C1288.1,308.6,1288.1,308.6,1288.1,308.6z M1288.1,314.2c1.3,0,2.4-1.1,2.4-2.4
		c0-1.3-1.1-2.4-2.4-2.4c-1.3,0-2.4,1.1-2.4,2.4C1285.7,313.1,1286.8,314.2,1288.1,314.2z"
                />
                <path
                  className="st15"
                  d="M1293.9,310.3v4.6h-0.9v-6.3h0.7l3.8,4.7v-4.7h0.9v6.3h-0.7L1293.9,310.3z"
                />
                <path
                  className="st15"
                  d="M1072.1,331.6v0.9h-2.1v2.9h-0.9v-6.3h3.6v0.9h-2.7v1.6H1072.1z"
                />
                <path
                  className="st15"
                  d="M1077.4,333.8h-2.7l-0.6,1.6h-0.9l2.6-6.3h0.6l2.6,6.3h-0.9L1077.4,333.8z M1075.1,333h1.9l-0.9-2.4
		L1075.1,333z"
                />
                <path className="st15" d="M1080.5,329.1h0.9v6.3h-0.9V329.1z" />
                <path
                  className="st15"
                  d="M1084.6,332.5v2.9h-0.9v-6.3h2.2c0.5,0,0.9,0.1,1.3,0.4c0.7,0.6,0.8,1.7,0.2,2.4c-0.1,0.1-0.1,0.1-0.2,0.2
		c-0.2,0.2-0.5,0.3-0.8,0.3l2.3,3h-1.1l-2.3-2.9H1084.6z M1085.9,331.6c0.3,0,0.5,0,0.7-0.2c0.3-0.3,0.4-0.8,0.1-1.1
		c0,0,0,0-0.1-0.1c-0.2-0.2-0.4-0.2-0.7-0.2h-1.3v1.6L1085.9,331.6z"
                />
                <path
                  className="st15"
                  d="M1093.1,331.6v0.9h-2v2.9h-0.9v-6.3h3.6v0.9h-2.7v1.6H1093.1z"
                />
                <path className="st15" d="M1095.4,329.1h0.9v6.3h-0.9V329.1z" />
                <path
                  className="st15"
                  d="M1101.6,331.6v0.9h-2.1v2.1h2.8v0.8h-3.7v-6.3h3.6v0.9h-2.7v1.6H1101.6z"
                />
                <path
                  className="st15"
                  d="M1105.1,334.6h2.7v0.8h-3.6v-6.3h0.9V334.6z"
                />
                <path
                  className="st15"
                  d="M1109.5,335.4v-6.3h1.9c0.8,0,1.5,0.2,2.2,0.6c0.8,0.6,1.2,1.6,1.2,2.6c0,1-0.5,1.9-1.2,2.6
		c-0.7,0.4-1.4,0.5-2.2,0.5L1109.5,335.4z M1113.2,330.5c-0.5-0.4-1.2-0.5-1.8-0.5h-1v4.6h1c0.6,0,1.3-0.1,1.8-0.5
		C1114.1,333.1,1114.1,331.5,1113.2,330.5z"
                />
                <path
                  className="st15"
                  d="M1069.2,342.9c0.4,0.5,1,0.8,1.6,0.8c0.5,0.1,1-0.3,1.1-0.9c0,0,0-0.1,0-0.1c0-0.9-1.4-1-2.2-1.6
		c-0.5-0.3-0.8-0.8-0.8-1.4c0-0.9,0.8-1.7,1.8-1.6c0,0,0.1,0,0.1,0c0.6,0,1.2,0.2,1.7,0.6l-0.5,0.6c-0.4-0.2-0.8-0.4-1.2-0.4
		c-0.5-0.1-0.9,0.3-1,0.8c0,0,0,0.1,0,0.1c0,0.8,1.3,0.9,2.1,1.5c0.6,0.2,0.9,0.8,0.9,1.4c0,1-0.8,1.8-1.8,1.8c-0.1,0-0.1,0-0.2,0
		c-0.8,0-1.7-0.3-2.2-1L1069.2,342.9z"
                />
                <path
                  className="st15"
                  d="M1073.8,338.1h4.3v0.9h-1.7v5.4h-0.9V339h-1.7L1073.8,338.1z"
                />
                <path
                  className="st15"
                  d="M1082.6,342.8h-2.6l-0.7,1.6h-0.9l2.6-6.3h0.6l2.6,6.3h-0.9L1082.6,342.8z M1080.3,342h2l-1-2.4L1080.3,342z"
                />
                <path
                  className="st15"
                  d="M1084.6,338.1h4.3v0.9h-1.7v5.4h-0.9V339h-1.7L1084.6,338.1z"
                />
                <path className="st15" d="M1090.5,338.1h0.9v6.3h-0.9V338.1z" />
                <path
                  className="st15"
                  d="M1096.3,338.1c1.8-0.1,3.2,1.3,3.3,3.1s-1.3,3.2-3.1,3.3s-3.2-1.3-3.3-3.1c0,0,0-0.1,0-0.1
		C1093.2,339.6,1094.6,338.2,1096.3,338.1z M1096.3,343.7c1.3,0.1,2.5-0.9,2.6-2.2s-0.9-2.5-2.2-2.6c-1.3-0.1-2.5,0.9-2.6,2.2
		c0,0.1,0,0.1,0,0.2C1094,342.6,1095,343.6,1096.3,343.7C1096.3,343.7,1096.3,343.7,1096.3,343.7z"
                />
                <path
                  className="st15"
                  d="M1102.2,339.8v4.6h-0.9v-6.3h0.6l3.8,4.7v-4.7h0.9v6.3h-0.6L1102.2,339.8z"
                />
                <path
                  className="st15"
                  d="M498.8,897.8v0.8h-2v3h-0.9v-6.3h3.6v0.9h-2.7v1.6H498.8z"
                />
                <path
                  className="st15"
                  d="M502,900.7h2.8v0.9h-3.7v-6.3h0.9L502,900.7z"
                />
                <path className="st15" d="M506.5,895.3h0.9v6.3h-0.9V895.3z" />
                <path
                  className="st15"
                  d="M510.6,897v4.6h-0.9v-6.3h0.6l3.8,4.6v-4.6h0.9v6.3h-0.6L510.6,897z"
                />
                <path
                  className="st15"
                  d="M517.3,901.6v-6.3h1.9c0.7-0.1,1.5,0.2,2.1,0.6c0.8,0.6,1.3,1.6,1.3,2.6c-0.1,1.8-1.5,3.2-3.3,3.1
		c0,0-0.1,0-0.1,0L517.3,901.6z M520.9,896.7c-0.5-0.4-1.2-0.6-1.8-0.5h-0.9v4.5h0.9c0.6,0.1,1.3-0.1,1.8-0.5c0.5-0.4,0.8-1,0.8-1.7
		C521.7,897.8,521.4,897.1,520.9,896.7L520.9,896.7z"
                />
                <path
                  className="st15"
                  d="M527.4,897.8v0.8h-2.1v2.1h2.8v0.9h-3.7v-6.3h3.6v0.9h-2.7v1.6H527.4z"
                />
                <path
                  className="st15"
                  d="M530.8,898.6v3h-0.9v-6.3h2.2c0.5-0.1,0.9,0.1,1.3,0.4c0.4,0.3,0.6,0.8,0.6,1.3c0,0.5-0.2,1-0.6,1.3l-0.8,0.3
		l2.3,3h-1.1l-2.2-3H530.8z M532.1,897.8c0.4,0,0.6-0.1,0.7-0.3c0.2-0.1,0.3-0.3,0.3-0.5c0-0.2-0.1-0.5-0.3-0.6
		c-0.1-0.2-0.3-0.2-0.7-0.2h-1.3v1.6H532.1z"
                />
                <path
                  className="st15"
                  d="M536.4,900c0.3,0.5,0.9,0.8,1.5,0.8c0.6,0,1.1-0.3,1.1-0.9s-1.3-1.1-2.1-1.6c-0.5-0.3-0.8-0.8-0.8-1.4
		c0.1-1,0.9-1.8,1.9-1.7c0,0,0,0,0,0c0.6,0,1.2,0.3,1.7,0.6l-0.6,0.7c-0.3-0.3-0.7-0.4-1.1-0.4c-0.5-0.1-0.9,0.3-1,0.8c0,0,0,0,0,0
		c0,0.8,1.3,1,2.1,1.5c0.5,0.3,0.8,0.9,0.8,1.5c0,1-0.8,1.8-1.8,1.8c0,0-0.1,0-0.1,0c-0.9,0-1.7-0.4-2.2-1.1L536.4,900z"
                />
                <path
                  className="st15"
                  d="M544.8,900c0.3,0.5,0.9,0.8,1.5,0.8c0.6,0,1.1-0.3,1.1-0.9s-1.3-1.1-2.1-1.6c-0.5-0.3-0.8-0.8-0.8-1.4
		c0.1-1,0.9-1.8,1.9-1.7c0,0,0,0,0,0c0.6,0,1.2,0.3,1.7,0.6l-0.6,0.7c-0.3-0.3-0.7-0.4-1.1-0.4c-0.5-0.1-0.9,0.3-1,0.8c0,0,0,0,0,0
		c0,0.8,1.3,1,2.1,1.5c0.5,0.3,0.8,0.9,0.8,1.5c0,1-0.8,1.8-1.8,1.8c0,0-0.1,0-0.1,0c-0.9,0-1.7-0.4-2.2-1.1L544.8,900z"
                />
                <path
                  className="st15"
                  d="M549.3,895.3h4.3v0.9h-1.7v5.4H551v-5.4h-1.7V895.3z"
                />
                <path
                  className="st15"
                  d="M556.2,898.6v3h-0.9v-6.3h2.2c0.4,0,0.9,0.1,1.2,0.4c0.4,0.3,0.6,0.8,0.6,1.3c0,0.5-0.2,1-0.6,1.3l-0.8,0.3
		l2.3,3h-1.1l-2.2-3H556.2z M557.4,897.8c0.3,0,0.6-0.1,0.8-0.3c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.4-0.2-0.6
		c-0.2-0.2-0.4-0.2-0.8-0.2h-1.2v1.6H557.4z"
                />
                <path
                  className="st15"
                  d="M564.7,897.8v0.8h-2.1v2.1h2.8v0.9h-3.7v-6.3h3.6v0.9h-2.7v1.6H564.7z"
                />
                <path
                  className="st15"
                  d="M570.2,897.8v0.8h-2.1v2.1h2.8v0.9h-3.7v-6.3h3.6v0.9h-2.7v1.6H570.2z"
                />
                <path
                  className="st15"
                  d="M572.1,895.3h4.3v0.9h-1.7v5.4h-0.9v-5.4h-1.7L572.1,895.3z"
                />
                <path
                  className="st15"
                  d="M495.9,909c0.4,0.5,1,0.8,1.6,0.8c0.6,0,1.1-0.3,1.1-0.9s-1.3-1.1-2.2-1.6c-0.5-0.3-0.8-0.8-0.8-1.4
		c0.1-1,0.9-1.8,1.9-1.7c0,0,0,0,0,0c0.6,0,1.2,0.2,1.7,0.6l-0.5,0.7c-0.3-0.3-0.7-0.4-1.1-0.4c-0.6,0-1.1,0.3-1.1,0.8
		s1.4,1,2.2,1.5c0.5,0.3,0.8,0.9,0.8,1.5c0,1-0.8,1.8-1.8,1.8c-0.1,0-0.1,0-0.2,0c-0.9,0-1.7-0.4-2.2-1.1L495.9,909z"
                />
                <path
                  className="st15"
                  d="M500.5,904.3h4.3v0.9h-1.7v5.4h-0.9v-5.4h-1.7L500.5,904.3z"
                />
                <path
                  className="st15"
                  d="M509.4,909h-2.7l-0.7,1.6h-0.9l2.6-6.3h0.6l2.7,6.3h-1L509.4,909z M507.1,908.1h1.9l-1-2.3L507.1,908.1z"
                />
                <path
                  className="st15"
                  d="M511.3,904.3h4.3v0.9h-1.7v5.4H513v-5.4h-1.7V904.3z"
                />
                <path className="st15" d="M517.2,904.3h0.9v6.3h-0.9V904.3z" />
                <path
                  className="st15"
                  d="M523.1,904.2c1.8-0.1,3.3,1.4,3.4,3.2c0.1,1.8-1.4,3.3-3.2,3.4c-1.8,0.1-3.3-1.4-3.4-3.2c0,0,0-0.1,0-0.1
		c-0.1-1.8,1.3-3.2,3.1-3.3C523,904.2,523.1,904.2,523.1,904.2z M523.1,909.8c1.2,0,2.2-1,2.2-2.2c0,0,0-0.1,0-0.1
		c0.1-1.2-0.8-2.3-2-2.4c-0.1,0-0.1,0-0.2,0c-1.3,0-2.3,1-2.3,2.3c0,0,0,0.1,0,0.1C520.8,908.8,521.8,909.8,523.1,909.8z"
                />
                <path
                  className="st15"
                  d="M528.9,906v4.6H528v-6.3h0.6l3.8,4.6v-4.6h0.9v6.3h-0.6L528.9,906z"
                />
                <path
                  className="st15"
                  d="M779.7,987.5v2.9h-0.9v-6.3h2.2c0.5,0,0.9,0.1,1.3,0.4c0.7,0.6,0.8,1.7,0.2,2.4c-0.1,0.1-0.1,0.1-0.2,0.2
		c-0.2,0.2-0.5,0.3-0.8,0.3l2.3,3h-1.1l-2.2-2.9H779.7z M781,986.6c0.3,0,0.6-0.1,0.8-0.2c0.3-0.4,0.3-0.8,0-1.2
		c-0.2-0.1-0.5-0.2-0.8-0.2h-1.3v1.6L781,986.6z"
                />
                <path className="st15" d="M785.3,984.1h0.9v6.3h-0.9V984.1z" />
                <path
                  className="st15"
                  d="M791.2,984c0.9,0,1.7,0.4,2.3,1l-0.6,0.6c-0.5-0.4-1.1-0.7-1.7-0.7c-1.3,0-2.4,1.1-2.4,2.4
		c0,1.3,1.1,2.4,2.4,2.4c0.7,0,1.4-0.3,1.8-0.9l0.7,0.6c-0.7,0.7-1.6,1.1-2.5,1.1c-1.8-0.3-3-2-2.7-3.8
		C788.8,985.3,789.8,984.2,791.2,984L791.2,984z"
                />
                <path
                  className="st15"
                  d="M799.8,987.5h-3.6v2.9h-0.9v-6.3h0.9v2.5h3.6v-2.5h0.9v6.3h-0.9V987.5z"
                />
                <path
                  className="st15"
                  d="M806.3,989.1h-0.6l-1.8-2.9v4.2H803v-6.3h0.6l2.4,3.9l2.4-3.9h0.7v6.3h-0.9v-4.2L806.3,989.1z"
                />
                <path
                  className="st15"
                  d="M814,984c1.8,0.3,3,2,2.7,3.8c-0.2,1.4-1.3,2.4-2.7,2.7c-1.8-0.3-3-2-2.7-3.8
		C811.6,985.3,812.6,984.2,814,984z M814,989.7c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4c-1.3,0-2.4,1.1-2.4,2.4
		C811.6,988.6,812.7,989.7,814,989.7z"
                />
                <path
                  className="st15"
                  d="M819.9,985.8v4.6H819v-6.3h0.6l3.8,4.7v-4.7h0.9v6.3h-0.6L819.9,985.8z"
                />
                <path
                  className="st15"
                  d="M826.6,990.4v-6.3h1.9c0.7-0.1,1.5,0.2,2.1,0.6c0.8,0.6,1.3,1.6,1.3,2.6c0,1-0.5,1.9-1.3,2.5
		c-0.6,0.4-1.4,0.7-2.1,0.6L826.6,990.4z M830.2,985.5c-0.5-0.4-1.2-0.5-1.8-0.5h-0.9v4.6h0.9c0.7,0.1,1.3-0.2,1.8-0.6
		c0.5-0.4,0.8-1,0.8-1.7C831,986.6,830.7,985.9,830.2,985.5L830.2,985.5z"
                />
                <path
                  className="st15"
                  d="M778.9,997.9c0.4,0.5,1,0.8,1.6,0.8c0.6,0,1-0.4,1.1-1c0-0.9-1.4-1-2.2-1.6c-0.5-0.3-0.8-0.8-0.8-1.4
		c0.1-1,0.9-1.8,1.9-1.7c0,0,0,0,0,0c0.6,0,1.2,0.3,1.7,0.7l-0.5,0.6c-0.3-0.3-0.8-0.4-1.2-0.4c-0.5-0.1-0.9,0.3-1,0.8c0,0,0,0,0,0
		c0,0.8,1.3,1,2.1,1.6c0.6,0.2,0.9,0.8,0.9,1.4c0,1-0.8,1.8-1.8,1.8c-0.1,0-0.1,0-0.2,0c-0.8,0-1.6-0.4-2.2-1L778.9,997.9z"
                />
                <path
                  className="st15"
                  d="M783.4,993.1h4.4v0.9h-1.7v5.4h-0.9V994h-1.8V993.1z"
                />
                <path
                  className="st15"
                  d="M792.3,997.8h-2.6l-0.7,1.6h-0.9l2.6-6.3h0.6l2.6,6.3H793L792.3,997.8z M790,997h2l-1-2.4L790,997z"
                />
                <path
                  className="st15"
                  d="M794.2,993.1h4.4v0.9h-1.7v5.4H796V994h-1.8V993.1z"
                />
                <path className="st15" d="M800.2,993.1h0.9v6.3h-0.9V993.1z" />
                <path
                  className="st15"
                  d="M806,993c1.8,0.3,3,2,2.7,3.8c-0.2,1.4-1.3,2.4-2.7,2.7c-1.8-0.3-3-2-2.7-3.8
		C803.6,994.3,804.6,993.2,806,993z M806,998.7c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.4-2.4-2.4c-1.3,0-2.4,1.1-2.4,2.4
		C803.6,997.6,804.7,998.7,806,998.7z"
                />
                <path
                  className="st15"
                  d="M811.9,994.8v4.6H811v-6.3h0.6l3.8,4.7v-4.7h0.9v6.3h-0.6L811.9,994.8z"
                />
                <path
                  className="st15"
                  d="M316.1,901.9c0.4,0.5,1,0.9,1.6,0.9c0.6,0,1-0.4,1.1-1c0-1-1.4-1.1-2.2-1.6c-0.5-0.3-0.8-0.8-0.8-1.4
		c0.1-1,0.9-1.8,1.9-1.7c0,0,0,0,0,0c0.6,0,1.2,0.3,1.7,0.7l-0.6,0.6c-0.3-0.3-0.7-0.4-1.1-0.4c-0.5-0.1-0.9,0.3-1,0.8c0,0,0,0,0,0
		c0,0.8,1.3,1,2.1,1.5c0.6,0.3,0.9,0.9,0.9,1.5c0,1-0.8,1.8-1.8,1.8c-0.1,0-0.1,0-0.2,0c-0.8,0-1.6-0.4-2.2-1L316.1,901.9z"
                />
                <path
                  className="st15"
                  d="M324.2,897.1c1.8-0.1,3.3,1.4,3.4,3.2c0.1,1.8-1.4,3.3-3.2,3.4c-1.8,0.1-3.3-1.4-3.4-3.2c0,0,0-0.1,0-0.1
		c-0.1-1.8,1.3-3.2,3.1-3.3C324.1,897.1,324.2,897.1,324.2,897.1z M324.2,902.8c1.3-0.1,2.3-1.1,2.2-2.4c0,0,0,0,0,0
		c0.3-1.2-0.5-2.5-1.8-2.7s-2.5,0.5-2.7,1.8c-0.1,0.3-0.1,0.6,0,1c-0.1,1.3,0.9,2.3,2.2,2.4C324.1,902.8,324.2,902.8,324.2,902.8z"
                />
                <path
                  className="st15"
                  d="M329.8,902.8c-0.5-0.5-0.7-1.2-0.7-1.9v-3.7h0.9v3.8c0,0.4,0.1,0.9,0.4,1.2c0.6,0.7,1.7,0.8,2.4,0.2
		c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.4-0.8,0.4-1.2v-3.8h0.9v3.7c0,0.7-0.2,1.4-0.6,1.9c-0.5,0.5-1.3,0.8-2,0.8
		C331,903.6,330.3,903.3,329.8,902.8z"
                />
                <path
                  className="st15"
                  d="M335.8,897.2h4.4v0.9h-1.7v5.4h-0.9v-5.4h-1.8V897.2z"
                />
                <path
                  className="st15"
                  d="M346.2,900.5h-3.5v3h-0.9v-6.3h0.9v2.5h3.5v-2.5h0.9v6.3h-0.9V900.5z"
                />
                <path
                  className="st15"
                  d="M352.4,899.7v0.8h-2.1v2.2h2.8v0.8h-3.7v-6.3h3.6v0.9h-2.7v1.6H352.4z"
                />
                <path
                  className="st15"
                  d="M355.8,900.5v3h-0.9v-6.3h2.2c0.5,0,0.9,0.1,1.3,0.4c0.7,0.6,0.8,1.7,0.2,2.4c-0.1,0.1-0.1,0.1-0.2,0.2
		c-0.2,0.2-0.5,0.3-0.8,0.3l2.3,3h-1.1l-2.2-3H355.8z M357.1,899.7c0.3,0,0.5,0,0.7-0.2c0.2-0.2,0.3-0.4,0.3-0.6
		c0-0.2-0.1-0.5-0.3-0.6c-0.2-0.2-0.4-0.2-0.7-0.2h-1.3v1.6H357.1z"
                />
                <path
                  className="st15"
                  d="M362.3,898.9v4.6h-0.9v-6.3h0.6l3.8,4.6v-4.6h0.9v6.3H366L362.3,898.9z"
                />
                <path
                  className="st15"
                  d="M374.8,897.1c0.9,0,1.7,0.4,2.3,1l-0.6,0.6c-0.5-0.4-1.1-0.7-1.7-0.7c-1.3,0-2.4,1.1-2.4,2.4
		c0,1.3,1.1,2.4,2.4,2.4c0.7,0,1.4-0.3,1.9-0.9l0.6,0.5c-1.1,1.4-3.1,1.6-4.5,0.5c-0.8-0.6-1.2-1.5-1.2-2.5
		c-0.1-1.7,1.2-3.2,2.9-3.3C374.6,897.1,374.7,897.1,374.8,897.1z"
                />
                <path
                  className="st15"
                  d="M379.9,900.5v3H379v-6.3h2.2c0.4,0,0.9,0.1,1.2,0.4c0.7,0.6,0.8,1.7,0.2,2.4c-0.1,0.1-0.1,0.1-0.2,0.2
		c-0.2,0.2-0.4,0.3-0.7,0.3l2.2,3h-1.1l-2.2-3H379.9z M381.1,899.7c0.3,0,0.6-0.1,0.8-0.2c0.1-0.2,0.2-0.4,0.2-0.6
		c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.1-0.5-0.2-0.8-0.2h-1.2v1.6H381.1z"
                />
                <path
                  className="st15"
                  d="M387.8,897.1c1.8,0.3,3,2,2.7,3.8c-0.2,1.4-1.3,2.4-2.7,2.7c-1.8-0.3-3-2-2.7-3.8
		C385.4,898.4,386.4,897.3,387.8,897.1z M387.8,902.8c1.3,0,2.3-1,2.3-2.3c0,0,0-0.1,0-0.1c0.1-1.3-0.9-2.3-2.2-2.4c0,0-0.1,0-0.1,0
		c-1.2,0-2.2,1-2.2,2.2c0,0.1,0,0.1,0,0.2C385.5,901.7,386.5,902.7,387.8,902.8C387.8,902.8,387.8,902.8,387.8,902.8z"
                />
                <path
                  className="st15"
                  d="M392.8,901.9c0.3,0.5,0.9,0.8,1.5,0.9c0.5,0.1,1-0.3,1.1-0.9c0,0,0-0.1,0-0.1c0-1-1.3-1.1-2.1-1.6
		c-0.5-0.3-0.8-0.8-0.8-1.4c0.1-1,0.9-1.8,1.9-1.7c0,0,0,0,0,0c0.6,0,1.2,0.3,1.7,0.7l-0.6,0.6c-0.3-0.3-0.7-0.4-1.1-0.4
		c-0.5-0.1-0.9,0.3-1,0.8c0,0,0,0,0,0c0,0.8,1.3,1,2.1,1.5c0.5,0.3,0.8,0.9,0.8,1.5c0,1-0.8,1.8-1.8,1.8c0,0-0.1,0-0.1,0
		c-0.8,0-1.6-0.4-2.2-1L392.8,901.9z"
                />
                <path
                  className="st15"
                  d="M398.2,901.9c0.3,0.5,0.9,0.8,1.5,0.9c0.5,0.1,1-0.3,1.1-0.9c0,0,0-0.1,0-0.1c0-1-1.3-1.1-2.1-1.6
		c-0.5-0.3-0.8-0.8-0.8-1.4c0.1-1,0.9-1.8,1.9-1.7c0,0,0,0,0,0c0.6,0,1.2,0.3,1.7,0.7l-0.6,0.6c-0.3-0.3-0.7-0.4-1.1-0.4
		c-0.5-0.1-0.9,0.3-1,0.8c0,0,0,0,0,0c0,0.8,1.3,1,2.1,1.5c0.5,0.3,0.8,0.9,0.8,1.5c0,1-0.8,1.8-1.8,1.8c0,0-0.1,0-0.1,0
		c-0.8,0-1.6-0.4-2.2-1L398.2,901.9z"
                />
                <path
                  className="st15"
                  d="M316.1,910.9c0.4,0.5,1,0.9,1.6,0.9c0.6,0,1-0.4,1.1-1c0-1-1.4-1.1-2.2-1.6c-0.5-0.3-0.8-0.8-0.8-1.4
		c0.1-1,0.9-1.8,1.9-1.7c0,0,0,0,0,0c0.6,0,1.2,0.3,1.7,0.7l-0.6,0.6c-0.3-0.3-0.7-0.4-1.1-0.4c-0.5-0.1-0.9,0.3-1,0.8c0,0,0,0,0,0
		c0,0.8,1.3,1,2.1,1.5c0.6,0.3,0.9,0.9,0.9,1.5c0,1-0.8,1.8-1.8,1.8c-0.1,0-0.1,0-0.2,0c-0.8,0-1.6-0.4-2.2-1L316.1,910.9z"
                />
                <path
                  className="st15"
                  d="M320.6,906.2h4.4v0.9h-1.7v5.4h-0.9v-5.4h-1.8V906.2z"
                />
                <path
                  className="st15"
                  d="M329.5,910.9h-2.6l-0.7,1.6h-0.9l2.6-6.3h0.6l2.6,6.3h-0.9L329.5,910.9z M327.2,910h2l-1-2.3L327.2,910z"
                />
                <path
                  className="st15"
                  d="M331.4,906.2h4.4v0.9h-1.7v5.4h-0.9v-5.4h-1.8V906.2z"
                />
                <path className="st15" d="M337.4,906.2h0.9v6.3h-0.9V906.2z" />
                <path
                  className="st15"
                  d="M343.2,906.1c1.8,0.3,3,2,2.7,3.8c-0.2,1.4-1.3,2.4-2.7,2.7c-1.8-0.3-3-2-2.7-3.8
		C340.8,907.4,341.8,906.3,343.2,906.1z M343.2,911.8c1.3,0,2.3-1,2.3-2.3c0,0,0-0.1,0-0.1c0.1-1.3-0.9-2.3-2.2-2.4c0,0-0.1,0-0.1,0
		c-1.2,0-2.2,1-2.2,2.2c0,0.1,0,0.1,0,0.2C340.9,910.7,341.9,911.7,343.2,911.8C343.2,911.8,343.2,911.8,343.2,911.8z"
                />
                <path
                  className="st15"
                  d="M349.1,907.9v4.6h-0.9v-6.3h0.6l3.8,4.6v-4.6h0.9v6.3h-0.6L349.1,907.9z"
                />
                <circle className="st17" cx="1246.7" cy={307} r="9.9" />
                <path
                  className="st6"
                  d="M1249.4,310.4c0.9-0.1,1.5-0.8,1.5-1.7v-6.6c-0.1-1-0.9-1.8-1.9-1.8h-4.5c-1,0-1.8,0.8-1.9,1.8v6.6
		c0,0.8,0.6,1.6,1.4,1.7l-2.1,3.2h1.2l1.6-2.2h4.1l1.6,2.2h1.2L1249.4,310.4z M1245.5,301c0-0.2,0.2-0.3,0.4-0.3h1.7
		c0.2,0,0.3,0.1,0.3,0.3v0v0.5c0,0.2-0.1,0.3-0.3,0.3l0,0h-1.7c-0.2,0-0.4-0.1-0.4-0.3V301z M1244.4,309.5c-0.4,0-0.8-0.4-0.8-0.8
		c0-0.4,0.4-0.8,0.8-0.8l0,0c0.4-0.1,0.7,0.2,0.8,0.6c0,0.1,0,0.1,0,0.2C1245.2,309.1,1244.8,309.5,1244.4,309.5L1244.4,309.5z
		 M1244.5,305.2c-0.5,0-0.9-0.4-0.9-0.9c0,0,0,0,0,0v-1.2c-0.1-0.4,0.2-0.8,0.7-0.9c0.1,0,0.1,0,0.2,0h4.5c0.4-0.1,0.8,0.2,0.9,0.7
		c0,0.1,0,0.1,0,0.2v1.2c0,0.5-0.4,0.9-0.9,0.9l0,0H1244.5z M1248.2,308.7c0-0.4,0.4-0.8,0.8-0.8l0,0c0.4-0.1,0.7,0.2,0.8,0.6
		c0,0.1,0,0.1,0,0.2c0,0.4-0.4,0.8-0.8,0.8l0,0C1248.6,309.5,1248.2,309.1,1248.2,308.7z"
                />
                <circle className="st17" cx="1332.7" cy="254.1" r="9.9" />
                <path
                  className="st6"
                  d="M1335.4,257.6c0.9-0.1,1.5-0.9,1.5-1.8v-6.6c-0.1-1-0.9-1.8-1.9-1.8h-4.5c-1,0-1.8,0.8-1.9,1.8v6.6
		c0,0.8,0.6,1.6,1.4,1.8l-2.1,3.2h1.2l1.6-2.3h4.1l1.6,2.3h1.2L1335.4,257.6z M1331.5,248.1c0-0.2,0.2-0.3,0.4-0.3h1.7
		c0.2,0,0.3,0.1,0.3,0.3c0,0,0,0,0,0v0.5c0,0.2-0.1,0.3-0.3,0.3l0,0h-1.7c-0.2,0-0.4-0.1-0.4-0.3V248.1z M1330.4,256.6
		c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8s0.8,0.4,0.8,0.8C1331.2,256.2,1330.8,256.6,1330.4,256.6z M1330.5,252.3
		c-0.4,0.1-0.8-0.2-0.9-0.7c0-0.1,0-0.1,0-0.2v-1.2c-0.1-0.4,0.2-0.8,0.7-0.9c0.1,0,0.1,0,0.2,0h4.5c0.4-0.1,0.8,0.2,0.9,0.7
		c0,0.1,0,0.1,0,0.2v1.2c0.1,0.4-0.2,0.8-0.7,0.9c-0.1,0-0.1,0-0.2,0H1330.5z M1334.2,255.8c0-0.4,0.4-0.8,0.8-0.8
		c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8C1334.6,256.6,1334.2,256.2,1334.2,255.8z"
                />
                <circle className="st17" cx="1078.2" cy="316.9" r="9.9" />
                <path
                  className="st6"
                  d="M1080.9,320.3c0.9-0.1,1.5-0.8,1.5-1.7V312c-0.1-1-0.9-1.8-1.9-1.8h-4.5c-1,0-1.8,0.8-1.9,1.8v6.6
		c0,0.8,0.6,1.6,1.4,1.7l-2.1,3.2h1.2l1.6-2.2h4.1l1.6,2.2h1.2L1080.9,320.3z M1077,310.9c0-0.2,0.2-0.3,0.4-0.3h1.7
		c0.2,0,0.3,0.1,0.3,0.3v0v0.5c0,0.2-0.1,0.3-0.3,0.3l0,0h-1.7c-0.2,0-0.4-0.1-0.4-0.3V310.9z M1075.9,319.4c-0.4,0-0.8-0.4-0.8-0.8
		c0-0.4,0.4-0.8,0.8-0.8l0,0c0.4-0.1,0.7,0.2,0.8,0.6c0,0.1,0,0.1,0,0.2C1076.7,319,1076.3,319.4,1075.9,319.4L1075.9,319.4z
		 M1076,315.1c-0.4,0.1-0.8-0.2-0.9-0.7c0-0.1,0-0.1,0-0.2V313c-0.1-0.4,0.2-0.8,0.7-0.9c0.1,0,0.1,0,0.2,0h4.5
		c0.4-0.1,0.8,0.2,0.9,0.7c0,0.1,0,0.1,0,0.2v1.2c0.1,0.4-0.2,0.8-0.7,0.9c-0.1,0-0.1,0-0.2,0H1076z M1079.7,318.6
		c0-0.4,0.4-0.8,0.8-0.8l0,0c0.4-0.1,0.7,0.2,0.8,0.6c0,0.1,0,0.1,0,0.2c0,0.4-0.4,0.8-0.8,0.8l0,0
		C1080.1,319.4,1079.7,319,1079.7,318.6z"
                />
                <circle className="st17" cx="973.6" cy="316.9" r="9.9" />
                <path
                  className="st6"
                  d="M976.3,320.3c0.8-0.1,1.4-0.9,1.4-1.7V312c0-1-0.8-1.8-1.8-1.8h-4.5c-1,0-1.8,0.8-1.9,1.8v6.6
		c0,0.8,0.6,1.6,1.4,1.7l-2.1,3.2h1.2l1.5-2.2h4.2l1.5,2.2h1.3L976.3,320.3z M972.4,310.9c0-0.2,0.1-0.3,0.3-0.3h1.8
		c0.2,0,0.3,0.1,0.3,0.3v0.5c0,0.2-0.1,0.3-0.3,0.3h-1.8c-0.2,0-0.3-0.1-0.3-0.3V310.9z M971.3,319.4c-0.4,0-0.8-0.4-0.8-0.8
		c0-0.4,0.4-0.8,0.8-0.8c0.4-0.1,0.7,0.2,0.8,0.6c0,0.1,0,0.1,0,0.2C972.1,319,971.7,319.4,971.3,319.4z M971.4,315.1
		c-0.4,0.1-0.8-0.2-0.9-0.7c0-0.1,0-0.1,0-0.2V313c-0.1-0.4,0.2-0.8,0.7-0.9c0.1,0,0.1,0,0.2,0h4.4c0.5-0.1,0.9,0.3,1,0.8
		c0,0,0,0.1,0,0.1v1.2c0,0.5-0.4,0.9-0.9,0.9c0,0-0.1,0-0.1,0H971.4z M975.1,318.6c0-0.4,0.4-0.8,0.8-0.8c0.4-0.1,0.7,0.2,0.8,0.6
		c0,0.1,0,0.1,0,0.2c0,0.4-0.4,0.8-0.8,0.8C975.5,319.4,975.1,319,975.1,318.6z"
                />
                <circle className="st17" cx="865.6" cy="341.5" r="9.9" />
                <path
                  className="st6"
                  d="M868.3,345c0.8-0.2,1.4-1,1.4-1.8v-6.5c0-1-0.8-1.8-1.8-1.8h-4.6c-1,0-1.8,0.8-1.8,1.8v6.5
		c0,0.8,0.6,1.6,1.4,1.8l-2.1,3.2h1.2l1.5-2.3h4.2l1.5,2.3h1.2L868.3,345z M864.4,335.5c0-0.2,0.1-0.3,0.3-0.3h1.8
		c0.1,0.1,0.2,0.2,0.3,0.3v0.6c0,0.2-0.1,0.3-0.3,0.3h-1.8c-0.2,0-0.3-0.1-0.3-0.3V335.5z M863.3,344c-0.4,0.1-0.7-0.2-0.8-0.6
		c0-0.1,0-0.1,0-0.2c0-0.4,0.4-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8C864.1,343.6,863.7,344,863.3,344z M863.4,339.8
		c-0.5,0-0.9-0.4-0.9-0.9c0,0,0-0.1,0-0.1v-1.2c0-0.5,0.4-0.9,0.9-0.9l0,0h4.4c0.5,0,0.9,0.4,0.9,0.9c0,0,0,0,0,0v1.2
		c0.1,0.5-0.3,0.9-0.8,1c0,0-0.1,0-0.1,0H863.4z M867.1,343.2c0-0.4,0.4-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8
		c-0.4,0.1-0.7-0.2-0.8-0.6C867.1,343.3,867.1,343.3,867.1,343.2L867.1,343.2z"
                />
                <circle className="st17" cx="830.1" cy="459.8" r="9.9" />
                <path
                  className="st6"
                  d="M832.8,463.3c0.8-0.2,1.4-1,1.4-1.8V455c0-1-0.8-1.8-1.8-1.8h-4.6c-1,0-1.8,0.8-1.8,1.8v0v6.5
		c0,0.8,0.6,1.6,1.4,1.8l-2.1,3.2h1.2l1.5-2.3h4.2l1.5,2.3h1.2L832.8,463.3z M828.9,453.8c0.1-0.1,0.2-0.2,0.3-0.3h1.8
		c0.2,0,0.3,0.1,0.3,0.3v0.6c0,0.2-0.1,0.3-0.3,0.3h-1.8c-0.2,0-0.3-0.1-0.3-0.3L828.9,453.8L828.9,453.8z M827.8,462.3
		c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8C828.6,461.9,828.2,462.3,827.8,462.3z M827.9,458.1
		c-0.5,0-0.9-0.4-0.9-0.9c0,0,0-0.1,0-0.1v-1.2c0-0.5,0.4-0.9,0.9-0.9l0,0h4.4c0.5,0,0.9,0.4,0.9,0.9c0,0,0,0,0,0v1.2
		c0.1,0.5-0.3,0.9-0.8,1c0,0-0.1,0-0.1,0H827.9z M831.6,461.5c0-0.4,0.4-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8c0.1,0.4-0.2,0.7-0.6,0.8
		c-0.1,0-0.1,0-0.2,0C832,462.3,831.6,461.9,831.6,461.5L831.6,461.5z"
                />
                <circle className="st17" cx="809.5" cy="617.2" r="9.9" />
                <path
                  className="st6"
                  d="M812.2,620.7c0.8-0.2,1.4-1,1.4-1.8v-6.6c0-1-0.8-1.8-1.8-1.8h-4.6c-1,0-1.8,0.8-1.8,1.8v6.6
		c0,0.8,0.6,1.6,1.4,1.8l-2.1,3.1h1.2l1.5-2.2h4.2l1.5,2.2h1.2L812.2,620.7z M808.3,611.2c0-0.2,0.1-0.3,0.3-0.3h1.8
		c0.2,0,0.3,0.1,0.3,0.3v0.5c0,0.2-0.1,0.3-0.3,0.3h-1.8c-0.2,0-0.3-0.1-0.3-0.3V611.2z M807.2,619.7c-0.4,0-0.8-0.4-0.8-0.8
		c-0.1-0.4,0.2-0.7,0.6-0.8c0.1,0,0.1,0,0.2,0c0.4,0,0.8,0.4,0.8,0.8C808,619.3,807.6,619.7,807.2,619.7z M807.3,615.4
		c-0.4,0.1-0.8-0.2-0.9-0.7c0-0.1,0-0.1,0-0.2v-1.2c-0.1-0.4,0.2-0.8,0.7-0.9c0.1,0,0.1,0,0.2,0h4.4c0.4-0.1,0.8,0.2,0.9,0.7
		c0,0.1,0,0.1,0,0.2v1.2c0.1,0.4-0.2,0.8-0.7,0.9c-0.1,0-0.1,0-0.2,0H807.3z M811,618.9c-0.1-0.4,0.2-0.7,0.6-0.8c0.1,0,0.1,0,0.2,0
		c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8C811.4,619.7,811,619.3,811,618.9z"
                />
                <circle className="st17" cx="799.6" cy="696.7" r="9.9" />
                <path
                  className="st6"
                  d="M802.3,700.2c0.8-0.2,1.4-1,1.4-1.8v-6.6c0-0.9-0.8-1.7-1.7-1.7c0,0-0.1,0-0.1,0h-4.5c-1-0.1-1.8,0.7-1.9,1.7
		c0,0,0,0,0,0v6.6c0,0.8,0.6,1.6,1.4,1.8l-2.1,3.2h1.2l1.5-2.3h4.2l1.5,2.3h1.3L802.3,700.2z M798.4,690.7c0.1-0.1,0.2-0.2,0.3-0.3
		h1.8c0.2,0,0.3,0.1,0.3,0.3v0.6c0,0.2-0.1,0.3-0.3,0.3h-1.8c-0.1-0.1-0.2-0.2-0.3-0.3V690.7z M797.3,699.2c-0.4,0-0.8-0.4-0.8-0.8
		c0-0.4,0.4-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8c0.1,0.4-0.2,0.7-0.6,0.8C797.4,699.2,797.4,699.2,797.3,699.2z M797.4,695
		c-0.5-0.1-0.9-0.5-0.9-1v-1.2c0-0.5,0.4-0.9,0.9-0.9h0h4.4c0.5,0,0.9,0.4,1,0.9v1.2c0,0.6-0.5,0.9-1,1H797.4z M801.1,698.4
		c0-0.4,0.4-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8c0.1,0.4-0.2,0.7-0.6,0.8c-0.1,0-0.1,0-0.2,0C801.5,699.2,801.1,698.8,801.1,698.4z"
                />
                <circle className="st17" cx="786.8" cy="789.3" r="9.9" />
                <path
                  className="st6"
                  d="M789.5,792.8c0.8-0.2,1.4-0.9,1.4-1.8v-6.5c0-1-0.8-1.8-1.8-1.8c0,0-0.1,0-0.1,0h-4.5c-1-0.1-1.8,0.7-1.9,1.7
		c0,0,0,0.1,0,0.1v6.5c0,0.9,0.6,1.7,1.5,1.8l-2.2,3.2h1.3l1.5-2.2h4.1l1.6,2.2h1.2L789.5,792.8z M785.6,783.4
		c0-0.2,0.1-0.3,0.3-0.3h1.8c0.2,0,0.3,0.1,0.3,0.3v0.5c-0.1,0.1-0.2,0.2-0.3,0.3h-1.8c-0.2,0-0.3-0.1-0.3-0.3V783.4z M784.4,791.8
		c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8c0.5,0,0.8,0.3,0.9,0.8c0,0.4-0.4,0.8-0.8,0.8C784.5,791.8,784.4,791.8,784.4,791.8
		L784.4,791.8z M784.6,787.6c-0.5,0.1-0.9-0.3-1-0.8c0-0.1,0-0.1,0-0.2v-1.1c0-0.6,0.4-1,1-1h4.4c0.5,0,0.9,0.4,0.9,0.9
		c0,0,0,0.1,0,0.1v1.1c0.1,0.5-0.3,0.9-0.8,1c0,0-0.1,0-0.1,0H784.6z M788.2,791c0.1-0.5,0.4-0.8,0.9-0.8c0.4,0,0.8,0.4,0.8,0.8
		c0,0.4-0.4,0.8-0.8,0.8c-0.4,0.1-0.8-0.3-0.9-0.7C788.2,791.1,788.2,791,788.2,791L788.2,791z"
                />
                <circle className="st17" cx="774.6" cy="854.9" r="9.9" />
                <path
                  className="st6"
                  d="M777.3,858.3c0.9-0.1,1.5-0.8,1.5-1.7V850c-0.1-1-0.9-1.8-1.9-1.8h-4.5c-1,0-1.8,0.8-1.9,1.8v6.6
		c0,0.8,0.6,1.6,1.4,1.7l-2.1,3.2h1.2l1.6-2.2h4.1l1.5,2.2h1.3L777.3,858.3z M773.4,848.9c0-0.2,0.1-0.3,0.3-0.3h1.8
		c0.2,0,0.3,0.1,0.3,0.3v0.5c0,0.2-0.1,0.3-0.3,0.3h-1.8c-0.2,0-0.3-0.1-0.3-0.3V848.9z M772.3,857.4c-0.4,0-0.8-0.4-0.8-0.8
		c0-0.4,0.4-0.8,0.8-0.8c0.4-0.1,0.7,0.2,0.8,0.6c0,0.1,0,0.1,0,0.2C773.1,857,772.7,857.4,772.3,857.4
		C772.3,857.4,772.3,857.4,772.3,857.4L772.3,857.4z M772.4,853.1c-0.4,0.1-0.8-0.2-0.9-0.7c0-0.1,0-0.1,0-0.2V851
		c-0.1-0.4,0.2-0.8,0.7-0.9c0.1,0,0.1,0,0.2,0h4.5c0.4-0.1,0.8,0.2,0.9,0.7c0,0.1,0,0.1,0,0.2v1.2c0.1,0.4-0.2,0.8-0.7,0.9
		c-0.1,0-0.1,0-0.2,0L772.4,853.1L772.4,853.1z M776.1,856.6c0-0.4,0.4-0.8,0.8-0.8c0.4-0.1,0.7,0.2,0.8,0.6c0,0.1,0,0.1,0,0.2
		c0,0.4-0.4,0.8-0.8,0.8C776.5,857.4,776.1,857,776.1,856.6z"
                />
                <circle className="st17" cx="684.6" cy="878.2" r="9.9" />
                <path
                  className="st6"
                  d="M687.3,881.7c0.8-0.2,1.4-1,1.4-1.8v-6.5c0-1-0.8-1.8-1.8-1.8h-4.6c-1,0-1.8,0.8-1.8,1.8v6.5
		c0,0.8,0.6,1.6,1.4,1.8l-2.1,3.2h1.2l1.5-2.2h4.2l1.5,2.2h1.2L687.3,881.7z M683.4,872.3c0-0.2,0.1-0.3,0.3-0.3h1.8
		c0.2,0,0.3,0.1,0.3,0.3v0.5c0,0.2-0.1,0.3-0.3,0.3h-1.8c-0.2,0-0.3-0.1-0.3-0.3V872.3z M682.3,880.7c-0.4,0.1-0.7-0.2-0.8-0.6
		c0-0.1,0-0.1,0-0.2c0-0.4,0.4-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8C683.1,880.3,682.7,880.7,682.3,880.7z M682.4,876.5
		c-0.5,0-0.9-0.4-0.9-0.9c0,0,0-0.1,0-0.1v-1.1c-0.1-0.5,0.3-0.9,0.8-1c0,0,0.1,0,0.1,0h4.4c0.5,0,0.9,0.4,0.9,0.9c0,0,0,0.1,0,0.1
		v1.1c0.1,0.5-0.3,0.9-0.8,1c0,0-0.1,0-0.1,0H682.4z M686.1,879.9c0-0.4,0.4-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8
		c0,0.4-0.4,0.8-0.8,0.8c-0.4,0.1-0.7-0.2-0.8-0.6C686.1,880,686.1,880,686.1,879.9z"
                />
                <circle className="st17" cx="764.1" cy="992.2" r="9.9" />
                <path
                  className="st6"
                  d="M766.8,995.7c0.8-0.2,1.4-1,1.4-1.8v-6.5c0-1-0.8-1.8-1.8-1.8h-4.6c-1,0-1.8,0.8-1.8,1.8v6.5
		c0,0.8,0.6,1.6,1.4,1.8l-2.1,3.2h1.2l1.5-2.2h4.2l1.5,2.2h1.2L766.8,995.7z M762.9,986.3c0-0.2,0.1-0.3,0.3-0.3h1.8
		c0.2,0,0.3,0.1,0.3,0.3v0.5c0,0.2-0.1,0.3-0.3,0.3h-1.8c-0.2,0-0.3-0.1-0.3-0.3L762.9,986.3L762.9,986.3z M761.8,994.7
		c-0.4,0.1-0.7-0.2-0.8-0.6c0-0.1,0-0.1,0-0.2c0-0.4,0.4-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8C762.6,994.3,762.2,994.7,761.8,994.7z
		 M761.9,990.5c-0.5,0-0.9-0.4-0.9-0.9c0,0,0-0.1,0-0.1v-1.1c-0.1-0.5,0.3-0.9,0.8-1c0,0,0.1,0,0.1,0h4.4c0.5,0,0.9,0.4,0.9,0.9
		c0,0,0,0.1,0,0.1v1.1c0.1,0.5-0.3,0.9-0.8,1c0,0-0.1,0-0.1,0H761.9z M765.6,993.9c0-0.4,0.4-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8
		c0,0,0,0,0,0c0,0.4-0.4,0.8-0.8,0.8C766,994.7,765.6,994.4,765.6,993.9C765.6,993.9,765.6,993.9,765.6,993.9z"
                />
                <circle className="st17" cx="843.3" cy="1028.1" r="9.9" />
                <path
                  className="st6"
                  d="M846,1031.5c0.8-0.1,1.4-0.9,1.4-1.7v-6.6c-0.1-1-0.9-1.8-1.9-1.8H841c-1,0-1.8,0.8-1.9,1.8v6.6
		c0,0.8,0.6,1.6,1.4,1.7l-2.1,3.2h1.3l1.5-2.2h4.1l1.6,2.2h1.2L846,1031.5z M842.1,1022.1c0-0.2,0.1-0.3,0.3-0.3h1.7
		c0.2,0,0.3,0.1,0.3,0.3v0.5c0,0.2-0.1,0.3-0.3,0.3h-1.7c-0.2,0-0.3-0.1-0.3-0.3V1022.1z M840.9,1030.6c-0.4,0-0.8-0.4-0.8-0.8
		c0-0.4,0.4-0.8,0.8-0.8c0,0,0,0,0,0c0.5-0.1,0.8,0.3,0.9,0.8C841.7,1030.2,841.3,1030.6,840.9,1030.6L840.9,1030.6z M841,1026.3
		c-0.5,0-0.9-0.4-0.9-0.9l0,0v-1.2c-0.1-0.4,0.2-0.8,0.7-0.9c0.1,0,0.1,0,0.2,0h4.5c0.4-0.1,0.8,0.2,0.9,0.7c0,0.1,0,0.1,0,0.2v1.2
		c0,0.5-0.4,0.9-0.9,0.9h0H841L841,1026.3z M844.7,1029.8c0-0.4,0.4-0.8,0.8-0.8c0,0,0,0,0,0c0.4-0.1,0.8,0.3,0.9,0.7
		c0,0,0,0.1,0,0.1c-0.1,0.5-0.4,0.8-0.9,0.8C845.1,1030.6,844.7,1030.2,844.7,1029.8L844.7,1029.8z"
                />
                <circle className="st17" cx="780.9" cy="1213.7" r="9.9" />
                <path
                  className="st6"
                  d="M783.6,1217.2c0.8-0.2,1.4-1,1.4-1.8v-6.6c0-0.9-0.8-1.7-1.7-1.7c0,0-0.1,0-0.1,0h-4.5c-1-0.1-1.8,0.7-1.9,1.7
		c0,0,0,0,0,0v6.6c0,0.8,0.6,1.6,1.4,1.8l-2.1,3.2h1.2l1.5-2.3h4.2l1.5,2.3h1.2L783.6,1217.2z M779.7,1207.7
		c0.1-0.1,0.2-0.2,0.3-0.3h1.8c0.2,0,0.3,0.1,0.3,0.3l0,0v0.6c0,0.2-0.1,0.3-0.3,0.3c0,0,0,0,0,0H780c-0.1-0.1-0.2-0.2-0.3-0.3
		L779.7,1207.7L779.7,1207.7z M778.6,1216.2c-0.4,0-0.8-0.4-0.8-0.8l0,0c0-0.4,0.4-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8l0,0
		c0.1,0.4-0.2,0.7-0.6,0.8C778.7,1216.2,778.7,1216.2,778.6,1216.2z M778.7,1212c-0.5-0.1-0.9-0.5-0.9-1v-1.2c0-0.5,0.4-0.9,0.9-0.9
		h0h4.4c0.5,0,0.9,0.4,1,0.9v1.2c0,0.6-0.5,0.9-1,1H778.7z M782.4,1215.4c0-0.4,0.4-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8l0,0
		c0.1,0.4-0.2,0.7-0.6,0.8c-0.1,0-0.1,0-0.2,0C782.8,1216.2,782.4,1215.8,782.4,1215.4L782.4,1215.4z"
                />
                <circle className="st17" cx="970.1" cy="1045.4" r="9.9" />
                <path
                  className="st6"
                  d="M972.8,1048.9c0.8-0.1,1.4-0.9,1.4-1.7v-6.6c0-1-0.8-1.8-1.8-1.8c0,0-0.1,0-0.1,0h-4.5
		c-0.9-0.1-1.7,0.7-1.8,1.6c0,0.1,0,0.1,0,0.2v6.6c0,0.8,0.6,1.6,1.4,1.7l-2.2,3.2h1.3l1.5-2.2h4.2l1.5,2.2h1.2L972.8,1048.9z
		 M968.9,1039.5c0-0.2,0.1-0.3,0.3-0.3c0,0,0,0,0,0h1.8c0.2,0,0.3,0.1,0.3,0.3l0,0v0.5c-0.1,0.1-0.2,0.2-0.3,0.3h-1.8
		c-0.2,0-0.3-0.1-0.3-0.3l0,0L968.9,1039.5L968.9,1039.5z M967.8,1048c-0.5-0.1-0.8-0.4-0.8-0.9c0-0.4,0.4-0.8,0.8-0.8c0,0,0,0,0,0
		c0.4,0,0.8,0.4,0.8,0.8C968.6,1047.5,968.2,1047.9,967.8,1048z M967.9,1043.7c-0.6,0-1-0.4-1-1v-1.1c0-0.6,0.4-1,1-1h4.4
		c0.5,0,0.9,0.4,0.9,0.9c0,0,0,0.1,0,0.1v1.1c0.1,0.5-0.3,0.9-0.8,1c0,0-0.1,0-0.1,0H967.9z M971.6,1047.1c0-0.4,0.4-0.8,0.8-0.8
		c0,0,0,0,0,0c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.9C971.9,1047.9,971.6,1047.6,971.6,1047.1z"
                />
                <circle className="st17" cx="1141.9" cy="962.4" r="9.9" />
                <path
                  className="st6"
                  d="M1144.6,965.8c0.8-0.1,1.4-0.9,1.4-1.7v-6.6c0-1-0.8-1.8-1.8-1.8l0,0h-4.6c-1,0-1.8,0.8-1.8,1.8c0,0,0,0,0,0
		v6.6c0,0.8,0.6,1.6,1.4,1.7l-2.1,3.2h1.2l1.5-2.2h4.2l1.5,2.2h1.2L1144.6,965.8z M1140.7,956.4c0-0.2,0.1-0.3,0.3-0.3l0,0h1.8
		c0.2,0,0.3,0.1,0.3,0.3c0,0,0,0,0,0v0.5c0,0.2-0.1,0.3-0.3,0.3l0,0h-1.8c-0.2,0-0.3-0.1-0.3-0.3c0,0,0,0,0,0V956.4z M1139.6,964.9
		c-0.5-0.1-0.8-0.4-0.8-0.9c0-0.4,0.4-0.8,0.8-0.8c0.4,0,0.8,0.4,0.8,0.8c0,0,0,0,0,0C1140.4,964.5,1140.1,964.8,1139.6,964.9
		L1139.6,964.9z M1139.7,960.6c-0.5,0-0.9-0.4-0.9-0.9v0v-1.2c-0.1-0.4,0.2-0.8,0.7-0.9c0.1,0,0.1,0,0.2,0h4.4
		c0.4-0.1,0.8,0.2,0.9,0.7c0,0.1,0,0.1,0,0.2v1.2c0,0.5-0.4,0.9-0.9,0.9l0,0H1139.7z M1143.4,964c0-0.4,0.4-0.8,0.8-0.8
		c0.4,0,0.8,0.4,0.8,0.8c0,0,0,0,0,0c0,0.4-0.4,0.8-0.8,0.8C1143.8,964.8,1143.4,964.5,1143.4,964C1143.4,964,1143.4,964,1143.4,964
		z"
                />
                <circle className="st17" cx="1308.3" cy="955.4" r="9.9" />
                <path
                  className="st6"
                  d="M1311,958.9c0.8-0.2,1.4-1,1.4-1.8v-6.5c0-1-0.8-1.8-1.8-1.8l0,0h-4.6c-1,0-1.8,0.8-1.8,1.8c0,0,0,0,0,0v6.5
		c0,0.8,0.6,1.6,1.4,1.8l-2.1,3.2h1.2l1.5-2.2h4.2l1.5,2.2h1.2L1311,958.9z M1307.1,949.5c0-0.2,0.1-0.3,0.3-0.3l0,0h1.8
		c0.2,0,0.3,0.1,0.3,0.3c0,0,0,0,0,0v0.5c0,0.2-0.1,0.3-0.3,0.3l0,0h-1.8c-0.2,0-0.3-0.1-0.3-0.3c0,0,0,0,0,0V949.5z M1306,957.9
		c-0.4,0.1-0.7-0.2-0.8-0.6c0-0.1,0-0.1,0-0.2c0-0.4,0.4-0.8,0.8-0.8l0,0c0.4,0,0.8,0.4,0.8,0.8
		C1306.8,957.5,1306.4,957.9,1306,957.9L1306,957.9z M1306.1,953.7c-0.5,0-0.9-0.4-0.9-0.9c0,0,0-0.1,0-0.1v-1.1
		c-0.1-0.5,0.3-0.9,0.8-1c0,0,0.1,0,0.1,0h4.4c0.5,0,0.9,0.4,0.9,0.9c0,0,0,0.1,0,0.1v1.1c0.1,0.5-0.3,0.9-0.8,1c0,0-0.1,0-0.1,0
		H1306.1z M1309.8,957.1c0-0.4,0.4-0.8,0.8-0.8l0,0c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8l0,0c-0.4,0.1-0.7-0.2-0.8-0.6
		C1309.8,957.2,1309.8,957.2,1309.8,957.1L1309.8,957.1z"
                />
                <circle className="st17" cx="1420.5" cy="970.8" r="9.9" />
                <path
                  className="st6"
                  d="M1423.2,974.2c0.8-0.1,1.4-0.9,1.4-1.7v-6.6c0-1-0.8-1.8-1.8-1.8h-4.6c-1,0-1.8,0.8-1.8,1.8v6.6
		c0,0.8,0.6,1.6,1.4,1.7l-2.1,3.2h1.2l1.5-2.2h4.2l1.5,2.2h1.2L1423.2,974.2z M1419.3,964.8c0-0.2,0.1-0.3,0.3-0.3l0,0h1.8
		c0.2,0,0.3,0.1,0.3,0.3c0,0,0,0,0,0v0.5c0,0.2-0.1,0.3-0.3,0.3l0,0h-1.8c-0.2,0-0.3-0.1-0.3-0.3c0,0,0,0,0,0V964.8z M1418.2,973.3
		c-0.4,0-0.8-0.4-0.8-0.8c0,0,0,0,0,0c-0.1-0.4,0.3-0.8,0.7-0.9c0,0,0.1,0,0.1,0c0.5,0.1,0.8,0.4,0.8,0.9
		C1419,972.9,1418.6,973.3,1418.2,973.3z M1418.3,969c-0.5,0-0.9-0.4-0.9-0.9v0v-1.2c-0.1-0.4,0.2-0.8,0.7-0.9c0.1,0,0.1,0,0.2,0
		h4.4c0.4-0.1,0.8,0.2,0.9,0.7c0,0.1,0,0.1,0,0.2v1.2c0,0.5-0.4,0.9-0.9,0.9l0,0H1418.3z M1422,972.5c0-0.5,0.4-0.9,0.8-0.8
		s0.8,0.3,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8C1422.4,973.3,1422,973,1422,972.5C1422,972.5,1422,972.5,1422,972.5L1422,972.5z"
                />
                <circle className="st17" cx="1574.2" cy="1026.6" r="9.9" />
                <path
                  className="st6"
                  d="M1576.9,1030.1c0.8-0.2,1.4-1,1.4-1.8v-6.6c0-1-0.8-1.8-1.8-1.8h-4.6c-1,0-1.8,0.8-1.8,1.8v6.6
		c0,0.8,0.6,1.6,1.4,1.8l-2.1,3.2h1.2l1.5-2.3h4.2l1.5,2.3h1.2L1576.9,1030.1z M1573,1020.6c0-0.2,0.1-0.3,0.3-0.3l0,0h1.8
		c0.1,0.1,0.2,0.2,0.3,0.3v0.5c0,0.2-0.1,0.3-0.3,0.3l0,0h-1.8c-0.2,0-0.3-0.1-0.3-0.3c0,0,0,0,0,0V1020.6z M1571.9,1029.1
		c-0.4,0-0.8-0.4-0.8-0.8v0c-0.1-0.4,0.2-0.7,0.6-0.8c0.1,0,0.1,0,0.2,0c0.4,0,0.8,0.4,0.8,0.8v0
		C1572.7,1028.7,1572.3,1029.1,1571.9,1029.1z M1572,1024.8c-0.4,0.1-0.8-0.2-0.9-0.7c0-0.1,0-0.1,0-0.2v-1.2
		c-0.1-0.4,0.2-0.8,0.7-0.9c0.1,0,0.1,0,0.2,0h4.4c0.4-0.1,0.8,0.2,0.9,0.7c0,0.1,0,0.1,0,0.2v1.2c0.1,0.4-0.2,0.8-0.7,0.9
		c-0.1,0-0.1,0-0.2,0H1572z M1575.7,1028.3c-0.1-0.4,0.2-0.7,0.6-0.8c0.1,0,0.1,0,0.2,0c0.4,0,0.8,0.4,0.8,0.8v0
		c0,0.4-0.4,0.8-0.8,0.8C1576.1,1029.1,1575.7,1028.7,1575.7,1028.3L1575.7,1028.3z"
                />
                <circle className="st17" cx="1685.1" cy="1016.7" r="9.9" />
                <path
                  className="st6"
                  d="M1687.8,1020.2c0.8-0.2,1.4-1,1.4-1.8v-6.6c0-1-0.8-1.8-1.8-1.8h-4.6c-1,0-1.8,0.8-1.8,1.8v6.6
		c0,0.8,0.6,1.6,1.4,1.8l-2.1,3.1h1.2l1.5-2.2h4.2l1.5,2.2h1.2L1687.8,1020.2z M1683.9,1010.7c0-0.2,0.1-0.3,0.3-0.3l0,0h1.8
		c0.2,0,0.3,0.1,0.3,0.3c0,0,0,0,0,0v0.5c0,0.2-0.1,0.3-0.3,0.3l0,0h-1.8c-0.2,0-0.3-0.1-0.3-0.3c0,0,0,0,0,0V1010.7z
		 M1682.8,1019.2c-0.4,0-0.8-0.4-0.8-0.8c0,0,0,0,0,0c-0.1-0.4,0.2-0.7,0.6-0.8c0.1,0,0.1,0,0.2,0c0.4,0,0.8,0.4,0.8,0.8
		c0,0,0,0,0,0C1683.6,1018.8,1683.2,1019.2,1682.8,1019.2z M1682.9,1014.9c-0.4,0.1-0.8-0.2-0.9-0.7c0-0.1,0-0.1,0-0.2v-1.2
		c-0.1-0.4,0.2-0.8,0.7-0.9c0.1,0,0.1,0,0.2,0h4.4c0.4-0.1,0.8,0.2,0.9,0.7c0,0.1,0,0.1,0,0.2v1.2c0.1,0.4-0.2,0.8-0.7,0.9
		c-0.1,0-0.1,0-0.2,0H1682.9z M1686.6,1018.4c-0.1-0.4,0.2-0.7,0.6-0.8c0.1,0,0.1,0,0.2,0c0.4,0,0.8,0.4,0.8,0.8c0,0,0,0,0,0
		c0,0.4-0.4,0.8-0.8,0.8C1687,1019.2,1686.6,1018.8,1686.6,1018.4C1686.6,1018.4,1686.6,1018.4,1686.6,1018.4z"
                />
                <circle className="st17" cx="483.3" cy="904.4" r="9.9" />
                <path
                  className="st6"
                  d="M486,907.9c0.8-0.2,1.4-1,1.4-1.8v-6.6c0-1-0.8-1.8-1.8-1.8H481c-1,0-1.8,0.8-1.8,1.8v6.6
		c0,0.8,0.6,1.6,1.4,1.8l-2.1,3.2h1.2l1.5-2.3h4.2l1.5,2.3h1.2L486,907.9z M482.1,898.4c0-0.2,0.1-0.3,0.3-0.3h1.8
		c0.1,0.1,0.2,0.2,0.3,0.3v0.5c0,0.2-0.1,0.3-0.3,0.3h-1.8c-0.2,0-0.3-0.1-0.3-0.3V898.4z M481,906.9c-0.4,0-0.8-0.4-0.8-0.8
		c-0.1-0.4,0.2-0.7,0.6-0.8c0.1,0,0.1,0,0.2,0c0.4,0,0.8,0.4,0.8,0.8C481.8,906.5,481.4,906.9,481,906.9z M481.1,902.6
		c-0.4,0.1-0.8-0.2-0.9-0.7c0-0.1,0-0.1,0-0.2v-1.2c-0.1-0.4,0.2-0.8,0.7-0.9c0.1,0,0.1,0,0.2,0h4.4c0.4-0.1,0.8,0.2,0.9,0.7
		c0,0.1,0,0.1,0,0.2v1.2c0.1,0.4-0.2,0.8-0.7,0.9c-0.1,0-0.1,0-0.2,0H481.1z M484.8,906.1c-0.1-0.4,0.2-0.7,0.6-0.8
		c0.1,0,0.1,0,0.2,0c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8C485.2,906.9,484.8,906.5,484.8,906.1L484.8,906.1L484.8,906.1z"
                />
                <circle className="st17" cx="303.9" cy="905.3" r="9.9" />
                <path
                  className="st6"
                  d="M306.6,908.8c0.8-0.2,1.4-1,1.4-1.8v-6.6c0-1-0.8-1.8-1.8-1.8h-4.6c-1,0-1.8,0.8-1.8,1.8v6.6
		c0,0.8,0.6,1.6,1.4,1.8l-2.1,3.1h1.2l1.5-2.2h4.2l1.5,2.2h1.2L306.6,908.8z M302.7,899.3c0-0.2,0.1-0.3,0.3-0.3h1.8
		c0.2,0,0.3,0.1,0.3,0.3v0.5c0,0.2-0.1,0.3-0.3,0.3H303c-0.2,0-0.3-0.1-0.3-0.3V899.3z M301.6,907.8c-0.4,0-0.8-0.4-0.8-0.8
		c-0.1-0.4,0.2-0.7,0.6-0.8c0.1,0,0.1,0,0.2,0c0.4,0,0.8,0.4,0.8,0.8C302.4,907.4,302,907.8,301.6,907.8z M301.7,903.5
		c-0.5,0.1-0.9-0.3-1-0.8c0,0,0-0.1,0-0.1v-1.2c0-0.5,0.4-0.9,0.9-0.9c0,0,0.1,0,0.1,0h4.4c0.4-0.1,0.8,0.2,0.9,0.7
		c0,0.1,0,0.1,0,0.2v1.2c0.1,0.4-0.2,0.8-0.7,0.9c-0.1,0-0.1,0-0.2,0H301.7z M305.4,907c-0.1-0.4,0.2-0.7,0.6-0.8c0.1,0,0.1,0,0.2,0
		c0.4,0,0.8,0.4,0.8,0.8c0,0.4-0.4,0.8-0.8,0.8C305.8,907.8,305.4,907.4,305.4,907L305.4,907L305.4,907z"
                />
                <path
                  className="st15"
                  d="M379.8,849.9h-2.4v-8.8l-3.7,8.8h-2l-3.6-8.7v8.7h-2.4v-12.6h3.3l3.7,9.1l3.7-9.1h3.4L379.8,849.9z"
                />
                <path
                  className="st15"
                  d="M388.3,846.8l2,0.6c-0.3,0.8-0.7,1.5-1.4,2c-0.8,0.5-1.7,0.8-2.6,0.8c-1.2,0-2.4-0.4-3.2-1.3
		c-0.9-0.9-1.4-2.1-1.3-3.4c-0.1-1.2,0.4-2.4,1.2-3.3c0.8-0.8,1.9-1.3,3.1-1.3c1.2-0.1,2.3,0.4,3.1,1.2c0.8,0.9,1.3,2.1,1.2,3.3v0.8
		h-6.2c0,0.6,0.3,1.1,0.7,1.4c0.4,0.4,1,0.5,1.5,0.5C387.3,848.1,388,847.6,388.3,846.8z M384.2,844.5h3.9c-0.1-1-1-1.8-2-1.7
		c-0.5,0-1,0.2-1.4,0.6C384.4,843.7,384.2,844.1,384.2,844.5L384.2,844.5z"
                />
                <path className="st15" d="M394.6,849.9h-2.3V837h2.3V849.9z" />
                <path
                  className="st15"
                  d="M399.4,849.9h-2.3V837h2.4v5.1c0.2-0.4,0.6-0.6,1-0.8c0.5-0.2,1-0.4,1.6-0.4c1.1,0,2.2,0.5,3,1.3
		c0.7,1,1.1,2.1,1,3.3c0.1,1.2-0.3,2.4-1.1,3.3c-0.7,0.9-1.9,1.4-3,1.3c-1,0.1-2-0.4-2.6-1.3V849.9z M403.2,847.3
		c0.4-0.5,0.7-1.1,0.6-1.8c0-0.7-0.2-1.3-0.6-1.8c-0.4-0.4-1-0.6-1.6-0.6c-0.6,0-1.2,0.2-1.6,0.6c-0.4,0.5-0.6,1.1-0.6,1.8
		c-0.1,0.7,0.2,1.3,0.7,1.8c0.4,0.5,0.9,0.7,1.5,0.7C402.2,848,402.8,847.8,403.2,847.3L403.2,847.3z"
                />
                <path
                  className="st15"
                  d="M408.7,842.2c0.8-0.9,2-1.4,3.2-1.3c2.4-0.1,4.5,1.8,4.6,4.2c0,0.1,0,0.3,0,0.4c0.1,1.3-0.4,2.5-1.3,3.4
		c-0.9,0.8-2.1,1.3-3.3,1.3c-1.2,0-2.4-0.4-3.2-1.3c-0.9-0.9-1.4-2.1-1.4-3.4C407.3,844.3,407.8,843.1,408.7,842.2z M410.4,847.4
		c0.4,0.4,0.9,0.6,1.5,0.6c0.6,0,1.2-0.2,1.6-0.6c0.5-0.5,0.7-1.2,0.7-1.9c0-0.7-0.3-1.3-0.7-1.8c-0.4-0.4-1-0.6-1.6-0.6
		c-0.6,0-1.1,0.2-1.5,0.6c-0.5,0.5-0.7,1.1-0.7,1.8C409.7,846.2,409.9,846.9,410.4,847.4L410.4,847.4z"
                />
                <path
                  className="st15"
                  d="M424.1,849.9c-0.1-0.3-0.1-0.6-0.1-0.9c-0.2,0.4-0.6,0.7-1,0.8c-0.4,0.2-0.9,0.3-1.4,0.3
		c-0.9,0.1-1.8-0.3-2.5-0.9c-0.5-0.7-0.8-1.6-0.8-2.5v-5.5h2.3v5c0,0.5,0.1,0.9,0.4,1.3c0.7,0.7,1.7,0.7,2.4,0
		c0.3-0.3,0.5-0.8,0.5-1.3v-5h2.3v7.1c0,0.6,0.1,1.1,0.1,1.6L424.1,849.9z"
                />
                <path
                  className="st15"
                  d="M434.1,841.1v2.4h-0.7c-1.2-0.1-2.2,0.7-2.3,1.8c0,0.2,0,0.4,0,0.7v4h-2.3v-8.7h2.2v1.3
		c0.5-0.9,1.5-1.5,2.5-1.4L434.1,841.1z"
                />
                <path
                  className="st15"
                  d="M438.1,844.9v5h-2.3v-8.7h2.2v1.1c0.2-0.5,0.6-0.8,1.1-1c0.5-0.2,1-0.4,1.5-0.4c0.9,0,1.7,0.3,2.3,1
		c0.6,0.7,0.9,1.6,0.8,2.5v5.5h-2.3v-5.1c0-0.5-0.2-0.9-0.4-1.3c-0.4-0.3-0.8-0.5-1.3-0.4c-0.4,0-0.8,0.2-1.1,0.5
		C438.3,844,438.1,844.4,438.1,844.9z"
                />
                <path
                  className="st15"
                  d="M452,846.8l2,0.6c-0.3,0.8-0.7,1.5-1.4,2c-0.8,0.5-1.7,0.8-2.6,0.8c-1.2,0-2.4-0.4-3.2-1.3
		c-0.9-0.9-1.4-2.1-1.3-3.4c-0.1-1.2,0.4-2.4,1.2-3.3c0.8-0.8,1.9-1.3,3.1-1.3c1.2-0.1,2.3,0.4,3.1,1.2c0.8,0.9,1.3,2.1,1.2,3.3v0.8
		h-6.2c0,0.6,0.3,1.1,0.7,1.4c0.4,0.4,1,0.5,1.5,0.5C451,848.1,451.7,847.6,452,846.8z M447.8,844.5h4c-0.1-1-1-1.8-2-1.7
		c-0.5,0-1,0.2-1.4,0.6C448.1,843.7,447.9,844.1,447.8,844.5z"
                />
                <path
                  className="st15"
                  d="M466.2,850.2c-3.4,0.1-6.3-2.6-6.4-6c0-0.2,0-0.4,0-0.6c-0.1-1.8,0.6-3.5,1.9-4.7c1.2-1.2,2.8-1.9,4.5-1.9
		c2.7-0.1,5.1,1.6,5.8,4.2l-2.4,0.7c-0.1-0.7-0.5-1.4-1.1-1.8c-1.6-1.1-3.6-0.9-5,0.4c-0.8,0.8-1.3,1.9-1.2,3.1
		c-0.1,1.2,0.4,2.3,1.2,3.1c0.7,0.7,1.7,1.1,2.7,1.1c0.9,0,1.7-0.3,2.4-0.8c0.5-0.5,0.9-1.1,1.1-1.8l2.3,0.7c-0.1,0.5-0.3,1-0.6,1.5
		c-0.3,0.5-0.7,1-1.1,1.4c-0.6,0.4-1.2,0.7-1.8,1C467.8,850,467,850.2,466.2,850.2z"
                />
                <path
                  className="st15"
                  d="M474.1,837.3h4.5c1-0.1,2,0.3,2.8,1c0.7,0.6,1,1.5,1,2.4c0,0.6-0.1,1.2-0.5,1.7c-0.3,0.5-0.8,0.8-1.3,1
		c0.6,0.1,1.2,0.5,1.6,1c0.4,0.6,0.6,1.3,0.6,2c0.1,0.9-0.3,1.9-1,2.5c-0.8,0.7-1.8,1.1-2.9,1h-4.8L474.1,837.3z M476.5,842.5h1.7
		c0.5,0,1-0.1,1.4-0.4c0.3-0.3,0.4-0.8,0.4-1.2c0-0.4-0.1-0.8-0.4-1.1c-0.4-0.3-0.9-0.4-1.4-0.4h-1.7V842.5z M476.5,847.9h2
		c0.5,0,1-0.2,1.4-0.5c0.7-0.7,0.7-1.7,0-2.4c-0.4-0.3-0.9-0.5-1.4-0.5h-2V847.9z"
                />
                <path
                  className="st15"
                  d="M489.4,849.9h-4.5v-12.6h4.5c1.7-0.1,3.3,0.5,4.5,1.7c1.2,1.2,1.8,2.9,1.7,4.6c0.1,1.7-0.5,3.4-1.7,4.6
		C492.7,849.3,491.1,849.9,489.4,849.9z M487.4,847.6h1.9c1,0.1,2-0.3,2.7-1c1.5-1.7,1.5-4.3,0-6c-0.7-0.7-1.7-1.1-2.7-1h-1.9V847.6
		z"
                />
                <ellipse
                  transform="matrix(0.4305 -0.9026 0.9026 0.4305 -450.9421 1122.5574)"
                  className="st8"
                  cx="664.1"
                  cy="918.6"
                  rx="9.5"
                  ry="12.6"
                />
                <path
                  className="st15"
                  d="M697.4,925.5h-2.1V918l-3.1,7.5h-1.7l-3.1-7.5v7.5h-2.1v-10.8h2.8l3.3,7.8l3.1-7.8h2.9L697.4,925.5z"
                />
                <path
                  className="st15"
                  d="M704.7,925.8c-1.5,0-2.9-0.6-3.9-1.6c-1-1.1-1.6-2.5-1.6-4c0-1.5,0.5-3,1.6-4.1c1-1,2.4-1.6,3.9-1.6
		c1.2,0,2.4,0.3,3.3,1.1c0.8,0.6,1.4,1.5,1.7,2.5l-2,0.6c-0.2-0.6-0.5-1.1-1-1.5c-0.6-0.5-1.3-0.7-2-0.7c-0.9,0-1.7,0.4-2.3,1
		c-0.7,0.7-1.1,1.7-1,2.7c-0.1,1,0.3,1.9,1,2.6c0.6,0.6,1.4,0.9,2.3,0.9c0.7,0,1.5-0.2,2.1-0.6c0.5-0.4,0.8-1,1-1.6l1.9,0.6
		c-0.1,0.4-0.3,0.9-0.5,1.3c-0.5,1-1.4,1.7-2.5,2C706.1,925.7,705.4,925.8,704.7,925.8z"
                />
                <path
                  className="st15"
                  d="M721.2,925.5h-1.7l-0.2-1.2c-0.3,0.4-0.7,0.8-1.2,1.1c-0.6,0.2-1.3,0.4-2,0.4c-1.4,0-2.8-0.6-3.8-1.6
		c-1.1-1.1-1.6-2.5-1.6-4c-0.1-1.5,0.6-3,1.7-4.1c1-1.1,2.4-1.7,3.9-1.6c1.2-0.1,2.3,0.3,3.2,1c0.8,0.6,1.4,1.4,1.7,2.3l-2,0.8
		c-0.2-0.6-0.5-1.1-1-1.5c-0.5-0.4-1.2-0.6-1.9-0.6c-0.9,0-1.7,0.3-2.4,0.9c-0.7,0.8-1.1,1.8-1,2.8c-0.1,1,0.3,2,1,2.7
		c0.6,0.6,1.5,1,2.4,1c0.7,0,1.5-0.2,2-0.7c0.4-0.4,0.7-0.9,0.9-1.4h-3.4v-1.9h5.4L721.2,925.5z"
                />
								<g id="Group-2" transform="translate(1121, 340)">
  
  <path id="Shape" d="M53.5,31.59997 L108.09998,29.699982 L95.19995,96.799988 C94.79993,94.599976 93,93.099976 90.79993,93 C86.8999,92.700012 73.69995,94.5 70.3999,94.100006 C67.09985,93.700012 58.29993,91.300018 58.29993,91.300018 L56.3999,63.200012 L59.09985,42.200012 L55.8999,26 L53.5,31.49997" fill="#636667"></path>

	<g id="Page-1" stroke="none" stroke-width="1" fill="none" fillRule="evenodd" transform="translate(28 30)">
        <g id="demo" fillRule="nonzero">
            <polygon id="Fill-1" fill="#3C3C3B" points="0 0 0 29.1964193 42.9211165 29.1964193 48.6959082 34 54.4712432 29.1964193 99 29.1964193 99 0"></polygon>
            <path d="M86,19.802424 L86,19.6460177 C85.1103641,19.567526 84.9546641,19.2853021 84.9546641,17.7518276 L84.9546641,9 C84.0221144,9.36013853 82.4970239,9.81435167 81.2250146,10.0959985 L81.2536237,10.2679877 C81.7201741,10.2841477 81.9743559,10.4088111 82.1718693,10.7222009 C82.3979917,11.0505964 82.4546602,11.4113121 82.4546602,12.3503271 L82.4546602,12.9609465 C82.0728371,12.8045402 81.9039329,12.7577915 81.5787783,12.7577915 C79.4457429,12.7577915 77.7363427,14.7928049 77.7363427,17.3599461 C77.7363427,19.4578684 78.8240429,20.9924971 80.3067697,20.9924971 C81.0841691,20.9924971 81.7762916,20.6006156 82.4546602,19.7400923 L82.4546602,20.9924971 C84.0507234,20.4130435 84.6300592,20.2093113 86,19.802424 Z M82.4546602,19.4734513 C82.1295056,19.8803386 81.931442,20.0061562 81.5925329,20.0061562 C80.7452606,20.0061562 80.3777424,19.0983071 80.3777424,16.9218931 C80.3777424,14.3541747 80.8580467,12.9609465 81.7476826,12.9609465 C82.1856239,12.9609465 82.4546602,13.3055021 82.4546602,13.8376299 L82.4546602,19.4734513 Z M73.7101484,20.7887649 L77.7220385,20.7887649 L77.7220385,20.6323586 C76.9589433,20.5538669 76.8604614,20.3813005 76.874216,19.0983071 L76.874216,15.0427087 C76.874216,14.2133513 76.7894887,13.7591381 76.5496117,13.4151597 C76.281125,12.9921123 75.7441522,12.7577915 75.1086982,12.7577915 C74.1766987,12.7577915 73.512635,13.1329357 72.5377216,14.2445171 L72.5377216,12.7577915 C71.1672311,13.2899192 70.0938359,13.6500577 68.8086224,13.9628703 L68.8366818,14.1192767 C69.3026812,14.1510196 69.5568631,14.2762601 69.7549267,14.5734898 C69.9810491,14.9024625 70.0371674,15.2776068 70.0371674,16.2171989 L70.0371674,18.7849173 C70.0371674,20.3813005 69.9106267,20.5856099 68.9076545,20.6323586 L68.9076545,20.7887649 L73.2017853,20.7887649 L73.2017853,20.6323586 C72.608144,20.5538669 72.523967,20.3662947 72.5377216,19.0983071 L72.5377216,14.4949981 C72.9332986,14.1192767 73.2584531,13.9472874 73.6111169,13.9472874 C73.8515441,13.9472874 74.1200302,14.1192767 74.2185121,14.3385917 C74.345603,14.6046557 74.3742121,14.8863024 74.3742121,16.1387072 L74.3742121,19.0983071 C74.3885163,20.3662947 74.3032394,20.5538669 73.7101484,20.6323586 L73.7101484,20.7887649 Z M68.9637721,16.1237014 C68.8647406,15.3093497 68.7238951,14.8395537 68.3706817,14.3074259 C67.7203726,13.321085 66.6755864,12.7577915 65.5031596,12.7577915 C63.3558193,12.7577915 61.6607243,14.6202385 61.6607243,16.9848019 C61.6607243,19.2541362 63.271092,20.9924971 65.3898232,20.9924971 C66.478073,20.9924971 67.4386822,20.506541 68.0878908,19.6304348 C68.4834678,19.0983071 68.7095909,18.6596768 69.0204406,17.7356675 L68.8933496,17.6733359 C68.3140132,18.6435167 67.6499501,19.0353982 66.6332234,19.0353982 C65.0795238,19.0353982 64.3021237,18.0646403 64.2883691,16.1237014 L68.9637721,16.1237014 Z M66.4494639,15.9355521 L64.2746146,15.9355521 C64.2746146,14.025202 64.7120056,12.9609465 65.4745505,12.9609465 C65.9411002,12.9609465 66.2090366,13.2737591 66.3504324,13.9784533 C66.4214051,14.4015006 66.4494639,14.8863024 66.4494639,15.9355521 Z M61.2579948,17.8297422 C61.2579948,16.8907272 60.7776903,16.1387072 59.8742999,15.6539053 C59.308718,15.3405156 58.7018729,15.1841093 57.3033232,14.99596 C58.1643501,14.9492113 58.7299319,14.8551366 59.2239908,14.6831473 C60.1284816,14.3385917 60.6225404,13.6656406 60.6225404,12.8045402 C60.6225404,12.0057715 60.1989042,11.3795691 59.3373272,10.9259331 C58.5318682,10.5028857 57.4584731,10.3464794 55.3391917,10.3464794 L51.6387019,10.3464794 L51.6387019,10.5028857 C52.2604018,10.5502116 52.5145835,10.6592921 52.6977924,10.941516 C52.9096105,11.2699115 52.9525243,11.5521355 52.9525243,13.0238553 L52.9525243,18.111389 C52.9525243,19.5831089 52.9096105,19.8647557 52.6977924,20.1937283 C52.5145835,20.4759523 52.2604018,20.5856099 51.6387019,20.6323586 L51.6387019,20.7887649 L56.9215005,20.7887649 C59.5915089,20.7887649 61.2579948,19.6616006 61.2579948,17.8297422 Z M56.102287,14.9492113 L55.7347689,14.9492113 L55.7347689,10.5346287 L56.0736778,10.5346287 C56.7806552,10.5346287 57.1333185,10.6437091 57.4161095,10.941516 C57.7550184,11.3016545 57.9101683,11.880531 57.9101683,12.7422085 C57.9101683,13.4463255 57.7973821,13.9472874 57.5575049,14.3541747 C57.3033232,14.8083879 56.9644143,14.9492113 56.102287,14.9492113 Z M58.2919911,17.8764909 C58.2919911,19.7712582 57.7836276,20.6006156 56.6106505,20.6006156 C55.8761643,20.6006156 55.7347689,20.3345517 55.7347689,18.9413236 L55.7347689,15.1373605 L56.1727097,15.1373605 C57.0205323,15.1373605 57.4161095,15.262601 57.7550184,15.6539053 C58.108232,16.0607926 58.2919911,16.8122355 58.2919911,17.8764909 Z M51.8543713,19.6385148 C51.5858849,19.7954983 51.4593442,19.842247 51.2898897,19.842247 C51.0500126,19.842247 50.8381945,19.7170065 50.7672217,19.5132743 C50.6830446,19.3257022 50.6681898,19.1225471 50.6681898,18.5280877 L50.6681898,14.9290111 C50.6681898,14.0373221 50.5273446,13.5681031 50.118013,13.2079646 C49.7928584,12.9107349 49.3983816,12.7699115 48.8751634,12.7699115 C47.6471685,12.7699115 46.0092919,13.2391305 44.9226925,13.9276645 C44.047361,14.4597922 43.6380295,15.0230858 43.6380295,15.680454 C43.6380295,16.3216622 44.047361,16.7752982 44.6261472,16.7752982 C45.431056,16.7752982 45.9955374,16.1496729 46.1231785,15.1639092 C46.2359648,14.1781455 46.2497192,14.0840708 46.3762599,13.802424 C46.5462645,13.4116968 46.926987,13.1767988 47.3368688,13.1767988 C47.6048049,13.1767988 47.8171732,13.3020393 47.972323,13.5519431 C48.1131683,13.802424 48.1698366,14.2716429 48.1698366,15.3358984 L48.1698366,16.1496729 C47.1960235,16.4624856 46.3625054,16.7752982 45.6852377,17.1036937 C44.1320883,17.8233936 43.624275,18.3711043 43.624275,19.2945363 C43.624275,20.2953059 44.4429382,21 45.6285694,21 C46.743778,21 47.4920186,20.5619469 48.1698366,19.5132743 C48.3530455,20.514621 48.8052909,21 49.5815905,21 C50.3012218,21 50.9647352,20.6554444 51.9390985,19.7481724 L51.8543713,19.6385148 Z M48.1698366,18.7624086 C48.1698366,19.4821085 47.844682,19.9357445 47.3225642,19.9357445 C46.7866918,19.9357445 46.5039009,19.4197769 46.5039009,18.4807618 C46.5039009,17.291843 46.8846233,16.7908811 48.1698366,16.3372451 L48.1698366,18.7624086 Z M43.9208204,14.1313967 C43.9208204,13.3643709 43.3557887,12.7699115 42.6504619,12.7699115 C41.7327669,12.7699115 41.083008,13.5051943 40.5185264,15.1639092 L40.5185264,12.7699115 C38.9983877,13.3851481 38.4806712,13.5617545 37.1817036,13.9028473 C37.1718004,13.9778761 37.1855548,14.0021162 37.1855548,14.0806079 C37.1855548,14.0915737 37.198759,14.1539053 37.198759,14.1654483 C37.5013563,14.2237399 37.6939183,14.3501347 37.8501685,14.5844555 C38.0762912,14.9134283 38.1324093,15.2885725 38.1324093,16.2275875 L38.1324093,18.7935745 C38.1324093,20.3893805 38.0058686,20.5931127 37.0028961,20.6398615 L37.0028961,20.7962678 L41.7608259,20.7962678 L41.7608259,20.6398615 C40.7589538,20.5931127 40.6313127,20.3893805 40.6313127,18.7935745 L40.6313127,16.838207 C40.6313127,15.445556 40.6736763,15.0698345 40.8854944,14.6473644 C40.9982807,14.4286264 41.1534306,14.3189689 41.3234353,14.3189689 C41.4785852,14.3189689 41.605676,14.4124663 41.7608259,14.6317815 C42.0573712,15.0859946 42.0573712,15.0859946 42.1701575,15.1794921 C42.3401622,15.3514813 42.5937937,15.445556 42.8336708,15.445556 C43.4410661,15.445556 43.9208204,14.8822624 43.9208204,14.1313967 Z M37.1817036,13.9028473 C37.0815714,13.2495191 36.5633047,12.7699115 35.9295009,12.7699115 C35.0118059,12.7699115 34.3625971,13.5051943 33.7975654,15.1639092 L33.7975654,12.7699115 C32.1739935,13.4272797 31.6942392,13.583686 30.1834534,13.9744133 L30.2120626,14.1313967 C30.6775123,14.1625625 30.931694,14.287803 31.1297577,14.5844555 C31.3553302,14.9134283 31.4114483,15.2885725 31.4114483,16.2275875 L31.4114483,18.7935745 C31.4114483,20.3893805 31.2849076,20.5931127 30.2824853,20.6398615 L30.2824853,20.7962678 L35.0398649,20.7962678 L35.0398649,20.6398615 C34.0374426,20.5931127 33.9103517,20.3893805 33.9103517,18.7935745 L33.9103517,16.838207 C33.9103517,15.445556 33.9527153,15.0698345 34.1645334,14.6473644 C34.2773197,14.4286264 34.4324696,14.3189689 34.6024743,14.3189689 C34.7576242,14.3189689 34.884715,14.4124663 35.0398649,14.6317815 C35.3364103,15.0859946 35.3364103,15.0859946 35.4491965,15.1794921 C35.618651,15.3514813 35.8728328,15.445556 36.1127099,15.445556 C36.7107522,15.445556 37.1839043,14.8989996 37.198759,14.1654483 L37.1817036,13.9028473 Z M30.1834534,19.842247 C29.9435763,19.842247 29.7317582,19.7170065 29.6613355,19.5132743 C29.5766083,19.3257022 29.5623037,19.1225471 29.5623037,18.5280877 L29.5623037,14.9290111 C29.5623037,14.0373221 29.4214584,13.5681031 29.0115766,13.2079646 C28.6869723,12.9107349 28.2913951,12.7699115 27.7692772,12.7699115 C26.5412824,12.7699115 24.9034058,13.2391305 23.8168064,13.9276645 C22.9414749,14.4597922 22.5321433,15.0230858 22.5321433,15.680454 C22.5321433,16.3216622 22.9414749,16.7752982 23.520261,16.7752982 C24.3246197,16.7752982 24.8896513,16.1496729 25.016192,15.1639092 C25.1295284,14.1781455 25.143833,14.0840708 25.2703737,13.802424 C25.4398282,13.4116968 25.8211008,13.1767988 26.2304324,13.1767988 C26.4989188,13.1767988 26.7101867,13.3020393 26.8658867,13.5519431 C27.0067321,13.802424 27.0634002,14.2716429 27.0634002,15.3358984 L27.0634002,16.1496729 C26.089037,16.4624856 25.2566193,16.7752982 24.5788014,17.1036937 C23.025652,17.8233936 22.5172885,18.3711043 22.5172885,19.2945363 C22.5172885,20.2953059 23.336502,21 24.5226833,21 C25.6373417,21 26.3861325,20.5619469 27.0634002,19.5132743 C27.2471593,20.514621 27.6988546,21 28.4751542,21 C29.1953357,21 29.8588491,20.6554444 30.8332124,19.7481724 L30.7479349,19.6385148 C30.4799988,19.7954983 30.3529079,19.842247 30.1834534,19.842247 Z M27.0634002,18.7624086 C27.0634002,19.4821085 26.7387959,19.9357445 26.216678,19.9357445 C25.6797053,19.9357445 25.3980148,19.4197769 25.3980148,18.4807618 C25.3980148,17.291843 25.7787372,16.7908811 27.0634002,16.3372451 L27.0634002,18.7624086 Z M25.2516677,10.5173143 L25.2516677,10.3603309 L21.6656147,10.3603309 L21.6656147,10.5173143 C22.0892509,10.6731435 22.27301,11.0644479 22.27301,11.8308965 C22.27301,12.7231627 21.96216,13.7083493 21.3267057,14.8510966 L20.8469515,15.7116199 L19.2371339,12.7543286 C18.8564114,12.0502116 18.715016,11.6589073 18.715016,11.2676029 C18.715016,10.8451327 18.9829521,10.5790689 19.4775612,10.5173143 L19.4775612,10.3603309 L14,10.3603309 L14,10.5173143 C14.7482406,10.6263948 15.1432676,11.0021162 15.8634492,12.2851097 L18.1791437,16.5559831 L18.1791437,18.1206233 C18.1791437,19.5917661 18.1362299,19.8734129 17.924962,20.2018084 C17.7412029,20.4834552 17.4870212,20.5931127 16.8658715,20.6398615 L16.8658715,20.7962678 L22.27301,20.7962678 L22.27301,20.6398615 C21.6518603,20.5931127 21.4114329,20.4834552 21.2139195,20.2018084 C21.0021014,19.8734129 20.9597377,19.5761831 20.9597377,18.1206233 L20.9597377,15.8836091 L21.6799193,14.5688727 C23.1483415,12.0028857 24.3202182,10.6731435 25.2516677,10.5173143 Z" id="Fill-2" fill="#FFFFFF"></path>
        </g>
    </g>
</g>
              </g>
              <g
                id="Parks"
                style={{
                  display:
                    selectedItem && selectedItem === "Parks"
                      ? "initial"
                      : "none"
                }}
              >
                <g>
                  <circle className="st18" cx="932.2" cy="622.3" r="9.9" />
                  <g>
                    <path
                      className="st6"
                      d="M925.6,620.7c0-0.1,0-0.3,0-0.5c0-1.4,1.1-2.7,2.9-2.7c1.8,0,2.9,1.2,2.9,2.6c0,1.1-0.6,1.9-1.6,2.5l-1.6,1
				c-0.4,0.2-0.7,0.5-0.8,0.9h4v1.3h-5.9c0-1.4,0.5-2.5,1.9-3.4l1.3-0.8c0.7-0.5,1-0.9,1-1.5c0-0.7-0.5-1.3-1.4-1.3
				c-1,0-1.4,0.7-1.4,1.5c0,0.1,0,0.3,0,0.4L925.6,620.7z"
                    />
                    <path
                      className="st6"
                      d="M932.8,623.7c0-0.9,0.6-1.7,1.5-2c-0.8-0.3-1.3-1.1-1.3-1.9c0-1.4,1.2-2.3,2.8-2.3s2.8,0.9,2.8,2.3
				c0,0.8-0.5,1.6-1.3,1.9c0.9,0.3,1.5,1.1,1.5,2c0,1.4-1.2,2.4-3,2.4C934,626.1,932.8,625.1,932.8,623.7z M937.4,623.6
				c0-0.7-0.5-1.3-1.5-1.3c-1,0-1.5,0.6-1.5,1.3c0,0.7,0.5,1.2,1.5,1.2C936.8,624.8,937.4,624.2,937.4,623.6z M937.2,619.9
				c0-0.6-0.5-1.2-1.3-1.2c-0.8,0-1.3,0.5-1.3,1.2c0,0.7,0.5,1.2,1.3,1.2C936.6,621.1,937.2,620.6,937.2,619.9z"
                    />
                  </g>
                </g>
                <g>
                  <circle className="st18" cx="1008.2" cy="549.7" r="9.9" />
                  <g>
                    <path
                      className="st6"
                      d="M1002.7,548.5l2.3-2h-3.7v-1.3h5.7v1.3l-2.2,1.9c1.2,0,2.4,0.9,2.4,2.5c0,1.4-1.1,2.7-3.1,2.7
				c-1.9,0-3-1.2-3.1-2.6l1.5-0.3c0,0.9,0.7,1.6,1.6,1.6c1,0,1.5-0.6,1.5-1.4c0-0.9-0.8-1.3-1.4-1.3c-0.4,0-0.6,0.1-0.8,0.1
				L1002.7,548.5z"
                    />
                    <path
                      className="st6"
                      d="M1009.2,546.3c0.5-0.8,1.4-1.3,2.6-1.3s2.1,0.5,2.6,1.3c0.6,0.8,0.7,1.9,0.7,2.9s-0.2,2.1-0.7,2.9
				c-0.5,0.8-1.4,1.3-2.6,1.3s-2.1-0.5-2.6-1.3c-0.6-0.8-0.7-1.9-0.7-2.9S1008.7,547.1,1009.2,546.3z M1010.6,551.5
				c0.3,0.4,0.7,0.6,1.3,0.6s1-0.2,1.3-0.6c0.4-0.5,0.6-1.3,0.6-2.3s-0.2-1.8-0.6-2.3c-0.3-0.4-0.7-0.6-1.3-0.6s-1,0.2-1.3,0.6
				c-0.4,0.5-0.6,1.3-0.6,2.3S1010.2,551,1010.6,551.5z"
                    />
                  </g>
                </g>
                <g>
                  <circle className="st18" cx="1333.9" cy="387.7" r="9.9" />
                  <g>
                    <path
                      className="st6"
                      d="M1328.9,386.5l2.3-2h-3.7v-1.3h5.7v1.3l-2.2,1.9c1.2,0,2.4,0.9,2.4,2.5c0,1.4-1.1,2.7-3.1,2.7
				c-1.9,0-3-1.2-3.1-2.6l1.5-0.3c0,0.9,0.7,1.6,1.6,1.6c1,0,1.5-0.6,1.5-1.4c0-0.9-0.8-1.3-1.4-1.3c-0.4,0-0.6,0.1-0.8,0.1
				L1328.9,386.5z"
                    />
                    <path
                      className="st6"
                      d="M1334.8,386.1c0-0.1,0-0.3,0-0.5c0-1.4,1.1-2.7,2.9-2.7c1.8,0,2.9,1.2,2.9,2.6c0,1.1-0.6,1.9-1.6,2.5l-1.6,1
				c-0.4,0.2-0.7,0.5-0.8,0.9h4v1.3h-5.9c0-1.4,0.5-2.5,1.9-3.4l1.3-0.8c0.7-0.5,1-0.9,1-1.5c0-0.7-0.5-1.3-1.4-1.3
				c-1,0-1.4,0.7-1.4,1.5c0,0.1,0,0.3,0,0.4L1334.8,386.1z"
                    />
                  </g>
                </g>
                <g>
                  <circle className="st18" cx="1233.8" cy="417.8" r="9.9" />
                  <g>
                    <path
                      className="st6"
                      d="M1229.1,416.5l2.3-2h-3.7v-1.3h5.7v1.3l-2.2,1.9c1.2,0,2.4,0.9,2.4,2.5c0,1.4-1.1,2.7-3.1,2.7
				c-1.9,0-3-1.2-3.1-2.6l1.5-0.3c0,0.9,0.7,1.6,1.6,1.6c1,0,1.5-0.6,1.5-1.4c0-0.9-0.8-1.3-1.4-1.3c-0.4,0-0.6,0.1-0.8,0.1
				L1229.1,416.5z"
                    />
                    <path
                      className="st6"
                      d="M1240.6,414.5c-0.7,0.6-3,2.6-3.3,6.8h-1.6c0.4-4.6,3.2-6.8,3.2-6.8h-4.4v-1.3h6.1V414.5z"
                    />
                  </g>
                </g>
                <g>
                  <circle className="st18" cx="1011.2" cy="585.4" r="9.9" />
                  <g>
                    <path
                      className="st6"
                      d="M1007.2,584.1l2.3-2h-3.7v-1.3h5.7v1.3l-2.2,1.9c1.2,0,2.4,0.9,2.4,2.5c0,1.4-1.1,2.7-3.1,2.7
				c-1.9,0-3-1.2-3.1-2.6l1.5-0.3c0,0.9,0.7,1.6,1.6,1.6c1,0,1.5-0.6,1.5-1.4c0-0.9-0.8-1.3-1.4-1.3c-0.4,0-0.6,0.1-0.8,0.1
				L1007.2,584.1z"
                    />
                    <path
                      className="st6"
                      d="M1014.8,589v-5.6h-2v-1c1.2,0,2-0.7,2.2-1.5h1.3v8.2H1014.8z"
                    />
                  </g>
                </g>
                <g>
                  <circle className="st18" cx="1420.1" cy="434.9" r="9.9" />
                  <g>
                    <path
                      className="st6"
                      d="M1415,433.6l2.3-2h-3.7v-1.3h5.7v1.3l-2.2,1.9c1.2,0,2.4,0.9,2.4,2.5c0,1.4-1.1,2.7-3.1,2.7
				c-1.9,0-3-1.2-3.1-2.6l1.5-0.3c0,0.9,0.7,1.6,1.6,1.6c1,0,1.5-0.6,1.5-1.4c0-0.9-0.8-1.3-1.4-1.3c-0.4,0-0.6,0.1-0.8,0.1
				L1415,433.6z"
                    />
                    <path
                      className="st6"
                      d="M1422.4,433.6l2.3-2h-3.7v-1.3h5.7v1.3l-2.2,1.9c1.2,0,2.4,0.9,2.4,2.5c0,1.4-1.1,2.7-3.1,2.7
				c-1.9,0-3-1.2-3.1-2.6l1.5-0.3c0,0.9,0.7,1.6,1.6,1.6c1,0,1.5-0.6,1.5-1.4c0-0.9-0.8-1.3-1.4-1.3c-0.4,0-0.6,0.1-0.8,0.1
				L1422.4,433.6z"
                    />
                  </g>
                </g>
                <g>
                  <circle className="st18" cx="1479.6" cy="462.2" r="9.9" />
                  <g>
                    <path
                      className="st6"
                      d="M1474.3,460.9l2.3-2h-3.7v-1.3h5.7v1.3l-2.2,1.9c1.2,0,2.4,0.9,2.4,2.5c0,1.4-1.1,2.7-3.1,2.7
				c-1.9,0-3-1.2-3.1-2.6l1.5-0.3c0,0.9,0.7,1.6,1.6,1.6c1,0,1.5-0.6,1.5-1.4c0-0.9-0.8-1.3-1.4-1.3c-0.4,0-0.6,0.1-0.8,0.1
				L1474.3,460.9z"
                    />
                    <path
                      className="st6"
                      d="M1480,462.3l3.5-4.7h1.9v5h1.4v1.3h-1.4v1.8h-1.5v-1.8h-3.9V462.3z M1483.9,459.1l-2.6,3.5h2.6V459.1z"
                    />
                  </g>
                </g>
                <g>
                  <circle className="st18" cx="1622.2" cy="331.3" r="9.9" />
                  <g>
                    <path
                      className="st6"
                      d="M1617,330l2.3-2h-3.7v-1.3h5.7v1.3l-2.2,1.9c1.2,0,2.4,0.9,2.4,2.5c0,1.4-1.1,2.7-3.1,2.7
				c-1.9,0-3-1.2-3.1-2.6l1.5-0.3c0,0.9,0.7,1.6,1.6,1.6c1,0,1.5-0.6,1.5-1.4c0-0.9-0.8-1.3-1.4-1.3c-0.4,0-0.6,0.1-0.8,0.1
				L1617,330z"
                    />
                    <path
                      className="st6"
                      d="M1623.4,333.3c0.3,0.2,0.9,0.4,1.5,0.4c1.7,0,2.6-1,2.7-2.6c-0.3,0.5-1,0.9-2,0.9c-1.5,0-2.8-1-2.8-2.7
				c0-1.7,1.4-2.8,3.1-2.8c1.7,0,3.2,1.2,3.2,3.8c0,3-1.4,4.7-4.2,4.7c-0.7,0-1.5-0.2-1.9-0.5L1623.4,333.3z M1625.8,327.8
				c-0.8,0-1.6,0.6-1.6,1.5c0,1,0.7,1.5,1.6,1.5c0.8,0,1.6-0.6,1.6-1.5C1627.3,328.4,1626.6,327.8,1625.8,327.8z"
                    />
                  </g>
                </g>
                <g>
                  <circle className="st18" cx="1750.5" cy="324.6" r="9.9" />
                  <g>
                    <path
                      className="st6"
                      d="M1745.2,323.4l2.3-2h-3.7V320h5.7v1.3l-2.2,1.9c1.2,0,2.4,0.9,2.4,2.5c0,1.4-1.1,2.7-3.1,2.7
				c-1.9,0-3-1.2-3.1-2.6l1.5-0.3c0,0.9,0.7,1.6,1.6,1.6c1,0,1.5-0.6,1.5-1.4c0-0.9-0.8-1.3-1.4-1.3c-0.4,0-0.6,0.1-0.8,0.1
				L1745.2,323.4z"
                    />
                    <path
                      className="st6"
                      d="M1756.8,321.5c-0.3-0.2-0.7-0.3-1.4-0.3c-1.5,0-2.6,1-2.8,2.6c0.4-0.7,1.2-1,2.1-1c1.6,0,2.8,1.1,2.8,2.8
				c0,1.7-1.4,2.8-3.1,2.8c-2.1,0-3.3-1.7-3.3-3.8c0-3,1.8-4.7,4.4-4.7c0.8,0,1.4,0.2,1.7,0.4L1756.8,321.5z M1754.4,327.1
				c0.9,0,1.6-0.6,1.6-1.5c0-1-0.7-1.5-1.6-1.5s-1.6,0.6-1.6,1.5C1752.8,326.5,1753.5,327.1,1754.4,327.1z"
                    />
                  </g>
                </g>
                <g>
                  <circle className="st18" cx="1540.2" cy="318.6" r="9.9" />
                  <g>
                    <path
                      className="st6"
                      d="M1535.1,317.3l2.3-2h-3.7V314h5.7v1.3l-2.2,1.9c1.2,0,2.4,0.9,2.4,2.5c0,1.4-1.1,2.7-3.1,2.7
				c-1.9,0-3-1.2-3.1-2.6l1.5-0.3c0,0.9,0.7,1.6,1.6,1.6c1,0,1.5-0.6,1.5-1.4c0-0.9-0.8-1.3-1.4-1.3c-0.4,0-0.6,0.1-0.8,0.1
				L1535.1,317.3z"
                    />
                    <path
                      className="st6"
                      d="M1542.2,319.5c0.1,0.9,0.7,1.5,1.6,1.5c0.9,0,1.5-0.6,1.5-1.5c0-1-0.7-1.5-1.6-1.5c-0.6,0-1.1,0.2-1.4,0.6
				l-1.4-0.5l1-4.1h4.5v1.3h-3.4l-0.5,2.1c0.4-0.4,1-0.6,1.6-0.6c1.6,0,2.8,1,2.8,2.7c0,1.5-1.2,2.8-3.1,2.8c-1.8,0-3-1.2-3.1-2.5
				L1542.2,319.5z"
                    />
                  </g>
                </g>
                <g>
                  <circle className="st18" cx="1619.2" cy={307} r="9.9" />
                  <g>
                    <path
                      className="st6"
                      d="M1614,305.7l2.3-2h-3.7v-1.3h5.7v1.3l-2.2,1.9c1.2,0,2.4,0.9,2.4,2.5c0,1.4-1.1,2.7-3.1,2.7
				c-1.9,0-3-1.2-3.1-2.6l1.5-0.3c0,0.9,0.7,1.6,1.6,1.6c1,0,1.5-0.6,1.5-1.4c0-0.9-0.8-1.3-1.4-1.3c-0.4,0-0.6,0.1-0.8,0.1
				L1614,305.7z"
                    />
                    <path
                      className="st6"
                      d="M1619.8,308.3c0-0.9,0.6-1.7,1.5-2c-0.8-0.3-1.3-1.1-1.3-1.9c0-1.4,1.2-2.3,2.8-2.3s2.8,0.9,2.8,2.3
				c0,0.8-0.5,1.6-1.3,1.9c0.9,0.3,1.5,1.1,1.5,2c0,1.4-1.2,2.4-3,2.4C1621,310.7,1619.8,309.7,1619.8,308.3z M1624.4,308.2
				c0-0.7-0.5-1.3-1.5-1.3c-1,0-1.5,0.6-1.5,1.3c0,0.7,0.5,1.2,1.5,1.2C1623.8,309.4,1624.4,308.8,1624.4,308.2z M1624.2,304.5
				c0-0.6-0.5-1.2-1.3-1.2s-1.3,0.5-1.3,1.2c0,0.7,0.5,1.2,1.3,1.2C1623.7,305.7,1624.2,305.2,1624.2,304.5z"
                    />
                  </g>
                </g>
                <g>
                  <circle className="st18" cx="968.8" cy="652.7" r="9.9" />
                  <g>
                    <path
                      className="st6"
                      d="M962.1,651.1c0-0.1,0-0.3,0-0.5c0-1.4,1.1-2.7,2.9-2.7c1.8,0,2.9,1.2,2.9,2.6c0,1.1-0.6,1.9-1.6,2.5l-1.6,1
				c-0.4,0.2-0.7,0.5-0.8,0.9h4v1.3H962c0-1.4,0.5-2.5,1.9-3.4l1.3-0.8c0.7-0.5,1-0.9,1-1.5c0-0.7-0.5-1.3-1.4-1.3
				c-1,0-1.4,0.7-1.4,1.5c0,0.1,0,0.3,0,0.4L962.1,651.1z"
                    />
                    <path
                      className="st6"
                      d="M969.8,654.8c0.3,0.2,0.9,0.4,1.5,0.4c1.7,0,2.6-1,2.7-2.6c-0.3,0.5-1,0.9-2,0.9c-1.5,0-2.8-1-2.8-2.7
				c0-1.7,1.4-2.8,3.1-2.8c1.7,0,3.2,1.2,3.2,3.8c0,3-1.4,4.7-4.2,4.7c-0.7,0-1.5-0.2-1.9-0.5L969.8,654.8z M972.3,649.2
				c-0.8,0-1.6,0.6-1.6,1.5c0,1,0.7,1.5,1.6,1.5c0.8,0,1.6-0.6,1.6-1.5C973.8,649.8,973.1,649.2,972.3,649.2z"
                    />
                  </g>
                </g>
                <g>
                  <circle className="st19" cx="1148.5" cy="407.5" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1141.8156 411.0805)"
                    className="st6 st20 st21"
                    id="loc-27"
                  >
                    27
                  </text>
                </g>
              </g>
              <g
                id="Food"
                style={{
                  display:
                    selectedItem && selectedItem === "Food" ? "initial" : "none"
                }}
              >
                <g>
                  <circle className="st22" cx="1234.7" cy="265.8" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1227.2761 269.2939)"
                    className="st6 st20 st21"
                    id="loc-45"
                  >
                    45
                  </text>
                </g>
                <g>
                  <circle className="st22" cx={1232} cy="324.6" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1224.4315 328.1337)"
                    className="st6 st20 st21"
                    id="loc-44"
                  >
                    44
                  </text>
                </g>
                <g>
                  <circle className="st22" cx="1196.5" cy="326.1" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1188.9696 329.6337)"
                    className="st6 st20 st21"
                    id="loc-46"
                  >
                    46
                  </text>
                </g>
                <g>
                  <circle className="st22" cx="1162.5" cy="302.2" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1154.9159 305.7075)"
                    className="st6 st20 st21"
                    id="loc-49"
                  >
                    49
                  </text>
                </g>
                <g>
                  <circle className="st22" cx={1058} cy="338.2" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1050.9935 341.7807)"
                    className="st6 st20 st21"
                    id="loc-47"
                  >
                    47
                  </text>
                </g>
                <g>
                  <circle className="st22" cx="1090.5" cy="292.9" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1083.3926 296.395)"
                    className="st6 st20 st21"
                    id="loc-52"
                  >
                    52
                  </text>
                </g>
                <g>
                  <circle className="st22" cx={840} cy="223.6" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 832.6156 227.1718)"
                    className="st6 st20 st21"
                    id="loc-54"
                  >
                    54
                  </text>
                </g>
                <g>
                  <circle className="st22" cx="1051.4" cy="315.6" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1044.2688 319.1305)"
                    className="st6 st20 st21"
                    id="loc-53"
                  >
                    53
                  </text>
                </g>
                <g>
                  <circle className="st22" cx={1108} cy="310.2" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1100.4501 313.7608)"
                    className="st6 st20 st21"
                    id="loc-50"
                  >
                    50
                  </text>
                </g>
                <g>
                  <circle className="st22" cx="1061.3" cy="360.3" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1053.8723 363.8394)"
                    className="st6 st20 st21"
                    id="loc-48"
                  >
                    48
                  </text>
                </g>
                <g>
                  <circle className="st22" cx="1078.4" cy="344.5" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1072.3406 348.0467)"
                    className="st6 st20 st21"
                    id="loc-51"
                  >
                    51
                  </text>
                </g>
              </g>
              <g
                id="Shopping"
                style={{
                  display:
                    selectedItem && selectedItem === "Shopping"
                      ? "initial"
                      : "none"
                }}
              >
                <g>
                  <circle className="st23" cx="1096.9" cy={330} r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1089.702 333.5778)"
                    className="st6 st20 st21"
                    id="loc-55"
                  >
                    55
                  </text>
                </g>
                <g>
                  <circle className="st23" cx="1130.8" cy="304.7" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1124.0061 308.2491)"
                    className="st6 st20 st21"
                    id="loc-57"
                  >
                    57
                  </text>
                </g>
                <g>
                  <circle className="st23" cx="1121.4" cy="229.8" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1114.1825 233.3233)"
                    className="st6 st20 st21"
                    id="loc-58"
                  >
                    58
                  </text>
                </g>
                <g>
                  <circle className="st23" cx="1115.3" cy="285.8" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1107.9194 289.3774)"
                    className="st6 st20 st21"
                    id="loc-56"
                  >
                    56
                  </text>
                </g>
              </g>
              <g
                id="Hospitals"
                style={{
                  display:
                    selectedItem && selectedItem === "Hospitals"
                      ? "initial"
                      : "none"
                }}
              >
                <g>
                  <circle className="st24" cx="1510.2" cy="61.9" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1502.3704 65.4671)"
                    className="st6 st20 st21"
                    id="loc-40"
                  >
                    40
                  </text>
                </g>
                <g>
                  <circle className="st24" cx="1533.2" cy="46.7" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1525.8789 50.2039)"
                    className="st6 st20 st21"
                    id="loc-42"
                  >
                    42
                  </text>
                </g>
                <g>
                  <circle className="st24" cx="1499.7" cy="739.4" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1492.3086 742.9785)"
                    className="st6 st20 st21"
                    id="loc-43"
                  >
                    43
                  </text>
                </g>
                <g>
                  <circle className="st24" cx="1514.5" cy="30.2" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1508.2653 33.7351)"
                    className="st6 st20 st21"
                    id="loc-41"
                  >
                    41
                  </text>
                </g>
              </g>
              <g
                id="Education"
                style={{
                  display:
                    selectedItem && selectedItem === "Education"
                      ? "initial"
                      : "none"
                }}
              >
                <g>
                  <circle className="st25" cx="1301.7" cy="338.6" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1294.0713 342.1149)"
                    className="st6 st20 st21"
                    id="loc-08"
                  >
                    08
                  </text>
                </g>
                <g>
                  <circle className="st25" cx="1464.2" cy="556.9" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1458.1285 560.3943)"
                    className="st6 st20 st21"
                    id="loc-15"
                  >
                    15
                  </text>
                </g>
                <g>
                  <circle className="st25" cx="1473.7" cy="528.7" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1467.4417 532.2753)"
                    className="st6 st20 st21"
                    id="loc-16"
                  >
                    16
                  </text>
                </g>
                <g>
                  <circle className="st25" cx="1289.9" cy={716} r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1284.2344 719.5623)"
                    className="st6 st20 st21"
                    id="loc-17"
                  >
                    17
                  </text>
                </g>
                <g>
                  <circle className="st25" cx="1237.5" cy="824.2" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1230.517 827.6935)"
                    className="st6 st20 st21"
                    id="loc-22"
                  >
                    22
                  </text>
                </g>
                <g>
                  <circle className="st25" cx="1313.1" cy={757} r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1306.9824 760.537)"
                    className="st6 st20 st21"
                    id="loc-18"
                  >
                    18
                  </text>
                </g>
                <g>
                  <circle className="st25" cx={1280} cy={791} r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1273.7585 794.5803)"
                    className="st6 st20 st21"
                    id="loc-19"
                  >
                    19
                  </text>
                </g>
                <g>
                  <circle className="st25" cx="1200.8" cy="719.6" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1193.7346 723.1039)"
                    className="st6 st20 st21"
                    id="loc-23"
                  >
                    23
                  </text>
                </g>
                <g>
                  <circle className="st25" cx={1613} cy="573.3" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1605.7278 576.8791)"
                    className="st6 st20 st21"
                    id="loc-24"
                  >
                    24
                  </text>
                </g>
                <g>
                  <circle className="st25" cx="1335.8" cy="799.2" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1328.3508 802.7886)"
                    className="st6 st20 st21"
                    id="loc-20"
                  >
                    20
                  </text>
                </g>
                <g>
                  <circle className="st25" cx="1284.9" cy={398} r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1278.3687 401.5744)"
                    className="st6 st20 st21"
                    id="loc-10"
                  >
                    10
                  </text>
                </g>
                <g>
                  <circle className="st25" cx={1391} cy="236.8" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1386.0686 240.3097)"
                    className="st6 st20 st21"
                    id="loc-11"
                  >
                    11
                  </text>
                </g>
                <g>
                  <circle className="st25" cx="1442.3" cy="117.9" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1436.3776 121.3996)"
                    className="st6 st20 st21"
                    id="loc-12"
                  >
                    12
                  </text>
                </g>
                <g>
                  <circle className="st25" cx="1284.8" cy="77.7" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1278.7858 81.2309)"
                    className="st6 st20 st21"
                    id="loc-13"
                  >
                    13
                  </text>
                </g>
                <g>
                  <circle className="st25" cx="1331.2" cy="207.7" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1324.9617 211.2319)"
                    className="st6 st20 st21"
                    id="loc-14"
                  >
                    14
                  </text>
                </g>
                <g>
                  <circle className="st25" cx="1137.4" cy="325.3" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1129.6271 328.8428)"
                    className="st6 st20 st21"
                    id="loc-09"
                  >
                    09
                  </text>
                </g>
                <g>
                  <circle className="st25" cx="1330.4" cy={839} r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1324.467 842.5439)"
                    className="st6 st20 st21"
                    id="loc-21"
                  >
                    21
                  </text>
                </g>
                <g>
                  <circle className="st25" cx="1442.1" cy="854.9" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1435.0221 858.4138)"
                    className="st6 st20 st21"
                    id="loc-25"
                  >
                    25
                  </text>
                </g>
                <g>
                  <circle className="st25" cx="1699.8" cy="870.2" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1692.5747 873.7219)"
                    className="st6 st20 st21"
                    id="loc-26"
                  >
                    26
                  </text>
                </g>
              </g>
              <g
                id="Villages"
                style={{
                  display:
                    selectedItem && selectedItem === "Villages"
                      ? "initial"
                      : "none"
                }}
              >
                <g>
                  <circle className="st26" cx="1521.1" cy="575.3" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1513.5205 578.8771)"
                    className="st6 st20 st21"
                    id="loc-03"
                  >
                    03
                  </text>
                </g>
                <g>
                  <circle className="st26" cx="1227.6" cy="666.1" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1220.1182 669.6705)"
                    className="st6 st20 st21"
                    id="loc-02"
                  >
                    02
                  </text>
                </g>
                <g>
                  <circle className="st26" cx="1246.7" cy="891.7" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1239.5195 895.2289)"
                    className="st6 st20 st21"
                    id="loc-07"
                  >
                    07
                  </text>
                </g>
                <g>
                  <circle className="st26" cx="1557.6" cy="159.9" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 1550.063 163.4092)"
                    className="st6 st20 st21"
                    id="loc-05"
                  >
                    05
                  </text>
                </g>
                <g>
                  <circle className="st26" cx="786.8" cy="474.9" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 778.9523 478.4748)"
                    className="st6 st20 st21"
                    id="loc-04"
                  >
                    04
                  </text>
                </g>
                <g>
                  <circle className="st26" cx="1086.1" cy="228.2" r="9.9" />
                  <text
                    id="loc-01"
                    transform="matrix(1 0 0 1 1079.5881 231.7369)"
                    className="st6 st20 st21"
                  >
                    01
                  </text>
                </g>
                <g>
                  <circle className="st26" cx="856.7" cy="178.6" r="9.9" />
                  <text
                    transform="matrix(1 0 0 1 848.9567 182.187)"
                    className="st6 st20 st21"
                    id="loc-06"
                  >
                    06
                  </text>
                </g>
              </g>
            </svg>
          </div>
          <RightSidebar className="col col-03 mobile-hide">
            {locationGroups.map(this.renderLocGroup)}
          </RightSidebar>
        </div>
        <div className="grid">
          <RightSidebar className="col col-xs-12 desktop-hide">
            {this.renderLocGroupMobile()}
          </RightSidebar>
        </div>
      </LocationMapWrapper>
    );
  }
}

const LocationMapWrapper = styled.div`
  margin-bottom: ${vars.padding.inner}rem;
  &:last-child {
    margin-bottom: 0;
  }
  > div {
    display: flex !important;
  }
	.grid{
		padding-left: 0;
		padding-right: 0;
		max-width: 100%;
	}

	svg text{
		font-family: ${vars.fonts.main} !important;
	}
  svg circle,
  svg text {
    cursor: pointer;
		
  }
  #popover {
    animation: 1s ${fadeInUpAnimation};
    background-color: rgba(0, 0, 0, 0.85);
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
    padding: 7px 10px;
    width: 180px;
    max-width: 180px;
		margin-left: -30px;
		p{
		font-size: 12px;
		}
    ${below.desktop`
      width: 150px;
      max-width: 150px;
      > p {
        font-size: 1.2rem;
        line-height: 1.4;
      }
		`};
    z-index: 4;
    &:before {
      border-top: 7px solid rgba(0, 0, 0, 0.85);
      border-right: 7px solid transparent;
      border-left: 7px solid transparent;
      bottom: -7px;
      content: "";
      display: block;
      left: 50%;
      margin-left: -7px;
      position: absolute;
    }
  }
`;

const RightSidebar = styled.div`
  background-color: #333333;
  color: #777777;
  ${below.desktop`
    color: white;
  `};
  li {
    display: block;
    list-style: none;
    padding: 5px 10px;
    &:hover {
      cursor: pointer;
    }
    &.active > p {
      color: white;
    }
  }

  .loc-group-item > p {
    padding-bottom: 0;
  }

  .loc-group-bullet {
    display: inline-block;
    margin-right: 20px;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    ${below.desktop`
      width: 10px;
    height: 10px;
    `};
  }

  .loc-subgroups {
    position: relative;
    padding: 20px 20px;
    background-color: #454242;
    ${below.desktop`
      background-color: transparent;
      padding: 5px 10px;
		`};
    animation: 1s ${fadeInAnimation};
    .drop-arrow {
      position: absolute;
      top: 0;
      left: 40px;
      border-top: 10px solid #333333;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      margin-bottom: 0px;
    }
    .grid {
      padding: 0;
    }
    .loc-subgroup-item {
      padding-left: 10px;
      padding-right: 5px;
      padding-top: 7px;
      word-wrap: break-word;
			cursor: pointer;
			font-size: 13px;
      &:hover {
        color: white;
      }
    }
  }

  &&&.mobile-hide {
    ${below.desktop`
			display: none;
		`};
  }
  &&&.desktop-hide {
    ${above.desktop`
			display: none;
		`};
  }
`;

export default LocationMap;



// WEBPACK FOOTER //
// ./src/components/location_map.js